import { avatarClasses } from "@mui/material";
import { create } from "@mui/material/styles/createTransitions";
import { createSlice } from "@reduxjs/toolkit";
import { actions } from "react-table";
import startOfWeek from "date-fns/startOfWeek";
import endOfWeek from "date-fns/endOfWeek";
import Client from "../Component/MainComponent/Client/Client";
import { get } from "lodash";

//------sidebar---
const SidebarSlice = createSlice({
  name: "sidebar",
  initialState: {
    SidebarActive: false,
  },
  reducers: {
    getsidebarActions: (state, actions) => {
      state.SidebarActive = actions.payload;
    },
  },
});
const SideBarDispatchSlices = createSlice({
  name: "sidebardispatchCall",
  initialState: {
    SideStatus: false,
  },
  reducers: {
    getSideBarStatus: (state, actions) => {
      state.SideStatus = actions.payload;
    },
  },
});
const LanguageSlice = createSlice({
  name: "Laguage",
  initialState: {
    Language: [],
  },
  reducers: {
    setLaguage: (state, actions) => {
      state.Language = actions.payload;
    },
  },
});
const SideBarfileActiveSlice = createSlice({
  name: "SideBarFiles",
  initialState: {
    SideBarFile: "",
    Role: "",
    NameRoles: "",
    TOKEN: "",
    UDSTOKEN: "",
    ValidationDate: "",
    ValidationDateto: "",

    PanvalidationDate: "",
    PanvalidationDateTo: "",

    BankValidation: "",
    BankValidationTodate: "",

    WhatsappValidation: "",
    WhatsappValidationTodate: "",
    UDSEmployeeeImage: "",
    UserIDsemp: "",
    EmployeeUDSImages: "",
    UserEmailID: "",
    LoginIDs: "",
    KycRoleListed: "",
    SideBarNotification: false,
    NearDueStatusFilterClient: { value: "0", label: "Open" },
    NearDueStatusFilterDepartment: { value: "0", label: "Open" },
    LoginUserdataofassinged: { value: "external", label: "Assigned" },
    settheSubAssignPopupChanges: 2,
    selectedUploadTab: "Denave Bulkupload",
  },
  reducers: {
    gettheticketdhashboardofROutesActions: (state, actions) => {
      state.settheSubAssignPopupChanges = actions.payload;
    },

    getthedhashboardtickeyTypeactions: (state, actions) => {
      state.LoginUserdataofassinged = actions.payload;
    },

    gettheNearDueClientFilterStates: (state, actions) => {
      state.NearDueStatusFilterClient = actions.payload;
    },
    gettheNearDueDepartmentsFilterStates: (state, actions) => {
      state.NearDueStatusFilterDepartment = actions.payload;
    },
    gettheSideBarNotificationState: (state, actions) => {
      state.SideBarNotification = actions.payload;
    },
    getSideBarfilesActions: (state, actions) => {
      state.SideBarFile = actions.payload;
    },
    SetARole: (state, actions) => {
      state.Role = actions.payload;
    },
    setTheRoleName: (state, actions) => {
      state.NameRoles = actions.payload;
    },
    settheKycroles: (state, actions) => {
      state.KycRoleListed = actions.payload;
    },
    setTheUserEmailIDS: (state, actions) => {
      state.UserEmailID = actions.payload;
    },
    setTheUDSTOKEN: (state, actions) => {
      state.TOKEN = actions.payload;
    },
    settheLoginIds: (state, actions) => {
      state.LoginIDs = actions.payload;
    },
    setTheUDSAttendanceTOKEN: (state, actions) => {
      state.UDSTOKEN = actions.payload;
    },
    setTheudsEmployeeImage: (state, actions) => {
      state.UDSEmployeeeImage = actions.payload;
    },
    setthevalidationRange: (state, actions) => {
      state.ValidationDate = actions.payload;
    },
    setthevalidationRangeTodate: (state, actions) => {
      state.ValidationDateto = actions.payload;
    },
    setthepanvalidationRange: (state, actions) => {
      state.PanvalidationDate = actions.payload;
    },

    setthepanvalidationTodateRange: (state, actions) => {
      state.PanvalidationDateTo = actions.payload;
    },

    setTheBankValidationRange: (state, actions) => {
      state.BankValidation = actions.payload;
    },
    setTheBankValidationTodateRange: (state, actions) => {
      state.BankValidationTodate = actions.payload;
    },

    setTheWhatsAppValidations: (state, actions) => {
      state.WhatsappValidation = actions.payload;
    },
    setTheWhatsAppValidationsTodate: (state, actions) => {
      state.WhatsappValidationTodate = actions.payload;
    },
    setTheUserIDFroCRUD: (state, actions) => {
      state.UserIDsemp = actions.payload;
    },
    settheEmployeeUdsImages: (state, actions) => {
      state.EmployeeUDSImages = actions.payload;
    },
    setSelectedUploadTab: (state, actions) => {
      state.selectedUploadTab = actions.payload;
    },
  },
});
// ------LoginSlice-------
const usersSlice = createSlice({
  name: "LoginData",
  initialState: {
    UserData: [],
    error: "",
    userdatas: null,
  },
  reducers: {
    getUserAction: (state, payload) => {
      state.error = "";
      state.UserData = [];
      state.userdatas = [];
    },
    getUserSuccessAction: (state, action) => {
      state.UserData = action.payload;
    },
    getUserdata: (state, action) => {
      state.userdatas = action.payload;
    },
    getUserErrorAction: (state, action) => {
      state.error = action.payload;
    },
  },
});
const User401ErrorSlice = createSlice({
  name: "ErrorDisplay",
  initialState: {
    SetErrorDisplay: "",
  },
  reducers: {
    SetErrorDisplayPage: (state, actions) => {
      state.SetErrorDisplay = actions.payload;
    },
  },
});
//-------------------__Forgot-Password-------------------
const ForgotPasswordSlice = createSlice({
  name: "forgotpassword",
  initialState: {
    ForgotPerson: [],
    email: [],
    error: "",
  },
  reducers: {
    getForgotPasswordPerson: (state, actions) => {
      state.ForgotPerson = [];
      state.error = "";
    },
    getForgotPasswordPerosonSuccessResponse: (state, actions) => {
      state.ForgotPerson = actions.payload;
    },
    getForgotPasswordEmail: (state, actions) => {
      state.email = actions.payload;
    },
    getForgotPasswordErrorMessage: (state, actions) => {
      state.error = actions.payload;
    },
  },
});
//----Resend---Otp
const ReSendOtpSlice = createSlice({
  name: "ResendOtp",
  initialState: {
    ResendOtp: [],
    Error: "",
  },
  reducers: {
    GetResendPerson: (state, actions) => {
      state.ResendOtp = [];
      state.Error = "";
    },
    GetRespondError: (state, actions) => {
      state.ResendOtp = actions.payload;
    },
  },
});
//-----Otp----Verify--------------------------
const OptVerifySlice = createSlice({
  name: "OtpVerifyCall",
  initialState: {
    Otp: [],
    Error: "",
  },
  reducers: {
    getOtpVerifyActions: (state, actions) => {
      state.Otp = [];
      state.Error = "";
    },
    getOtpVerifyActionsSuccessResponse: (state, actions) => {
      state.Otp = actions.payload;
    },
    getOtpVerifyErrorResponse: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});
//-----------UpdatedPasswords----------------
const UpdatePasswordSlice = createSlice({
  name: "UpdatePassword",
  initialState: {
    UpdatepPassword: [],
    Error: "",
  },
  reducers: {
    getUpdatedPasswordActions: (state, actions) => {
      state.UpdatepPassword = [];
      state.Error = "";
    },
    getUpdatedPasswordSuccessResponse: (state, actions) => {
      state.UpdatepPassword = actions.payload;
    },
    getUpdatedPassswordError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

//---Sheet Bulk Uplaod
const sheetBulkUploadSlice = createSlice({
  name: "sheetBulkUpload",
  initialState: {
    data: null,
    Error: "",
    Loading: false,
  },
  reducers: {
    SheetBulkUploadSucess: (state, action) => {
      state.data = action.payload;
      state.Loading = false;
      state.Error = null;
    },
    SheetBulkUploadError: (state, action) => {
      state.Error = action.payload;
      state.Loading = false;
    },
  },
});
//---Employee Bulk Uplaod
const employeeBulkUploadSlice = createSlice({
  name: "employeeBulkUpload",
  initialState: {
    data: null,
    Error: "",
    Loading: false,
  },
  reducers: {
    EmployeeBulkUploadSucess: (state, action) => {
      state.data = action.payload;
      state.Loading = false;
      state.Error = null;
    },
    EmployeeBulkUploadError: (state, action) => {
      state.Error = action.payload;
      state.Loading = false;
    },
  },
});
const sheetBulkUploadGetSlice = createSlice({
  name: "sheetBulkUploadGetData",
  initialState: {
    sheetBulkUploaddata: null,
    Error: "",
    totalCount: 0,
    Loading: false,
  },
  reducers: {
    GetSheetBulkUploadDataRequest: (state) => {
      state.Loading = true;
    },

    //  SUCCESS
    GetSheetBulkUploadDataSuccess: (state, action) => {
      state.sheetBulkUploaddata = action.payload.data; // store array
      state.totalCount = action.payload.total_count; //  FIXED
      state.Loading = false;
      state.Error = null;
    },

    GetSheetBulkUploadDataFail: (state, action) => {
      state.Loading = false;
      state.Error = action.payload;
    },
  },
});

// Denave State Get Api
const DenaveStateGetSlice = createSlice({
  name: "denaveStateGetData",
  initialState: {
    denaveStateData: null,
    Error: "",
    totalCount: 0,
    Loading: false,
  },
  reducers: {
    getDenaveStateDataRequest: (state) => {
      state.Loading = true;
    },

    //  SUCCESS
    getDenaveStateDataSuccess: (state, action) => {
      state.denaveStateData = action.payload.data; // store array
      state.totalCount = action.payload.total_count; //  FIXED
      state.Loading = false;
      state.Error = null;
    },

    getDenaveStateDataFail: (state, action) => {
      state.Loading = false;
      state.Error = action.payload;
    },
  },
});

// Employee Bulkupload
const employeeBulkUploadGetSlice = createSlice({
  name: "employeeBulkUploadGetData",
  initialState: {
    employeeBulkUploaddata: null,
    Error: "",
    totalCount: 0,
    Loading: false,
  },
  reducers: {
    GetEmployeeBulkUploadDataRequest: (state) => {
      state.Loading = true;
    },

    //  SUCCESS
    GetEmployeeBulkUploadDataSuccess: (state, action) => {
      state.employeeBulkUploaddata = action.payload.data; // store array
      state.totalCount = action.payload.total_count; //  FIXED
      state.Loading = false;
      state.Error = null;
    },

    GetEmployeeBulkUploadDataFail: (state, action) => {
      state.Loading = false;
      state.Error = action.payload;
    },
  },
});

//---Denave Bulk Upload New
const denaveBulkUploadNewSlice = createSlice({
  name: "denaveBulkUploadNew",
  initialState: {
    data: null,
    Error: "",
    Loading: false,
  },
  reducers: {
    DenaveBulkUploadNewSuccess: (state, action) => {
      state.data = action.payload;
      state.Loading = false;
      state.Error = null;
    },
    DenaveBulkUploadNewError: (state, action) => {
      state.Error = action.payload;
      state.Loading = false;
    },
  },
});

// Denave Bulk Upload New Get
const denaveBulkUploadNewGetSlice = createSlice({
  name: "denaveBulkUploadNewGetData",
  initialState: {
    denaveBulkUploadNewData: null,
    Error: "",
    totalCount: 0,
    Loading: false,
  },
  reducers: {
    GetDenaveBulkUploadNewDataRequest: (state) => {
      state.Loading = true;
    },

    GetDenaveBulkUploadNewDataSuccess: (state, action) => {
      state.denaveBulkUploadNewData = action.payload.data;
      state.totalCount = action.payload.total_count;
      state.Loading = false;
      state.Error = null;
    },

    GetDenaveBulkUploadNewDataFail: (state, action) => {
      state.Loading = false;
      state.Error = action.payload;
    },
  },
});

// Sony Bulk Upload
const sonyBulkUploadSlice = createSlice({
  name: "sonyBulkUpload",
  initialState: {
    data: null,
    Error: "",
    Loading: false,
  },
  reducers: {
    SonyBulkUploadSuccess: (state, action) => {
      state.data = action.payload;
      state.Loading = false;
      state.Error = null;
    },
    SonyBulkUploadError: (state, action) => {
      state.Error = action.payload;
      state.Loading = false;
    },
  },
});

// Letter Onboarding Bulk Upload
const letterOnboardingBulkUploadSlice = createSlice({
  name: "letterOnboardingBulkUpload",
  initialState: {
    data: null,
    Error: "",
    Loading: false,
  },
  reducers: {
    LetterOnboardingBulkUploadSuccess: (state, action) => {
      state.data = action.payload;
      state.Loading = false;
      state.Error = null;
    },
    LetterOnboardingBulkUploadError: (state, action) => {
      state.Error = action.payload;
      state.Loading = false;
    },
  },
});

// Letter Onboarding Employee List
const letterOnboardingEmployeeListSlice = createSlice({
  name: "letterOnboardingEmployeeList",
  initialState: {
    letterOnboardingEmployeeListData: null,
    totalCount: 0,
    Loading: false,
    Error: null,
  },
  reducers: {
    getLetterOnboardingEmployeeListRequest: (state) => {
      state.Loading = true;
    },
    getLetterOnboardingEmployeeListSuccess: (state, action) => {
      state.letterOnboardingEmployeeListData =
        action.payload?.results || action.payload?.data || action.payload;
      state.totalCount =
        action.payload?.count || action.payload?.total_count || 0;
      state.Loading = false;
      state.Error = null;
    },
    getLetterOnboardingEmployeeListFail: (state, action) => {
      state.Loading = false;
      state.Error = action.payload;
    },
  },
});

// Sony Bulk Upload Get
const sonyBulkUploadGetSlice = createSlice({
  name: "sonyBulkUploadGetData",
  initialState: {
    sonyBulkUploaddata: null,
    Error: "",
    totalCount: 0,
    Loading: false,
  },
  reducers: {
    GetSonyBulkUploadDataRequest: (state) => {
      state.Loading = true;
    },
    GetSonyBulkUploadDataSuccess: (state, action) => {
      state.sonyBulkUploaddata = action.payload.data;
      state.totalCount = action.payload.total_count;
      state.Loading = false;
      state.Error = null;
    },
    GetSonyBulkUploadDataFail: (state, action) => {
      state.Loading = false;
      state.Error = action.payload;
    },
  },
});

// HRMS Connectivity List Slice
const HrmsConnectivityListSlice = createSlice({
  name: "hrmsConnectivityList",
  initialState: {
    hrmsConnectivityListData: [],
    Error: "",
    Total_Count: "",
  },
  reducers: {
    getHrmsConnectivityListAction: (state) => {
      state.Error = "";
      state.hrmsConnectivityListData = [];
      state.Total_Count = "";
    },
    getHrmsConnectivityListResponse: (state, action) => {
      state.hrmsConnectivityListData = action.payload;
    },
    setHrmsConnectivityListTotalCount: (state, action) => {
      state.Total_Count = action.payload;
    },
    setHrmsConnectivityListError: (state, action) => {
      state.Error = action.payload;
    },
  },
});

// ID Card List Slice
const IdCardListSlice = createSlice({
  name: "idCardList",
  initialState: {
    idCardListData: [],
    Error: "",
    Total_Count: "",
    status: { value: "", label: "All" },
  },
  reducers: {
    getIdCardListAction: (state) => {
      state.Error = "";
      state.idCardListData = [];
      state.Total_Count = "";
    },
    getIdCardListResponse: (state, action) => {
      state.idCardListData = action.payload;
    },
    setIdCardListTotalCount: (state, action) => {
      state.Total_Count = action.payload;
    },
    setIdCardListError: (state, action) => {
      state.Error = action.payload;
    },
    setIdCardListStatus: (state, action) => {
      state.status = action.payload;
    },
  },
});

// HRMS Connectivity Update Slice
const HrmsConnectivityUpdateSlice = createSlice({
  name: "hrmsConnectivityUpdate",
  initialState: {
    hrmsConnectivityUpdateData: [],
    Error: "",
  },
  reducers: {
    setHrmsConnectivityUpdateAction: (state) => {
      state.Error = "";
      state.hrmsConnectivityUpdateData = [];
    },
    setHrmsConnectivityUpdateResponse: (state, action) => {
      state.hrmsConnectivityUpdateData = action.payload;
    },
    setHrmsConnectivityUpdateError: (state, action) => {
      state.Error = action.payload;
    },
  },
});

// HRMS Connectivity Status Update Slice
const HrmsConnectivityStatusUpdateSlice = createSlice({
  name: "hrmsConnectivityStatusUpdate",
  initialState: {
    hrmsConnectivityStatusUpdateData: [],
    Error: "",
  },
  reducers: {
    setHrmsConnectivityStatusUpdateAction: (state) => {
      state.Error = "";
      state.hrmsConnectivityStatusUpdateData = [];
    },
    setHrmsConnectivityStatusUpdateResponse: (state, action) => {
      state.hrmsConnectivityStatusUpdateData = action.payload;
    },
    setHrmsConnectivityStatusUpdateError: (state, action) => {
      state.Error = action.payload;
    },
  },
});

// Smart Connect Employee List Slice
const SmartConnectEmployeeListSlice = createSlice({
  name: "smartConnectEmployeeList",
  initialState: {
    smartConnectEmployeeListData: null,
    totalCount: 0,
    Loading: false,
    Error: null,
  },
  reducers: {
    getSmartConnectEmployeeListRequest: (state) => {
      state.Loading = true;
    },
    getSmartConnectEmployeeListSuccess: (state, action) => {
      state.smartConnectEmployeeListData = action.payload?.data || action.payload?.results || action.payload;
      state.totalCount = action.payload?.total_count ?? (Array.isArray(action.payload?.data) ? action.payload?.data?.length : 0);
      state.Loading = false;
      state.Error = null;
    },
    getSmartConnectEmployeeListFail: (state, action) => {
      state.Loading = false;
      state.Error = action.payload;
    },
  },
});

// Smart Connect Hiring List Slice
const SmartConnectHiringListSlice = createSlice({
  name: "smartConnectHiringList",
  initialState: {
    smartConnectHiringListData: null,
    totalCount: 0,
    Loading: false,
    Error: null,
  },
  reducers: {
    getSmartConnectHiringListRequest: (state) => {
      state.Loading = true;
    },
    getSmartConnectHiringListSuccess: (state, action) => {
      state.smartConnectHiringListData = action.payload?.data || action.payload?.results || action.payload;
      state.totalCount = action.payload?.total_count ?? (Array.isArray(action.payload?.data) ? action.payload?.data?.length : 0);
      state.Loading = false;
      state.Error = null;
    },
    getSmartConnectHiringListFail: (state, action) => {
      state.Loading = false;
      state.Error = action.payload;
    },
  },
});


// Smart Connect Bulk Upload Slice
const SmartConnectBulkUploadSlice = createSlice({
  name: "smartConnectBulkUpload",
  initialState: {
    data: null,
    Loading: false,
    Error: null,
  },
  reducers: {
    smartConnectBulkUploadRequest: (state) => {
      state.Loading = true;
    },
    smartConnectBulkUploadSuccess: (state, action) => {
      state.data = action.payload;
      state.Loading = false;
      state.Error = null;
    },
    smartConnectBulkUploadFail: (state, action) => {
      state.Loading = false;
      state.Error = action.payload;
    },
  },
});



//------Role---LIsts----
const ROleListsSlice = createSlice({
  name: "RoleLists",
  initialState: {
    RoleList: [],
    Error: "",
    Total_Count: "",
  },
  reducers: {
    getRoleListActions: (state, actions) => {
      state.RoleList = [];
      state.Error = "";
      state.Total_Count = "";
    },
    getRoleListSuccessResponseActions: (state, actions) => {
      state.RoleList = actions.payload;
    },
    getRoleListTotal_pageCounst: (state, actions) => {
      state.Total_Count = actions.payload;
    },
    getRoleListErroResponsen: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});
//--------ROleCreate-------------
const RoleCreateSlice = createSlice({
  name: "roleCreates",
  initialState: {
    Role: [],
    Error: "",
  },
  reducers: {
    getRoleCreateActions: (state, actions) => {
      state.Role = [];
      state.Error = "";
    },
    getRoleCreateSuccessActions: (state, actions) => {
      state.Role = actions.payload;
    },
    getRoleCreateErrors: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

//-------ROle-----Delete-------
const RoleDeleteSlice = createSlice({
  name: "roleDeleteCal",
  initialState: {
    RoleDelete: [],
    Error: "",
  },
  reducers: {
    SetRoleDeleteCalActions: (state, actions) => {
      state.RoleDelete = [];
      state.Error = "";
    },
    SetRoleDeleteSuccessResponseCall: (state, actions) => {
      state.RoleDelete = actions.payload;
    },
    setRoleDeleteErrorActions: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});
//------Role------Retrieve
const RoleRetrieveSlice = createSlice({
  name: "roleRrieve",
  initialState: {
    RoleRetrieve: [],
    Error: "",
  },
  reducers: {
    setRoleRetrieveActions: (state, actions) => {
      state.RoleRetrieve = [];
      state.Error = "";
    },
    setRoleRetrieveSuccessResponseCall: (state, actions) => {
      state.RoleRetrieve = actions.payload;
    },
    setRoleRetrieveErrorCall: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});
//----ROle------Edits----
const RoleEditSlice = createSlice({
  name: "RoleEditsCalls",
  initialState: {
    RoleEdit: [],
    Error: "",
  },
  reducers: {
    setRoleEditActions: (state, actions) => {
      state.RoleEdit = [];
      state.Error = "";
    },
    setRoleEditSuccessResponse: (state, actions) => {
      state.RoleEdit = actions.payload;
    },
    setRoleEditErrors: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});
//------Users------------------
const UserSlicess = createSlice({
  name: "UserSlice",
  initialState: {
    UserList: [],
    Error: "",
    Total_Count: "",
  },
  reducers: {
    setUserActions: (state, actions) => {
      state.UserList = [];
      state.Error = "";
    },
    setUserSuccessResponse: (state, actions) => {
      state.UserList = actions.payload;
    },
    setTotal_count_user: (state, actions) => {
      state.Total_Count = actions.payload;
    },
    setUserErrorsMessage: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const UserSelectedOptionsSlicess = createSlice({
  name: "UserSelectedPayloadsSlice",
  initialState: {
    UserOptionsDataList: [],
    Error: "",
    Total_Count: "",
  },
  reducers: {
    setUserOptionDatasActions: (state, actions) => {
      state.UserOptionsDataList = [];
      state.Error = "";
    },
    setUserSuccessOptionResponse: (state, actions) => {
      state.UserOptionsDataList = actions.payload;
    },
    setoptionResponseTotal_count_user: (state, actions) => {
      state.Total_Count = actions.payload;
    },
    setUserOptionResponserrorsMessage: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const UserSelectedDahboardEmployeesSlicess = createSlice({
  name: "UserSelectedDashboArdEmployeesgetdatas",
  initialState: {
    UserOptionsDashboardEmplpyee: [],
    Error: "",
    Total_Count: "",
  },
  reducers: {
    setUserOptionDashboardEmployeesActions: (state, actions) => {
      state.UserOptionsDashboardEmplpyee = [];
      state.Error = "";
    },
    setUserSuccessDashboardEmplpyeesResponse: (state, actions) => {
      state.UserOptionsDashboardEmplpyee = actions.payload;
    },
    setoptionResponseDashboardEmployeeTotal_count_user: (state, actions) => {
      state.Total_Count = actions.payload;
    },
    setUserOptionResponseDashboardEmployeerrorsMessage: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

///-------Users--Filter---based---On---the ----state-region---Zone
const UserFilterSLice = createSlice({
  name: "UserFilterCall",
  initialState: {
    UserFIlterState: [],
    Error: "",
    Total_Count: "",
  },
  reducers: {
    SettheUserFilterActions: (state, actions) => {
      state.UserFIlterState = [];
      state.Error = "";
      state.Total_Count = "";
    },
    SetUserFilterResponses: (state, actions) => {
      state.UserFIlterState = actions.payload;
    },
    setTotal_count_userfilter: (state, actions) => {
      state.Total_Count = actions.payload;
    },
    setUserErrorsMessageFilter: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});
//-----User------------Delete-------------
const UserDelteSlice = createSlice({
  name: "UserDeleteCall",
  initialState: {
    UserDelete: [],
    Error: "",
  },
  reducers: {
    setUserDeleteActions: (state, actions) => {
      state.UserDelete = [];
      state.Error = "";
    },
    setUserDeleteSuccessResponse: (state, actions) => {
      state.UserDelete = actions.payload;
    },
    setUserDeleteErrorMessage: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});
//-----User----Create-----------------
const userCreateSlice = createSlice({
  name: "userCreate",
  initialState: {
    UserSCreate: [],
    Error: "",
  },
  reducers: {
    setUserCreateActions: (state, action) => {
      state.UserSCreate = [];
      state.Error = "";
    },
    setUserCreateSuccessAction: (state, action) => {
      state.UserSCreate = action.payload;
    },
    setUserCreateError: (state, action) => {
      state.Error = action.payload;
    },
  },
});
//------UserEdits---------------
const UserEditsSlice = createSlice({
  name: "UserEdits",
  initialState: {
    UserEdits: [],
    Error: "",
  },
  reducers: {
    SetUserEditActions: (state, actions) => {
      state.UserEdits = [];
      state.Error = "";
    },
    SteUserEditSuccessResponse: (state, actions) => {
      state.UserEdits = actions.payload;
    },
    SetUserEditsErrorMessage: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});
///----------User----REtrive----------
const UserRetrieveSlice = createSlice({
  name: "UserRetrieve",
  initialState: {
    userRetrireve: [],
    Error: "",
  },
  reducers: {
    SetUserREtrieveActions: (state, actions) => {
      state.Error = "";
      state.userRetrireve = [];
    },
    SetUserRetrieveSuccessResponse: (state, actions) => {
      state.userRetrireve = actions.payload;
    },
    SetUserRetrieveError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});
//-----GEo-------Locationns
const GeoStateSlice = createSlice({
  name: "GeoState",
  initialState: {
    State: [],
    Error: "",
    Total_count: "",
  },
  reducers: {
    setGeoLoactionStateAction: (state, actions) => {
      state.State = [];
      state.Error = "";
    },
    setGeoStateSuccessResponseActions: (state, actions) => {
      state.State = actions.payload;
    },
    setGeoStateErrorMessages: (state, actions) => {
      state.Error = actions.payload;
    },
    SetGeoListTotalCount: (state, actions) => {
      state.Total_count = actions.payload;
    },
  },
});
//-----State----Create------------
const StateCreateSlice = createSlice({
  name: "stateCreate",
  initialState: {
    StateCreate: [],
    Error: "",
  },
  reducers: {
    getStateCreateActions: (state, actions) => {
      state.Error = "";
      state.StateCreate = [];
    },
    getStateCreateSuccessResponse: (state, actions) => {
      state.StateCreate = actions.payload;
    },
    getStateErroMessage: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});
///---State---Delte-------------
const StateDeleteSlice = createSlice({
  name: "StateDelete",
  initialState: {
    stateDelete: [],
    Error: "",
  },
  reducers: {
    setStateDeleteActions: (state, actions) => {
      state.stateDelete = [];
      state.Error = "";
    },
    setSatteDeleteSuccessResponse: (state, actions) => {
      state.stateDelete = actions.payload;
    },
    setStateDeleteErrorMessage: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

//------Role------Retrieve
const StateREtrieveSlice = createSlice({
  name: "StateRetrieve",
  initialState: {
    StateRetrieve: [],
    Error: "",
  },
  reducers: {
    setStateetrieveAction: (state, actions) => {
      state.StateRetrieve = [];
      state.Error = "";
    },
    setStateRetrirveSuccessActions: (state, actions) => {
      state.StateRetrieve = actions.payload;
    },
    setStateRetrieveErrorCall: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});
//----State------Edits----
const StateEditSlice = createSlice({
  name: "StateEdit",
  initialState: {
    StateEdit: [],
    Error: "",
  },
  reducers: {
    setStateEditActions: (state, actions) => {
      state.StateEdit = [];
      state.Error = "";
    },
    setStateEditSuccessResponse: (state, actions) => {
      state.StateEdit = actions.payload;
    },
    setStateEditErrors: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

//---Regions---------------
const RegionSlice = createSlice({
  name: "regioncall",
  initialState: {
    RegionDat: [],
    Error: "",
    Total_Count: "",
  },
  reducers: {
    setRegionActions: (state, actions) => {
      state.RegionDat = [];
      state.Error = "";
      state.Total_Count = "";
    },
    setRegionSuccessResponse: (state, actions) => {
      state.RegionDat = actions.payload;
    },
    setRegionTotal_counts: (state, actions) => {
      state.Total_Count = actions.payload;
    },
    setRegionsError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

////---region---Create
const RegionCreateSlice = createSlice({
  name: "regioncreate",
  initialState: {
    Regioncreate: [],
    Error: "",
  },
  reducers: {
    getRegionCreateActions: (state, actions) => {
      state.Error = "";
      state.Regioncreate = [];
    },
    getRegionCreateSuccessResponse: (state, actions) => {
      state.Regioncreate = actions.payload;
    },
    getRegionErroMessage: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

//---Region--Edits---
const regionEditSlice = createSlice({
  name: "RegionEditCalls",
  initialState: {
    RegionEdit: [],
    Error: "",
  },
  reducers: {
    setRegionEditActions: (state, actions) => {
      state.RegionEdit = [];
      state.Error = "";
    },
    setRegionEditSuccessResponse: (state, actions) => {
      state.RegionEdit = actions.payload;
    },
    setRegionEditErrors: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});
//

const RegionDelete = createSlice({
  name: "RegionDelete",
  initialState: {
    RegionDelete: [],
    Error: "",
  },
  reducers: {
    setRegionDeleteActions: (state, actions) => {
      state.RegionDelete = [];
      state.Error = "";
    },
    setRegionDeleteSuccessResponse: (state, actions) => {
      state.RegionDelete = actions.payload;
    },
    setRegionDeleteErrorMessage: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

//------Region------Retrieve
const setRegionRetrievenSlice = createSlice({
  name: "RegionRetrieve",
  initialState: {
    RegionRetrieve: [],
    Error: "",
  },
  reducers: {
    setRegionetrieveAction: (state, actions) => {
      state.RegionRetrieve = [];
      state.Error = "";
    },
    setRegionRetrirveSuccessActions: (state, actions) => {
      state.RegionRetrieve = actions.payload;
    },
    setRegionRetrieveErrorCall: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

///------------_-----ZONE
const ZoneSlice = createSlice({
  name: "ZonePart",
  initialState: {
    Zone: [],
    Error: "",
    Total_count: "",
  },
  reducers: {
    setZoneActions: (state, actions) => {
      state.Zone = [];
      state.Error = "";
    },
    setZoneSuccessResponse: (state, actions) => {
      state.Zone = actions.payload;
    },
    setZoneErrorMessages: (state, actions) => {
      state.Error = actions.payload;
    },
    SteZoneListToTal_counts: (state, actions) => {
      state.Total_count = actions.payload;
    },
  },
});

//-----Zone----Create------------
const ZoneCreateSlice = createSlice({
  name: "ZoneCreate",
  initialState: {
    ZoneCreate: [],
    Error: "",
  },
  reducers: {
    getZoneCreateActions: (state, actions) => {
      state.Error = "";
      state.ZoneCreate = [];
    },
    getZoneCreateSuccessResponse: (state, actions) => {
      state.ZoneCreate = actions.payload;
    },
    getZoneErroMessage: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});
///---ZOne---Delte-------------
const ZoneDeleteSlice = createSlice({
  name: "ZoneDelete",
  initialState: {
    ZoneDelete: [],
    Error: "",
  },
  reducers: {
    setZoneDeleteActions: (state, actions) => {
      state.ZoneDelete = [];
      state.Error = "";
    },
    setZoneDeleteSuccessResponse: (state, actions) => {
      state.ZoneDelete = actions.payload;
    },
    setZoneDeleteErrorMessage: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

//------ZONE------Retrieve
const ZoneRetrieveSlice = createSlice({
  name: "ZoneRetrieve",
  initialState: {
    ZoneRetrieve: [],
    Error: "",
  },
  reducers: {
    setZoneetrieveAction: (state, actions) => {
      state.ZoneRetrieve = [];
      state.Error = "";
    },
    setZoneRetrirveSuccessActions: (state, actions) => {
      state.ZoneRetrieve = actions.payload;
    },
    setZoneRetrieveErrorCall: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});
const ZoneEditSlice = createSlice({
  name: "ZoneEditCalls",
  initialState: {
    ZoneEdit: [],
    Error: "",
  },
  reducers: {
    setZoneEditActions: (state, actions) => {
      state.ZoneEdit = [];
      state.Error = "";
    },
    setZoneEditSuccessResponse: (state, actions) => {
      state.ZoneEdit = actions.payload;
    },
    setZoneEditErrors: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});
//---------------Client-----
const ClientSlice = createSlice({
  name: "ClientList",
  initialState: {
    ClientLists: [],
    Error: "",
    Total_Count: "",
  },
  reducers: {
    SetClientActions: (state, actions) => {
      state.ClientLists = [];
      state.Error = "";
      state.Total_Count = "";
    },
    SetClientSuccessRespoenesActions: (state, actions) => {
      state.ClientLists = actions.payload;
    },
    SetClientErrorActions: (state, actions) => {
      state.Error = actions.payload;
    },
    SetClientTotal_CountActions: (state, actions) => {
      state.Total_Count = actions.payload;
    },
  },
});

//-----CLient----Create------------
const ClientCreateSlice = createSlice({
  name: "ClientCreate",
  initialState: {
    ClientCreate: [],
    Error: "",
  },
  reducers: {
    getClientCreateActions: (state, actions) => {
      state.Error = "";
      state.ClientCreate = [];
    },

    getClientCreateSuccessResponse: (state, actions) => {
      state.ClientCreate = actions.payload;
    },
    getClientErroMessage: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});
// ///---Client---Delte-------------
const ClientDeleteSlice = createSlice({
  name: "ClientDeletes",
  initialState: {
    ClientDelete: [],
    Error: "",
  },
  reducers: {
    setCLientDeleteActions: (state, actions) => {
      state.ClientDelete = [];
      state.Error = "";
    },
    setCLientDeleteSuccessResponse: (state, actions) => {
      state.ClientDelete = actions.payload;
    },
    setClientDeleteErrorMessage: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

//------Clienet------Retrieve
const ClientRetrieveSlice = createSlice({
  name: "ClientRetrieves",
  initialState: {
    ClientRetrieve: [],
    Error: "",
  },
  reducers: {
    setCLientetrieveAction: (state, actions) => {
      state.ClientRetrieve = [];
      state.Error = "";
    },
    setClientRetrirveSuccessActions: (state, actions) => {
      state.ClientRetrieve = actions.payload;
    },
    setClientRetrieveErrorCall: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});
const ClientEditSlice = createSlice({
  name: "ClientEditCalls",
  initialState: {
    ClientEdit: [],
    Error: "",
  },
  reducers: {
    setClientEditActions: (state, actions) => {
      state.ClientEdit = [];
      state.Error = "";
    },
    setClientEditSuccessResponse: (state, actions) => {
      state.ClientEdit = actions.payload;
    },
    setClientEditErrors: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});
/////-----------------Client----Branche-----------
const ClientBranchSLice = createSlice({
  name: "ClientBranch",
  initialState: {
    ClientBranchess: [],
    Error: "",
    Total_Count: "",
  },
  reducers: {
    setClientBranchActions: (state, actions) => {
      state.ClientBranchess = [];
      state.Error = "";
    },
    setClientBranchesSuccessResponse: (state, actions) => {
      state.ClientBranchess = actions.payload;
    },
    setClientBranchessTotal_count: (state, actions) => {
      state.Total_Count = actions.payload;
    },
    setCLientBranchesErrorsMessage: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const ClienrBranchedDeleteSlice = createSlice({
  name: "ClientBranchDeleteCall",
  initialState: {
    ClientBranDelete: [],
    Error: "",
  },
  reducers: {
    setClientBranchDeleteActions: (state, actions) => {
      state.ClientBranDelete = [];
      state.Error = "";
    },
    setClientBranDeleteSuccessResponse: (state, actions) => {
      state.ClientBranDelete = actions.payload;
    },
    setClientBranDeleteErrorMessage: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});
const ClientBrancheCreateSlice = createSlice({
  name: "ClientBranchCreate",
  initialState: {
    ClientBranCreate: [],
    Error: "",
  },
  reducers: {
    setClientBranchCreateActions: (state, action) => {
      state.ClientBranCreate = [];
      state.Error = "";
    },
    setClientBranchCreateSuccessAction: (state, action) => {
      state.ClientBranCreate = action.payload;
    },
    setClientBranchCreateError: (state, action) => {
      state.Error = action.payload;
    },
  },
});

const ClientBranchesRetrieveSlice = createSlice({
  name: "BranchRetrieveDATA",
  initialState: {
    BranchesRetrieve: [],
    Error: "",
  },
  reducers: {
    setClientBranchesRetrieveActions: (state, actions) => {
      state.BranchesRetrieve = [];
      state.Error = "";
    },
    SetClientBranchesRetrieveSuccessResponse: (state, actions) => {
      state.BranchesRetrieve = actions.payload;
    },
    SetClientBranchesREtrieveErrorRetieve: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});
const BranchEditSlice = createSlice({
  name: "BranchEdits",
  initialState: {
    BranchEdit: [],
    Error: "",
  },
  reducers: {
    SetBranchEditActions: (state, actions) => {
      state.BranchEdit = [];
      state.Error = "";
    },
    SetBranchEditSuccessResponse: (state, actions) => {
      state.BranchEdit = actions.payload;
    },
    SetBranchEditsErrorMessage: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

//----Brachn---_Search-----------------
const BranchSearchSlice = createSlice({
  name: "BranchSearchpart",
  initialState: {
    BranchSearch: [],
    Error: "",
    Total_count: "",
  },
  reducers: {
    setClientBranchSearchAction: (state, actions) => {
      state.BranchSearch = [];
      state.Error = "";
      state.Total_count = "";
    },
    setClientBrancheSearchSuccesRespones: (state, actions) => {
      state.BranchSearch = actions.payload;
    },
    setClientBranchSearchEmpty: (state, actions) => {
      state.BranchSearch = actions.payload;
    },
    setClientBranchSearchErrorActions: (state, actions) => {
      state.Error = actions.payload;
    },
    setClientBrancheSearchTotal_counts: (state, actions) => {
      state.Total_count = actions.payload;
    },
  },
});

///------------Shifts-------------------
const ShiftListSlice = createSlice({
  name: "ShiftList",
  initialState: {
    ShiftLists: [],
    Error: "",
    Total_Count: "",
  },
  reducers: {
    setShiftListsActions: (state, actions) => {
      state.ShiftLists = [];
      state.Error = "";
      state.Total_Count = "";
    },
    setshiftListResponseActions: (state, actions) => {
      state.ShiftLists = actions.payload;
    },
    setShiftErrorMessages: (state, actions) => {
      state.Error = actions.payload;
    },
    SetShiftTotal_countActions: (state, actions) => {
      state.Total_Count = actions.payload;
    },
  },
});
//----Shft----Create=----
const ShiftCreateSlice = createSlice({
  name: "shiftCreate",
  initialState: {
    ShiftCreate: [],
    Error: "",
  },
  reducers: {
    setShiftCreateActions: (state, actions) => {
      state.ShiftCreate = [];
      state.Error = "";
    },
    SetShiftCreatedSuccessResponse: (state, actions) => {
      state.ShiftCreate = actions.payload;
    },
    SteShiftCreateErrorResponse: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});
////-------___Shift------with___SEARCH
const ShiftSearchSlice = createSlice({
  name: "ShiftSearch",
  initialState: {
    ShiftSearch: [],
    Error: "",
    Total_Count: "",
  },
  reducers: {
    SetShiftSearchActions: (state, actions) => {
      state.ShiftSearch = [];
      state.Error = "";
      state.Total_Count = "";
    },
    SetShiftSearchSuccessResponse: (state, actions) => {
      state.ShiftSearch = actions.payload;
    },
    SetShiftSearchError: (state, actions) => {
      state.Error = actions.payload;
    },
    SetShiftSearchTotal_Counts: (state, actions) => {
      state.Total_Count = actions.payload;
    },
  },
});
const ShiftDeleteSlice = createSlice({
  name: "ShiftDelete",
  initialState: {
    ShiftDelete: [],
    Error: "",
  },
  reducers: {
    setShiftDeletCall: (state, actions) => {
      state.ShiftDelete = [];
    },
    setShiftDeleteSuccessResponse: (state, actions) => {
      state.ShiftDelete = actions.payload;
    },
    setShiftDeleteErrorMessages: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

//----Retrieve
const ShiftRetrieveSlice = createSlice({
  name: "ShiftRetrieveData",
  initialState: {
    ShiftRetrieve: [],
    Error: "",
  },
  reducers: {
    setShiftRetrieveActions: (state, actions) => {
      state.ShiftRetrieve = [];
      state.Error = "";
    },
    SetRetrieveSuccessAction: (state, actions) => {
      state.ShiftRetrieve = actions.payload;
    },
    SetShiftRetrieveErrorActions: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});
////-----Shift___Edit
const ShiftEditSlice = createSlice({
  name: "ShiftEdits",
  initialState: {
    ShiftEdits: [],
    Error: "",
  },
  reducers: {
    SetShiftEditActions: (state, actions) => {
      state.ShiftEdits = [];
      state.Error = "";
    },
    SetShiftEditSuccessActions: (state, actions) => {
      state.ShiftEdits = actions.payload;
    },
    SetShiftEditsErrorMessages: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

///-------empolyeees
const EmployeeListSlice = createSlice({
  name: "EmployeeList",
  initialState: {
    EmployeeLists: [],
    Error: "",
    Total_Count: "",
  },
  reducers: {
    setEmployeetListsActions: (state, actions) => {
      state.EmployeeLists = [];
      state.Error = "";
      state.Total_Count = "";
    },
    setEmployeeListResponseActions: (state, actions) => {
      state.EmployeeLists = actions.payload;
    },
    setEmployeeErrorMessages: (state, actions) => {
      state.Error = actions.payload;
    },
    SetEmployeeTotal_countActions: (state, actions) => {
      state.Total_Count = actions.payload;
    },
  },
});
const EmployeeCreateSlice = createSlice({
  name: "EmployeeCreate",
  initialState: {
    EmployeeCreate: [],
    Error: "",
  },
  reducers: {
    SetEmployeeActions: (state, actions) => {
      state.EmployeeCreate = [];
      state.Error = "";
    },
    SetEmployeeSuccessResponen: (state, actions) => {
      state.EmployeeCreate = actions.payload;
    },
    SetEmployeeErrorActions: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});
///---Employee--Delete
const EmployeeDeleteSlice = createSlice({
  name: "EmployeeDelete",
  initialState: {
    EmployeeDelete: [],
    Error: "",
  },
  reducers: {
    SetEmployeeDeleteActions: (state, actions) => {
      state.EmployeeDelete = [];
      state.Error = "";
    },
    SetEmployeeDeleteSuccessResponen: (state, actions) => {
      state.EmployeeDelete = actions.payload;
    },
    SetEmployeeDeleteErrorActions: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});
///---Employeee--_EDit
const EmployeeEditSlice = createSlice({
  name: "EmployeeEditsCalls",
  initialState: {
    EmployeeEdit: [],
    Error: "",
  },
  reducers: {
    SetEmployeeEditcallActions: (state, actions) => {
      state.EmployeeEdit = [];
      state.Error = "";
    },
    SetEmployeeEditcallSuccessResponse: (state, actions) => {
      state.EmployeeEdit = actions.payload;
    },
    SetEmployeeEditcallErrorActions: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});
const SideBarDropSlice = createSlice({
  name: "SideBarDrop",
  initialState: {
    SideBarDrops: [],
  },
  reducers: {
    getSideBarDropActions: (state, actions) => {
      state.SideBarDrops = actions.payload;
    },
  },
});

const EmployeeRetrieveSlice = createSlice({
  name: "EmployeeRetrieve",
  initialState: {
    EmployeeRetrieve: [],
    Error: "",
  },
  reducers: {
    SetEmployeeRetrieveActions: (state, actions) => {
      state.EmployeeRetrieve = [];
      state.Error = "";
    },
    SetEmployeeRetrieveSuccessResponen: (state, actions) => {
      state.EmployeeRetrieve = actions.payload;
    },
    SetEmployeeRetrieverrorActions: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

//----Route--the ---Client----Id----in the----Employee create
const RouteClientIdsSlice = createSlice({
  name: "ClientBranchIDs",
  initialState: {
    ClientBranchID: "",
    EmployeeIDs: "",
    ClientEditFunctions: false,
    SingelEmployeelistes: "",
    clientBranchEditView: "",
    SetViews: false,
    NavigateCAll: [],
    role_id: "",
    EmployeeDetailsProfile: "",
    IS_pendingDetails: false,
    clientID: "",
    StatusBtn: false,
    DashboardIDs: 1,
    ShiftExcelsheetID: "",
    Exit_No_dueData: [],
    BranchObject: {},
    UserObject: {},
    userProfileId: "",
    monthANDYEA: "",
    SUBROLE: "",
    authoriedID: "",
    StateName: { value: "", label: "ALL" },
    RegionName: { value: "", label: "ALL" },
    ZoneName: { value: "", label: "ALL" },
    EmployeeListState: { value: "", label: "ALL" },
    EmployeeRegion: { value: "", label: "ALL" },
    EmployeeZone: { value: "", label: "ALL" },
    First: "1",
    Attendance_State: { value: "", label: "ALL" },
    Attendance_Region: { value: "", label: "ALL" },
    Attendacen_Zone: { value: "", label: "ALL" },

    BranchList_State: { value: "", label: "ALL" },
    BranchList_Region: { value: "", label: "ALL" },
    BranchList_Zone: { value: "", label: "ALL" },

    Employeeapprove_State: { value: "", label: "ALL" },
    Employeeapprove_Region: { value: "", label: "ALL" },
    Employeeapprove_Zone: { value: "", label: "ALL" },

    User_datas_State: { value: "", label: "ALL" },
    User_datas_Region: { value: "", label: "ALL" },
    User_datas_Zone: { value: "", label: "ALL" },
    DesignationUSER: { value: "", label: "Select" },
    EmpDesigna_Zone: { value: true, label: "UDS" },
    KYC_Data: { value: "", label: "ALL" },

    UserDatas: {
      white_collar: false,
      stateId: "",
      regionsId: "",
      zoneId: "",
      search: "",
    },
    ApproveRequest: 1,
    TicketSystem_State: { value: "", label: "ALL" },
    TicketSystem_Region: { value: "", label: "ALL" },
    TicketSystem_Zone: { value: "", label: "ALL" },
    TicketSystem_Priority: { value: "", label: "ALL" },
    TicketSystem_Status: { value: "", label: "ALL" },
    TicketSystem_Branch: { value: "", label: "ALL" },

    TicketSystem_list_State: { value: "", label: "ALL" },
    TicketSystem_List_Region: { value: "", label: "ALL" },
    TicketSystem_List_Zone: { value: "", label: "ALL" },

    TicketSystem_List_Branch: { value: "", label: "ALL" },

    InernalDashboardTicketSystem_State: { value: "", label: "ALL" },
    InernalDashboardTicketSystem_Region: { value: "", label: "ALL" },
    InernalDashboardTicketSystem_Zone: { value: "", label: "ALL" },
    InernalDashboardTicketSystem_Priority: { value: "", label: "ALL" },
    InernalDashboardTicketSystem_Status: { value: "", label: "ALL" },
    InernalDashboardTicketSystem_Branch: { value: "", label: "ALL" },

    InernallistTicketSystem_list_State: { value: "", label: "ALL" },
    InernalListTicketSystem_List_Region: { value: "", label: "ALL" },
    InernalListTicketSystem_List_Zone: { value: "", label: "ALL" },
    InernalTicketList_Priority: { value: "", label: "ALL" },
    InernalTicketSystem_ListStatus: { value: "", label: "ALL" },

    InernalListTicketSystem_List_Branch: { value: "", label: "ALL" },

    InernallistTicketSystemLoneUsers_list_State: { value: "", label: "ALL" },
    InernalListTicketSystemLoneUsers_List_Region: { value: "", label: "ALL" },
    InernalListTicketSystemLoneUsers_List_Zone: { value: "", label: "ALL" },
    InernalTicketListLoneUsers_Priority: { value: "", label: "All" },
    InernalTicketSystemLoneUsers_ListStatus: { value: "", label: "ALL" },

    InernalListTicketSystemLoneUsers_List_Branch: { value: "", label: "ALL" },

    TicketingsysteminernalusersRange1: "",

    TicketingsysteminternalusersRange2: "",

    AdvanceDashboardState: { value: "", label: "ALL" },
    AdvanceDashboardRgion: { value: "", label: "ALL" },
    AdvanceDasboardZone: { value: "", label: "ALL" },
    Client_InternSupport_selectedValues: { value: "", label: "All" },
    Client_internalSupport_TicketlistFilters: { value: "", label: "All" },
  },
  reducers: {
    gettheClient_internalsuportticketlisted: (state, actions) => {
      state.Client_internalSupport_TicketlistFilters = actions.payload;
    },
    getthe_client_InternalSupportSelected: (state, actions) => {
      state.Client_InternSupport_selectedValues = actions.payload;
    },
    gettheAdvanceDashboardStateActions: (state, actions) => {
      state.AdvanceDashboardState = actions.payload;
    },

    gettheAdvanceDashboardRegionActions: (state, actions) => {
      state.AdvanceDashboardRgion = actions.payload;
    },
    gettheAdvanceDashboardZoneActions: (state, actions) => {
      state.AdvanceDasboardZone = actions.payload;
    },

    gettheinternalUsersTicketingRangesone: (state, actions) => {
      state.TicketingsysteminernalusersRange1 = actions.payload;
    },
    gettheinternalUsersTicketingRangesTwo: (state, actions) => {
      state.TicketingsysteminternalusersRange2 = actions.payload;
    },

    gettheinernalticketlistLoneUsersState: (state, actions) => {
      state.InernallistTicketSystemLoneUsers_list_State = actions.payload;
    },
    gettheinernalTicketListLoneUserRegion: (state, actions) => {
      state.InernalListTicketSystemLoneUsers_List_Region = actions.payload;
    },

    gettheinernalTicketLOneUsersZone: (state, actions) => {
      state.InernalListTicketSystemLoneUsers_List_Zone = actions.payload;
    },

    gettheinernalTicketLoneusersPriority: (state, actions) => {
      state.InernalTicketListLoneUsers_Priority = actions.payload;
    },

    gettheinernalTicketLoneuserstatus: (state, actions) => {
      state.InernalTicketSystemLoneUsers_ListStatus = actions.payload;
    },

    gettheinernalTicketLoneusersbranch: (state, actions) => {
      state.InernalListTicketSystemLoneUsers_List_Branch = actions.payload;
    },

    gettheinernalDashboardState: (state, actions) => {
      state.InernalDashboardTicketSystem_State = actions.payload;
    },
    gettheinernalDashboardRegion: (state, actions) => {
      state.InernalDashboardTicketSystem_Region = actions.payload;
    },

    gettheinernalDashboardZone: (state, actions) => {
      state.InernalDashboardTicketSystem_Zone = actions.payload;
    },

    gettheinernalDashboardPriority: (state, actions) => {
      state.InernalDashboardTicketSystem_Priority = actions.payload;
    },

    gettheinernalDashboardStatus: (state, actions) => {
      state.InernalDashboardTicketSystem_Status = actions.payload;
    },

    gettheinernalDashboardbranch: (state, actions) => {
      state.InernalDashboardTicketSystem_Branch = actions.payload;
    },

    gettheinernalticketlistState: (state, actions) => {
      state.InernallistTicketSystem_list_State = actions.payload;
    },
    gettheinernallistRegion: (state, actions) => {
      state.InernalListTicketSystem_List_Region = actions.payload;
    },

    gettheinernalticketlistone: (state, actions) => {
      state.InernalListTicketSystem_List_Zone = actions.payload;
    },

    gettheinernalListPriority: (state, actions) => {
      state.InernalTicketList_Priority = actions.payload;
    },

    gettheinernalticketlisttatus: (state, actions) => {
      state.InernalTicketSystem_ListStatus = actions.payload;
    },

    gettheinernalticketlistbranch: (state, actions) => {
      state.InernalListTicketSystem_List_Branch = actions.payload;
    },

    getClientBranchIds: (state, actions) => {
      state.ClientBranchID = actions.payload;
    },
    getEMployeeInquriyIDS: (state, actions) => {
      state.EmployeeIDs = actions.payload;
    },
    getClientEditActions: (state, actions) => {
      state.ClientEditFunctions = actions.payload;
    },
    getSingleEmployeeActions: (state, actions) => {
      state.SingelEmployeelistes = actions.payload;
    },
    setTheBranchObject: (state, actions) => {
      state.BranchObject = actions.payload;
    },
    setTheUserObjects: (state, actions) => {
      state.UserObject = actions.payload;
    },

    getClientbranchEditView: (state, actions) => {
      state.clientBranchEditView = actions.payload;
    },
    setTheMonthandYearFilters: (state, actions) => {
      state.monthANDYEA = actions.payload;
    },
    setTheUserDatasFortheFilters: (state, actions) => {
      state.UserDatas = actions.payload;
    },
    setDetailView: (state, actions) => {
      state.SetViews = actions.payload;
    },
    SetTHeNavigateList: (state, actions) => {
      state.NavigateCAll = actions.payload;
    },
    SetRole_id: (state, actions) => {
      state.role_id = actions.payload;
    },
    SetEmployeeProfileDetailsID: (state, actions) => {
      state.EmployeeDetailsProfile = actions.payload;
    },
    SetISPendingDetails: (state, actions) => {
      state.IS_pendingDetails = actions.payload;
    },
    setID: (state, actions) => {
      state.clientID = actions.payload;
    },
    SetStatusBTN: (state, actions) => {
      state.StatusBtn = actions.payload;
    },
    SetDashboards: (state, actions) => {
      state.DashboardIDs = actions.payload;
    },
    setTheShiftExcelSheetIDS: (state, actions) => {
      state.ShiftExcelsheetID = actions.payload;
    },
    SetTheNo_due_formdata: (state, actions) => {
      state.Exit_No_dueData = actions.payload;
    },
    setTheuserprofileID: (state, actions) => {
      state.userProfileId = actions.payload;
    },
    setTheSUBROLE: (state, actions) => {
      state.SUBROLE = actions.payload;
    },
    setTheAUthoriedID: (state, actions) => {
      state.authoriedID = actions.payload;
    },
    setTheuserStateName: (state, actions) => {
      state.StateName = actions.payload;
    },
    setTheUserregionName: (state, actions) => {
      state.RegionName = actions.payload;
    },
    setTheUserZoneName: (state, actions) => {
      state.ZoneName = actions.payload;
    },

    setTheEmployeeeStateName: (state, actions) => {
      state.EmployeeListState = actions.payload;
    },
    setTheEmployeeregionName: (state, actions) => {
      state.EmployeeRegion = actions.payload;
    },
    setTheEmployeeZoneName: (state, actions) => {
      state.EmployeeZone = actions.payload;
    },
    seTheFilterfirstTime: (state, actions) => {
      state.First = actions.payload;
    },

    setTheAttendanceStateObject: (state, actions) => {
      state.Attendance_State = actions.payload;
    },
    setTheAttendanceregionObject: (state, actions) => {
      state.Attendance_Region = actions.payload;
    },
    setTheAttendanceZoneObject: (state, actions) => {
      state.Attendacen_Zone = actions.payload;
    },

    setTheBranchListStateObject: (state, actions) => {
      state.BranchList_State = actions.payload;
    },
    setTheBranchListObject: (state, actions) => {
      state.BranchList_Region = actions.payload;
    },
    setTheBranchListZONEObject: (state, actions) => {
      state.BranchList_Zone = actions.payload;
    },

    setTheApproveRequestStateObject: (state, actions) => {
      state.Employeeapprove_State = actions.payload;
    },
    setTheApproverequestRegionObject: (state, actions) => {
      state.Employeeapprove_Region = actions.payload;
    },
    setTheApproveRequestZoneObject: (state, actions) => {
      state.Employeeapprove_Zone = actions.payload;
    },

    setTheUSERDATASStateObject: (state, actions) => {
      state.User_datas_State = actions.payload;
    },
    setTheUSERDATASRegionObject: (state, actions) => {
      state.User_datas_Region = actions.payload;
    },
    setTheUSERDATASZoneObject: (state, actions) => {
      state.User_datas_Zone = actions.payload;
    },

    setTheUSERKYCVERIFIEDObject: (state, actions) => {
      state.KYC_Data = actions.payload;
    },
    setTheUSERDATADEigntionsObject: (state, actions) => {
      state.EmpDesigna_Zone = actions.payload;
    },

    setTheUserDesignationsObject: (state, actions) => {
      state.DesignationUSER = actions.payload;
    },
    setTheApproveRequeststate: (state, actions) => {
      state.ApproveRequest = actions.payload;
    },

    setTheTicketSystemStateObject: (state, actions) => {
      state.TicketSystem_State = actions.payload;
    },
    setTheTicketSystemRegionObject: (state, actions) => {
      state.TicketSystem_Region = actions.payload;
    },
    setTheTicketSystemZoneObject: (state, actions) => {
      state.TicketSystem_Zone = actions.payload;
    },

    setTheTicketSystemPriorityObject: (state, actions) => {
      state.TicketSystem_Priority = actions.payload;
    },
    setTheTicketSystemStatusObject: (state, actions) => {
      state.TicketSystem_Status = actions.payload;
    },
    setTheTicketSystemBranchObject: (state, actions) => {
      state.TicketSystem_Branch = actions.payload;
    },

    setTheTicketSystemListStateObject: (state, actions) => {
      state.TicketSystem_list_State = actions.payload;
    },
    setTheTicketSystemlistRegionObject: (state, actions) => {
      state.TicketSystem_List_Region = actions.payload;
    },
    setTheTicketSystemlistZoneObject: (state, actions) => {
      state.TicketSystem_List_Zone = actions.payload;
    },
    setTheTicketSystemlistBranchObject: (state, actions) => {
      state.TicketSystem_List_Branch = actions.payload;
    },
  },
});
const DropDownOptionNumbersSlice = createSlice({
  name: "NumberCounts",
  initialState: {
    Option1: "1",
    Option2: "2",
    Option3: "3",
    Option4: "4",
    Option5: "5",
    namerednder: "",
    CountBasedValues: "1",
    Options: {},
    AllEmpoyeeListCOunts: 1,
    Editable: 1,
    Rolechanges: 1,
    EmployeeRoleId: "",
    JobinformationID: "",

    branchId: "",
    // BranchObject: {},
    BranchObject: { value: "", label: "Select" },
    BranchObjectFieldAgent: { value: "", label: "Select" },
    selectedOnoardClient: null,

    RoleOjects: { value: "", label: "Select" },
    BranchObjectJobInfoFieldAgent: { value: "", label: "Select" },

    grossSalaryAmount: 1000,
    WbsElements: "",
    grossSalary: "",
    RemoveFIlterRole: 1,
    AllFormPDF: false,
    ZONEobjects: {},
    FirstName: "", /// get the Name for verify the Bank form (Ac Name anc the Aadhar fetched name)
    BankNameVerification: false,
    EmployeeFormFIll: false,
    SelectedValuesemplist: {
      is_pending: "",
      is_decline: "",
      approved: "",
    },
    employeeliststatus: { value: "1", label: "All" },
    Client_list_from_role: { value: "", label: "All" },
    Store_filter_monthand_yeas: { month: "", year: "" },
    StoreUser_list_filter_monthand_yeas: { month: "", year: "" },
    Store_for_payslplist_filter_monthand_year: { month: "", year: "" },
  },
  reducers: {
    settheDate_and_monthfilter_payslip: (state, actions) => {
      state.Store_for_payslplist_filter_monthand_year = actions.payload;
    },
    settheStore_filter_monthand_yeas: (state, actions) => {
      state.Store_filter_monthand_yeas = actions.payload;
    },
    settheUsersStore_filter_monthand_yeas: (state, actions) => {
      state.StoreUser_list_filter_monthand_yeas = actions.payload;
    },

    SettheAllOptions: (state, actions) => {
      state.Option1 = actions.payload;
    },
    settheSelectedValuesemplist: (state, actions) => {
      state.SelectedValuesemplist = actions.payload;
    },
    settheSelectedemployeeliststatust: (state, actions) => {
      state.employeeliststatus = actions.payload;
    },
    SettheCompletedOptions: (state, actions) => {
      state.Option2 = actions.payload;
    },
    SetthePendingOptions: (state, actions) => {
      state.Option3 = actions.payload;
    },
    SettheDeclineOptions: (state, actions) => {
      state.Option4 = actions.payload;
    },
    SettheApproveOptions: (state, actions) => {
      state.Option5 = actions.payload;
    },
    setDropDownRenders: (state, actions) => {
      state.namerednder = actions.payload;
    },
    setThecountBasedRenders: (state, actions) => {
      state.CountBasedValues = actions.payload;
    },
    setTheoptions: (state, actions) => {
      state.Options = actions.payload;
    },
    setAllemployeeListCounts: (state, actions) => {
      state.AllEmpoyeeListCOunts = actions.payload;
    },
    setEditableActions: (state, actions) => {
      state.Editable = actions.payload;
    },
    settheEmployeeFormFilled: (state, actions) => {
      state.EmployeeFormFIll = actions.payload;
    },
    setaRoleChnage: (state, actions) => {
      state.Rolechanges = actions.payload;
    },
    setTheemployeeRoleId: (state, actions) => {
      state.EmployeeRoleId = actions.payload;
    },

    SettheBracnhId: (state, actions) => {
      state.branchId = actions.payload;
    },
    setTheBranchoptions: (state, actions) => {
      state.BranchObject = actions.payload;
    },
    setTheBranchoptionsFieldAgent: (state, actions) => {
      state.BranchObjectFieldAgent = actions.payload;
    },
    setSelectedOnboardClient: (state, actions) => {
      state.selectedOnoardClient = actions.payload;
    },
    settheJobinfoBranchEmployeeProfile: (state, actions) => {
      state.BranchObjectJobInfoFieldAgent = actions.payload;
    },

    setTheWbsElements: (state, actions) => {
      state.WbsElements = actions.payload;
    },
    setTheGrossSalary: (state, actions) => {
      state.grossSalary = actions.payload;
    },
    setTheRoleObjects: (state, actions) => {
      state.RoleOjects = actions.payload;
    },
    setTheGrossSalarayAmount: (state, actions) => {
      state.grossSalaryAmount = actions.payload;
    },
    setTheRoleRemoveFilters: (state, actions) => {
      state.RemoveFIlterRole = actions.payload;
    },
    setTheAllFormPdf: (state, actions) => {
      state.AllFormPDF = actions.payload;
    },
    setTheZoneObjectinEmployeeList: (state, actions) => {
      state.ZONEobjects = actions.payload;
    },
    setTheFirstNames: (state, actions) => {
      state.FirstName = actions.payload;
    },
    setTheBankNameVerification: (state, actions) => {
      state.BankNameVerification = actions.payload;
    },
    setthejobinformationroleID: (state, actions) => {
      state.JobinformationID = actions.payload;
    },
    setClient_options_inRole_list: (state, actions) => {
      state.Client_list_from_role = actions.payload;
    },
  },
});
////-------------Employee----Verifiycations
const EmployeeVerificationsNeededDatasSlice = createSlice({
  name: "EmployeeVerificationsNeed",
  initialState: {
    BranchName: "",
    Zone: "",
    EmployeeRequst: "",
    FROMDATE: "",
    TODATE: "",

    ONboardFROMDATE: "",
    ONboardTODATE: "",
    AttendanceFROMDATE: "",
    AttendanceTODATE: "",

    employeelistFROMDATE: "",
    employeelistTODATE: "",

    AttendanceDashboardStatus: "",
    OnborderPhoneNumber: "",
    WhiteCollar: false,
    SetTheWhiteObjects: {
      value: "",
      label: "ALL",
    },
    StateObjects: {
      value: "",
      label: "ALL",
    },
    RegionObjects: {
      value: "",
      label: "ALL",
    },
    ZoneObjects: {
      value: "",
      label: "ALL",
    },
    BranchObjects: {
      value: "",
      label: "ALL",
    },
    reportrange1: "",
    reportRange2: "",

    EmployeeRangeOne: "",
    EmployeeRangeTwo: "",

    EmployeeActionsState: {
      value: "",
      label: "ALL",
    },
    EmployeeActionRegion: {
      value: "",
      label: "ALL",
    },
    EmployeeActionZone: {
      value: "",
      label: "ALL",
    },

    EmployeeAction_Branch: {
      value: "",
      label: "ALL",
    },
    OverAllReportDatas: [],
    API_TYPE: "",
    API_type_ID: "",
    Attendance_dashboard_client_listed: { value: "", label: "ALL" },

    ////approve requested----
    ApproveRequestEmployeelist_State: { value: "", label: "ALL" },
    ApproveRequestEmployeelist_Region: { value: "", label: "ALL" },
    ApproveRequestEmployeelist_Zone: { value: "", label: "ALL" },
    ApproveRequestEmployeelist_Client: { value: "", label: "ALL" },

    ApproveRequestEmployeelist_Organizations: { value: "", label: "ALL" },

    ApproveRequestEmployeelist_From_Date: "",
    ApproveRequestEmployeelist_To_date: "",
    ApproveRequestEmployeelist_FilterOptions: { value: "", label: "All" },

    FROMDATE_AdvanceDashboard: "",
    TODATE_advanceDashboard: "",

    AdvanceAttendance_State: { value: "", label: "ALL" },
    AdvanceAttendance_Region: { value: "", label: "ALL" },
    AdvancaAttendances_Zone: { value: "", label: "ALL" },

    FromDateTOAdvanceAttendancer: "",
    ToDateTOAdvanceAttendancer: "",
    advance_attendanceloader: false,
    RmOnboarderdatas: false,
    Internal_dashboard_Bool: false,
    advance_attendanceloader_summary: false,
    Requested_employee_list_filters: { value: "", label: "" },
    Employee_actions_Employee_filter_old_new: {
      label: "NEW EMPLOYEE",
      value: false,
      Advance_attendance_dashboard_employee_Designations: {
        value: "",
        label: "ALL",
      },
    },
  },

  reducers: {
    setthe_Advance_attendance_dashboard_employee_Designations: (
      state,
      actions,
    ) => {
      state.Advance_attendance_dashboard_employee_Designations =
        actions.payload;
    },
    settheinternalDashboardloadBool: (state, actions) => {
      state.Internal_dashboard_Bool = actions.payload;
    },
    settheadvance_attendanceloader: (state, actions) => {
      state.advance_attendanceloader = actions.payload;
    },
    settheadvance_attendanceloader_summary: (state, actions) => {
      state.advance_attendanceloader_summary = actions.payload;
    },
    setadvanceAttendanceDashboard_state: (state, actions) => {
      state.AdvanceAttendance_State = actions.payload;
    },
    setadvanceAttendanceDashboard_Region: (state, actions) => {
      state.AdvanceAttendance_Region = actions.payload;
    },

    setadvanceAttendanceDashboard_Zone: (state, actions) => {
      state.AdvancaAttendances_Zone = actions.payload;
    },

    setadvanceAttendanceDashboard_FromDate: (state, actions) => {
      state.FromDateTOAdvanceAttendancer = actions.payload;
    },
    setadvanceAttendanceDashboard_TODate: (state, actions) => {
      state.ToDateTOAdvanceAttendancer = actions.payload;
    },

    settheFromDateForAdvanceDashboard: (state, actions) => {
      state.FROMDATE_AdvanceDashboard = actions.payload;
    },
    settheToateForAdvanceDashboard: (state, actions) => {
      state.TODATE_advanceDashboard = actions.payload;
    },
    getEmployeeBranchName: (state, actions) => {
      state.BranchName = actions.payload;
    },
    getEmployeeBranchZones: (state, actions) => {
      state.Zone = actions.payload;
    },
    getEmployeeEReuestlist: (state, actions) => {
      state.EmployeeRequst = actions.payload;
    },
    setTheFROMDATELIST: (state, actions) => {
      state.FROMDATE = actions.payload;
    },
    setTheTODATELISTINDASH: (state, actions) => {
      state.TODATE = actions.payload;
    },

    setTheOnboardFromDateLIST: (state, actions) => {
      state.ONboardFROMDATE = actions.payload;
    },
    setOnboardTODtaeDASH: (state, actions) => {
      state.ONboardTODATE = actions.payload;
    },

    setTheAttendanceDateLIST: (state, actions) => {
      state.AttendanceFROMDATE = actions.payload;
    },
    setAttendacenDASHTodate: (state, actions) => {
      state.AttendanceTODATE = actions.payload;
    },

    setTheEmployeeLISTfromdate: (state, actions) => {
      state.employeelistFROMDATE = actions.payload;
    },
    setEmployeeLstTodate: (state, actions) => {
      state.employeelistTODATE = actions.payload;
    },
    setTheReportRange1: (state, actions) => {
      state.reportrange1 = actions.payload;
    },
    settheReportRange2: (state, actions) => {
      state.reportRange2 = actions.payload;
    },

    setTheAttendanceDhasboardStatus: (state, actions) => {
      state.AttendanceDashboardStatus = actions.payload;
    },
    setTheOnboardPhoneNumber: (state, actions) => {
      state.OnborderPhoneNumber = actions.payload;
    },
    seTheWhiteCollor: (state, actions) => {
      state.WhiteCollar = actions.payload;
    },
    seTheWhiteCollar_objects: (state, actions) => {
      state.SetTheWhiteObjects = actions.payload;
    },
    settheStateObjects: (state, actions) => {
      state.StateObjects = actions.payload;
    },
    setTheregionsObjects: (state, actions) => {
      state.RegionObjects = actions.payload;
    },
    setTheZoneObjects: (state, actions) => {
      state.ZoneObjects = actions.payload;
    },
    setTheBranchFilters: (state, actions) => {
      state.BranchObjects = actions.payload;
    },
    setTheEmployeeRangeOne: (state, actions) => {
      state.EmployeeRangeOne = actions.payload;
    },
    setTheEmployeeRangetwo: (state, actions) => {
      state.EmployeeRangeTwo = actions.payload;
    },

    settheEmployeeActionState: (state, actions) => {
      state.EmployeeActionsState = actions.payload;
    },
    settheEmployeeActionRegion: (state, actions) => {
      state.EmployeeActionRegion = actions.payload;
    },
    settheEmployeeActionZone: (state, actions) => {
      state.EmployeeActionZone = actions.payload;
    },
    setTheEmpoyeeAction_branch: (state, actions) => {
      state.EmployeeAction_Branch = actions.payload;
    },

    setTheOverallReportTableDatas: (state, actions) => {
      state.OverAllReportDatas = actions.payload;
    },
    settheAPI_Key_type: (state, actions) => {
      state.API_TYPE = actions.payload;
    },
    setTheAPI_type_IDS: (state, actions) => {
      state.API_type_ID = actions.payload;
    },

    settheApproveRequestEmployeelist_State: (state, actions) => {
      state.ApproveRequestEmployeelist_State = actions.payload;
    },

    settheApproveRequestEmployeelist_Region: (state, actions) => {
      state.ApproveRequestEmployeelist_Region = actions.payload;
    },
    settheApproveRequestEmployeelist_Zone: (state, actions) => {
      state.ApproveRequestEmployeelist_Zone = actions.payload;
    },
    settheApproveRequestEmployeelist_Organizations: (state, actions) => {
      state.ApproveRequestEmployeelist_Organizations = actions.payload;
    },
    settheApproveRequestEmployeelist_Client: (state, actions) => {
      state.ApproveRequestEmployeelist_Client = actions.payload;
    },

    settheApproveRequestEmployeelist_From_Date: (state, actions) => {
      state.ApproveRequestEmployeelist_From_Date = actions.payload;
    },

    settheApproveRequestEmployeelist_To_date: (state, actions) => {
      state.ApproveRequestEmployeelist_To_date = actions.payload;
    },
    settheApproveRequestEmployeelist_FilterOptions: (state, actions) => {
      state.ApproveRequestEmployeelist_FilterOptions = actions.payload;
    },
    setRmOnboarderdatas: (state, actions) => {
      state.RmOnboarderdatas = actions.payload;
    },
    setthe_requested_employee_list_filters: (state, actions) => {
      state.Requested_employee_list_filters = actions.payload;
    },
    setthe_attendance_client_filter_dashboard: (state, actions) => {
      state.Attendance_dashboard_client_listed = actions.payload;
    },

    setthe_employeee_actions_forEmployee_filter: (state, actions) => {
      state.Employee_actions_Employee_filter_old_new = actions.payload;
    },
    settheSonyEmployeeActionState: (state, actions) => {
      state.SonyEmployeeActionsState = actions.payload;
    },
    settheSonyEmployeeActionRegion: (state, actions) => {
      state.SonyEmployeeActionRegion = actions.payload;
    },
    settheSonyEmployeeActionZone: (state, actions) => {
      state.SonyEmployeeActionZone = actions.payload;
    },
    setTheSonyEmpoyeeAction_branch: (state, actions) => {
      state.SonyEmployeeAction_Branch = actions.payload;
    },
    setthe_sony_requested_employee_list_filters: (state, actions) => {
      state.Sony_requested_employee_list_filters = actions.payload;
    },
    setthe_sony_employeee_actions_forEmployee_filter: (state, actions) => {
      state.Sony_employee_actions_forEmployee_filter_old_new = actions.payload;
    },
    setthe_sony_employeee_letter_type_filter: (state, actions) => {
      state.Sony_employee_letter_type_filter = actions.payload;
    },
  },
});
////-----SignaturePad-------------------------------
const SignaturePadSlice = createSlice({
  name: "signaturepad",
  initialState: {
    SignaturePopups: false,
    ImageUrlSign: "",
    fileName: "",
    setUserSignError: "",
    setCountingNum: "",
    setSignEdits: false,
    originFile: "",
    ChangesURl: 1,
    SignaturePadNumbers: 0,
    PresentURL: "",
    PresentFullURL: [],
    PresentUrlsSended: false,
  },
  reducers: {
    SetSignaturePops: (state, actions) => {
      state.SignaturePopups = actions.payload;
    },
    SetTheSignatureImgaUrl: (state, actions) => {
      state.ImageUrlSign = actions.payload;
    },
    setTheSingatureFilename: (state, actions) => {
      state.fileName = actions.payload;
    },
    SetTheSetUserSignError: (state, actions) => {
      state.setUserSignError = actions.payload;
    },
    SetTheCountNumbersNam: (state, actions) => {
      state.setCountingNum = actions.payload;
    },
    SetTheEditFunction: (state, actions) => {
      state.setSignEdits = actions.payload;
    },
    Files: (state, actions) => {
      state.originFile = actions.payload;
    },

    SetChangedUrl: (state, actions) => {
      state.ChangesURl = actions.payload;
    },
    setTheSignaturePadNumberSet: (state, actions) => {
      state.SignaturePadNumbers = actions.payload;
    },
    setThepresentUrlOfSignature: (state, actions) => {
      state.PresentURL = actions.payload;
    },
    settheFullPresentUrl: (state, actions) => {
      state.PresentFullURL = actions.payload;
    },
    setThePresentUrlsSended: (state, actions) => {
      state.PresentUrlsSended = actions.payload;
    },
  },
});

//-----Employee-------List------
const EMployeeListSlice = createSlice({
  name: "EmployeeDATASList",
  initialState: {
    EmployeeListDatas: [],
    Error: "",
    Total_Count: "",
  },
  reducers: {
    setEmployeeListsDATASActions: (state, actions) => {
      state.EmployeeListDatas = [];
      state.Error = "";
      state.Total_Count = "";
    },
    setEmployeeListDATASResponseActions: (state, actions) => {
      state.EmployeeListDatas = actions.payload;
    },
    setEmployeeDataErrorMessages: (state, actions) => {
      state.Error = actions.payload;
    },
    SetEmployeeDataTotal_countActions: (state, actions) => {
      state.Total_Count = actions.payload;
    },
  },
});

///------Employee---ProfileDetails
const EMployeeProfileSlice = createSlice({
  name: "EmployeeProfile",
  initialState: {
    EmployeeProfileList: [],
    Error: "",
    Total_Count: "",
  },
  reducers: {
    setEmployeeProfileDATASActions: (state, actions) => {
      state.EmployeeProfileList = [];
      state.Error = "";
      state.Total_Count = "";
    },
    setEmployeeListProfileSResponseActions: (state, actions) => {
      state.EmployeeProfileList = actions.payload;
    },
    setEmployeeDataprofileErrorMessages: (state, actions) => {
      state.Error = actions.payload;
    },
    SetEmployeeDataprofileTotal_countActions: (state, actions) => {
      state.Total_Count = actions.payload;
    },
  },
});

///=----Employeee----------Persons---Lists
const EmployeePersonListSlice = createSlice({
  name: "EmployeeListPresons",
  initialState: {
    EmployeePersons: [],
    Inquriy: [],
    Error: "",
    Total_Count: "",
  },
  reducers: {
    getEmployeeListPersonsListed: (state, actions) => {
      state.EmployeePersons = [];
      state.Error = "";
      state.Total_Count = "";
      state.Inquriy = [];
    },
    setEmployeeListSPersonsResponseActions: (state, actions) => {
      state.EmployeePersons = actions.payload;
    },
    SetTheInquriyStatus: (state, actions) => {
      state.Inquriy = actions.payload;
    },
    setEmployeeDataPersonsErrorMessages: (state, actions) => {
      state.Error = actions.payload;
    },
    SetEmployeeDataTotal_countPersonsActions: (state, actions) => {
      state.Total_Count = actions.payload;
    },
  },
});

const ApproveRequestListSlice = createSlice({
  name: "ApproverequestDatass",
  initialState: {
    ApproveRequestDatas: [],
    Inquriy: [],
    Error: "",
    Total_Count: "",
  },
  reducers: {
    getApproveRequestActionListed: (state, actions) => {
      state.ApproveRequestDatas = [];
      state.Error = "";
      state.Total_Count = "";
      state.Inquriy = [];
    },
    setApproveRequestPersonsResponseActions: (state, actions) => {
      state.ApproveRequestDatas = actions.payload;
    },
    SetTheApproveRequestInquriyStatus: (state, actions) => {
      state.Inquriy = actions.payload;
    },
    setApproveRequestPersonsErrorMessages: (state, actions) => {
      state.Error = actions.payload;
    },
    SetApproveRequestTotal_countPersonsActions: (state, actions) => {
      state.Total_Count = actions.payload;
    },
  },
});

///=----Employeee--------FOR---The---_Filter--Persons---Lists
const EmployeePersonFilterListSlice = createSlice({
  name: "EmployeeListfilterPresons",
  initialState: {
    EmployeePersonsFIlter: [],
    Error: "",
    Total_Count: "",
    InquriyFilter: [],
  },
  reducers: {
    getEmployeeListFilterPersonsListed: (state, actions) => {
      state.EmployeePersonsFIlter = [];
      state.Error = "";
      state.Total_Count = "";
      state.InquriyFilter = [];
    },
    setEmployeeListSPersonsFilterResponseActions: (state, actions) => {
      state.EmployeePersonsFIlter = actions.payload;
    },
    SetTheInquriyStatusFilter: (state, actions) => {
      state.InquriyFilter = actions.payload;
    },
    setEmployeeDataPersonsFilterErrorMessages: (state, actions) => {
      state.Error = actions.payload;
    },
    SetEmployeeDataTotal_countPersonsFilterActions: (state, actions) => {
      state.Total_Count = actions.payload;
    },
  },
});

///=----Leave Status----------Persons---Lists
const LeaveStatusListSLice = createSlice({
  name: "LeaveStatusListed",
  initialState: {
    LeaveStatusLis: [],
    Inquriy: [],
    Error: "",
    Total_Count: "",
  },
  reducers: {
    getLeaveStatusPersonsListed: (state, actions) => {
      state.LeaveStatusLis = [];
      state.Error = "";
      state.Total_Count = "";
      state.Inquriy = [];
    },
    setLeaveStatusLisPersonsResponseActions: (state, actions) => {
      state.LeaveStatusLis = actions.payload;
    },
    SetTheInquriyLeaveStatus: (state, actions) => {
      state.Inquriy = actions.payload;
    },
    setLeaveStatusLisDataPersonsErrorMessages: (state, actions) => {
      state.Error = actions.payload;
    },
    SetLeaveStatusLisDataTotal_countPersonsActions: (state, actions) => {
      state.Total_Count = actions.payload;
    },
  },
});

////----Total---Forms-----------------------
const ToatalFormsDetails = createSlice({
  name: "totalDetailsforms",
  initialState: {
    TotalformList: [],
    Error: "",
  },
  reducers: {
    setTotalFormDetailList: (state, actions) => {
      state.TotalformList = [];
      state.Error = "";
    },
    setTotalFormDetailsActions: (state, actions) => {
      state.TotalformList = actions.payload;
    },
    setToatalFormDetailError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

//////----------------BASIC-----Forms----------------------
const FormsSlice = createSlice({
  name: "FormsSDETAILS",
  initialState: {
    BasciForm: [],
    BasicERROR: "",
  },
  reducers: {
    SetActionsBasicFormsDetails: (state, actions) => {
      state.BasciForm = [];
      state.BasicERROR = "";
    },
    SETBASICFORMdetails: (state, actions) => {
      state.BasciForm = actions.payload;
    },
    SETBasicFOrmError: (state, actions) => {
      state.BasicERROR = actions.payload;
    },
  },
});

const BasicFormCreateSlice = createSlice({
  name: "BasicFormCreated",
  initialState: {
    BasciFormCreate: [],
    BasicERROR: "",
    user_ID: "",
    BacicDatas: {},
  },
  reducers: {
    SetActionsBasicFormscreateDetails: (state, actions) => {
      state.BasciFormCreate = [];
      state.BasicERROR = "";
    },
    SETBASICFORMcreatedetails: (state, actions) => {
      state.BasciFormCreate = actions.payload;
    },
    SETBasicFOrmcreateError: (state, actions) => {
      state.BasicERROR = actions.payload;
    },
    setTheUser_ID: (state, actions) => {
      state.user_ID = actions.payload;
    },
    setTheBacisHoldDatas: (state, actions) => {
      state.BacicDatas = actions.payload;
    },
  },
});

////-----Basic--from---Edits--Slice---

const BasicFormEditSlice = createSlice({
  name: "BasicFormEdit",
  initialState: {
    BasciFormEdit: [],
    BasicERROR: "",
  },
  reducers: {
    SetActionsBasicFormsEditDetails: (state, actions) => {
      state.BasciFormEdit = [];
      state.BasicERROR = "";
    },
    SETBASICFORMEDITdetails: (state, actions) => {
      state.BasciFormEdit = actions.payload;
    },
    SETBasicFOrmEditError: (state, actions) => {
      state.BasicERROR = actions.payload;
    },
  },
});

//////----------------BASIC-----Forms---------------------
const AddressFormSlice = createSlice({
  name: "AddressForms",
  initialState: {
    AddressForm: [],
    AddressError: "",
  },
  reducers: {
    SetAddressForm: (state, actions) => {
      state.AddressForm = [];
      state.AddressError = "";
    },
    SetAddressFormAction: (state, actions) => {
      state.AddressForm = actions.payload;
    },
    SetAddressFormError: (state, actions) => {
      state.AddressError = actions.payload;
    },
  },
});

//////----------------Address--Create-----Forms---------------------
const AddressCreateSlice = createSlice({
  name: "AddressCraeteForms",
  initialState: {
    AddressCreateForm: [],
    AddressError: "",
  },
  reducers: {
    SetAddressCreateForm: (state, actions) => {
      state.AddressCreateForm = [];
      state.AddressError = "";
    },
    SetAddressFormcreateAction: (state, actions) => {
      state.AddressCreateForm = actions.payload;
    },
    SetAddressFormcreateError: (state, actions) => {
      state.AddressError = actions.payload;
    },
  },
});

//////----------------Address--Edit-----Forms---------------------
const AddressEditSlice = createSlice({
  name: "AddressEditorms",
  initialState: {
    AddressEditForm: [],
    AddressError: "",
  },
  reducers: {
    SetAddressEditForm: (state, actions) => {
      state.AddressEditForm = [];
      state.AddressError = "";
    },
    SetAddressFormEDitAction: (state, actions) => {
      state.AddressEditForm = actions.payload;
    },
    SetAddressFormEditError: (state, actions) => {
      state.AddressError = actions.payload;
    },
  },
});

///----------------ID---Verifications-----------------------

const IDverificationSlice = createSlice({
  name: "IdverificationName",
  initialState: {
    IdVerifycationData: [],
    IdverifyError: "",
  },
  reducers: {
    setIdVerificationActions: (state, actions) => {
      state.IdVerifycationData = [];
      state.IdverifyError = "";
    },
    SetIdVerificationFormAction: (state, actions) => {
      state.IdVerifycationData = actions.payload;
    },
    SetIdverificationFormError: (state, actions) => {
      state.IdverifyError = actions.payload;
    },
  },
});

///----------------ID---Verifications----Create-------------------

const IDverificationCreateSlice = createSlice({
  name: "IdverificationNameCreate",
  initialState: {
    IdVerifycationDatacreate: [],
    IdverifyError: "",
  },
  reducers: {
    setIdVerificationActionsCreate: (state, actions) => {
      state.IdVerifycationDatacreate = [];
      state.IdverifyError = "";
    },
    SetIdVerificationFormcreateAction: (state, actions) => {
      state.IdVerifycationDatacreate = actions.payload;
    },
    SetIdverificationFormcreateError: (state, actions) => {
      state.IdverifyError = actions.payload;
    },
  },
});
///--_From---Edit---

const IDverificationEditSlice = createSlice({
  name: "IdverificationNameEdit",
  initialState: {
    IdVerifycationDataEdit: [],
    IdverifyError: "",
  },
  reducers: {
    setIdVerificationActionsEdit: (state, actions) => {
      state.IdVerifycationDataEdit = [];
      state.IdverifyError = "";
    },
    SetIdVerificationFormEditAction: (state, actions) => {
      state.IdVerifycationDataEdit = actions.payload;
    },
    SetIdverificationFormEditError: (state, actions) => {
      state.IdverifyError = actions.payload;
    },
  },
});

//---ID---Verification----Edit----call

const IdverificationeditSlice = createSlice({
  name: "IdVrificationEditCall",
  initialState: {
    EditIdVerifidata: [],
    Error: "",
  },
  reducers: {
    SetTheIdVerifycationActions: (state, actions) => {
      state.EditIdVerifidata = [];
      state.Error = "";
    },
    SetTheIDverifycationEditResponse: (state, actions) => {
      state.EditIdVerifidata = actions.payload;
    },
    SetIdverificationEditError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

///----------------Bank Details--------------------------

const BankDetailsSlice = createSlice({
  name: "BankDetails",
  initialState: {
    Bankdata: [],
    BankDataError: "",
  },
  reducers: {
    setBankDataActions: (state, actions) => {
      state.Bankdata = [];
      state.BankDataError = "";
    },
    SetBankDataResponeActions: (state, actions) => {
      state.Bankdata = actions.payload;
    },
    setBankDataError: (state, actions) => {
      state.BankDataError = actions.payload;
    },
  },
});

///----------------EDUCATION Details-----------------------

const EducationSlice = createSlice({
  name: "EducationAction",
  initialState: {
    EducationData: [],
    EducationDataError: "",
  },
  reducers: {
    setEducationDataActions: (state, actions) => {
      state.EducationData = [];
      state.EducationDataError = "";
    },
    SetEducationDataResponeActions: (state, actions) => {
      state.EducationData = actions.payload;
    },
    setEducationDataError: (state, actions) => {
      state.EducationDataError = actions.payload;
    },
  },
});

////--------------Education--Put slice---------------------
const EducationPutSlice = createSlice({
  name: "EducationPutCall",
  initialState: {
    EducationPutData: [],
    EducationPutDataError: "",
  },
  reducers: {
    setEducationDataPutActions: (state, actions) => {
      state.EducationPutData = [];
      state.EducationPutDataError = "";
    },
    SetEducationDataPutResponeActions: (state, actions) => {
      state.EducationPutData = actions.payload;
    },
    setEducationDataPutError: (state, actions) => {
      state.EducationPutDataError = actions.payload;
    },
  },
});

///----------------Previous Employee Details-----------------------

const PreviousEmployeeSlice = createSlice({
  name: "PreviousEmp",
  initialState: {
    PreviousEmpData: [],
    PreviousEmpError: "",
  },
  reducers: {
    setPreviousEmpDataActions: (state, actions) => {
      state.PreviousEmpData = [];
      state.PreviousEmpError = "";
    },
    SetPreviuousEmpDataResponeActions: (state, actions) => {
      state.PreviousEmpData = actions.payload;
    },
    setPreviousDataError: (state, actions) => {
      state.PreviousEmpError = actions.payload;
    },
  },
});

///----------------Previous Employee Details--Craete---------------------

const PreviousEmployeeCreateSlice = createSlice({
  name: "PreviousCreateEmp",
  initialState: {
    PreviousEmpCreateData: [],
    PreviousEmpCreaateError: "",
  },
  reducers: {
    setPreviousEmpDataCreateActions: (state, actions) => {
      state.PreviousEmpCreateData = [];
      state.PreviousEmpCreaateError = "";
    },
    SetPreviuousEmpDataCreateResponeActions: (state, actions) => {
      state.PreviousEmpCreateData = actions.payload;
    },
    setPreviousDataCreateError: (state, actions) => {
      state.PreviousEmpCreaateError = actions.payload;
    },
  },
});

///----------------Previous Employee Details--Edit---------------------

const PreviousEmployeeEditSlice = createSlice({
  name: "PreviousEditEmp",
  initialState: {
    PreviousEmpEDITData: [],
    PreviousEmpEDITeError: "",
  },
  reducers: {
    setPreviousEmpDataeditActions: (state, actions) => {
      state.PreviousEmpEDITData = [];
      state.PreviousEmpEDITeError = "";
    },
    SetPreviuousEmpDataEditResponeActions: (state, actions) => {
      state.PreviousEmpEDITData = actions.payload;
    },
    setPreviousDataEditError: (state, actions) => {
      state.PreviousEmpEDITeError = actions.payload;
    },
  },
});

///----------------Decalaration Employee Details-----------------------

const DeclarationSlice = createSlice({
  name: "DeclarationCall",
  initialState: {
    Decalarationdatat: [],
    DeclarationError: "",
  },
  reducers: {
    SetDeclarationAction: (state, actions) => {
      state.Decalarationdatat = [];
      state.DeclarationError = "";
    },
    setDecalarationActionData: (state, actions) => {
      state.Decalarationdatat = actions.payload;
    },
    setDecalarationDataError: (state, actions) => {
      state.DeclarationError = actions.payload;
    },
  },
});

//----------------Decalaration Employee Details----create-------------------

const DeclarationcreateSlice = createSlice({
  name: "DeclarationcreateCall",
  initialState: {
    Decalarationcreatedatat: [],
    DeclarationError: "",
  },
  reducers: {
    SetDeclarationcreateAction: (state, actions) => {
      state.Decalarationcreatedatat = [];
      state.DeclarationError = "";
    },
    setDecalarationActioncreateData: (state, actions) => {
      state.Decalarationcreatedatat = actions.payload;
    },
    setDecalarationDatacreateError: (state, actions) => {
      state.DeclarationError = actions.payload;
    },
  },
});

///--------
//----------------Decalaration Employee Details---Edit--------------------

const DeclarationEditSlice = createSlice({
  name: "DeclarationEditCall",
  initialState: {
    DecalarationEditdatat: [],
    DeclarationEditError: "",
  },
  reducers: {
    SetDeclarationEditAction: (state, actions) => {
      state.DecalarationEditdatat = [];
      state.DeclarationEditError = "";
    },
    setDecalarationEditActionData: (state, actions) => {
      state.DecalarationEditdatat = actions.payload;
    },
    setDecalarationEditDataError: (state, actions) => {
      state.DeclarationEditError = actions.payload;
    },
  },
});

///----------------ESI  Details----------------------

const EsiFormSlice = createSlice({
  name: "ESIdetails",
  initialState: {
    ESIDATAS: [],
    ESIERROR: "",
  },
  reducers: {
    SetESICALLAction: (state, actions) => {
      state.ESIDATAS = [];
      state.ESIERROR = "";
    },
    setESIRESPONSESData: (state, actions) => {
      state.ESIDATAS = actions.payload;
    },
    setESIDataError: (state, actions) => {
      state.ESIERROR = actions.payload;
    },
  },
});

///----------------ESI  Details----Create------------------

const EsiFormCreateSlice = createSlice({
  name: "ESICreatedetails",
  initialState: {
    ESICreateDATAS: [],
    ESIERROR: "",
  },
  reducers: {
    SetESICraeteCALLAction: (state, actions) => {
      state.ESICreateDATAS = [];
      state.ESIERROR = "";
    },
    setESIRESPONSESCreateData: (state, actions) => {
      state.ESICreateDATAS = actions.payload;
    },
    setESIDataCraeteError: (state, actions) => {
      state.ESIERROR = actions.payload;
    },
  },
});

///----------------ESI  Details----EDIT------------------

const EsiFormEditSlice = createSlice({
  name: "ESIEditdetails",
  initialState: {
    ESIEditDATAS: [],
    ESIERROR: "",
  },
  reducers: {
    SetESIEditCALLAction: (state, actions) => {
      state.ESIEditDATAS = [];
      state.ESIERROR = "";
    },
    setESIRESPONSESEditData: (state, actions) => {
      state.ESIEditDATAS = actions.payload;
    },
    setESIDataEditError: (state, actions) => {
      state.ESIERROR = actions.payload;
    },
  },
});

///----------------JOB OFFER----  Details----------------------

const JOBOFFERSlice = createSlice({
  name: "JOBOfferCall",
  initialState: {
    JobDATATS: [],
    JOBofferError: "",
  },
  reducers: {
    SetJObofferCall: (state, actions) => {
      state.JobDATATS = [];
      state.JOBofferError = "";
    },
    SetJobofferresponse: (state, actions) => {
      state.JobDATATS = actions.payload;
    },
    SetJobofferError: (state, actions) => {
      state.JOBofferError = actions.payload;
    },
  },
});

///----------------JOB OFFER PREVIEW----====== Details----------------------

const JOBOFFERPreviewSlice = createSlice({
  name: "JOBOfferPreviewCall",
  initialState: {
    JobOfferPreivewData: [],
    JOBofferPreviewError: "",
  },
  reducers: {
    SetJObofferPreviewCallAction: (state, actions) => {
      state.JobOfferPreivewData = [];
      state.JOBofferPreviewError = "";
    },
    SetJobofferPreviewresponseCreate: (state, actions) => {
      state.JobOfferPreivewData = actions.payload;
    },
    SetJobofferPreviewErrorcreate: (state, actions) => {
      state.JOBofferPreviewError = actions.payload;
    },
  },
});
///----------------Remainder Mail for approve request ----====== Details----------------------

const RemainderMailSlice = createSlice({
  name: "RemainderMailCall",
  initialState: {
    RemainderMailData: [],
    RemainderMailError: "",
  },
  reducers: {
    SetRemainderMailCallAction: (state, actions) => {
      state.RemainderMailData = [];
      state.RemainderMailError = "";
    },
    SetRemainderMailresponseCreate: (state, actions) => {
      state.RemainderMailData = actions.payload;
    },
    SetRemainderMailErrorcreate: (state, actions) => {
      state.RemainderMailError = actions.payload;
    },
  },
});
///----------------JOB OFFER----Create====== Details----------------------

const JOBOFFERCreateSlice = createSlice({
  name: "JOBOfferCreateCall",
  initialState: {
    JobDATATSCreate: [],
    JOBofferError: "",
    grossSalaryCreate: "",
  },
  reducers: {
    SetJObofferCallAction: (state, actions) => {
      state.JobDATATSCreate = [];
      state.JOBofferError = "";
    },
    SetJobofferresponseCreate: (state, actions) => {
      state.JobDATATSCreate = actions.payload;
    },
    SetJobofferErrorcreate: (state, actions) => {
      state.JOBofferError = actions.payload;
    },
    setTherossSalaryCreateActions: (state, actions) => {
      state.grossSalary = actions.payload;
    },
  },
});

///----------------JOB OFFER----Edit====== Details----------------------

const JOBOFFEReditSlice = createSlice({
  name: "JOBOfferEditall",
  initialState: {
    JobDATATSEDIT: [],
    JOBofferError: "",
    grossSalary: "",
  },
  reducers: {
    SetJObofferDITCallAction: (state, actions) => {
      state.JobDATATSEDIT = [];
      state.JOBofferError = "";
    },
    SetJobofferresponseEDIT: (state, actions) => {
      state.JobDATATSEDIT = actions.payload;
    },
    SetJobofferErrorEDIt: (state, actions) => {
      state.JOBofferError = actions.payload;
    },
    setTherossSalaryActions: (state, actions) => {
      state.grossSalary = actions.payload;
    },
  },
});
///----------------Denave HR Approval OFFER----Edit====== Details----------------------

const hrApprovalSlice = createSlice({
  name: "HrApprovalDataCall",
  initialState: {
    hrApprovalData: [],
    hrApprovalError: "",
  },
  reducers: {
    setHrApprovalCallAction: (state, actions) => {
      state.hrApprovalData = [];
      state.hrApprovalError = "";
    },
    SetHrApprovalresponseEDIT: (state, actions) => {
      state.hrApprovalData = actions.payload;
    },
    setHrApprovalErrorEdit: (state, actions) => {
      state.hrApprovalError = actions.payload;
    },
    // setTherossSalaryActions: (state, actions) => {
    //   state.grossSalary = actions.payload;
    // },
  },
});

///----------------Family Employee Details-----------------------

const FamilyEmployeeSlice = createSlice({
  name: "FamilyList",
  initialState: {
    FamilyDetails: [],
    FamilyDetailsError: "",
  },
  reducers: {
    setFamilyEmpDataActions: (state, actions) => {
      state.FamilyDetails = [];
      state.FamilyDetailsError = "";
    },
    SetFamilyEmpDataResponeActions: (state, actions) => {
      state.FamilyDetails = actions.payload;
    },
    setFamilyDataError: (state, actions) => {
      state.FamilyDetailsError = actions.payload;
    },
  },
});

///----------------Family Employee Details-Create----------------------

const FamilyEmployeeCreateSlice = createSlice({
  name: "FamilycreateList",
  initialState: {
    FamilycreateDetails: [],
    FamilyDetailsError: "",
  },
  reducers: {
    setFamilyEmpDatacreateActions: (state, actions) => {
      state.FamilycreateDetails = [];
      state.FamilyDetailsError = "";
    },
    SetFamilyEmpDatacreateResponeActions: (state, actions) => {
      state.FamilycreateDetails = actions.payload;
    },
    setFamilyDatacreateError: (state, actions) => {
      state.FamilyDetailsError = actions.payload;
    },
  },
});

///----------------Family Employee Details-Edit----------------------

const FamilyEmployeeEditSlice = createSlice({
  name: "FamilyEditList",
  initialState: {
    FamilyEditDetails: [],
    FamilyDetailsError: "",
  },
  reducers: {
    setFamilyEmpDataEditActions: (state, actions) => {
      state.FamilyEditDetails = [];
      state.FamilyDetailsError = "";
    },
    SetFamilyEmpDataEditResponeActions: (state, actions) => {
      state.FamilyEditDetails = actions.payload;
    },
    setFamilyDataEditError: (state, actions) => {
      state.FamilyDetailsError = actions.payload;
    },
  },
});

/////-----------------FORMS--------------------_IDS-------------
const FormsIdSlice = createSlice({
  name: "FormsIDList",
  initialState: {
    ActiveTabs: 1,
    BasicFormID: "",
    AddressId: "",
    Idverify: "",
    BankDetailID: "",
    EducationID: "",
    PreviousempID: "",
    FamilyDetailsId: "",
    DecalarationID: "",
    ESIFormsid: "",
    Job_offer_id: "",
    USERIDS: "",
    DashboardNavtabs: "1",
    OrganizationClientID: "",
  },
  reducers: {
    SetBasiformsID: (state, actions) => {
      state.BasicFormID = actions.payload;
    },
    SetAddressId: (state, actions) => {
      state.AddressId = actions.payload;
    },
    SetIdVeriications: (state, actions) => {
      state.Idverify = actions.payload;
    },
    setBankDetailsId: (state, actions) => {
      state.BankDetailID = actions.payload;
    },
    SetEducationDetails: (state, actions) => {
      state.EducationID = actions.payload;
    },
    SetPreviousEmployeeID: (state, actions) => {
      state.PreviousempID = actions.payload;
    },
    setfamliydetailsid: (state, actions) => {
      state.FamilyDetailsId = actions.payload;
    },
    SetDeclarationId: (state, actions) => {
      state.DecalarationID = actions.payload;
    },
    SetEsiFormIdActions: (state, actions) => {
      state.ESIFormsid = actions.payload;
    },
    SetJobOfferID: (state, actions) => {
      state.Job_offer_id = actions.payload;
    },
    SetActiveTabs: (state, actions) => {
      state.ActiveTabs = actions.payload;
    },
    SetOrganizationClientID: (state, actions) => {
      state.OrganizationClientID = actions.payload;
    },
    setDashboardactiveTabs: (state, actions) => {
      state.DashboardNavtabs = actions.payload;
    },
    SetTheUserIDS: (state, actions) => {
      state.USERIDS = actions.payload;
    },
  },
});

//---Approval-----Slice----------------
const ApprovelSlice = createSlice({
  name: "ApprovalCall",
  initialState: {
    ApprovalData: [],
    Error: "",
  },
  reducers: {
    SetApprovalCallsActions: (state, actions) => {
      state.ApprovalData = [];
      state.Error = "";
    },
    SetApprovalResponseActions: (state, actions) => {
      state.ApprovalData = actions.payload;
    },
    SetApprovalErrorStatus: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

///----------____Verified----Users-----------------
const VerifiedUsersSlice = createSlice({
  name: "VerifiedUsers",
  initialState: {
    VerifiedUsersData: [],
    Error: "",
    Total_Count: "",
  },

  reducers: {
    SetVerifiedUserActions: (state, actions) => {
      state.VerifiedUsersData = [];
      state.Error = "";
    },
    SetVerifiedUsersResponse: (state, actions) => {
      state.VerifiedUsersData = actions.payload;
    },
    SetTotal_counts_for_VerifiedEmployees: (state, actions) => {
      state.Total_Count = actions.payload;
    },
    SetVerifiedUserError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});
//----Generat----the----Job---Offer-----letter----date
const JoningDateSlice = createSlice({
  name: "JoningDateCall",
  initialState: {
    JoiningDate: [],
    Error: "",
  },
  reducers: {
    SetTheJoiningDateCall: (state, actions) => {
      state.JoiningDate = [];
      state.Error = "";
    },
    SetTheJoiningDateResponseCall: (state, actions) => {
      state.JoiningDate = actions.payload;
    },
    SetThaeJoiningDateErrorMessage: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const SignatureSlice = createSlice({
  name: "SignatureCall",
  initialState: {
    Signature: [],
    Error: "",
  },
  reducers: {
    SetSignatureActions: (state, actions) => {
      state.Signature = [];
      state.Error = "";
    },
    SetSignatureResponses: (state, actions) => {
      state.Signature = actions.payload;
    },
    SetSignatureErrorMessage: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});
///---------UPLOAD--------------EXCEL-----------------SHEET
const UPloadExcelSheeSlice = createSlice({
  name: "excelsheets",
  initialState: {
    ExcelSheets: [],
    error: "",
  },
  reducers: {
    SettheExcelSheeetUpaloads: (state, actions) => {
      state.ExcelSheets = [];
      state.error = "";
    },
    setTheExcelSheetresponseStatus: (state, actions) => {
      state.ExcelSheets = actions.payload;
    },
    SetTheExcelSheetErrors: (state, actions) => {
      state.error = actions.payload;
    },
  },
});
///=----shift Excel sheet ----------
const ShiftExcelSheetGetApiSlice = createSlice({
  name: "ShfitData",
  initialState: {
    Shiftdatas: [],
    Inquriy: [],
    Error: "",
    Total_Count: "",
  },
  reducers: {
    getShiftStatusPersonsListed: (state, actions) => {
      state.Shiftdatas = [];
      state.Error = "";
      state.Total_Count = "";
      state.Inquriy = [];
    },
    setShiftStatusLisPersonsResponseActions: (state, actions) => {
      state.Shiftdatas = actions.payload;
    },
    SetTheInquriyShiftsStatus: (state, actions) => {
      state.Inquriy = actions.payload;
    },
    setShiftsDataPersonsErrorMessages: (state, actions) => {
      state.Error = actions.payload;
    },
    SetShiftDataTotal_countPersonsActions: (state, actions) => {
      state.Total_Count = actions.payload;
    },
  },
});
////----excel---Sheet---Retrieve----
const excelShiftSheetRetrieveSlice = createSlice({
  name: "ShifteexcelshettRetriev",
  initialState: {
    ShfiexcelRetrieve: [],
    Error: "",
  },
  reducers: {
    setTheShiftexcelSheetRetrieveAction: (state, actions) => {
      state.ShfiexcelRetrieve = [];
      state.Error = "";
    },
    setTheShiftexcelRetrieveResponse: (state, actions) => {
      state.ShfiexcelRetrieve = actions.payload;
    },
    setTheShiftExcelSheetError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});
///----To---making----Changes----------------
const MakingChangeSlice = createSlice({
  name: "makingChanges",
  initialState: {
    ExcelSheetRender: 1,
  },
  SetTheExcelSheetRender: (state, actions) => {
    state.ExcelSheetRender = actions.payload;
  },
});
///-------------------Leave--------Type--------Create
const LeaveTypeCreateSlice = createSlice({
  name: "LeaveTypeCareteCall",
  initialState: {
    LeaveCreateStatus: [],
    Error: "",
  },
  reducers: {
    SetActionForLeaveTypes: (state, actions) => {
      state.Error = "";
      state.LeaveCreateStatus = [];
    },
    SetLeaveTypeCreate: (state, actions) => {
      state.LeaveCreateStatus = actions.payload;
    },
    SetLeaveTypeError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});
///----__Leave----__Type-------___List
const LeaveTypeListSlice = createSlice({
  name: "LeaveTypeList",
  initialState: {
    LeaveTypeList: [],
    Error: "",
    Total_Count: "",
  },
  reducers: {
    SetLeaveTypeActions: (state, actions) => {
      state.LeaveTypeList = [];
      state.Error = "";
    },
    setLeaveTypeResponses: (state, actions) => {
      state.LeaveTypeList = actions.payload;
    },
    setLeaveTypeResponseTotalCounts: (state, actions) => {
      state.Total_Count = actions.payload;
    },
    SetLeaveTypeListError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});
////----Leave---TYpe------Delete--------
const LeaveTypeDeleteSlice = createSlice({
  name: "LeaveTypeDelete",
  initialState: {
    LeaveTypeDelete: [],
    Error: "",
  },
  reducers: {
    SetLeaveTypeDeleteActions: (state, actions) => {
      state.LeaveTypeDelete = [];
      state.Error = "";
    },

    setLeaveTypeResponsesDelete: (state, actions) => {
      state.LeaveTypeDelete = actions.payload;
    },
    SetLeaveTypeDeleteError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

///---Leave----tyep---_retrieve--------------
const LeaveTypeRetrieveSlice = createSlice({
  name: "LeaveTypeRetrieveCall",
  initialState: {
    LeaveTypeRetrieve: [],
    Error: "",
  },
  reducers: {
    SetLeaveTypeRetrieveActions: (state, actions) => {
      state.LeaveTypeRetrieve = [];
      state.Error = "";
    },

    setLeaveTypeResponsesRetrieve: (state, actions) => {
      state.LeaveTypeRetrieve = actions.payload;
    },
    SetLeaveTypeRetrieveError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

///---Leave----tyep---Edit--------------
const LeaveTypeEDITSSlice = createSlice({
  name: "LeaveTypeEditCall",
  initialState: {
    LeaveTypeEdit: [],
    Error: "",
  },
  reducers: {
    SetLeaveTypeEditActions: (state, actions) => {
      state.LeaveTypeEdit = [];
      state.Error = "";
    },

    setLeaveTypeResponsesEdit: (state, actions) => {
      state.LeaveTypeEdit = actions.payload;
    },
    SetLeaveTypeEditError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

///---Leave--Permission-----List
const LeavePermissionListSlice = createSlice({
  name: "LeavePremissionLists",
  initialState: {
    LeavePermissionList: [],
    Error: "",
    Total_Count: "",
  },
  reducers: {
    SetTheLeavePermissionListActions: (state, actions) => {
      state.LeavePermissionList = [];
      state.Error = "";
      state.Total_Count = "";
    },
    SetTheLeavePermissionlistResponse: (state, actions) => {
      state.LeavePermissionList = actions.payload;
    },
    SetTheLeavePermissionListTotal_counts: (state, actions) => {
      state.Total_Count = actions.payload;
    },
    SetTheLeavePermissionListError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});
///----Leave---Permission---Delete----
const LeavePermissionDeleteSlice = createSlice({
  name: "LeavepermissionDeleteCall",
  initialState: {
    LeavePermissionDelete: [],
    Error: "",
  },
  reducers: {
    SetTheLeavePermissionDelete: (state, actions) => {
      state.LeavePermissionDelete = [];
      state.Error = "";
    },
    SetTheLeavePermissionDeleteResponse: (state, actions) => {
      state.LeavePermissionDelete = actions.payload;
    },
    SetTheLeavePermissionDeleteError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

/////---Leave---Permission---Retrieve------
const LeavePermissionRetrieveSlice = createSlice({
  name: "LeavePermissionRetrieveCall",
  initialState: {
    LeaveRetrieveStatus: [],
    Error: "",
  },
  reducers: {
    SetTheLeavePremissionRetrieveActions: (state, actions) => {
      state.Error = "";
      state.LeaveRetrieveStatus = [];
    },
    SettheLeaveRetrievePremissionActions: (state, actions) => {
      state.LeaveRetrieveStatus = actions.payload;
    },
    SetTheLeavePermissionErrorRetrieve: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

/////---Leave---Permission---Edits------
const LeavePermissionEditsSlice = createSlice({
  name: "LeavePermissionEditsCall",
  initialState: {
    LeaveEditsStatus: [],
    Error: "",
  },
  reducers: {
    SetTheLeavePremissionEditsActions: (state, actions) => {
      state.Error = "";
      state.LeaveEditsStatus = [];
    },
    SettheLeaveEditsPremissionActions: (state, actions) => {
      state.LeaveEditsStatus = actions.payload;
    },
    SetTheLeavePermissionErrorEdits: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

///---Leave--Permission-----List----Search
const LeavePermissionListSearchSlice = createSlice({
  name: "LeavePremissionSearchLists",
  initialState: {
    LeavePermissionSearchList: [],
    Error: "",
    Total_Count: "",
  },
  reducers: {
    SetTheLeavePermissionListSearchActions: (state, actions) => {
      state.LeavePermissionSearchList = [];
      state.Error = "";
      state.Total_Count = "";
    },
    SetTheLeavePermissionlistSearchResponse: (state, actions) => {
      state.LeavePermissionSearchList = actions.payload;
    },
    SetTheLeavePermissionListSearchTotal_counts: (state, actions) => {
      state.Total_Count = actions.payload;
    },
    SetTheLeavePermissionListSearchError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

////----DashBoard-----
const DaShboardSlice = createSlice({
  name: "DashboardCall",
  initialState: {
    Dashboard: [],
    Error: "",
    DashboardCLientList: { value: "", label: "ALL" },
    onboardashboardCLientList: { value: "", label: "ALL" },
    DashboardOrganizationSelcetdList: { value: "", label: "ALL" },
  },
  reducers: {
    setTheDashboardactions: (state, actions) => {
      state.Dashboard = [];
      state.Error = "";
    },
    setTheDashboardResponses: (state, actions) => {
      state.Dashboard = actions.payload;
    },
    setTheDashboardErrors: (state, actions) => {
      state.Error = actions.payload;
    },
    SetTheDashboardClientList: (state, actions) => {
      state.DashboardCLientList = actions.payload;
    },
    SetTheDashboardOrganizationListed: (state, actions) => {
      state.DashboardOrganizationSelcetdList = actions.payload;
    },
    settheOnboardDashboardClient: (state, actions) => {
      state.onboardashboardCLientList = actions.payload;
    },
  },
});

const DaShboardOnboardingOverviewSlice = createSlice({
  name: "DashboardOnboardOverviewCall",
  initialState: {
    onboardingOverviewdata: [],
    Error: "",
    DashboardOnboardOverviewCLientList: { value: "", label: "ALL" },
    onboardashboardOnboardOverViewCLientList: { value: "", label: "ALL" },
    onboardashboardOnboardOverViewOrganizationList: { value: "", label: "ALL" },
  },
  reducers: {
    setTheDashboardonboadOverviewactions: (state, actions) => {
      state.onboardingOverviewdata = [];
      state.Error = "";
    },
    setTheDashboardOnboarderOverviewResponses: (state, actions) => {
      state.onboardingOverviewdata = actions.payload;
    },
    setTheDashboarOnboarderOverViewdErrors: (state, actions) => {
      state.Error = actions.payload;
    },
    SetTheDashboardonBoardOverViewClientList: (state, actions) => {
      state.DashboardOnboardOverviewCLientList = actions.payload;
    },
    SetTheDashboardonBoardOverViewOrganizationListed_stateList: (
      state,
      actions,
    ) => {
      state.onboardashboardOnboardOverViewOrganizationList = actions.payload;
    },
    settheOnboardOverviewDashboardClient: (state, actions) => {
      state.onboardashboardOnboardOverViewCLientList = actions.payload;
    },
  },
});

/////----Shift----Premission
const ShiftPermissionSlice = createSlice({
  name: "shiftPermission",
  initialState: {
    shiftPermissiondata: [],
    Error: "",
    Total_Count: "",
  },
  reducers: {
    setShiftPermissionActions: (state, actions) => {
      state.shiftPermissiondata = [];
      state.Error = "";
      state.Total_Count = "";
    },
    setTheshiftPermissionRespons: (state, actions) => {
      state.shiftPermissiondata = actions.payload;
    },
    setTheShiftPermissionTotal_counts: (state, actions) => {
      state.Total_Count = actions.payload;
    },
    setShiftPermissionError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

/////---shift---Permission---Retrieve------
const ShiftPermissionRetrieveSlice = createSlice({
  name: "ShiftPermissionRetrieveCall",
  initialState: {
    ShiftRetrieveStatus: [],
    Error: "",
  },
  reducers: {
    SetTheShiftPremissionRetrieveActions: (state, actions) => {
      state.Error = "";
      state.ShiftRetrieveStatus = [];
    },
    SettheShiftRetrievePremissionActions: (state, actions) => {
      state.ShiftRetrieveStatus = actions.payload;
    },
    SetTheShiftermissionErrorRetrieve: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

/////---Leave---Permission---Edits------
const ShiftPermissionEditsSlice = createSlice({
  name: "ShiftPermissionEditsCall",
  initialState: {
    shitfEditsStatus: [],
    Error: "",
  },
  reducers: {
    SetTheShiftPremissionEditsActions: (state, actions) => {
      state.Error = "";
      state.shitfEditsStatus = [];
    },
    SettheShiftditsPremissionActions: (state, actions) => {
      state.shitfEditsStatus = actions.payload;
    },
    SetTheShiftPermissionErrorEdits: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});
///----shitf---Permission---Delete----
const ShiftPermissionDeleteSlice = createSlice({
  name: "ShiftpermissionDeleteCall",
  initialState: {
    SiftPermissionDelete: [],
    Error: "",
  },
  reducers: {
    SetTheShiftPermissionDelete: (state, actions) => {
      state.SiftPermissionDelete = [];
      state.Error = "";
    },
    SetTheshiftPermissionDeleteResponse: (state, actions) => {
      state.SiftPermissionDelete = actions.payload;
    },
    SetTheShiftPermissionDeleteError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

////--------Appraisal-----

const AppraisalSlice = createSlice({
  name: "AppraisliceCall",
  initialState: {
    AppraaisalData: [],
    Error: "",
    Total_Count: "",
  },
  reducers: {
    setAppraisalAction: (state, actions) => {
      state.AppraaisalData = [];
      state.Error = "";
      state.Total_Count = "";
    },
    setAppraisaltResponse: (state, actions) => {
      state.AppraaisalData = actions.payload;
    },
    setAppraisalTotal_counts: (state, actions) => {
      state.Total_Count = actions.payload;
    },
    setAppraisalError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

////--------------Re---Investment---------------------
const ReinvsetmentSlice = createSlice({
  name: "reinvestmentCall",
  initialState: {
    reinvestment: [],
    Error: "",
    Total_Count: "",
  },
  reducers: {
    setReinvestmentAction: (state, actions) => {
      state.reinvestment = [];
      state.Error = "";
      state.Total_Count = "";
    },
    setReinvestmentResponse: (state, actions) => {
      state.reinvestment = actions.payload;
    },
    setReinvestmentTotal_counts: (state, actions) => {
      state.Total_Count = actions.payload;
    },
    setReInvestmentError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

/////------Appraisal---Retrieve------
const AppraisaltRetrirSlice = createSlice({
  name: "AppraisalRetrieveCall",
  initialState: {
    Appraisalretrieve: [],
    Error: "",
  },
  reducers: {
    SetTheAppraisalRetrieveActions: (state, actions) => {
      state.Error = "";
      state.Appraisalretrieve = [];
    },
    SettheAppraisalRetrieveActions: (state, actions) => {
      state.Appraisalretrieve = actions.payload;
    },
    SetAppraisalErrorRetrieve: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

/////------ReInvsement---Retrieve------
const ReinvsetmentRetrirSlice = createSlice({
  name: "reInvestmentRetrieveCall",
  initialState: {
    reinvestmentretrieve: [],
    Error: "",
  },
  reducers: {
    SetTheReinvestmentRetrieveActions: (state, actions) => {
      state.Error = "";
      state.reinvestmentretrieve = [];
    },
    SettheReinvestmentRetrieveActions: (state, actions) => {
      state.reinvestmentretrieve = actions.payload;
    },
    SetReinvestmentErrorRetrieve: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

/////---Re---Investment--Edits------
const ReinvsetmentEditSlice = createSlice({
  name: "ReinvestmentEditCall",
  initialState: {
    reinvestmentEdit: [],
    Error: "",
  },
  reducers: {
    SetTheReInvestmentEditsActions: (state, actions) => {
      state.Error = "";
      state.reinvestmentEdit = [];
    },
    SettheReInvestmentResponsesActions: (state, actions) => {
      state.reinvestmentEdit = actions.payload;
    },
    SetTheReInvestmentErrorEdits: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

////----OnDuty-----Get----List------------
const OnDutySlice = createSlice({
  name: "OndutyCalls",
  initialState: {
    OnDutyDatas: [],
    Error: "",
    Total_counts: "",
  },
  reducers: {
    SetTheOndutyActions: (state, actions) => {
      state.OnDutyDatas = [];
      state.Error = "";
      state.Total_counts = "";
    },
    SeTheOndutyRespones: (state, actions) => {
      state.OnDutyDatas = actions.payload;
    },
    SetheOndutytatolCounts: (state, actions) => {
      state.Total_counts = actions.payload;
    },
    SetTheIndutyError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

///------Appraisal---edits---

const AppaisalEditSlice = createSlice({
  name: "AppraisalEditCall",
  initialState: {
    AppraisalEdit: [],
    Error: "",
  },
  reducers: {
    SetTheAppraisalditsActions: (state, actions) => {
      state.Error = "";
      state.AppraisalEdit = [];
    },
    SettheAppraisalResponsesActions: (state, actions) => {
      state.AppraisalEdit = actions.payload;
    },
    SetTheAppraisalErrorEdits: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

///----On---Duty----Request---Accept-----
const OndutyRetrieveSlice = createSlice({
  name: "onDutyRetrieveCall",
  initialState: {
    OndutyDataRetrieve: [],
    Error: "",
  },
  reducers: {
    SetTheonDutyRetrieveActions: (state, actions) => {
      state.Error = "";
      state.OndutyDataRetrieve = [];
    },
    SettheOndutyResponeActions: (state, actions) => {
      state.OndutyDataRetrieve = actions.payload;
    },
    SetTheOndutyErrorRetrieve: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

/////--On--Duty---Edits------
const OnDutyEditSlice = createSlice({
  name: "OnDutyEditsCall",
  initialState: {
    OndutyEditData: [],
    Error: "",
  },
  reducers: {
    setTheOndutyEditAction: (state, actions) => {
      state.Error = "";
      state.OndutyEditData = [];
    },
    SettheOndutyEditReponse: (state, actions) => {
      state.OndutyEditData = actions.payload;
    },
    SetTheOndutyErrorEdits: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

///----On---Duty---Delete----
const ONdutyDeleteSlice = createSlice({
  name: "OnDutyDeleteCall",
  initialState: {
    OndutyDelete: [],
    Error: "",
  },
  reducers: {
    SetTheOndutynDelete: (state, actions) => {
      state.OndutyDelete = [];
      state.Error = "";
    },
    SetTheOndutyDeleteResponse: (state, actions) => {
      state.OndutyDelete = actions.payload;
    },
    SetTheOndutyDeleteError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

////----Resign-----Get----List------------
const ResignSlice = createSlice({
  name: "resignCall",
  initialState: {
    ResginDatas: [],
    Error: "",
    Total_counts: "",
  },
  reducers: {
    SetTheResignActions: (state, actions) => {
      state.ResginDatas = [];
      state.Error = "";
      state.Total_counts = "";
    },
    SeTheResignRespones: (state, actions) => {
      state.ResginDatas = actions.payload;
    },
    SetheResigntatolCounts: (state, actions) => {
      state.Total_counts = actions.payload;
    },
    SetTheresignError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});
///----Resign-----Retrieve----
const ResignRetrieveSlice = createSlice({
  name: "ResignRetrieveCall",
  initialState: {
    ResignDataRetrieve: [],
    Error: "",
  },
  reducers: {
    SetTheResignRetrieveActions: (state, actions) => {
      state.Error = "";
      state.ResignDataRetrieve = [];
    },
    SettheResignResponeActions: (state, actions) => {
      state.ResignDataRetrieve = actions.payload;
    },
    SetTheResignErrorRetrieve: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

/////-----Resign---Edits------
const ResignEditSlice = createSlice({
  name: "ResignEditsCall",
  initialState: {
    ResignEditData: [],
    Error: "",
  },
  reducers: {
    setTheResignEditAction: (state, actions) => {
      state.Error = "";
      state.ResignEditData = [];
    },
    SettheResignEditReponse: (state, actions) => {
      state.ResignEditData = actions.payload;
    },
    SetTheResignErrorEdits: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

///----Resign---Delete----
const ResignDeleteSlice = createSlice({
  name: "ResignDeleteCall",
  initialState: {
    ResignDelete: [],
    Error: "",
  },
  reducers: {
    SetTheResignDelete: (state, actions) => {
      state.ResignDelete = [];
      state.Error = "";
    },
    SetTheResginDeleteResponse: (state, actions) => {
      state.ResignDelete = actions.payload;
    },
    SetTheResignDeleteError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

////----Exit-----Get----List------------
const ExitSlice = createSlice({
  name: "ExitCall",
  initialState: {
    ExitDatas: [],
    Error: "",
    Total_counts: "",
  },
  reducers: {
    SetTheExitActions: (state, actions) => {
      state.ExitDatas = [];
      state.Error = "";
      state.Total_counts = "";
    },
    SeTheExitRespones: (state, actions) => {
      state.ExitDatas = actions.payload;
    },
    SetheExittatolCounts: (state, actions) => {
      state.Total_counts = actions.payload;
    },
    SetTheExitError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});
///----Exit-----Retrieve----
const ExitRetrieveSlice = createSlice({
  name: "ExitRetrieveCall",
  initialState: {
    ExitDataRetrieve: [],
    Error: "",
  },
  reducers: {
    SetTheExitRetrieveActions: (state, actions) => {
      state.Error = "";
      state.ExitDataRetrieve = [];
    },
    SettheExitResponeActions: (state, actions) => {
      state.ExitDataRetrieve = actions.payload;
    },
    SetTheExitErrorRetrieve: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});
const ExitNoDueEditSlice = createSlice({
  name: "ExitNodueEditCall",
  initialState: {
    ExitNoDueEdit: [],
    Error: "",
  },
  reducers: {
    SetExitNoDueEditActions: (state, actions) => {
      state.Error = "";
      state.ExitDataRetrieve = [];
    },
    SetExitNoDueEditResponeActions: (state, actions) => {
      state.ExitDataRetrieve = actions.payload;
    },
    SetExitNoDueEditErrorRetrieve: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

/////-----Exit---Edits------
const ExitEditSlice = createSlice({
  name: "ExitEditsCall",
  initialState: {
    ExitEditData: [],
    Error: "",
  },
  reducers: {
    setTheExitEditAction: (state, actions) => {
      state.Error = "";
      state.ExitEditData = [];
    },
    SettheExitEditReponse: (state, actions) => {
      state.ExitEditData = actions.payload;
    },
    SetTheExitErrorEdits: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

///----Exit---Delete----
const ExitDeleteSlice = createSlice({
  name: "ExitDeleteCall",
  initialState: {
    ExitDelete: [],
    Error: "",
  },
  reducers: {
    SetTheExitDelete: (state, actions) => {
      state.ExitDelete = [];
      state.Error = "";
    },
    SetTheExitDeleteResponse: (state, actions) => {
      state.ExitDelete = actions.payload;
    },
    SetTheExitDeleteError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

//------Pay--Slip---LIsts----
const PaySlipSlice = createSlice({
  name: "payslip",
  initialState: {
    PaySlipData: [],
    Error: "",
    Total_Count: "",
  },
  reducers: {
    setThePayslipAcrions: (state, actions) => {
      state.PaySlipData = [];
      state.Error = "";
      state.Total_Count = "";
    },
    getPaySlipSuccessResponseActions: (state, actions) => {
      state.PaySlipData = actions.payload;
    },
    getPaySlipTotal_pageCounst: (state, actions) => {
      state.Total_Count = actions.payload;
    },
    getPaySlipErroResponsen: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});
////----Create--Pay--Slip
const PaySlipCreateSlice = createSlice({
  name: "payslipCreate",
  initialState: {
    PaySlipCreatesData: [],
    Error: "",
  },
  reducers: {
    setThePayslipCreateAcrions: (state, actions) => {
      state.PaySlipCreatesData = [];
      state.Error = "";
    },
    getPaySlipSuccessCreaetResponseActions: (state, actions) => {
      state.PaySlipCreatesData = actions.payload;
    },

    getPaySlipErroCreateResponsen: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});
////----Retrieve--Pay--Slip
const PaySlipRetrieveSlice = createSlice({
  name: "payslipRetrieve",
  initialState: {
    PaySlipRetrieveData: [],
    Error: "",
  },
  reducers: {
    setThePayslipRtrievecrions: (state, actions) => {
      state.PaySlipRetrieveData = [];
      state.Error = "";
    },
    getPaySlipSuccessRrtrieveResponseActions: (state, actions) => {
      state.PaySlipRetrieveData = actions.payload;
    },

    getPaySlipErroRetriveResponsen: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

////----edit--Pay--Slip
const PaySlipEditSlice = createSlice({
  name: "payslipEdit",
  initialState: {
    PaySlipEditData: [],
    Error: "",
  },
  reducers: {
    setThePayslipEditActions: (state, actions) => {
      state.PaySlipEditData = [];
      state.Error = "";
    },
    getPaySlipSuccessEditResponseActions: (state, actions) => {
      state.PaySlipEditData = actions.payload;
    },

    getPaySlipErroeditResponsen: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

////----edit--Pay--Slip
const PaySlipDEleteSlice = createSlice({
  name: "payslipDelete",
  initialState: {
    PaySlipDeleteData: [],
    Error: "",
  },
  reducers: {
    setThePayslipDeleteActions: (state, actions) => {
      state.PaySlipDeleteData = [];
      state.Error = "";
    },
    getPaySlipSuccessDeleteResponseActions: (state, actions) => {
      state.PaySlipDeleteData = actions.payload;
    },

    getPaySlipErrodeleteResponsen: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

///---E_verification---------------------
//  const EsignOtpVerificationsSlice = createSlice({
//   name :"EsignOtpVerifids",
//   initialState:{
//     OtpVerificitedOtpDatasPhone:"",
//     Error:"",

//   },

//  })

///----------------Bank Details-Create-------------------------

const BankDetailsCreateSlice = createSlice({
  name: "BankcreateDetails",
  initialState: {
    Bankcreatedata: [],
    BankDataError: "",
  },
  reducers: {
    setBankDataCreateActions: (state, actions) => {
      state.Bankcreatedata = [];
      state.BankDataError = "";
    },
    SetBankDataResponecreateActions: (state, actions) => {
      state.Bankcreatedata = actions.payload;
    },
    setBankDatacreateError: (state, actions) => {
      state.BankDataError = actions.payload;
    },
  },
});

///----------------Bank Details-Edit-------------------------

const BankDetailsEditSlice = createSlice({
  name: "BankEditDetails",
  initialState: {
    BankEditdata: [],
    BankDataError: "",
  },
  reducers: {
    setBankDataEditActions: (state, actions) => {
      state.BankEditdata = [];
      state.BankDataError = "";
    },
    SetBankDataResponeEditActions: (state, actions) => {
      state.BankEditdata = actions.payload;
    },
    setBankDataEditError: (state, actions) => {
      state.BankDataError = actions.payload;
    },
  },
});

///----------------EDUCATION Details---Create--------------------

const EducationcreateSlice = createSlice({
  name: "EducationcreateAction",
  initialState: {
    EducationcreateData: [],
    EducationDataError: "",
  },
  reducers: {
    setEducationDatacreateActions: (state, actions) => {
      state.EducationcreateData = [];
      state.EducationDataError = "";
    },
    SetEducationDataResponecrateActions: (state, actions) => {
      state.EducationcreateData = actions.payload;
    },
    setEducationDatacreateError: (state, actions) => {
      state.EducationDataError = actions.payload;
    },
  },
});

///-----Branch--list--for---field--afgent---list--out-
const fieldAgentBranchListSlice = createSlice({
  name: "fieldagentBracnhdata",
  initialState: {
    fieldagentBranchDatas: [],
    error: "",
    Total_Count: "",
  },
  reducers: {
    setThefieldAgentbranchactions: (state, actions) => {
      state.fieldagentBranchDatas = [];
      state.error = "";
      state.Total_Count = "";
    },
    setfieldbranchResponseActions: (state, actions) => {
      state.fieldagentBranchDatas = actions.payload;
    },
    setfieldagentErrorMessages: (state, actions) => {
      state.error = actions.payload;
    },
    SetFieldagentTotalCount: (state, actions) => {
      state.Total_Count = actions.payload;
    },
  },
});

///=----Employeee------Mnanager----Persons---Lists
const EmployeePersonManagerListSlice = createSlice({
  name: "EmployeeListManagerPresons",
  initialState: {
    EmployeemMnagerPersons: [],
    Inquriy: [],
    Error: "",
    Total_Count: "",
  },
  reducers: {
    getEmployeeListcreatePersonsListed: (state, actions) => {
      state.EmployeePersons = [];
      state.Error = "";
      state.Total_Count = "";
      state.Inquriy = [];
    },
    setEmployeeListSPersonsManagerResponseActions: (state, actions) => {
      state.EmployeePersons = actions.payload;
    },
    SetTheInquriyStatusmanager: (state, actions) => {
      state.Inquriy = actions.payload;
    },
    setEmployeeDataPersonsManagerErrorMessages: (state, actions) => {
      state.Error = actions.payload;
    },
    SetEmployeeDataTotal_countPersonsManagerActions: (state, actions) => {
      state.Total_Count = actions.payload;
    },
  },
});

//////----------------Previous  API-------Forms---------------------
const PreviousApiCallSlice = createSlice({
  name: "PreviousApiCallLine",
  initialState: {
    PreviousDatas: [],
    PreviousErr: "",
  },
  reducers: {
    setPreviousDataFetchActions: (state, actions) => {
      state.PreviousDatas = [];
      state.PreviousErr = "";
    },
    SetThePreviousDataResponsesActions: (state, actions) => {
      state.PreviousDatas = actions.payload;
    },
    setThePreviousErrAction: (state, actions) => {
      state.PreviousErr = actions.payload;
    },
  },
});

//////----------------DATA--FECTH  API-------Forms---------------------
const DATAFETCHslice = createSlice({
  name: "DatafetchCall",
  initialState: {
    DataFetchDatass: [],
    error: "",
  },
  reducers: {
    settheDataFetchActions: (state, actions) => {
      state.DataFetchDatass = [];
      state.error = "";
    },
    setTheDataFetchRESponse: (state, actions) => {
      state.DataFetchDatass = actions.payload;
    },
    setTheDataFETCHerror: (state, actions) => {
      state.error = actions.payload;
    },
  },
});

////--------------grievance---type---------------------
const grievanceTypeSlice = createSlice({
  name: "grievanceTypeCall",
  initialState: {
    grievanceDatas: [],
    Error: "",
    Total_Count: "",
  },
  reducers: {
    setGrievanceAction: (state, actions) => {
      state.grievanceDatas = [];
      state.Error = "";
      state.Total_Count = "";
    },
    setGrievanceResponse: (state, actions) => {
      state.grievanceDatas = actions.payload;
    },
    setgrievanceTotal_counts: (state, actions) => {
      state.Total_Count = actions.payload;
    },
    setgrievanceError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

////----Grievance---Employee--list---
const grievanceEMPLISTSlice = createSlice({
  name: "grievanceEMpListCall",
  initialState: {
    grievanceListDatas: [],
    Error: "",
    Total_Count: "",
  },
  reducers: {
    setGrievanceEMPListAction: (state, actions) => {
      state.grievanceListDatas = [];
      state.Error = "";
      state.Total_Count = "";
    },
    setGrievanceEMpListResponse: (state, actions) => {
      state.grievanceListDatas = actions.payload;
    },
    setgrievanceEmpListTotal_counts: (state, actions) => {
      state.Total_Count = actions.payload;
    },
    setgrievanceEmpListError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

///--Grievance---Employee--list---Approve-----------

const GrievanceApproveRetrieveSlice = createSlice({
  name: "GrievanceApproveretriveCall",
  initialState: {
    GrievanceRETEVEApprove: [],
    error: "",
  },
  reducers: {
    settheGrievanceEMPApproveretrieveActions: (state, actions) => {
      state.GrievanceRETEVEApprove = [];
      state.error = "";
    },
    setTheGrievanceApproveEMPretrieveRESponse: (state, actions) => {
      state.GrievanceRETEVEApprove = actions.payload;
    },
    setTheGrievanceApproveEMPretrieveerror: (state, actions) => {
      state.error = actions.payload;
    },
  },
});

///---Grieveance------delete--------
const Grieveancedeleteslices = createSlice({
  name: "GrievanceDeleteDataCall",
  initialState: {
    GrievanceDeleteData: [],
    error: "",
  },
  reducers: {
    setThegrieveacncedeleteActions: (state, actions) => {
      state.GrievanceDeleteData = [];
      state.error = "";
    },
    setThegrieveancedeletereponses: (state, actions) => {
      state.GrievanceDeleteData = actions.payload;
    },
    setThegrieveancedeleteErrors: (state, actions) => {
      state.error = actions.payload;
    },
  },
});

///---Create---Grievance---

const GrievanceSlice = createSlice({
  name: "GrievanceCall",
  initialState: {
    GrievanceCreate: [],
    error: "",
  },
  reducers: {
    settheGrievanceCreateActions: (state, actions) => {
      state.GrievanceCreate = [];
      state.error = "";
    },
    setTheGrievanceCreateRESponse: (state, actions) => {
      state.GrievanceCreate = actions.payload;
    },
    setTheGrievanceCreateerror: (state, actions) => {
      state.error = actions.payload;
    },
  },
});

///---retrieve---Grievance---

const GrievanceRetrieveSlice = createSlice({
  name: "GrievanceretrieveCall",
  initialState: {
    GrievanceRetrieve: [],
    error: "",
  },
  reducers: {
    settheGrievanceRetrieveActions: (state, actions) => {
      state.GrievanceRetrieve = [];
      state.error = "";
    },
    setTheGrievanceRetrieveRESponse: (state, actions) => {
      state.GrievanceRetrieve = actions.payload;
    },
    setTheGrievanceREtriveerror: (state, actions) => {
      state.error = actions.payload;
    },
  },
});

///---Edit---Grievance---

const GrievanceEditSlice = createSlice({
  name: "GrievanceEditCall",
  initialState: {
    GrievanceEdit: [],
    error: "",
  },
  reducers: {
    settheGrievanceEditActions: (state, actions) => {
      state.GrievanceEdit = [];
      state.error = "";
    },
    setTheGrievanceEditRESponse: (state, actions) => {
      state.GrievanceEdit = actions.payload;
    },
    setTheGrievancediterror: (state, actions) => {
      state.error = actions.payload;
    },
  },
});

////--------------Performance---type---------------------
const performanceTypeSlice = createSlice({
  name: "performanceTypeCall",
  initialState: {
    performanceDatas: [],
    selectedPerformerData: [],
    Error: "",
    Total_Count: "",
  },
  reducers: {
    setPerformanceAction: (state, actions) => {
      state.performanceDatas = [];
      state.Error = "";
      state.Total_Count = "";
    },
    setSelectedPerformer: (state, actions) => {
      state.selectedPerformerData = actions.payload;
    },
    setPerformanceResponse: (state, actions) => {
      state.performanceDatas = actions.payload;
    },
    setPerformanceTotal_counts: (state, actions) => {
      state.Total_Count = actions.payload;
    },
    setPerformanceError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});
////--------------Performance---type---------------------
const performanceTypeRetreveSlice = createSlice({
  name: "performanceRetrieveTypeCall",
  initialState: {
    performanceRetreveDatas: [],
    Error: "",
    Total_Count: "",
  },
  reducers: {
    setPerformanceRetreveAction: (state, actions) => {
      state.performanceRetreveDatas = [];
      state.Error = "";
    },
    setPerformanceRetreveResponse: (state, actions) => {
      state.performanceRetreveDatas = actions.payload;
    },
    setPerformanceRetreveError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});
////--------------Performance---create---------------------
const performanceTypeCreateSlice = createSlice({
  name: "performanceCreateTypeCall",
  initialState: {
    performanceCreateDatas: [],
    Error: "",
  },
  reducers: {
    setPerformanceCreateAction: (state, actions) => {
      state.performanceCreateDatas = [];
      state.Error = "";
    },
    setPerformanceCreateResponse: (state, actions) => {
      state.performanceCreateDatas = actions.payload;
    },
    setPerformanceCreateError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});
////--------------Performance---Update---------------------
const performanceTypeUpdateSlice = createSlice({
  name: "performanceUpdateTypeCall",
  initialState: {
    performanceUpdateDatas: [],
    Error: "",
  },
  reducers: {
    setPerformanceUpdateAction: (state, actions) => {
      state.performanceUpdateDatas = [];
      state.Error = "";
    },
    setPerformanceUpdateResponse: (state, actions) => {
      state.performanceUpdateDatas = actions.payload;
    },
    setPerformanceUpdateError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});
////--------------Performance---Delete---------------------
const performanceTypeDeleteSlice = createSlice({
  name: "performanceDeleteTypeCall",
  initialState: {
    performanceDeleteDatas: [],
    Error: "",
  },
  reducers: {
    setPerformanceDeleteAction: (state, actions) => {
      state.performanceDeleteDatas = [];
      state.Error = "";
    },
    setPerformanceDeleteResponse: (state, actions) => {
      state.performanceDeleteDatas = actions.payload;
    },
    setPerformanceDeleteError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});
////--------------PerformanceChild---type---------------------
const performanceChildTypeSlice = createSlice({
  name: "performanceChildTypeCall",
  initialState: {
    performanceChildDatas: [],
    Error: "",
    Total_Count: "",
  },
  reducers: {
    setPerformanceChildAction: (state, actions) => {
      state.performanceChildDatas = [];
      state.Error = "";
      state.Total_Count = "";
    },
    setPerformanceChildResponse: (state, actions) => {
      state.performanceChildDatas = actions.payload;
    },
    setPerformanceChildTotal_counts: (state, actions) => {
      state.Total_Count = actions.payload;
    },
    setPerformanceChildError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});
////--------------PerformanceChild---type---------------------
const performanceChildTypeRetreveSlice = createSlice({
  name: "performanceChildRetrieveTypeCall",
  initialState: {
    performanceChildRetreveDatas: [],
    Error: "",
    Total_Count: "",
  },
  reducers: {
    setPerformanceChildRetreveAction: (state, actions) => {
      state.performanceChildRetreveDatas = [];
      state.Error = "";
      state.Total_Count = "";
    },
    setPerformanceChildRetreveResponse: (state, actions) => {
      state.performanceChildRetreveDatas = actions.payload;
    },
    setPerformanceChildRetreveTotal_counts: (state, actions) => {
      state.Total_Count = actions.payload;
    },
    setPerformanceChildRetreveError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});
////--------------PerformanceChild---create---------------------
const performanceTypeChildCreateSlice = createSlice({
  name: "performanceChildCreateTypeCall",
  initialState: {
    performanceChildCreateDatas: [],
    Error: "",
  },
  reducers: {
    setPerformanceChildCreateAction: (state, actions) => {
      state.performanceChildCreateDatas = [];
      state.Error = "";
    },
    setPerformanceChildCreateResponse: (state, actions) => {
      state.performanceChildCreateDatas = actions.payload;
    },
    setPerformanceChildCreateError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});
////--------------PerformanceChild---Update---------------------
const performanceTypeUpdateChildSlice = createSlice({
  name: "performanceUpdateChildTypeCall",
  initialState: {
    performanceUpdateChildDatas: [],
    Error: "",
  },
  reducers: {
    setPerformanceUpdateChildAction: (state, actions) => {
      state.performanceUpdateChildDatas = [];
      state.Error = "";
    },
    setPerformanceUpdateChildResponse: (state, actions) => {
      state.performanceUpdateChildDatas = actions.payload;
    },
    setPerformanceUpdateChildError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});
////--------------PerformanceChild---Delete---------------------
const performanceTypeChildDeleteSlice = createSlice({
  name: "performanceChildDeleteTypeCall",
  initialState: {
    performanceChildDeleteDatas: [],
    Error: "",
  },
  reducers: {
    setPerformanceChildDeleteAction: (state, actions) => {
      state.performanceChildDeleteDatas = [];
      state.Error = "";
    },
    setPerformanceChildDeleteResponse: (state, actions) => {
      state.performanceChildDeleteDatas = actions.payload;
    },
    setPerformanceChildDeleteError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});
///-----------------------Performs---Field---agent---
const PerformFieldAgentSlice = createSlice({
  name: "PerformFieldAGentGet",
  initialState: {
    performsDataField: [],
    Error: "",
    Total_Count: "",
  },
  reducers: {
    setThePerformFieldAGentGet: (state, actions) => {
      state.performsDataField = [];
      state.Error = "";
      state.Total_Count = "";
    },
    setThePerformsFieldResponse: (state, actions) => {
      state.performsDataField = actions.payload;
    },
    setPerformanceFieldTotal_counts: (state, actions) => {
      state.Total_Count = actions.payload;
    },
    setPerformanceFieldError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

////----Performs------Field---AGent-----(Perform-----Datassss)
const PerformsFieldAGentetrieveSLice = createSlice({
  name: "PerformsFieldAgentRetrieve",
  initialState: {
    performsRetrieveData: [],
    Error: "",
  },
  reducers: {
    setThePerformsAgentRetrieveACtion: (state, actions) => {
      state.performsRetrieveData = [];
      state.Error = "";
    },
    setPerformanceRetrieveFieldResponse: (state, actions) => {
      state.performsRetrieveData = actions.payload;
    },
    setPerformanceRetrieveFielError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

////----Performs------Field---AGent-----(Perform-----Datassss)
const PerformsFieldAGentetrieveSeparateSLice = createSlice({
  name: "PerformsFieldAgentseparateRetrievename",
  initialState: {
    performsRetrieveseparatData: [],
    Error: "",
  },
  reducers: {
    setThePerformsAgentRetrieveseparatestandACtion: (state, actions) => {
      state.performsRetrieveseparatData = [];
      state.Error = "";
    },
    setPerformanceRetrieveFieldseparateResponse: (state, actions) => {
      state.performsRetrieveseparatData = actions.payload;
    },
    setPerformanceRetrieveFielseparateError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

////----Performs------Field---post-----
const PerformsFieldAGentCReateSLice = createSlice({
  name: "PerformsFieldAgentCreate",
  initialState: {
    performsCreateData: [],
    Error: "",
  },
  reducers: {
    setThePerformsAgentCreateACtion: (state, actions) => {
      state.performsCreateData = [];
      state.Error = "";
    },
    setPerformanceCreateFieldResponse: (state, actions) => {
      state.performsCreateData = actions.payload;
    },
    setPerformanceCreateFielError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});
////----Performs------Field---Put-----
const PerformsFieldAGentEditSLice = createSlice({
  name: "PerformsFieldAgentEdit",
  initialState: {
    performsEditData: [],
    Error: "",
  },
  reducers: {
    setThePerformsAgentEditACtion: (state, actions) => {
      state.performsEditData = [];
      state.Error = "";
    },
    setPerformanceEditFieldResponse: (state, actions) => {
      state.performsEditData = actions.payload;
    },
    setPerformanceEditFielError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

//-----COunting----For----The----
const CountingForClientDetailsSlice = createSlice({
  name: "clientDetailsCall",
  initialState: {
    ActiveClinetTabs: 1,
    clientBrancheditIDs: 1,
    ActiveForUserProfile: 1,
    UserId: "",
    CreateActive: 1,
  },
  reducers: {
    SettheActiveTabsActionClientDetails: (state, action) => {
      state.ActiveClinetTabs = action.payload;
    },
    Branch_EDIT_CLIENT_DETAILS: (state, actions) => {
      state.clientBrancheditIDs = actions.payload;
    },
    setTheUserProfileActive: (state, actions) => {
      state.ActiveForUserProfile = actions.payload;
    },
    setTheUseridEditIds: (state, actions) => {
      state.UserId = actions.payload;
    },
    setCreateActive: (state, actions) => {
      state.CreateActive = actions.payload;
    },
  },
});

///----Excel--Sheet----Upload----*
const excelSheetUploadSomeSlice = createSlice({
  name: "ExcelSheetUploadFieldST",
  initialState: {
    ExcelSheetUploadFieldST: [],
    Error: "",
  },
  reducers: {
    setTheSHeetuploaAction: (state, actions) => {
      state.Error = "";
      state.ExcelSheetUploadFieldST = [];
    },
    setTheExcelSheetUploadSTActions: (state, actions) => {
      state.ExcelSheetUploadFieldST = [];
    },
    setTheExcelSheetuploadERROES: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const craeetEmployeeSignSlice = createSlice({
  name: "createEmployeeCallSign",
  initialState: {
    createEmpLoSinData: [],
    Error: "",
  },
  reducers: {
    setThecreateEmploSigAction: (state, actions) => {
      state.Error = "";
      state.createEmpLoSinData = [];
    },
    settheCreateEmployeeResponse: (state, actions) => {
      state.createEmpLoSinData = [];
    },
    settheCreareEmployeErr: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});
///---grievance--Approval--
const GrievaceApproveSlice = createSlice({
  name: "GrivanceDatas",
  initialState: {
    GrivanceApproval: [],
    Error: "",
  },
  reducers: {
    SetTheGrievaceApprovalActions: (state, actions) => {
      state.GrivanceApproval = [];
      state.Error = "";
    },
    setTheGrievanceApprovalResponse: (state, actions) => {
      state.GrivanceApproval = actions.payload;
    },
    setTheGrievanceApprovalErrors: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

///---Attendance----Reuest---List---
export const AttendanceListSlice = createSlice({
  name: "AttendanceCall",
  initialState: {
    AttendanceListDatas: [],
    Error: "",
    Total_count: "",
  },
  reducers: {
    StetheAttendanceActions: (state, actions) => {
      state.AttendanceListDatas = [];
      state.Error = "";
      state.Total_count = "";
    },
    SetTheAttendanceResponseActions: (state, actions) => {
      state.AttendanceListDatas = actions.payload;
    },
    setTeAttendanceTotal_counts: (state, actions) => {
      state.Total_count = actions.payload;
    },
    setTheAttendanceListError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

///--Retrive----------Attendance Request----------------

export const AttendanceRetriveListSlice = createSlice({
  name: "AttendanceRetriveCall",
  initialState: {
    AttendanceListRetrievDatas: [],
    Error: "",
  },
  reducers: {
    StetheAttendanceRetrievActions: (state, actions) => {
      state.AttendanceListRetrievDatas = [];
      state.Error = "";
    },
    SetTheAttendanceResponseRetriveActions: (state, actions) => {
      state.AttendanceListRetrievDatas = actions.payload;
    },

    setTheAttendanceListRetrieveError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

///----Attendance-------Request----Approve
export const AttendanceApproveListSlice = createSlice({
  name: "AttendanceApproveeCall",
  initialState: {
    AttendanceListApproveDatas: [],
    Error: "",
  },
  reducers: {
    StetheAttendanceApproveActions: (state, actions) => {
      state.AttendanceListApproveDatas = [];
      state.Error = "";
    },
    SetTheAttendanceResponsepproveActions: (state, actions) => {
      state.AttendanceListApproveDatas = actions.payload;
    },

    setTheAttendanceListApproveError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

////--Man---Power---Performs------Active---_pads---
export const ManPowerActiveSlice = createSlice({
  name: "ManPowerActiveDataTabs",
  initialState: {
    ActiveTabManPower: 1,
    EditIDs: "",
    NameForForm: "",
    Ids: "",
    total_ids: [],
    ListNames: [],
    putIDS: "",
    LastIDSPerformanceidss: "",
    LastObjectWithName_total: [],
    tocallretrieve: false,
    statusCOdeForESign: 100,
    Employeeskillassessmentids: "",
    ListofSkillAssessment: [],
    fortheformSkillAssessment: [],
    SetthefristNameofassessmentemp: "",
  },
  reducers: {
    setManpowerActivetabs: (state, actions) => {
      state.ActiveTabManPower = actions.payload;
    },
    SetTheIDs: (state, actions) => {
      state.EditIDs = actions.payload;
    },
    settheempsillassessmentsids: (state, actions) => {
      state.Employeeskillassessmentids = actions.payload;
    },
    setTheNameFormForm: (state, actions) => {
      console.log(actions.payload, "asduasidas dpo ");

      state.NameForForm = actions.payload;
    },
    settheEmpAssessmentNames: (state, actions) => {
      state.SetthefristNameofassessmentemp = actions.payload;
    },
    setthelistifskillassessment: (state, actions) => {
      state.ListofSkillAssessment = actions.payload;
    },
    settheformforskillassessment: (state, actions) => {
      state.fortheformSkillAssessment = actions.payload;
    },
    setTocalllRetrieve: (state, actions) => {
      state.tocallretrieve = actions.payload;
    },
    settheStandardIDS: (state, actions) => {
      state.Ids = actions.payload;
    },
    setthetotal_ids: (state, actions) => {
      state.total_ids = actions.payload;
    },
    setTheListNamesactions: (state, actions) => {
      state.ListNames = actions.payload;
    },
    setThePutIdAnswerIds: (state, actions) => {
      state.putIDS = actions.payload;
    },
    setTheLastPerformanceIds: (state, actions) => {
      state.LastIDSPerformanceidss = actions.payload;
    },
    setTheLastObjectwithTotal_points: (state, actions) => {
      state.LastObjectWithName_total = actions.payload;
    },
    setTheEsignatureCodes: (state, actions) => {
      state.statusCOdeForESign = actions.payload;
    },
  },
});
///--Attendance----exports--------------------
const AttendanceexportSlice = createSlice({
  name: "AttendanceexportCall",
  initialState: {
    AttendanceListExportDatas: [],
    Error: "",
  },
  reducers: {
    StetheAttendanceExportActions: (state, actions) => {
      state.AttendanceListExportDatas = [];
      state.Error = "";
    },
    SetTheAttendanceResponseExportActions: (state, actions) => {
      state.AttendanceListExportDatas = actions.payload;
    },

    setTheAttendanceListExportError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

///---Black--Permission-----List
const BlacklistListSlice = createSlice({
  name: "BlacklistLists",
  initialState: {
    BlackListdataList: [],
    Error: "",
    Total_Count: "",
  },
  reducers: {
    SetTheBlacklistActions: (state, actions) => {
      state.BlackListdataList = [];
      state.Error = "";
      state.Total_Count = "";
    },
    SetTheBlackllistResponse: (state, actions) => {
      state.BlackListdataList = actions.payload;
    },
    SetTheBlackistTotal_counts: (state, actions) => {
      state.Total_Count = actions.payload;
    },
    SetTheBlacklistError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

///------------BlackListRetrirSlice
const BlackListRetrirSlice = createSlice({
  name: "BlacklistRetrieveCall",
  initialState: {
    Blacklistdataretrieve: [],
    Error: "",
  },
  reducers: {
    SetTheBlacklistRetrieveActions: (state, actions) => {
      state.Error = "";
      state.Blacklistdataretrieve = [];
    },
    SettheBlacklistresponseRetrieveActions: (state, actions) => {
      state.Blacklistdataretrieve = actions.payload;
    },
    SetBlacklistErrorRetrieve: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const BlackListCREATESlice = createSlice({
  name: "BlacklistCreateCall",
  initialState: {
    BlacklistdataCreate: [],
    Error: "",
  },
  reducers: {
    SetTheBlacklistCreateActions: (state, actions) => {
      state.Error = "";
      state.BlacklistdataCreate = [];
    },
    SettheBlacklistresponseCreateActions: (state, actions) => {
      state.BlacklistdataCreate = actions.payload;
    },
    SetBlacklistErrorCreate: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

/////---BlacklistEditSlice----Edits------
const BlacklistEditSlice = createSlice({
  name: "BlacklistEditCall",
  initialState: {
    BlacklistEdit: [],
    Error: "",
  },
  reducers: {
    SetTheBlacklistEditsActions: (state, actions) => {
      state.Error = "";
      state.BlacklistEdit = [];
    },
    SettheBlacklistResponsesActions: (state, actions) => {
      state.BlacklistEdit = actions.payload;
    },
    SetTheBlacklistErrorEdits: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

////----Site---transfer---
const SiteTramsferSlice = createSlice({
  name: "SiteTransfertLists",
  initialState: {
    SiteTranfersdataList: [],
    Error: "",
    Total_Count: "",
  },
  reducers: {
    SetTheSiteTransferActions: (state, actions) => {
      state.SiteTranfersdataList = [];
      state.Error = "";
      state.Total_Count = "";
    },
    SetThesiteTramsferResponse: (state, actions) => {
      state.SiteTranfersdataList = actions.payload;
    },
    SetThesiteTramfersTotal_counts: (state, actions) => {
      state.Total_Count = actions.payload;
    },
    SetTheSiteTranferError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

////---Site---tansfer-----approve-----

const SiteTransferRetrirSlice = createSlice({
  name: "SiteTransferRetrieveCall",
  initialState: {
    SiteTramsferDataretrieve: [],
    Error: "",
  },
  reducers: {
    SetTheSiteTransferRetrieveActions: (state, actions) => {
      state.Error = "";
      state.SiteTramsferDataretrieve = [];
    },
    SettheSiteTransferRetrieveResponsesActions: (state, actions) => {
      state.SiteTramsferDataretrieve = actions.payload;
    },
    SetSiteTransferErrorRetrieve: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

/////---Site Transfer--Edits------
const SiteTramsferEditSlice = createSlice({
  name: "SiteTramsferEditCall",
  initialState: {
    SiteTramsferCallEdit: [],
    Error: "",
  },
  reducers: {
    SetTheSiteTransferEditsActions: (state, actions) => {
      state.Error = "";
      state.SiteTramsferCallEdit = [];
    },
    SettheSiteTranfserResponsesActions: (state, actions) => {
      state.SiteTramsferCallEdit = actions.payload;
    },
    SetTheSiteTramsferErrorEdits: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});
/////------site---Tramsfer
const SiteTransferCreateSlice = createSlice({
  name: "SiteTrabsferCreateCall",
  initialState: {
    SiteTransferCallCreate: [],
    Error: "",
  },
  reducers: {
    SetTheSiteTransferCreateActions: (state, actions) => {
      state.Error = "";
      state.SiteTransferCallCreate = [];
    },
    SettheSiteTranfserResponsesCreateActions: (state, actions) => {
      state.SiteTransferCallCreate = actions.payload;
    },
    SetTheSiteTramsferErrorCreate: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

///---send---notifications-------

const sendnotificationcreateSlice = createSlice({
  name: "SendNotificationferCreateCall",
  initialState: {
    SendNotificationsCallCreate: [],
    Error: "",
  },
  reducers: {
    SetThesendNotificationCreateActions: (state, actions) => {
      state.Error = "";
      state.SendNotificationsCallCreate = [];
    },
    setTheNotificationcreateResponse: (state, actions) => {
      state.SendNotificationsCallCreate = actions.payload;
    },
    SetTheSendnotificationErrorCreate: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

///-------------------------------html---formats=------downloads------
const PdfDownloadsSlices = createSlice({
  name: "pdfdownloadcall",
  initialState: {
    PdfDownloadDatas: "",
    Error: "",
  },
  reducers: {
    sethtmlformatpdfdownoadActions: (state, actions) => {
      state.PdfDownloadDatas = [];
      state.Error = "";
    },
    setHtlformatpdfdownloadreponse: (state, actions) => {
      state.PdfDownloadDatas = actions.payload;
    },

    sethtmlformatpdfdownloaderr: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

///----appraisal---post----imfor------------------------

export const AppraisalPostHtmlFormatsSlice = createSlice({
  name: "AppraisalPostcall",
  initialState: {
    AppraisalPostData: [],
    Error: "",
  },
  reducers: {
    setAppraisalHtmlPostActions: (state, actions) => {
      state.AppraisalPostData = [];
      state.Error = "";
    },
    settheAppraisalHtmlFormatsPostsResponse: (state, actions) => {
      state.AppraisalPostData = actions.payload;
    },

    setTheAppraisalErrorReponseshtmlForm: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

////-----------------------Attendance---export---get----list
const AttendanceExportGetlistSlice = createSlice({
  name: "AttendanceExportDatacall",
  initialState: {
    AttendanceExportdata: [],
    Error: "",
    Total_Count: "",
  },
  reducers: {
    setAttendanceExportgetlistActions: (state, actions) => {
      state.AttendanceExportdata = [];
      state.Error = "";
      state.Total_Count = "";
    },
    setTheAttendanceExportgetListReponse: (state, actions) => {
      state.AttendanceExportdata = actions.payload;
    },
    setTheAttendanceExportTotal_counts: (state, actions) => {
      state.Total_Count = actions.payload;
    },
    setTheAttendanceExportGetListError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

////-------------admin---access list---get----list
const AdminuseraccesslistGetlistSlice = createSlice({
  name: "AdminuseraccesslistCall",
  initialState: {
    AdminuseraccesslistDatas: [],
    Error: "",
    Total_Count: "",
  },
  reducers: {
    setAdminuseraccesslistDatasgetlistActions: (state, actions) => {
      state.AdminuseraccesslistDatas = [];
      state.Error = "";
      state.Total_Count = "";
    },
    setTheAdminuseraccesslistDatasgetListReponse: (state, actions) => {
      state.AdminuseraccesslistDatas = actions.payload;
    },
    setTheAdminuseraccesslistDatasTotal_counts: (state, actions) => {
      state.Total_Count = actions.payload;
    },
    setTheAdminuseraccesslistDatasGetListError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

///---Post---list--
export const adminuseraccesscreateSlice = createSlice({
  name: "adminuseraccesscrate",
  initialState: {
    adminuseraccesscreatedata: [],
    Error: "",
  },
  reducers: {
    setadminuseraccessceateActions: (state, actions) => {
      state.adminuseraccesscreatedata = [];
      state.Error = "";
    },
    settheadminuseraccesscratePostsResponse: (state, actions) => {
      state.adminuseraccesscreatedata = actions.payload;
    },

    setTheadminuseraccesscrateReponsesError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});
///---retrieve---
export const adminuseraccessRETRIEVESlice = createSlice({
  name: "adminuseraccessRETRIEVE",
  initialState: {
    adminuseraccessREtrievedata: [],
    Error: "",
  },
  reducers: {
    setadminuseraccessRetrieveActions: (state, actions) => {
      state.adminuseraccessREtrievedata = [];
      state.Error = "";
    },
    settheadminuseraccessRetrievePostsResponse: (state, actions) => {
      state.adminuseraccessREtrievedata = actions.payload;
    },

    setTheadminuseraccessRetrieveReponsesError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

//---PUt---
export const adminuseraccessEDITSlice = createSlice({
  name: "adminuseraccesEDIT",
  initialState: {
    adminuseraccessEDITdata: [],
    Error: "",
  },
  reducers: {
    setadminuseraccessEDITActions: (state, actions) => {
      state.adminuseraccessEDITdata = [];
      state.Error = "";
    },
    settheadminuseraccessEDITPutResponse: (state, actions) => {
      state.adminuseraccessEDITdata = actions.payload;
    },

    setTheadminuseraccessEDITReponsesError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});
export const adminuseraccesDELETESlice = createSlice({
  name: "adminuseraccesDelETE",
  initialState: {
    adminuseraccessDelETEdata: [],
    Error: "",
  },
  reducers: {
    setadminuseraccessdeleteActions: (state, actions) => {
      state.adminuseraccessDelETEdata = [];
      state.Error = "";
    },
    settheadminuseraccesdeleteResponse: (state, actions) => {
      state.adminuseraccessDelETEdata = actions.payload;
    },

    setTheadminuseraccessdeleteReponsesError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

export const IDVERIFYCATIONUNKOWNAPISLICE = createSlice({
  name: "idverfiyicationapidatas",
  initialState: {
    Idverificationanotherapidatas: [],
    Error: "",
    AAdharFrontImagesBase: "",
    AAdharBackmageBase64: "",
    AADHARFILESFRONt: {},
    AADHARFILESBackSide: {},

    AAdharFrontImagesDatas: [],
    AadharBackSideImageDatas: [],
    FirstAadharNumber: "",
    SecondAadharNumbers: "",
  },
  reducers: {
    setIDverifycationanotherapidatasActions: (state, actions) => {
      state.Idverificationanotherapidatas = [];
      state.Error = "";
    },
    settheIDverifycationanotherapidatasResponse: (state, actions) => {
      state.Idverificationanotherapidatas = actions.payload;
    },

    settheAadarFrontImageAsBase64: (state, actions) => {
      state.AAdharFrontImagesBase = actions.payload;
    },
    setAadharBackSideImageAsbase64: (state, actions) => {
      state.AAdharBackmageBase64 = actions.payload;
    },

    setTheAadharFrontImageDatas: (state, actions) => {
      state.AAdharFrontImagesDatas = actions.payload;
    },
    ///first data

    setTheAadharBackSideImageDatas: (state, actions) => {
      state.AadharBackSideImageDatas = actions.payload;
    },

    ///second datas

    setTheAadharFristNumbers: (state, actions) => {
      state.FirstAadharNumber = actions.payload;
    },

    setTHnUMBERSRESPONSES: (state, actions) => {
      state.SecondAadharNumbers = actions.payload;
    },

    settheAadarFrontFiles: (state, actions) => {
      state.AADHARFILESFRONt = actions.payload;
    },
    setAadharBackSideFilesAs: (state, actions) => {
      state.AADHARFILESBackSide = actions.payload;
    },
    setIDverifycationanotherapidatasReponsesError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

export const PanCardAnother_OtherParyApisSlice = createSlice({
  name: "OtherPartyApiForPAn",
  initialState: {
    OtherPartyPans: {},
    Error: "",
  },
  reducers: {
    setTheOtherpARTYaPIaCTIONS: (state, actions) => {
      state.OtherPartyPans = {};
      state.Error = "";
    },
    setTheOtherPartyApiResponsesActions: (state, actions) => {
      state.OtherPartyPans = actions.payload;
    },
    setTheotherAPtyApiInErrorMsg: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

export const ExportEXCELFORMATTOEMPLOYEESLICE = createSlice({
  name: "exportexcelsheetforEMPandClien",
  initialState: {
    sheetdownloaddatas: [],
    Error: "",
  },
  reducers: {
    setTheExcelsheetUploadDataForEmpCIlent: (state, actions) => {
      state.sheetdownloaddatas = [];
      state.Error = "";
    },
    setTheExcelSheetDataforEMpANdclientResponses: (state, actions) => {
      state.sheetdownloaddatas = actions.payload;
    },

    setExcelSheetgetEmpANdClientReponsesError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});
//---------Bank----Passbook---
export const bacnkPassbookOrChecqueSlice = createSlice({
  name: "UpdateDatafromChequeOrPassbook",
  initialState: {
    dataAdDecoded: [],
    DataAsEncoded: [],
    Error: "",
  },
  reducers: {
    setTheActionsFroTheBankPassbooks: (state, actions) => {
      state.dataAdDecoded = [];
      state.DataAsEncoded = [];
      state.Error = "";
    },
    setTheDataAsEncodedDataResponses: (state, actions) => {
      state.DataAsEncoded = actions.payload;
    },
    setTheDatabaseontheEncodededResponses: (state, actions) => {
      state.dataAdDecoded = actions.payload;
    },
    setThePassBookActionsErrorrs: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

///---------Otp---Veirifications ----
export const OtpverifiiedSLice = createSlice({
  name: "OtpVeririedPhoneNumbers",
  initialState: {
    phoneNumber: "",
    Error: "",
    statuscode: "",
  },
  reducers: {
    setTheActionForOtpPhoneNumbers: (state, actions) => {
      state.Error = "";
      state.phoneNumber = "";
    },
    setThePhoneNumberOtpREsponses: (state, actions) => {
      state.phoneNumber = actions.payload;
    },
    setTheStatusCodeFortheEmplyeeOnboards: (state, actions) => {
      state.statuscode = actions.payload;
    },
    setThePhoneNumberOfOtpVerified_Error: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

export const ResendOtpverifiiedSLice = createSlice({
  name: "ResentOtpVeririedPhoneNumbers",
  initialState: {
    ResentphoneNumber: "",
    Error: "",
    statusResentcode: "",
  },
  reducers: {
    setTheActionResentForOtpPhoneNumbers: (state, actions) => {
      state.Error = "";
      state.ResentphoneNumber = "";
    },
    setTheResentPhoneNumberOtpREsponses: (state, actions) => {
      state.ResentphoneNumber = actions.payload;
    },
    setTheStatusResentCodeFortheEmplyeeOnboards: (state, actions) => {
      state.statusResentcode = actions.payload;
    },
    setThePhoneNumberResentOfOtpVerified_Error: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

export const OtpverifiiedWithSLice = createSlice({
  name: "OtpVeririedwithPhoneNumbers",
  initialState: {
    PhoneNumerData: "",
    Error: "",
  },
  reducers: {
    setTheActionForOtpwithPhoneNumbers: (state, actions) => {
      state.Error = "";
      state.PhoneNumerData = "";
    },
    setThePhoneNumberwithOtpREsponses: (state, actions) => {
      state.PhoneNumerData = actions.payload;
    },
    setThePhoneNumberOfwithOtpVerified_Error: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

///---attendance---Requst----
const WebAttandanceRequestSlice = createSlice({
  name: "AttendancezRequestSliceList",
  initialState: {
    AttendanceRequestData: [],
    Error: "",
    Total_Count: "",
  },
  reducers: {
    setAttedancelistDatasgetlistActions: (state, actions) => {
      state.AttendanceRequestData = [];
      state.Error = "";
      state.Total_Count = "";
    },
    setTheAttendancesaccesslistDatasgetListReponse: (state, actions) => {
      state.AttendanceRequestData = actions.payload;
    },
    setTheAttendanceslistDatasTotal_counts: (state, actions) => {
      state.Total_Count = actions.payload;
    },
    setTheAdttendanceslistDatasGetListError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});
const ActiveEmployeeListSlice = createSlice({
  name: "ActveEmployeeList",
  initialState: {
    ActivEmployeeListDatas: [],
    Error: "",
    Total_Count: "",
  },
  reducers: {
    SetTheActiveEmployeeListACtions: (state, actions) => {
      state.ActivEmployeeListDatas = [];
      state.Error = "";
      state.Total_Count = "";
    },
    setTheActiveEmployeeListActionsResponses: (state, actions) => {
      state.ActivEmployeeListDatas = actions.payload;
    },
    setTheActiveEmployeeListErrorReponses: (state, actions) => {
      state.Error = actions.payload;
    },
    setTheActiveEmployeeTotal_counts: (state, actions) => {
      state.Total_Count = actions.payload;
    },
  },
});

const RetirveForAPPEmployeeToLeftSlice = createSlice({
  name: "RetrieveForAproEmployeeTOleft",
  initialState: {
    RetrieveForApoEmployeeLeftdata: [],
    Error: "",
  },
  reducers: {
    setTheRetrieveForApproveEmployeeTOLeftAOffice: (state, actions) => {
      state.RetrieveForApoEmployeeLeftdata = [];
      state.Error = "";
    },
    setTheRetrievForApproveEmployeeTOleftResponses: (state, actions) => {
      state.RetrieveForApoEmployeeLeftdata = actions.payload;
    },
    setTheRetieveFroApproveApproveEmployeeTOleftError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

///----Approve----
const ApproveEmployeeToLeftSlice = createSlice({
  name: "ApproveEmployeeTOleft",
  initialState: {
    ApproveEmployeeLeftdata: [],
    Error: "",
  },
  reducers: {
    setTheApproveEmployeeTOLeftAOffice: (state, actions) => {
      state.ApproveEmployeeLeftdata = [];
      state.Error = "";
    },
    setTheApproveEmployeeTOleftResponses: (state, actions) => {
      state.ApproveEmployeeLeftdata = actions.payload;
    },
    setTheApproveEmployeeTOleftError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

///---Active----Employee------Creates---
const ActiveEmployeeCreateListSLice = createSlice({
  name: "ActiveEmployeeCreateData",
  initialState: {
    ActiveEmployeeDaas: [],
    Error: "",
  },
  reducers: {
    setTheActiveEmployeeCreatesList: (state, actions) => {
      state.ActiveEmployeeDaas = [];

      state.Error = "";
    },
    setTheActiveEmployeeActionResponses: (state, actions) => {
      state.ActiveEmployeeDaas = actions.payload;
    },
    setTheActiveEmployeesResponseInErrorMessage: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const PerformSheetExportSLice = createSlice({
  name: "PerformanceAnswerExports",
  initialState: {
    PerformanceExportAnswerDatas: [],
    Error: "",
  },

  reducers: {
    SetThePerformanceExportSheetDatasActions: (state, actions) => {
      state.PerformanceExportAnswerDatas = [];

      state.Error = "";
    },
    setThePerformanceExportSheetDatasReponses: (state, actions) => {
      state.PerformanceExportAnswerDatas = actions.payload;
    },
    setThPerformanceExportSheetDatasErrorReponses: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

//----Appraisal----export -
const AppraisalDataSlices = createSlice({
  name: "AppraisalDatasListesUDS",
  initialState: {
    AppraisalDataListes: [],
    Error: "",
    Total_Count: "",
  },
  reducers: {
    SetTheAppraisalListActions: (state, actions) => {
      state.AppraisalDataListes = [];
      state.Error = "";
      state.Total_Count = "";
    },
    setTheAppraisalListedreponses: (state, actions) => {
      state.AppraisalDataListes = actions.payload;
    },
    setTheAAppraiisalEroorerrorReponses: (state, actions) => {
      state.Error = actions.payload;
    },
    setTheAppraisalListCountsTotal_counts: (state, actions) => {
      state.Total_Count = actions.payload;
    },
  },
});

///--Appraisal----Slice------retrieve
const AppraisalSliceRetrieveSlices = createSlice({
  name: "AppraisalSliceDatasss",
  initialState: {
    AppraisalDatasLists: [],
    Error: "",
  },

  reducers: {
    SetTheAppraisalRetrieveDatasActions: (state, actions) => {
      state.AppraisalDatasLists = [];

      state.Error = "";
    },
    setTheAppraisalRetrieveDatasReponses: (state, actions) => {
      state.AppraisalDatasLists = actions.payload;
    },
    setTheAppaisalRetrieveSlicesErrorReponses: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const SuperviorsSlicePutlist = createSlice({
  name: "PutCreateSuperviorserList",
  initialState: {
    putSuerpirosists: [],
    Error: "",
  },
  reducers: {
    setTheSuperviorsgeteListActions: (state, actions) => {
      state.putSuerpirosists = [];
      state.Error = "";
    },
    setThesuperViorsResponseActionss: (state, actions) => {
      state.putSuerpirosists = actions.payload;
    },
    setTheSuperviorseErrorResponses: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const SuperviorsSlicegetList = createSlice({
  name: "SuperviorsSlice",
  initialState: {
    SuperviorsData: [],
    Error: "",
    Total_Count: "",
  },
  reducers: {
    SetTheSuperviorsListACtions: (state, actions) => {
      state.SuperviorsData = [];
      state.Error = "";
      state.Total_Count = "";
    },
    setTheSuperviorsListActionsResponses: (state, actions) => {
      state.SuperviorsData = actions.payload;
    },
    setTheSuperviorsListErrorReponses: (state, actions) => {
      state.Error = actions.payload;
    },
    setTheSuperviorsTotal_counts: (state, actions) => {
      state.Total_Count = actions.payload;
    },
  },
});

const SuperviorsEmloyeegetList = createSlice({
  name: "SuperviorsEmployeee",
  initialState: {
    SuperviorsEmployeeeData: [],
    Error: "",
  },
  reducers: {
    SetTheSuperviorsLisEmployeeeetACtions: (state, actions) => {
      state.SuperviorsEmployeeeData = [];
      state.Error = "";
    },
    setTheSuperviorsListEmploeyeeActionsResponses: (state, actions) => {
      state.SuperviorsEmployeeeData = actions.payload;
    },
    setTheSuperviorsListErrorEmployeeeReponses: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

///----------attendancemulitiplelist
const attendancemulitipleListSlice = createSlice({
  name: "attendacemulitipleLists",
  initialState: {
    AttedanceEditmulitiple: [],
    Error: "",
  },
  reducers: {
    settheAttedanceListMulitipleActions: (state, actions) => {
      state.AttedanceEditmulitiple = [];
      state.Error = "";
    },
    setTheAttedanceListMulitipleResponses: (state, actions) => {
      state.AttedanceEditmulitiple = actions.payload;
    },
    setTheAttedanceListErrorMulitiples: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

///----Performance---Header---list
const PerformanceHeaderSliceList = createSlice({
  name: "PerfromancesheaderListedsicess",
  initialState: {
    PerformancesListedDatas: [],
    Error: "",
    Total_Count: "",
  },
  reducers: {
    setTheActionsListsPerformanceHeaderListed: (state, actions) => {
      state.PerformancesListedDatas = [];
      state.Error = "";
      state.Total_Count = "";
    },
    setThePerformancesHeaderListedResponses: (state, actions) => {
      state.PerformancesListedDatas = actions.payload;
    },
    setThePerfromanceListedErrorResponses: (state, actions) => {
      state.Error = actions.payload;
    },
    setthePerformancesListedTotal_counts: (state, actions) => {
      state.Total_Count = actions.payload;
    },
  },
});

///---needed datass------as slice
const NeededDatasAsSlice = createSlice({
  name: "NeededdatasListed",
  initialState: {
    clientNameList: "",
    BranchNameListed: "",
    IDS: 1,
    SubQueryIDs: "",
    dateOfJoing: "",
    UdsLoginEMP: 1,
    PageIndex: 1,
    StatusFilter: {
      is_pending: "",
      is_decline: "",
      approved: "",
    },
    MyonboardingList: { value: "", label: "All" },
    HRonboardingList: { value: "", label: "All" },
    HrmsConnectivityList: { value: "1", label: "All" },
    InternalTicketIds: "",
    Ticketpopup_thanks: false,
    RoutesDefinedof: 0,
    TicketSucssesPopup: false,
    ticketReassignpopup: false,
    TicketDashboardMangements: "Open",
    findthReassings: 3,
    ClosingPopups: 1,
    Notificationfirebasetoken: "",
  },
  reducers: {
    setfirebasenotificationtoken: (state, actions) => {
      state.Notificationfirebasetoken = actions.payload;
    },
    settehCLosingopups: (state, actions) => {
      state.ClosingPopups = actions.payload;
    },
    setthefindthReassings: (state, actions) => {
      state.findthReassings = actions.payload;
    },
    SettheTicketDashboardStatusManagement: (state, actions) => {
      state.TicketDashboardMangements = actions.payload;
    },
    settheReassignTicketpopups: (state, actions) => {
      state.ticketReassignpopup = actions.payload;
    },
    settheTicketSuccesspopuos: (state, actions) => {
      state.TicketSucssesPopup = actions.payload;
    },
    settheTicketViewIds: (state, actions) => {
      state.InternalTicketIds = actions.payload;
    },
    settheTicketraiseroutes: (state, actions) => {
      state.RoutesDefinedof = actions.payload;
    },
    settehTicketthankspopup: (state, actions) => {
      state.Ticketpopup_thanks = actions.payload;
    },
    setTheClientNamelisted: (state, actions) => {
      state.clientNameList = actions.payload;
    },
    setTheBranchNameAsListed: (state, actions) => {
      state.BranchNameListed = actions.payload;
    },
    setTheIdOne: (state, actions) => {
      state.IDS = actions.payload;
    },
    setTheSubQueryIDs: (state, actions) => {
      state.SubQueryIDs = actions.payload;
    },
    settheDateOfjoining: (state, actions) => {
      state.dateOfJoing = actions.payload;
    },
    setTheUDSEmployeeLogin: (state, actions) => {
      state.UdsLoginEMP = actions.payload;
    },
    setTheStatusFilter: (state, actions) => {
      state.StatusFilter = actions.payload;
    },
    setthemyonboardingListedDatas: (state, actions) => {
      state.MyonboardingList = actions.payload;
    },
    settheHRonboardingListedDatas: (state, actions) => {
      state.HRonboardingList = actions.payload;
    },
    settheHrmsConnectivityListedDatas: (state, actions) => {
      state.HrmsConnectivityList = actions.payload;
    },
    setThePageIndex: (state, actions) => (state.PageIndex = actions.payload),
  },
});

//----Dashboard--For---employee--attendance results
const EmployeeDashboardSlice = createSlice({
  name: "EmployeeDashBoardAttedances",
  initialState: {
    AttedanceDatas: [],
    Error: "",
  },
  reducers: {
    SettheEmployeeAttedanceResults: (state, actions) => {
      state.AttedanceDatas = [];
      state.Error = "";
    },
    SettheEmployeeAttendanceResponseDatas: (state, actions) => {
      state.AttedanceDatas = actions.payload;
    },
    setTheEmployeeDashboardAttedanceResults: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

////----DashBoard-----
const DaShboardwithemployeedetailsSlice = createSlice({
  name: "DashboardwithempAttendanceCall",
  initialState: {
    Dashboardwithemp: [],
    Error: "",
  },
  reducers: {
    setTheDashboardwithEmpactions: (state, actions) => {
      state.Dashboard = [];
      state.Error = "";
    },
    setTheDashboardwithEmployeeattendanceResponses: (state, actions) => {
      state.Dashboard = actions.payload;
    },
    setTheDashboardwithempAttendanceErrors: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

//----userDetails---export
const UserDetailsInexportedSlice = createSlice({
  name: "UserDetailsExportSheet",
  initialState: {
    userExportSheetDatas: [],
    Error: "",
  },
  reducers: {
    setTheUserDetailsExportActions: (state, actions) => {
      state.userExportSheetDatas = [];
      state.Error = "";
    },
    setTheUserDetailsResponsiveExport: (state, actions) => {
      state.userExportSheetDatas = actions.payload;
    },
    SettheUserDetailsErrorExport: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});
///-----Query---------------------------Questions-------------------------
const QueryQuestionsSlice = createSlice({
  name: "QueryQuetionsDatas",
  initialState: {
    QueryQuestionsDatas: [],
    Error: "",
    Total_Count: "",
  },
  reducers: {
    settheQueryQuestionActions: (state, actions) => {
      state.QueryQuestionsDatas = [];
      state.Error = "";
    },
    setTheQueryQuestionsResponses: (state, actions) => {
      state.QueryQuestionsDatas = actions.payload;
    },
    setTheQueryQuestionsError: (state, actions) => {
      state.Error = actions.payload;
    },
    setTheQueryQuestionTotalCounts: (state, actions) => {
      state.Total_Count = actions.payload;
    },
  },
});

///---query---------creations---
const queryQuestionCreateSlice = createSlice({
  name: "QueryQuestionsCreate",
  initialState: {
    QueryQuestionCreate: [],
    Error: "",
  },

  reducers: {
    setTheQueryQuestionsCreateActions: (state, actions) => {
      state.QueryQuestionCreate = [];
      state.Error = "";
    },
    setTheQueryQuestionsCreateResponsive: (state, actions) => {
      state.QueryQuestionCreate = actions.payload;
    },
    SettheQueryQuestionsCreateError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const queryQuestionEditSlice = createSlice({
  name: "QueryQuestionsEdit",
  initialState: {
    QueryQuestionEdit: [],
    Error: "",
  },

  reducers: {
    setTheQueryQuestionsEditActions: (state, actions) => {
      state.QueryQuestionEdit = [];
      state.Error = "";
    },
    setTheQueryQuestionsEditResponsive: (state, actions) => {
      state.QueryQuestionEdit = actions.payload;
    },
    SettheQueryQuestionsEditError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const queryQuestionRetrieveSlice = createSlice({
  name: "QueryQuestionsRetrieve",
  initialState: {
    QueryQuestionRetrieve: [],
    Error: "",
  },

  reducers: {
    setTheQueryQuestionsRetrieveActions: (state, actions) => {
      state.QueryQuestionRetrieve = [];
      state.Error = "";
    },
    setTheQueryQuestionsRetrieveResponsive: (state, actions) => {
      state.QueryQuestionRetrieve = actions.payload;
    },
    SettheQueryQuestionsRetrieveError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const queryQuestionDeleteSlice = createSlice({
  name: "QueryQuestionsDelete",
  initialState: {
    QueryQuestionDelete: [],
    Error: "",
  },

  reducers: {
    setTheQueryQuestionsDeleteActions: (state, actions) => {
      state.QueryQuestionDelete = [];
      state.Error = "";
    },
    setTheQueryQuestionsdeleteResponsive: (state, actions) => {
      state.QueryQuestionDelete = actions.payload;
    },
    SettheQueryQuestionsDeletError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

///-----Query-----------------------Sub----Questions-------------------------
const QuerySubQuestionsSlice = createSlice({
  name: "QuerySubQuetionsDatas",
  initialState: {
    QuerySubQuestionsDatas: [],
    Error: "",
    Total_Count: "",
  },
  reducers: {
    settheQuerySubQuestionActions: (state, actions) => {
      state.QuerySubQuestionsDatas = [];
      state.Error = "";
    },
    setTheQuerySubQuestionsResponses: (state, actions) => {
      state.QuerySubQuestionsDatas = actions.payload;
    },
    setTheQuerySubQuestionsError: (state, actions) => {
      state.Error = actions.payload;
    },
    setTheQuerySubQuestionTotalCounts: (state, actions) => {
      state.Total_Count = actions.payload;
    },
  },
});

///---query---------creations---
const QuerySUbQuestionCreateSlice = createSlice({
  name: "QuerySubQuestionsCreate",
  initialState: {
    QuerySubQuestionCreate: [],
    Error: "",
  },

  reducers: {
    setTheQuerySubQuestionsCreateActions: (state, actions) => {
      state.QuerySubQuestionCreate = [];
      state.Error = "";
    },
    setTheQuerySubQuestionsCreateResponsive: (state, actions) => {
      state.QuerySubQuestionCreate = actions.payload;
    },
    SettheQuerySubQuestionsCreateError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

///---query---------Editions---
const QuerySUbQuestionEdtionsSlice = createSlice({
  name: "QuerySubQuestionsEditions",
  initialState: {
    QuerySubQuestionEdit: [],
    Error: "",
  },

  reducers: {
    setTheQuerySubQuestionsEditionsActions: (state, actions) => {
      state.QuerySubQuestionEdit = [];
      state.Error = "";
    },
    setTheQuerySubQuestionsEditionsResponsive: (state, actions) => {
      state.QuerySubQuestionEdit = actions.payload;
    },
    SettheQuerySubQuestionsEditionError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

///---query---------Retrieve---
const QuerySUbQuestionRetrieveSlice = createSlice({
  name: "QuerySubQuestionsRetrieve",
  initialState: {
    QuerySubQuestionRetrieve: [],
    Error: "",
  },

  reducers: {
    setTheQuerySubQuestionsRetrieveActions: (state, actions) => {
      state.QuerySubQuestionRetrieve = [];
      state.Error = "";
    },
    setTheQuerySubQuestionsRetrieveResponsive: (state, actions) => {
      state.QuerySubQuestionRetrieve = actions.payload;
    },
    SettheQuerySubQuestionsRetrieveError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const querySUBQuestionDeleteSlice = createSlice({
  name: "QuerySUBQuestionsDelete",
  initialState: {
    QuerySUBQuestionDelete: [],
    Error: "",
  },

  reducers: {
    setTheQuerySUbQuestionsDeleteActions: (state, actions) => {
      state.QuerySUBQuestionDelete = [];
      state.Error = "";
    },
    setTheQuerySUbQuestionsdeleteResponsive: (state, actions) => {
      state.QuerySUBQuestionDelete = actions.payload;
    },
    SettheQuerySUbQuestionsDeletError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

///---Tracking---records-----------

const TrackingrecordSlice = createSlice({
  name: "TrackingrecordgetList",
  initialState: {
    TrackingrecordgetListData: [],
    Error: "",
    Total_Count: "",
    TrackingReport: [],
  },
  reducers: {
    settheTrackingrecordgetListDataActions: (state, actions) => {
      state.TrackingrecordgetListData = [];
      state.Error = "";
    },
    setTheTrackingrecordgetListDataResponses: (state, actions) => {
      state.TrackingrecordgetListData = actions.payload;
    },
    setTrackignRecordListDashboardReport: (state, actions) => {
      state.TrackingReport = actions.payload;
    },
    setTheQTrackingrecordgetListDatasError: (state, actions) => {
      state.Error = actions.payload;
    },
    setTheTrackingrecordgetListDataTotalCounts: (state, actions) => {
      state.Total_Count = actions.payload;
    },
  },
});

///---Tracking---------Retrieve---
const QueryTrackingrecordgetListRetrieveSlice = createSlice({
  name: "QueryTrackingrecordgetListRetrieve",
  initialState: {
    QueryTrackingrecordRetrieve: [],
    Error: "",
  },

  reducers: {
    setTheQueryTrackingrecordgetListRetrieveActions: (state, actions) => {
      state.QueryTrackingrecordRetrieve = [];
      state.Error = "";
    },
    setTheQueryTrackingrecordgetListRetrieveResponsive: (state, actions) => {
      state.QueryTrackingrecordRetrieve = actions.payload;
    },
    SettheTrackingrecordgetListRetrieveError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

///---Tracking---------Editions---
const QueryTrackingrecordgetListSlice = createSlice({
  name: "QueryTrackingrecordgetListEditions",
  initialState: {
    QueryTrackingrecordgetListEdit: [],
    Error: "",
  },

  reducers: {
    setTheTrackingEditionsActions: (state, actions) => {
      state.QueryTrackingrecordgetListEdit = [];
      state.Error = "";
    },
    setTheTrackingEditionsResponsive: (state, actions) => {
      state.QueryTrackingrecordgetListEdit = actions.payload;
    },
    SettheTrackingEditionError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const TrackingDeleteSlice = createSlice({
  name: "TrackingDelete",
  initialState: {
    TrackingDeletedatas: [],
    Error: "",
  },

  reducers: {
    setTheTrackingDeleteActions: (state, actions) => {
      state.TrackingDeletedatas = [];
      state.Error = "";
    },
    setTheTrackingdeleteResponsive: (state, actions) => {
      state.TrackingDeletedatas = actions.payload;
    },
    SettheTrackingDeletError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

//---my ticket---list
const MyTicketsSlice = createSlice({
  name: "MyTicketsSliceDatas",
  initialState: {
    MyTicketsSliceDATAS: [],
    Error: "",
    Total_Count: "",
    MyticketsCharts: [],
  },
  reducers: {
    settheMyTicketsDataActions: (state, actions) => {
      state.MyTicketsSliceDATAS = [];
      state.Error = "";
    },
    setTheMyticketsgetListDataResponses: (state, actions) => {
      state.MyTicketsSliceDATAS = actions.payload;
    },
    setTheQMyTicketsListDatasError: (state, actions) => {
      state.Error = actions.payload;
    },
    setTheMyTicketsListDataTotalCounts: (state, actions) => {
      state.Total_Count = actions.payload;
    },
    setTheMyticketsinChartList: (state, actions) => {
      state.MyticketsCharts = actions.payload;
    },
  },
});

//--tracking create---slice
const TrackingCreateSlice = createSlice({
  name: "TrackingCreateSliceName",
  initialState: {
    TracnkingCreateData: [],
    Error: "",
  },
  reducers: {
    setTheTrackingCreateActions: (state, actions) => {
      state.TracnkingCreateData = [];
      state.Error = "";
    },
    setTheTrackingCreateResponses: (state, actions) => {
      state.TracnkingCreateData = actions.payload;
    },
    setTheTrackingCreateError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

//----Finance-----listed

// const FinanceGetlistedSlice = createSlice({
//   name: "FinanceGetListedData",
//   initialState: {
//     FinanceDatas: [],
//     Error: "",
//     Total_Count: "",
//     FinanceDatasCounts: "",
//     PanCardDatas:[],
//     Total_CountPan: "",

//     WhatsAppData:[],
//     Total_CountWhatsAPp: "",

//     BanckCardData:[],
//     Total_Count_bank: "",

//   },

//   reducers: {
//     setThefinanceDataActions: (state, actions) => {
//       state.FinanceDatas = [];
//       state.Error = "";
//       state.Total_Count ="",
//       state.FinanceDatasCounts = "",
//       state.PanCardDatas = [],
//       state.Total_CountPan = "",
//       state.WhatsAppData = [],
//       state.Total_CountWhatsAPp = "",
//       state.BanckCardData = [],
//       state.Total_Count_bank = "",

//     },
//     setThefinanceResponsiveDatas: (state, actions) => {
//       state.FinanceDatas = actions.payload;
//     },
//     setTheFinanceCountsDatas: (state, actions) => {
//       state.FinanceDatasCounts = actions.payload;
//     },
//     setTheFinancetableTotal_Count: (state, actions) => {
//       state.Total_Count = actions.payload;
//     },
//     setTheFinanceErrorResponse: (state, actions) => {
//       state.Error = actions.payload;
//     },

//     setThefinanceResponsivePancardDatas: (state, actions) => {
//       state.PanCardDatas = actions.payload;
//     },

//     setTheFinancetableTotal_CountPan: (state, actions) => {
//       state.Total_CountPan = actions.payload;
//     },
//     setThefinanceResponsiveWhatsapppDatas: (state, actions) => {
//       state.Total_CountWhatsAPp = actions.payload;
//     },

//     setTheFinancetableTotal_CountwhatsApp: (state, actions) => {
//       state.WhatsAppData = actions.payload;
//     },

//     setThefinanceResponsiveBankDatas: (state, actions) => {
//       state.BanckCardData = actions.payload;
//     },
//     setTheFinancetableTotal_CountBank: (state, actions) => {
//       state.Total_Count_bank = actions.payload;
//     },
//   },
// });

const FinanceGetlistedSlice = createSlice({
  name: "FinanceGetListedData",
  initialState: {
    FinanceDatas: [],
    Error: "",
    Total_Count: "",
    FinanceDatasCounts: "",
    PanCardDatas: [],
    Total_CountPan: "",
    WhatsAppData: [],
    Total_CountWhatsAPp: "",
    BanckCardData: [],
    Total_Count_bank: "",
  },
  reducers: {
    setThefinanceDataActions: (state, actions) => {
      state.FinanceDatas = [];
      state.Error = "";
      state.Total_Count = "";
      state.FinanceDatasCounts = "";
      state.PanCardDatas = [];
      state.Total_CountPan = "";
      state.WhatsAppData = [];
      state.Total_CountWhatsAPp = "";
      state.BanckCardData = [];
      state.Total_Count_bank = "";
    },
    setThefinanceResponsiveDatas: (state, actions) => {
      state.FinanceDatas = actions.payload;
    },
    setTheFinanceCountsDatas: (state, actions) => {
      state.FinanceDatasCounts = actions.payload;
    },
    setTheFinancetableTotal_Count: (state, actions) => {
      state.Total_Count = actions.payload;
    },
    setTheFinanceErrorResponse: (state, actions) => {
      state.Error = actions.payload;
    },
    setThefinanceResponsivePancardDatas: (state, actions) => {
      state.PanCardDatas = actions.payload;
    },
    setTheFinancetableTotal_CountPan: (state, actions) => {
      state.Total_CountPan = actions.payload;
    },
    setThefinanceResponsiveWhatsapppDatas: (state, actions) => {
      state.WhatsAppData = actions.payload;
    },
    setTheFinancetableTotal_CountwhatsApp: (state, actions) => {
      state.Total_CountWhatsAPp = actions.payload;
    },
    setThefinanceResponsiveBankDatas: (state, actions) => {
      state.BanckCardData = actions.payload;
    },
    setTheFinancetableTotal_CountBank: (state, actions) => {
      state.Total_Count_bank = actions.payload;
    },
  },
});

const FinanceGetlistedExportSlice = createSlice({
  name: "FinanceGetListedExportData",
  initialState: {
    FinanceExportDatas: [],
    Error: "",
  },

  reducers: {
    setThefinanceDataExportActions: (state, actions) => {
      state.FinanceExportDatas = [];
      state.Error = "";
    },
    setThefinanceResponsiveExportDatas: (state, actions) => {
      state.FinanceExportDatas = actions.payload;
    },

    setTheFinanceErrorExportResponse: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const AttendanceREPORTSlice = createSlice({
  name: "AttendanceREPORTDataCall",
  initialState: {
    AttendanceReportData: [],
    Error: "",
    Total_Count: "",
  },

  reducers: {
    setTheAttendanceReportActions: (state, actions) => {
      state.AttendanceReportData = [];
      state.Error = "";
    },
    setTheAttendanceReportResponsiveDatas: (state, actions) => {
      state.AttendanceReportData = actions.payload;
    },

    setTheAttendanceReportTotal_Count: (state, actions) => {
      state.Total_Count = actions.payload;
    },
    setTheAttendanceReportErrorResponse: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const OnboaderDetailsSlice = createSlice({
  name: "OnboaderDetailsListOut",
  initialState: {
    OnboarderDetailsDATA: [],
    Error: "",
    Total_Count: "",
  },

  reducers: {
    setTheOnboarderdetailsReportActions: (state, actions) => {
      state.OnboarderDetailsDATA = [];
      state.Error = "";
    },
    setTheAuthrorzedToatalCounts: (state, actions) => {
      state.Total_Count = actions.payload;
    },
    setTheOnboarderDetailsResponsiveDatas: (state, actions) => {
      state.OnboarderDetailsDATA = actions.payload;
    },
    setTheOnboaderdetailsReportErrorResponse: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

///----Other---party Apis
const OtherPartyAAdhaarsendOtpSlice = createSlice({
  name: "AadharOtherPartyAPIPhoneOtp",
  initialState: {
    AadhaOtpSuccessResponse: [],
    Error: "",
    Client_id: "",
  },
  reducers: {
    setTheOtherAAdhaarOtpPhoneNuberAction: (state, actions) => {
      state.AadhaOtpSuccessResponse = [];
      state.Error = "";
    },
    setTheOtherPartyApiAADharReponse: (state, actions) => {
      state.AadhaOtpSuccessResponse = actions.payload;
    },
    settheAAdharPhoneNumberOtpSend: (state, actions) => {
      state.Error = actions.payload;
    },
    setTheClient_id: (state, actions) => {
      state.Client_id = actions.payload;
    },
  },
});

///---submit aadhar----send otp

const AADharSubmitOtpSlice = createSlice({
  name: "aadharsentSubmitthephoneotp",
  initialState: {
    aadharsentotpsubmit: [],
    Error: "",
    SubmitValues: false,
  },

  reducers: {
    setTheaadharsentOtpReportActions: (state, actions) => {
      state.aadharsentotpsubmit = [];
      state.Error = "";
    },

    setTheAadharsendthesubmitotpResponsiveDatas: (state, actions) => {
      state.aadharsentotpsubmit = actions.payload;
    },
    setTheaadharsubmitotpErrReportErrorResponse: (state, actions) => {
      state.Error = actions.payload;
    },
    setTheSumbitOtpFormsAadhar_verified: (state, actions) => {
      state.SubmitValues = actions.payload;
    },
  },
});

const PANCARDSubmitOtpSlice = createSlice({
  name: "PANCARDthephoneotp",
  initialState: {
    PANCARDDATA: false,
    Error: "",
    Client_ID: "",
    PanCardVerifyData: {},
  },

  reducers: {
    setThePANCARDeportActions: (state, actions) => {
      state.PANCARDDATA = [];
      state.Error = "";
      state.Client_ID = "";
    },
    setTheCLientID: (state, actions) => {
      state.Client_ID = actions.payload;
    },
    setThePANCARDotpResponsiveDatas: (state, actions) => {
      state.PANCARDDATA = actions.payload;
    },
    setThePANCARDVerifyDatas: (state, actions) => {
      state.PanCardVerifyData = actions.payload;
    },

    setThePANCARDrrReportErrorResponse: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const PANCARDSUBMIEDOtpSlice = createSlice({
  name: "PANCARDtheSUBMITEDphoneotp",
  initialState: {
    PANCARDDATASUBMITED: [],
    Error: "",
  },

  reducers: {
    setThePANCARDSUBMITeportActions: (state, actions) => {
      state.PANCARDDATASUBMITED = [];
      state.Error = "";
    },

    setThePANCARDotpSUBMITResponsiveDatas: (state, actions) => {
      state.PANCARDDATASUBMITED = actions.payload;
    },
    setThePANCARDSUBMITOTPResponse: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

///----penny drop---token create
const tokenCreateForpennydropslice = createSlice({
  name: "pennydropforBankVerify",
  initialState: {
    BankVerifyTokenCreate: [],
    Error: "",
  },
  reducers: {
    CreateTokenForBankVerifyActions: (state, actions) => {
      state.BankVerifyTokenCreate = [];
      state.Error = "";
    },
    Createtoken_store: (state, actions) => {
      state.BankVerifyTokenCreate = actions.payload;
    },
    createToken_store_erro_reposen: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

///--pennydrop---verify
const BankVerifiedDropslice = createSlice({
  name: "pennydropforBank",
  initialState: {
    BankVerify: false,
    Error: "",
    AccountExit: false,
    transaction_id: "",
    Bank_Holder_Name: "",
  },
  reducers: {
    BankVerifyActions: (state, actions) => {
      state.BankVerify = [];
      state.Error = "";
      state.AccountExit = false;
    },
    CreateResponse_store: (state, actions) => {
      state.BankVerify = actions.payload;
    },
    setTheAccountExit: (state, actions) => {
      state.AccountExit = actions.payload;
    },
    createBankverifyed_store_error_reposen: (state, actions) => {
      state.Error = actions.payload;
    },
    setTheTransactionID: (state, actions) => {
      state.transaction_id = actions.payload;
    },
    settheBankHolderName: (state, actions) => {
      state.Bank_Holder_Name = actions.payload;
    },
  },
});

////---onboarding-----------------------cpunts
const OnboardingCountsSlices = createSlice({
  name: "OnboardngCounts",
  initialState: {
    aadhar_count: 0,
    aadhar_front_count: 0,
    aadhar_back_count: 0,
    pan_verify_count: 0,
    pan_front_count: 0,
    bank_count: 0,
  },
  reducers: {
    setAadhar_counts: (state, actions) => {
      state.aadhar_count = actions.payload;
    },
    setTheAadhar_front_count: (state, actions) => {
      state.aadhar_front_count = actions.payload;
    },
    setTheAadharBack_counts: (state, actions) => {
      state.aadhar_back_count = actions.payload;
    },
    setThPanVerifyCounts: (state, actions) => {
      state.pan_verify_count = actions.payload;
    },
    setThePanFrontCOunt: (state, actions) => {
      state.pan_front_count = actions.payload;
    },
    setbankCounts: (state, actions) => {
      state.bank_count = actions.payload;
    },
  },
});

//----Report----sheet----export

const ReportSheetExportSlice = createSlice({
  name: "ReportSheetData",
  initialState: {
    ReportSheetDATAS: [],
    Error: "",
    Total_Count: "",
  },
  reducers: {
    getRoportDatasActions: (state, actions) => {
      state.ReportSheetDATAS = [];
      state.Error = "";
      state.Total_Count = "";
    },
    getRoportdatsListSuccessResponseActions: (state, actions) => {
      state.ReportSheetDATAS = actions.payload;
    },
    getRoportsTotal_pageCounst: (state, actions) => {
      state.Total_Count = actions.payload;
    },
    getRoportDatsListErroResponsen: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});
///---report----delete
const ReportSheetDeleteSlice = createSlice({
  name: "ReportSheetDeleted",
  initialState: {
    ReportSheetDelete: [],
    Error: "",
  },
  reducers: {
    getRoportDeletedActions: (state, actions) => {
      state.ReportSheetDelete = [];
      state.Error = "";
    },
    getRoportdatsListdeletedResponseActions: (state, actions) => {
      state.ReportSheetDelete = actions.payload;
    },

    getRoportDatsListErrodeleteResponsen: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

///post

const ReportSheetExportPostSlice = createSlice({
  name: "ReportSheetpostmethoh",
  initialState: {
    ReportPostcreate: [],
    Error: "",
  },
  reducers: {
    getRoportpostActions: (state, actions) => {
      state.ReportPostcreate = [];
      state.Error = "";
    },
    getRoportpostListSuccessResponseActions: (state, actions) => {
      state.ReportPostcreate = actions.payload;
    },

    getRoportPostListErroResponsen: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

//--------------------customeUDS-Employeeee---email---
const CustomUDSEmployeeLoginSlice = createSlice({
  name: "CustomUDSEMployeeLogin",
  initialState: {
    CustomoginDATAs: [],
    Error: "",
  },
  reducers: {
    SetTheCustomerUDSEmployeeLogin: (state, actions) => {
      state.CustomoginDATAs = [];
      state.Error = "";
    },
    settheCustomerUDSemployeeloginresponse: (state, actions) => {
      state.CustomoginDATAs = actions.payload;
    },
    settheCustomerUDSEmployeeErroMsg: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const LanguageSteup = createSlice({
  name: "laguagefoetheemployees",
  initialState: {
    COuntsForLanguage: 1,
  },
  reducers: {
    getLanguageSetUp: (state, actions) => {
      state.COuntsForLanguage = actions.payload;
    },
  },
});

const UDSROleEmployeeSLiceActions = createSlice({
  name: "UDSemployeeRoleActions",
  initialState: {
    PageChange: 1,
    Branch: {
      latitude: "",
      longitude: "",
    },
    CHECKINKEY: false,
    white_collar: false,
    AttendanceID: "",
    LeaveApplyedDate: [],
    EmpAttendancesBool: false,
  },
  reducers: {
    setTheUdsLoginPagechange: (state, actions) => {
      state.PageChange = actions.payload;
    },
    setTheBranchInlatANDLog: (state, actions) => {
      state.Branch = actions.payload;
    },
    setTheCheckingIn: (state, actions) => {
      state.CHECKINKEY = actions.payload;
    },
    setTheWhiteCollarState: (state, actions) => {
      state.white_collar = actions.payload;
    },
    setTheAttendanceId: (state, actions) => {
      state.AttendanceID = actions.payload;
    },
    setTheLeaveApplyDateUDS_employee: (state, actions) => {
      state.LeaveApplyedDate = actions.payload;
    },
    settheEmpAttendanceBoolValues: (state, actions) => {
      state.EmpAttendancesBool = actions.payload;
    },
  },
});

const CustomUDSEmployeeLsendOtpSlice = createSlice({
  name: "CustomUDSEMployeeSendOTP",
  initialState: {
    CustomSentOtpDATAs: [],
    Error: "",
  },
  reducers: {
    SetTheCustomerUDSEmployeeSendOtp: (state, actions) => {
      state.CustomSentOtpDATAs = [];
      state.Error = "";
    },
    settheCustomerUDSemployeeSendOTPresponse: (state, actions) => {
      state.CustomSentOtpDATAs = actions.payload;
    },
    settheCustomerUDSEmployeeErroMsgSendOtp: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

// ------TableData-------
const TableDataSlice = createSlice({
  name: "TableData",
  initialState: {
    TableData: [],
    error: "",
    Total_Count: "",
    is_show_false: "",
    is_show_true: "",
  },
  reducers: {
    setTableData: (state, payload) => {
      state.error = "";
      state.TableData = [];
    },
    setTableSuccessData: (state, action) => {
      state.TableData = action.payload;
    },
    setTableErrorAction: (state, action) => {
      state.error = action.payload;
      state.TableData = [];
    },
    setDataTotalPageCounts: (state, action) => {
      state.Total_Count = action.payload;
    },
    Setis_show_false: (state, actions) => {
      state.is_show_false = actions.payload;
    },
    setis_show_true: (state, actions) => {
      state.is_show_true = actions.payload;
    },
  },
});

////----Shift--_Datas----------
const ShiftDatasListSlice = createSlice({
  name: "ShiftDatas",
  initialState: {
    ShiftGetList: [],
    Error: "",
  },
  reducers: {
    SetTheShiftDatasActions: (state, actions) => {
      state.ShiftGetList = [];
      state.Error = "";
    },
    SetTheShiftDataresponse: (state, actions) => {
      state.ShiftGetList = actions.payload;
    },
    setTheShiftDatasError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

////----Shift--_Datas----------
const LeaveTypeDataSlice = createSlice({
  name: "LeaveTypeData",
  initialState: {
    LeaveTypeData: [],
    Error: "",
  },
  reducers: {
    SetLeaveTypeDataActions: (state, actions) => {
      state.LeaveTypeData = [];
      state.Error = "";
    },
    SetLeaveTypeDataresponse: (state, actions) => {
      state.LeaveTypeData = actions.payload;
    },
    setLeaveTypeDataError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const OndutyDaysempDataSlice = createSlice({
  name: "OndutyDaysemp",
  initialState: {
    OndutydatasEmployee: [],
    Error: "",
    Total_Count: "",
  },
  reducers: {
    setOndutyDatasEmpAction: (state, actions) => {
      state.OndutydatasEmployee = [];
      state.Error = "";
      state.Total_Count = "";
    },
    SetOndutyEmployeeDataresponse: (state, actions) => {
      state.OndutydatasEmployee = actions.payload;
    },
    SetOndutyEmployeetotalcountDataresponse: (state, actions) => {
      state.Total_Count = actions.payload;
    },
    setOndutyEmployeeDataError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const OndutyEmployeeCreateSlice = createSlice({
  name: "OndutyDaysempCreate",
  initialState: {
    OndutydatasEmployeeCreate: [],
    Error: "",
  },
  reducers: {
    setOndutyDatasEmpCreateAction: (state, actions) => {
      state.OndutydatasEmployeeCreate = [];
      state.Error = "";
    },
    SetOndutyEmployeeDataCreateresponse: (state, actions) => {
      state.OndutydatasEmployeeCreate = actions.payload;
    },
    setOndutyEmployeeDataCreateError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

////----Calendar--_Datas----------
const CalendarSlice = createSlice({
  name: "CalendarCall",
  initialState: {
    CalendarData: [],
    Error: "",
  },
  reducers: {
    SetCalendarActions: (state, actions) => {
      state.CalendarData = [];
      state.Error = "";
    },
    SetCalendarSuccessResponse: (state, actions) => {
      state.CalendarData = actions.payload;
    },
    setCalendarError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});
////----Calendar--_Datas----------
const PayslipSlice = createSlice({
  name: "PayslipCall",
  initialState: {
    PayslipData: [],
    Error: "",
  },
  reducers: {
    SetPayslipActions: (state, actions) => {
      state.PayslipData = [];
      state.Error = "";
    },
    SetPayslipSuccessResponse: (state, actions) => {
      state.PayslipData = actions.payload;
    },
    setPayslipError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

////----Attendance--_Datas----------
const AttenDanceSlice = createSlice({
  name: "AttenDanceCall",
  initialState: {
    AttenDanceData: [],
    Error: "",
    Total_Count: "",
    Responsess: [],
  },
  reducers: {
    SetTheAttendanceDatasActions: (state, actions) => {
      state.AttenDanceData = [];
      state.Error = "";
      state.Total_Count = "";
      state.Responsess = [];
      // state.AttenDanceData = actions.payload;
    },
    setTheAttendanceLeaveResponses: (state, actions) => {
      state.Responsess = actions.payload;
    },
    SetTheAttendanceDataresponse: (state, actions) => {
      state.AttenDanceData = actions.payload;
    },
    setTheAttendanceDatasError: (state, actions) => {
      state.Error = actions.payload;
    },
    setTheAttendanceTotal_counts: (state, actions) => {
      state.Total_Count = actions.payload;
    },
  },
});
////----Attendance--_Datas----------
const AttenDancePermissionSlice = createSlice({
  name: "AttenDancePermissionCall",
  initialState: {
    AttenDancePermissionData: [],
    Error: "",
    Total_Count: "",
    Response: [],
  },
  reducers: {
    SetTheAttendancePermissionDatasActions: (state, actions) => {
      //  state.AttenDancePermissionData = [];
      state.Error = "";
      state.Total_Count = "";
      state.AttenDancePermissionData = [];
    },
    setTheAttendanceResponses: (state, actions) => {
      state.Response = actions.payload;
    },
    SetAttendancePermissionResponse: (state, actions) => {
      state.AttenDancePermissionData = actions.payload;
    },
    setTheAttendancePermissionDatasError: (state, actions) => {
      state.Error = actions.payload;
    },
    setTheAttendancePermissionTotal_counts: (state, actions) => {
      state.Total_Count = actions.payload;
    },
  },
});
////----On duty--_Data----------
const OnDutyUDSSlice = createSlice({
  name: "onDutyCall",
  initialState: {
    OnDutyData: [],
    Error: "",
    Total_Count: "",
    Response: [],
  },
  reducers: {
    SetTheOnDutyDatasActions: (state, actions) => {
      state.Error = "";
      state.Total_Count = "";
      state.OnDutyData = [];
      state.Response = [];
    },
    SetOnDutySuccessResponse: (state, actions) => {
      state.OnDutyData = actions.payload;
    },
    setTheOnDutyResponses: (state, actions) => {
      state.Response = actions.payload;
    },
    setTheOnDutyTotal_counts: (state, actions) => {
      state.Total_Count = actions.payload;
    },
    setTheOnDutyDatasError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

////----Attendance--_Datas----------
const CreateLeaveSlice = createSlice({
  name: "CreateLeaveCall",
  initialState: {
    createLeaveData: [],
    Error: "",
  },
  reducers: {
    SetCreateLeaveAction: (state, actions) => {
      state.createLeaveData = [];
      state.Error = "";
    },
    updateCreateLeaveActionResponse: (state, actions) => {
      state.createLeaveData = [];
      state.Error = "";
    },
    SetCreateLeaveSuccessResponse: (state, actions) => {
      state.createLeaveData = actions.payload;
    },
    SetCreateLeaveError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});
////----Attendance--_Datas----------
const CreateOnDutySlice = createSlice({
  name: "CreateOnDutyCall",
  initialState: {
    createLeaveData: [],
    Error: "",
  },
  reducers: {
    SetCreateOnDutyAction: (state, actions) => {
      state.createLeaveData = [];
      state.Error = "";
    },
    SetCreateOnDutySuccessResponse: (state, actions) => {
      state.createLeaveData = actions.payload;
    },
    SetCreateOnDutyError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

///---Permission

const AttenDanceGetlistempPermissionSlice = createSlice({
  name: "AttenDancePermissionCallEmp",
  initialState: {
    AttenDancePermissionDataEMp: [],
    Error: "",
    Total_Count: "",
    Response: [],
  },
  reducers: {
    SetTheAttendancegetlistempPermissionDatasActions: (state, actions) => {
      state.Error = "";
      state.Total_Count = "";
      state.AttenDancePermissionDataEMp = [];
    },
    setTheAttendancegetlistempResponses: (state, actions) => {
      state.Response = actions.payload;
    },
    SetAttendancePermissiongetlistempResponse: (state, actions) => {
      state.AttenDancePermissionDataEMp = actions.payload;
    },
    setTheAttendancePermissiongetlistempDatasError: (state, actions) => {
      state.Error = actions.payload;
    },
    setTheAttendancePermissiongetListempTotal_counts: (state, actions) => {
      state.Total_Count = actions.payload;
    },
  },
});

///---permission create---for emp
const CreatePermissionForEmpSlice = createSlice({
  name: "CreatePermissionEmp",
  initialState: {
    PermissionCreateForEmp: [],
    Error: "",
  },
  reducers: {
    SetCreatePermissionEmpAction: (state, actions) => {
      state.PermissionCreateForEmp = [];
      state.Error = "";
    },
    SetCreatePermissionEmpSuccessResponse: (state, actions) => {
      state.PermissionCreateForEmp = actions.payload;
    },
    SetCreatePermissionEmpError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

///---attendance regularization

const AttendanceRegularizationForEmployee = createSlice({
  name: "AttenDance_RegularizationCallEmp",
  initialState: {
    AttenDanceRegularizationDataEMp: [],
    Error: "",
    Total_Count: "",
    Response: [],
  },
  reducers: {
    SetTheAttendancegetlistempRegularizationDatasActions: (state, actions) => {
      state.Error = "";
      state.Total_Count = "";
      state.AttenDanceRegularizationDataEMp = [];
    },
    setTheAttendancegetlistempResponsesRegularization: (state, actions) => {
      state.Response = actions.payload;
    },
    SetAttendanceRegularizationlistempResponse: (state, actions) => {
      state.AttenDanceRegularizationDataEMp = actions.payload;
    },
    setTheAttendanceRegularizationlistempDatasError: (state, actions) => {
      state.Error = actions.payload;
    },
    setTheAttendanceRegularizationListempTotal_counts: (state, actions) => {
      state.Total_Count = actions.payload;
    },
  },
});

///---AttendanceRegularization create---for emp
const CreateRegularizationForEmpSlice = createSlice({
  name: "CreateRegularizationEmp",
  initialState: {
    AttendanceRegualrizationCreateForEmp: [],
    Error: "",
  },
  reducers: {
    SetCreateAttendanceRegularizationEmpAction: (state, actions) => {
      state.AttendanceRegualrizationCreateForEmp = [];
      state.Error = "";
    },
    SetCreateAttendanceRegularizationEmpSuccessResponse: (state, actions) => {
      state.AttendanceRegualrizationCreateForEmp = actions.payload;
    },
    SetCreateAttendanceRegularizationEmpError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

///---over time

const OvertimeRegularizationEMpSlice = createSlice({
  name: "Overtime_RegularizationCallEmp",
  initialState: {
    overtimeRegularizationEmp: [],
    Error: "",
    Total_Count: "",
    Response: [],
  },
  reducers: {
    settheOvertimeRegulrizationActions: (state, actions) => {
      state.Error = "";
      state.Total_Count = "";
      state.overtimeRegularizationEmp = [];
    },
    setTheovertimeRegularizationResponse: (state, actions) => {
      state.Response = actions.payload;
    },
    settheOvertimeRegularizationsResponseStore: (state, actions) => {
      state.overtimeRegularizationEmp = actions.payload;
    },
    settheOvertimRegularizationErrorMsg: (state, actions) => {
      state.Error = actions.payload;
    },
    setTheOvertimeRegularizationListempTotal_counts: (state, actions) => {
      state.Total_Count = actions.payload;
    },
  },
});

////----CheckInOut--_Datas----------
const CheckInOutSlice = createSlice({
  name: "CheckInOutCall",
  initialState: {
    CheckInOutData: [],
    Error: "",
  },
  reducers: {
    SetCheckInOutAction: (state, actions) => {
      state.CheckInOutData = [];
      state.Error = "";
    },
    SetCheckInOutSuccessResponse: (state, actions) => {
      state.CheckInOutData = actions.payload;
    },
    SetCheckInOutError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

//---put---method
const CheckInOutPutMethodSlice = createSlice({
  name: "CheckInOutPutMethodCall",
  initialState: {
    CheckInOutPutMethodData: [],
    Error: "",
  },
  reducers: {
    SetCheckInOutputMethosAction: (state, actions) => {
      state.CheckInOutPutMethodData = [];
      state.Error = "";
    },
    SetCheckInOutSuccessputmethodResponse: (state, actions) => {
      state.CheckInOutPutMethodData = actions.payload;
    },
    SetCheckInOutErrorputmethod: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

///---Face verification-----
const FaceVerificationSlice = createSlice({
  name: "FaceVerificationDatas",
  initialState: {
    FaceVerificationSTore: [],
    Error: "",
  },
  reducers: {
    SetFaceVerificationAction: (state, actions) => {
      state.FaceVerificationSTore = [];
      state.Error = "";
    },
    SetCheckInOutSuccessFaceVerificationmethodResponse: (state, actions) => {
      state.FaceVerificationSTore = actions.payload;
    },
    SetCheckInOutFaceVerificationErrorputmethod: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

////----Attendance--_Datas----------
const CreatePermissionSlice = createSlice({
  name: "CreatePermissionCall",
  initialState: {
    createPermissionData: [],
    Error: "",
  },
  reducers: {
    SetCreatePermissionAction: (state, actions) => {
      state.createPermissionData = [];
      state.Error = "";
    },
    SetCreatePermissionSuccessResponse: (state, actions) => {
      state.createPermissionData = actions.payload;
    },
    SetCreatePermissionError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});
////----Reimbursement--_Datas----------
const FetchReimbursementSlice = createSlice({
  name: "FetchReimbursementCall",
  initialState: {
    fetchReimbursementData: [],
    fetchReimbursementFeedData: [],
    Error: "",
  },
  reducers: {
    SetFetchReimbursementAction: (state, actions) => {
      state.fetchReimbursementData = [];
      state.Error = "";
    },
    SetFetchReimbursementSuccessResponse: (state, actions) => {
      state.fetchReimbursementData = actions.payload;
    },
    SetFetchReimbursementResponse: (state, actions) => {
      state.fetchReimbursementFeedData = actions.payload;
    },
    SetFetchReimbursementError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

//-------------Profile-----signature----Get----
const ProfilesignatureSlice = createSlice({
  name: "ProfileSignatureCalls",
  initialState: {
    ProfileSignatureDatas: [],
    Error: "",
    Total_count: "",
  },
  reducers: {
    setTheProfileSignatureActions: (state, actions) => {
      state.ProfileSignatureDatas = [];
      state.Error = "";
    },
    setTheProfileSignatureGetActionsResponse: (state, actions) => {
      state.ProfileSignatureDatas = actions.payload;
    },
    setTheTotal_counts: (state, actions) => {
      state.Total_count = actions.payload;
    },
    settheprofileSignatureGetLIStErrorputmethod: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

//-------------Sony-----Employee----Calls----
const SonyEmployeeCallsSlice = createSlice({
  name: "SonyEmployeeCalls",
  initialState: {
    SonyEmployeeDatas: [],
    Error: "",
    Total_count: 0,
  },
  reducers: {
    setTheSonyEmployeeActions: (state, actions) => {
      state.SonyEmployeeDatas = [];
      state.Error = "";
    },
    setTheSonyEmployeeGetActionsResponse: (state, actions) => {
      state.SonyEmployeeDatas = actions.payload;
    },
    setTheSonyEmployeeTotal_counts: (state, actions) => {
      state.Total_count = actions.payload;
    },
    settheSonyEmployeeGetLIStErrorputmethod: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

///---Profile---signature----edit
//-------------Profile-----signature
const ProfilesignatureEditSlice = createSlice({
  name: "ProfileSignatureEditCalls",
  initialState: {
    ProfileSignatureEDITDatas: [],
    Error: "",
  },
  reducers: {
    setTheProfileSignatureEDITActions: (state, actions) => {
      state.ProfileSignatureEDITDatas = [];
      state.Error = "";
    },
    setTheProfileSignatureEDITResponse: (state, actions) => {
      state.ProfileSignatureEDITDatas = actions.payload;
    },
    settheprofileSignatureEDITmethod: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

///---- Emp_--Profile_get---
const EmployeeAttendanceProfileGetSlice = createSlice({
  name: "EmployeeProfileGetListData",
  initialState: {
    EmployeeProfileGetDataList: [],
    Error: "",
  },
  reducers: {
    setTheEMployeeAttendanceProfileActions: (state, actions) => {
      state.EmployeeProfileGetDataList = [];
      state.Error = "";
    },
    setTheEmpProfileGetAttendanceProfileResponse: (state, actions) => {
      state.EmployeeProfileGetDataList = actions.payload;
    },
    settheprofileErrorEmpAttendancemethod: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const UpdatePostUrlEmpAttendance = createSlice({
  name: "EmployeeProfilepostUpdateListData",
  initialState: {
    UpdatePostUrlEmpAttendaProfile: [],
    Error: "",
  },
  reducers: {
    setTheEMployeeAttendanceupdateProfileActions: (state, actions) => {
      state.UpdatePostUrlEmpAttendaProfile = [];
      state.Error = "";
    },
    setTheEmpProfileGetAttendanceupdateProfileResponse: (state, actions) => {
      state.UpdatePostUrlEmpAttendaProfile = actions.payload;
    },
    settheprofileErrorEmpUpdateAttendancemethod: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

//----------------OverAll Report
const OverAllReportSlice = createSlice({
  name: "OverAllReportCall",
  initialState: {
    overAllReport: [],
    Error: "",
    OverAllreportDatas: [],
    Total_Count: "",
    KYC_VALUE_APPROXIMATED: [],
    Expected_values: [],
  },
  reducers: {
    setOverReportActions: (state, actions) => {
      state.overAllReport = [];
      state.Error = "";
    },
    setOverReportSuccessResponse: (state, actions) => {
      state.overAllReport = actions.payload;
    },
    setTheOverAllReportDatas: (state, actions) => {
      state.OverAllreportDatas = actions.payload;
    },
    setTotal_count_OverReport: (state, actions) => {
      state.Total_Count = actions.payload;
    },
    setOverReportErrorsMessage: (state, actions) => {
      state.Error = actions.payload;
    },
    setThekycapproximatedvalue: (state, actions) => {
      state.KYC_VALUE_APPROXIMATED = actions.payload;
    },
    settheapproximated_values: (state, actions) => {
      state.Expected_values = actions.payload;
    },
  },
});

//----------------OverAll Report
const OverAllEmployeeListSlice = createSlice({
  name: "OverAllReportEmployeeListCall",
  initialState: {
    overAllReportEmployeeList: [],
    Error: "",
    Total_Count: "",
  },
  reducers: {
    setOverReportActionsEmployeeList: (state, actions) => {
      state.overAllReportEmployeeList = [];
      state.Error = "";
    },
    setOverReportSuccessResponseEmployeeList: (state, actions) => {
      state.overAllReportEmployeeList = actions.payload;
    },
    setTotal_count_OverReportEmployeeList: (state, actions) => {
      state.Total_Count = actions.payload;
    },
    setOverReportErrorsMessageEmployee: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const OverAllEmployeeListExportSlice = createSlice({
  name: "OverAllReportEmployeeListExportCall",
  initialState: {
    overAllReportExportEmployeeList: [],
    Error: "",
    Total_Count: "",
  },
  reducers: {
    setOverReportActionsExportEmployeeList: (state, actions) => {
      state.overAllReportExportEmployeeList = [];
      state.Error = "";
    },
    setOverReportSuccessResponseExportEmployeeList: (state, actions) => {
      state.overAllReportExportEmployeeList = actions.payload;
    },

    setOverReportErrorsMessageExportEmployee: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

//----------------OverAll Report
const OverAllReportCreateSlice = createSlice({
  name: "OverAllReportCreateCall",
  initialState: {
    overAllReportCreate: [],
    Error: "",
  },
  reducers: {
    setOverReportCreateActions: (state, actions) => {
      state.overAllReportCreate = [];
      state.Error = "";
    },
    setOverReportSuccessCreateResponse: (state, actions) => {
      state.overAllReportCreate = actions.payload;
    },
    setOverReportErrorsCreateMessage: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

//----------------OverAll Report
const OverAllReportEditSlice = createSlice({
  name: "OverAllReportEditCall",
  initialState: {
    overAllReportEdit: [],
    Error: "",
  },
  reducers: {
    setOverReportEdiyActions: (state, actions) => {
      state.overAllReportEdit = [];
      state.Error = "";
    },
    setOverReportSuccessEditResponse: (state, actions) => {
      state.overAllReportEdit = actions.payload;
    },
    setOverReportErrorsEditMessage: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const OverAllReportRetrieveSlice = createSlice({
  name: "OverAllReportRetrieveCall",
  initialState: {
    overAllReportRetrieve: [],
    Error: "",
  },
  reducers: {
    setOverReportRetrieveActions: (state, actions) => {
      state.overAllReportRetrieve = [];
      state.Error = "";
    },
    setOverReportSuccessRetrieveResponse: (state, actions) => {
      state.overAllReportRetrieve = actions.payload;
    },
    setOverReportErrorsRetrieveMessage: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

//---report----send---Edit
const sendEmailReportEditSlice = createSlice({
  name: "sendEmailREportEditData",
  initialState: {
    sendEmailreportDataEdit: [],
    Error: "",
  },
  reducers: {
    setthesendEmailActions: (state, actions) => {
      state.sendEmailreportDataEdit = [];
      state.Error = "";
    },
    setthesendEmailActionsResponse: (state, actions) => {
      state.sendEmailreportDataEdit = actions.payload;
    },
    setthesendEmailActionsEditError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const sendEmailReportgetslice = createSlice({
  name: "sendEmailREportgetData",
  initialState: {
    sendEmailreportGetList: [],
    Error: "",
  },
  reducers: {
    setthesendEmailGetListActions: (state, actions) => {
      state.sendEmailreportGetList = [];
      state.Error = "";
    },
    setthesendEmailActionsgetListResponse: (state, actions) => {
      state.sendEmailreportGetList = actions.payload;
    },
    setthesendEmailActionsGetListError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

////---state api ---call

const Overallstateslice = createSlice({
  name: "OverallStateCallData",
  initialState: {
    OverallStateGetList: [],
    Error: "",
  },
  reducers: {
    SetTheStateGetListActions: (state, actions) => {
      state.OverallStateGetList = [];
      state.Error = "";
    },
    settheStatesgetListResponse: (state, actions) => {
      state.OverallStateGetList = actions.payload;
    },
    settheStateGetListError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});
// let date = new Date();
// let months = date.getMonth() < 10 ? `0${date.getMonth() + 1}` : date.getMonth();

// let getfullyear = date.getFullYear();
// let skillAssessmentDate = `${getfullyear}-${months}`;
function convert(str) {
  var date = new Date(str),
    mnth = ("0" + (date.getMonth() + 1)).slice(-2),
    day = ("0" + date.getDate()).slice(-2);
  return [date.getFullYear(), mnth, day].join("-");
}

var startweet = convert(startOfWeek(new Date()));
var endweek = convert(endOfWeek(new Date()));

const StateManagementSlice = createSlice({
  name: "StateManagementOverallCall",
  initialState: {
    AttendanceReportState: { value: "", label: "ALL" },
    AttendanceReportZone: { value: "", label: "ALL" },
    AttendanceReportRegion: { value: "", label: "ALL" },

    NodueformState: { value: "", label: "ALL" },
    NodueformZone: { value: "", label: "ALL" },
    NodueformRegion: { value: "", label: "ALL" },
    NodueFormStatusState: { value: "", label: "All" },
    NodueEmployeedesignation: { value: "", label: "ALL" },

    PermissionrequestState: { value: "", label: "ALL" },
    PermissionrequestZone: { value: "", label: "ALL" },
    PermissionrequestRegion: { value: "", label: "ALL" },
    PermissionRequestRange1: "",
    PermissionRequestRange2: "",
    PermissionStatusState: { value: "", label: "All" },
    PermissionEmployeedesignation: { value: "", label: "ALL" },
    OndutyReuquestRange1: "",
    OndutyReuquestRange2: "",
    OndutyrequestState: { value: "", label: "ALL" },
    OndutyrequestZone: { value: "", label: "ALL" },
    OndutyrequestRegion: { value: "", label: "ALL" },
    OndtyStatusState: { value: "", label: "All" },
    OndutyEmployeedesignation: { value: "0", label: "ALL" },

    Attendance_RegularizationRange1: "",
    Attendance_RegularizationRange2: "",
    Attendance_RegularizationState: { value: "", label: "ALL" },
    Attendance_RegularizationZone: { value: "", label: "ALL" },
    Attendance_RegularizationRegion: { value: "", label: "ALL" },
    Attendance_RegularizationStatusState: { value: "", label: "All" },
    Attendance_RegularizationEmployeedesignation: { value: "", label: "ALL" },

    Overtime_RegularizationRange1: "",
    Overtime_RegularizationRange2: "",
    Overtime_RegularizationState: { value: "", label: "ALL" },
    Overtime_RegularizationZone: { value: "", label: "ALL" },
    Overtime_RegularizationRegion: { value: "", label: "ALL" },
    Overtime_RegularizationStatusState: { value: "", label: "All" },
    Overtime_RegularizationEmployeedesignation: { value: "", label: "ALL" },

    ResignState: { value: "", label: "ALL" },
    ResignZone: { value: "", label: "ALL" },
    ResignRegion: { value: "", label: "ALL" },
    Resigndesignation: { value: "0", label: "ALL" },
    ResignStatusState: { value: "", label: "All" },

    ReimbursementState: { value: "", label: "ALL" },
    ReimbursementZone: { value: "", label: "ALL" },
    ReimbursementRegion: { value: "", label: "ALL" },
    Reimbursementdesignation: { value: "", label: "ALL" },
    ReimbursementStatusState: { value: "", label: "All" },
    ReimbursementRange1: "",
    ReimbursementRange2: "",

    Employee_Block_RequestState: { value: "", label: "ALL" },
    Employee_Block_RequestZone: { value: "", label: "ALL" },
    Employee_Block_RequestRegion: { value: "", label: "ALL" },
    Employee_Block_Requestdesignation: { value: "", label: "ALL" },
    Employee_Block_RequestStatusState: { value: "", label: "All" },
    Employee_Block_RequestRange1: "",
    Employee_Block_RequestRange2: "",

    Appraisaldesignation: { value: "", label: "ALL" },
    AppraisalStatusState: { value: "", label: "All" },
    AppraisalRange1: "",
    AppraisalRange2: "",

    Site_TransferState: { value: "", label: "ALL" },
    Site_TransferZone: { value: "", label: "ALL" },
    Site_TransferRegion: { value: "", label: "ALL" },
    Site_Transferdesignation: { value: "", label: "ALL" },
    Site_TransferStatusState: { value: "", label: "All" },
    Site_TransferRange1: "",
    Site_TransferRange2: "",
    PaySlipDesignations: { value: "", label: "ALL" },

    Grievance_ListState: { value: "", label: "ALL" },
    Grievance_ListZone: { value: "", label: "ALL" },
    Grievance_ListRegion: { value: "", label: "ALL" },
    Grievance_Listdesignation: { value: "", label: "ALL" },
    Grievance_ListStatusState: { value: "", label: "All" },
    Grievance_ListRange1: "",
    Grievance_ListRange2: "",

    TicketsStatusState: { value: "0", label: "Open" },
    TicketsRange1: "",
    TicketsRange2: "",

    MYTicketsStatusState: { value: "", label: "All" },
    MYTicketsRange1: "",
    MYTicketsRange2: "",
    TicketingSUbOptionValues: { value: "0", label: "Open" },
    InternalTicketsStatusState: { value: "0", label: "Open" },

    TicketingsysttemStatusState: { value: "0", label: "Open" },
    TicketingsystemRange1: "",
    TicketingsystemRange2: "",
    TicketIDS: "",
    TicketPriorityStatus: { value: "", label: "All" },

    TicketingsystemDashboardRange1: "",
    TicketingsystemDashboardRange2: "",

    Leave_RequestState: { value: "", label: "ALL" },
    Leave_RequestZone: { value: "", label: "ALL" },
    Leave_RequestRegion: { value: "", label: "ALL" },
    Leave_Requestdesignation: { value: "", label: "ALL" },
    Leave_RequestStatusState: { value: "", label: "All" },
    Leave_RequestRange1: "",
    Leave_RequestRange2: "",
    Leave_RequestBranchList: { value: "", label: "ALL" },

    Myonboarding_RequestState: { value: "", label: "ALL" },
    Myonboarding_RequestZone: { value: "", label: "ALL" },
    Myonboarding_RequestRegion: { value: "", label: "ALL" },
    HRonboarding_RequestState: { value: "", label: "ALL" },
    HRonboarding_RequestZone: { value: "", label: "ALL" },
    HRonboarding_RequestRegion: { value: "", label: "ALL" },
    Myonboarding_Range1: "",
    Myonboarding_Range2: "",
    HRonboarding_Range1: "",
    HRonboarding_Range2: "",
    Myonboarding_RequestBranchList: { value: "", label: "ALL" },
    HRonboarding_RequestBranchList: { value: "", label: "ALL" },
    HrmsConnectivity_RequestState: { value: "", label: "ALL" },
    HrmsConnectivity_RequestZone: { value: "", label: "ALL" },
    HrmsConnectivity_RequestRegion: { value: "", label: "ALL" },
    HrmsConnectivity_Range1: "",
    HrmsConnectivity_Range2: "",
    HrmsConnectivity_RequestBranchList: { value: "", label: "ALL" },

    SkillAssesments: { value: "", label: "All" },
    skillassessmentsZone: { value: "", label: "ALL" },
    skillassessmentsRegion: { value: "", label: "ALL" },
    skillassessmentsdesignation: { value: false, label: "ALL" },
    skillassessmentsStatusState: { value: "", label: "All" },
    skillassessmentsStatusMonthYear: {
      month: String(new Date().getMonth() + 1),
      year: String(new Date().getFullYear()),
    },
    SkillassessmentCLient: { value: "", label: "All" },
    Skillassessmentrole: { value: "", label: "All" },
    RoleMonthYearFilter: { month: "", year: "" },
    ticketsystemSubcategoryActive: { value: "", label: "All" },
    DefualtDatefilyer: "ThisWeek",
    InternalDefualtDatesYer: "ThisWeek",
    UDS_ticket_user_typelist: "",
    TicketSummaryselected: "Open",
    AssignandReassign: 1,
    TicketStatus: "Open",
    ReassignTicketIds: "",

    TicketingsystemInnerDashbaordTicektsRange1: "",
    TicketingsystemInnerDashbaordTicketRange2: "",
    TicketExternalViewListedIds: "",
    TicketClientViewNewIholader: "",
    routetotheassignedtickettoview: 0,

    Customer_supportTabActives: "Overview",
    Internal_supportTabActive: "Overview",

    NewInternalSupport_DashbaordFromdate: "",
    NewInernalSupport_DashboardTodata: "",

    NewCustomer_Support_DashbaordFromdate: "",
    NewCustomer_Support_DashboardTodata: "",
    Employeee_designation_filter: { value: "", label: "ALL" },
    SkillAssessments_RegularizationRange1: "",
    SkillAssessments_RegularizationRange2: "",
  },

  reducers: {
    setEmployee_filter_inRole: (state, actions) => {
      state.Employeee_designation_filter = actions.payload;
    },
    settheInternal_SupportFromDate: (state, actions) => {
      state.NewInternalSupport_DashbaordFromdate = actions.payload;
    },
    settheInternal_SupportToDate: (state, actions) => {
      state.NewInernalSupport_DashboardTodata = actions.payload;
    },

    /// custom support date

    settheCustomer_SupportFromDate: (state, actions) => {
      state.NewCustomer_Support_DashbaordFromdate = actions.payload;
    },
    settheCustomer_SupportToDate: (state, actions) => {
      state.NewCustomer_Support_DashboardTodata = actions.payload;
    },

    settheInternalSupportsTabActives: (state, actions) => {
      state.Internal_supportTabActive = actions.payload;
    },
    settheCustomerSupportTabActives: (state, actions) => {
      state.Customer_supportTabActives = actions.payload;
    },
    settheExternalTicketviewslisted: (state, actions) => {
      state.TicketExternalViewListedIds = actions.payload;
    },
    settheInnerDashbaordTicketDaterangeOne: (state, actions) => {
      state.TicketingsystemInnerDashbaordTicektsRange1 = actions.payload;
    },
    settheInnerDashbaordTicketDaterangetwo: (state, actions) => {
      state.TicketingsystemInnerDashbaordTicketRange2 = actions.payload;
    },
    settheTicketingSUbOptionValuesListed: (state, actions) => {
      state.TicketingSUbOptionValues = actions.payload;
    },
    settheTicketReassignIds: (state, actions) => {
      state.ReassignTicketIds = actions.payload;
    },
    settheTicketStatusNames: (state, actions) => {
      state.TicketStatus = actions.payload;
    },
    settheAssignAndReassigns: (state, actions) => {
      state.AssignandReassign = actions.payload;
    },
    settheticketsummaryticketstatus: (state, actions) => {
      state.TicketSummaryselected = actions.payload;
    },
    settheTicketUser_type: (state, actions) => {
      state.ticket_user_type = actions.payload;
    },
    settheDefualtDatefilyer: (state, actions) => {
      state.DefualtDatefilyer = actions.payload;
    },
    settheInternalDefualtDatefilyer: (state, actions) => {
      state.InternalDefualtDatesYer = actions.payload;
    },
    setTheDesignationMonthAndyearFilter: (state, actions) => {
      state.RoleMonthYearFilter = actions.payload;
    },
    settheAttendanceReportState: (state, actions) => {
      state.AttendanceReportState = actions.payload;
    },
    setThaAttendanceReportRegion: (state, actions) => {
      state.AttendanceReportRegion = actions.payload;
    },

    setThaAttendanceReportZone: (state, actions) => {
      state.AttendanceReportZone = actions.payload;
    },

    settheNodueFromState: (state, actions) => {
      state.NodueformState = actions.payload;
    },
    setThaNodueFromrRegion: (state, actions) => {
      state.NodueformRegion = actions.payload;
    },
    setTheNodueDesginations: (state, actions) => {
      state.NodueEmployeedesignation = actions.payload;
    },
    setThaNoDueFormZone: (state, actions) => {
      state.NodueformZone = actions.payload;
    },
    settheNodueFormStatusState: (state, actions) => {
      state.NodueFormStatusState = actions.payload;
    },
    setthePermissionrequestState: (state, actions) => {
      state.PermissionrequestState = actions.payload;
    },
    setThePermissionRequestRegion: (state, actions) => {
      state.PermissionrequestRegion = actions.payload;
    },

    setThePermissionRequestZone: (state, actions) => {
      state.PermissionrequestZone = actions.payload;
    },
    setThePermssionrequestRange1: (state, actions) => {
      state.PermissionRequestRange1 = actions.payload;
    },
    setThePermissionRequestRange2: (state, actions) => {
      state.PermissionRequestRange2 = actions.payload;
    },
    setThePermissionStatusState: (state, actions) => {
      state.PermissionStatusState = actions.payload;
    },
    setTheEmployeeDesginationPermission: (state, actions) => {
      state.PermissionEmployeedesignation = actions.payload;
    },
    setTheOndutyrequestRange1: (state, actions) => {
      state.OndutyReuquestRange1 = actions.payload;
    },
    setTheOndutyRequestRange2: (state, actions) => {
      state.OndutyReuquestRange2 = actions.payload;
    },
    setTheOndutyRequestZone: (state, actions) => {
      state.OndutyrequestZone = actions.payload;
    },
    setTheOndutyRequestState: (state, actions) => {
      state.OndutyrequestState = actions.payload;
    },
    SettheOndutyRequestStatusState: (state, actions) => {
      state.OndtyStatusState = actions.payload;
    },
    setTheOndutyDesignation: (state, actions) => {
      state.OndutyEmployeedesignation = actions.payload;
    },

    setTheOndutyRequestRegion: (state, actions) => {
      state.OndutyrequestRegion = actions.payload;
    },

    setTheAttendance_RegularizationRange1: (state, actions) => {
      state.Attendance_RegularizationRange1 = actions.payload;
    },
    setTheAttendance_RegularizationRange2: (state, actions) => {
      state.Attendance_RegularizationRange2 = actions.payload;
    },
    setTheAttendance_RegularizationZone: (state, actions) => {
      state.Attendance_RegularizationZone = actions.payload;
    },
    setTheAttendance_RegularizationState: (state, actions) => {
      state.Attendance_RegularizationState = actions.payload;
    },
    setTheAttendance_regularizationDesignation: (state, actions) => {
      state.Attendance_RegularizationEmployeedesignation = actions.payload;
    },

    setTheAttendance_RegularizationRegion: (state, actions) => {
      state.Attendance_RegularizationRegion = actions.payload;
    },
    setTheAttedanceRegurlarzationStatus: (state, actions) => {
      state.Attendance_RegularizationStatusState = actions.payload;
    },

    setTheOvertime_RegularizationRange1: (state, actions) => {
      state.Overtime_RegularizationRange1 = actions.payload;
    },
    setTheOvertime_RegularizationRange2: (state, actions) => {
      state.Overtime_RegularizationRange2 = actions.payload;
    },
    setTheOvertime_RegularizationZone: (state, actions) => {
      state.Overtime_RegularizationZone = actions.payload;
    },
    setTheOvertime_RegularizationState: (state, actions) => {
      state.Overtime_RegularizationState = actions.payload;
    },
    setTheOvertime_RegularizationEmployeedesignation: (state, actions) => {
      state.Overtime_RegularizationEmployeedesignation = actions.payload;
    },
    setTheOvertime_RegularizationRegion: (state, actions) => {
      state.Overtime_RegularizationRegion = actions.payload;
    },
    setTheOvertime_RegularizationStatusState: (state, actions) => {
      state.Overtime_RegularizationStatusState = actions.payload;
    },
    settheInternal_Statuss: (state, actions) => {
      state.InternalTicketsStatusState = actions.payload;
    },

    setTheResignZone: (state, actions) => {
      state.ResignZone = actions.payload;
    },
    setTheResignState: (state, actions) => {
      state.ResignState = actions.payload;
    },

    setTheResignRegion: (state, actions) => {
      state.ResignRegion = actions.payload;
    },
    setheResigndesignationStatus: (state, actions) => {
      state.Resigndesignation = actions.payload;
    },
    setTheResignStateStatus: (state, actions) => {
      state.ResignStatusState = actions.payload;
    },

    setTheReimbursementZone: (state, actions) => {
      state.ReimbursementZone = actions.payload;
    },
    setTheReimbursementState: (state, actions) => {
      state.ReimbursementState = actions.payload;
    },

    setTheReimbursementRegion: (state, actions) => {
      state.ReimbursementRegion = actions.payload;
    },
    setheReimbursementdesignationStatus: (state, actions) => {
      state.Reimbursementdesignation = actions.payload;
    },
    setTheReimbursementStateStatus: (state, actions) => {
      state.ReimbursementStatusState = actions.payload;
    },

    setTheReimbursementRange1: (state, actions) => {
      state.ReimbursementRange1 = actions.payload;
    },
    setTheReimbursementRange2: (state, actions) => {
      state.ReimbursementRange2 = actions.payload;
    },

    setTheEmployee_Block_RequestState: (state, actions) => {
      state.Employee_Block_RequestState = actions.payload;
    },

    setTheEmployee_Block_RequestRegion: (state, actions) => {
      state.Employee_Block_RequestRegion = actions.payload;
    },
    setTheEmployee_Block_RequestZone: (state, actions) => {
      state.Employee_Block_RequestZone = actions.payload;
    },
    setheEmployee_Block_RequestdesignationStatus: (state, actions) => {
      state.Employee_Block_Requestdesignation = actions.payload;
    },
    setTheEmployee_Block_RequestStateStatus: (state, actions) => {
      state.Employee_Block_RequestStatusState = actions.payload;
    },

    setTheEmployee_Block_RequestRange1: (state, actions) => {
      state.Employee_Block_RequestRange1 = actions.payload;
    },
    setTheEmployee_Block_RequestRange2: (state, actions) => {
      state.Employee_Block_RequestRange2 = actions.payload;
    },

    setTheAppraisalRange2: (state, actions) => {
      state.AppraisalRange2 = actions.payload;
    },
    setTheAppraisalRange1: (state, actions) => {
      state.AppraisalRange1 = actions.payload;
    },
    settheAppraisalEmployeeDesignation: (state, actions) => {
      state.Appraisaldesignation = actions.payload;
    },
    setTheAppraisalEmploeeeStatuState: (state, actions) => {
      state.AppraisalStatusState = actions.payload;
    },

    setTheSiteTransferState: (state, actions) => {
      state.Site_TransferState = actions.payload;
    },

    setTheSiteTransferRegion: (state, actions) => {
      state.Site_TransferRegion = actions.payload;
    },
    setTheSiteTransferZone: (state, actions) => {
      state.Site_TransferZone = actions.payload;
    },
    setheSiteTransferdesignationStatus: (state, actions) => {
      state.Site_Transferdesignation = actions.payload;
    },
    setTheSiteTransferStateStatus: (state, actions) => {
      state.Site_TransferStatusState = actions.payload;
    },

    setTheSiteTransferRange1: (state, actions) => {
      state.Site_TransferRange1 = actions.payload;
    },
    setTheSiteTransferRange2: (state, actions) => {
      state.Site_TransferRange2 = actions.payload;
    },
    setThePaylipDesignations: (state, actions) => {
      state.PaySlipDesignations = actions.payload;
    },

    setTheGrievance_ListState: (state, actions) => {
      state.Grievance_ListState = actions.payload;
    },

    setTheGrievance_ListRegion: (state, actions) => {
      state.Grievance_ListRegion = actions.payload;
    },
    setTheGrievance_ListZone: (state, actions) => {
      state.Grievance_ListZone = actions.payload;
    },
    setheGrievance_ListdesignationStatus: (state, actions) => {
      state.Grievance_Listdesignation = actions.payload;
    },
    setTheGrievance_ListStateStatus: (state, actions) => {
      state.Grievance_ListStatusState = actions.payload;
    },

    setTheGrievance_ListRange1: (state, actions) => {
      state.Grievance_ListRange1 = actions.payload;
    },
    setTheGrievance_ListRange2: (state, actions) => {
      state.Grievance_ListRange2 = actions.payload;
    },
    setTheTicketsStatusStatuse: (state, actions) => {
      state.TicketsStatusState = actions.payload;
    },
    setTheTicketstRange1: (state, actions) => {
      state.TicketsRange1 = actions.payload;
    },
    setTheTicktesRange2: (state, actions) => {
      state.TicketsRange2 = actions.payload;
    },

    setTheTicketingsystemStatusState: (state, actions) => {
      state.TicketingsysttemStatusState = actions.payload;
    },
    setthePriorityStatus: (state, actions) => {
      state.TicketPriorityStatus = actions.payload;
    },
    setTheTicketingsystemtRange1: (state, actions) => {
      state.TicketingsystemRange1 = actions.payload;
    },
    setTheTicketingsystemRange2: (state, actions) => {
      state.TicketingsystemRange2 = actions.payload;
    },

    setTheTicketingsystemtdashboardRange1: (state, actions) => {
      state.TicketingsystemDashboardRange1 = actions.payload;
    },
    setTheTicketingsystemDashboardRange2: (state, actions) => {
      state.TicketingsystemDashboardRange2 = actions.payload;
    },
    settheTicketIDSActions: (state, actions) => {
      state.TicketIDS = actions.payload;
    },
    settheClientIdTicketViewHolder: (state, actions) => {
      state.TicketClientViewNewIholader = actions.payload;
    },
    settheroutesforticketAssignsViews: (state, actions) => {
      state.routetotheassignedtickettoview = actions.payload;
    },

    setTheMYTicketsStatusState: (state, actions) => {
      state.MYTicketsStatusState = actions.payload;
    },
    setTheMYTicketstRange1: (state, actions) => {
      state.MYTicketsRange1 = actions.payload;
    },
    setTheMYTicktesRange2: (state, actions) => {
      state.MYTicketsRange2 = actions.payload;
    },

    setTheLeaveRequestState: (state, actions) => {
      state.Leave_RequestState = actions.payload;
    },

    setTheLeaveRequestRegion: (state, actions) => {
      state.Leave_RequestRegion = actions.payload;
    },
    setTheLeaveRequestZone: (state, actions) => {
      state.Leave_RequestZone = actions.payload;
    },
    setheLeaveRequestesignationStatus: (state, actions) => {
      state.Leave_Requestdesignation = actions.payload;
    },
    setTheLeaveRequestStateStatus: (state, actions) => {
      state.Leave_RequestStatusState = actions.payload;
    },
    setTheSillAsssessmentsStatus: (state, actions) => {
      state.SkillAssesments = actions.payload;
    },

    setTheSillAsssessmentsState: (state, actions) => {
      state.skillassessmentsStatusState = actions.payload;
    },
    setTheSillAsssessmentsRegion: (state, actions) => {
      state.skillassessmentsRegion = actions.payload;
    },
    setTheSillAsssessmentsZONE: (state, actions) => {
      state.skillassessmentsZone = actions.payload;
    },

    setTheSillAsssessmentsAppsideCompleted: (state, actions) => {
      state.skillassessmentsdesignation = actions.payload;
    },
    setTHeSkillAssessmentsMonthanYearsFilter: (state, actions) => {
      state.skillassessmentsStatusMonthYear = actions.payload;
    },

    setTHeSkillAssessmentsClient_Filter: (state, actions) => {
      state.SkillassessmentCLient = actions.payload;
    },
    setTHeSkillAssessmentsDesginationsFilter: (state, actions) => {
      state.Skillassessmentrole = actions.payload;
    },

    setTheLeaveRequestRange1: (state, actions) => {
      state.Leave_RequestRange1 = actions.payload;
    },
    setTheLeaveRequestRange2: (state, actions) => {
      state.Leave_RequestRange2 = actions.payload;
    },

    setTheLeaveRequestBranchList: (state, actions) => {
      state.Leave_RequestBranchList = actions.payload;
    },

    setheMyOnboardingRequestState: (state, actions) => {
      state.Myonboarding_RequestState = actions.payload;
    },
    setheMyOnboardingRequesteRegion: (state, actions) => {
      state.Myonboarding_RequestRegion = actions.payload;
    },

    setheHROnboardingRequestZone: (state, actions) => {
      state.HRonboarding_RequestZone = actions.payload;
    },
    setheHROnboardingRequestState: (state, actions) => {
      state.HRonboarding_RequestState = actions.payload;
    },
    setheHROnboardingRequesteRegion: (state, actions) => {
      state.HRonboarding_RequestRegion = actions.payload;
    },

    setheMyOnboardingRequestZone: (state, actions) => {
      state.Myonboarding_RequestZone = actions.payload;
    },

    setTheMyonboardingRequestRange1: (state, actions) => {
      state.Myonboarding_Range1 = actions.payload;
    },
    setTheMyOnboardingRequestRange2: (state, actions) => {
      state.Myonboarding_Range2 = actions.payload;
    },
    setTheHRonboardingRequestRange1: (state, actions) => {
      state.HRonboarding_Range1 = actions.payload;
    },
    setTheHRonboardingRequestRange2: (state, actions) => {
      state.HRonboarding_Range2 = actions.payload;
    },

    setTheMyonboardingRequestBranchList: (state, actions) => {
      state.Myonboarding_RequestBranchList = actions.payload;
    },
    setTheHRonboardingRequestBranchList: (state, actions) => {
      state.HRonboarding_RequestBranchList = actions.payload;
    },
    setTheHrmsConnectivityRequestState: (state, actions) => {
      state.HrmsConnectivity_RequestState = actions.payload;
    },
    setTheHrmsConnectivityRequestRegion: (state, actions) => {
      state.HrmsConnectivity_RequestRegion = actions.payload;
    },
    setTheHrmsConnectivityRequestZone: (state, actions) => {
      state.HrmsConnectivity_RequestZone = actions.payload;
    },
    setTheHrmsConnectivityRequestRange1: (state, actions) => {
      state.HrmsConnectivity_Range1 = actions.payload;
    },
    setTheHrmsConnectivityRequestRange2: (state, actions) => {
      state.HrmsConnectivity_Range2 = actions.payload;
    },
    setTheHrmsConnectivityRequestBranchList: (state, actions) => {
      state.HrmsConnectivity_RequestBranchList = actions.payload;
    },

    setheticketsubcategoryactions: (state, actions) => {
      state.ticketsystemSubcategoryActive = actions.payload;
    },

    settheSkillAssessmentsRanges1: (state, actions) => {
      state.SkillAssessments_RegularizationRange1 = actions.payload;
    },
    setSkillAssessmentRange2date: (state, actions) => {
      state.SkillAssessments_RegularizationRange2 = actions.payload;
    },
  },
});

////---over----time----
const overtimeGetlistslice = createSlice({
  name: "OvertimeSliceCall",
  initialState: {
    OvertimeData: [],
    Error: "",
    Total_Count: "",
  },
  reducers: {
    setTheOvertimeAction: (state, actions) => {
      state.OvertimeData = [];
      state.Error = "";
    },
    setheOvertimeResponse: (state, actions) => {
      state.OvertimeData = actions.payload;
    },
    setTotal_count_OvertimeEmployeeList: (state, actions) => {
      state.Total_Count = actions.payload;
    },
    settheOvertimeErrorMessage: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const OvertimeApproveListSlice = createSlice({
  name: "OvertimeApprove",
  initialState: {
    OvertimeListApproveDatas: [],
    Error: "",
  },
  reducers: {
    SetOvertimeApproveActions: (state) => {
      state.OvertimeListApproveDatas = [];
      state.Error = "";
    },
    SetOvertimeResponseApproveActions: (state, actions) => {
      state.OvertimeListApproveDatas = actions.payload;
    },
    SetOvertimeListApproveError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

///---Attendance---Location
const AttendanceLocationSlice = createSlice({
  name: "AttendanceLocationSliceCall",
  initialState: {
    AttendanceLocationData: [],
    Error: "",
    Total_Count: "",
  },
  reducers: {
    setTheAttendanceLocationAction: (state, actions) => {
      state.AttendanceLocationData = [];
      state.Error = "";
    },
    setheAttendanceLocationResponse: (state, actions) => {
      state.AttendanceLocationData = actions.payload;
    },
    setTotal_count_AttedanceLocationEmployeeList: (state, actions) => {
      state.Total_Count = actions.payload;
    },
    settheAttendanceLocationErrorMessage: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const AttendanceLocationSliceCreate = createSlice({
  name: "AttendanceLocationSliceCreateCall",
  initialState: {
    AttendanceLocationCreateData: [],
    Error: "",
  },
  reducers: {
    setTheAttendanceLocationCreateAction: (state, actions) => {
      state.AttendanceLocationCreateData = [];
      state.Error = "";
    },
    setheAttendanceLocationCreateResponse: (state, actions) => {
      state.AttendanceLocationCreateData = actions.payload;
    },

    settheAttendanceLocationCreateErrorMessage: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const AttendanceLocationSliceRetrievemethod = createSlice({
  name: "AttendanceLocationSliceRetrieveMethosCall",
  initialState: {
    AttendanceLocationRetrievemethodData: [],
    Error: "",
  },
  reducers: {
    setTheAttendanceLocationRetrieveMetyhodAction: (state, actions) => {
      state.AttendanceLocationRetrievemethodData = [];
      state.Error = "";
    },
    setheAttendanceLocationRetrievemethodResponse: (state, actions) => {
      state.AttendanceLocationRetrievemethodData = actions.payload;
    },

    settheAttendanceLocationRetrieveMethodErrorMessage: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const AttendanceLocationSliceEdit = createSlice({
  name: "AttendanceLocationSliceEditionCall",
  initialState: {
    AttendanceLocationEditionsData: [],
    Error: "",
  },
  reducers: {
    setTheAttendanceLocationEditionsAction: (state, actions) => {
      state.AttendanceLocationEditionsData = [];
      state.Error = "";
    },
    setheAttendanceLocationEditionsResponse: (state, actions) => {
      state.AttendanceLocationEditionsData = actions.payload;
    },

    settheAttendanceLocationEditionsErrorMessage: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const AttendanceLocationSliceDelete = createSlice({
  name: "AttendanceLocationSliceDeletionCall",
  initialState: {
    AttendanceLocationDeleteData: [],
    Error: "",
  },
  reducers: {
    setTheAttendanceLocationDeleteAction: (state, actions) => {
      state.AttendanceLocationDeleteData = [];
      state.Error = "";
    },
    setheAttendanceLocationDeleteResponse: (state, actions) => {
      state.AttendanceLocationDeleteData = actions.payload;
    },

    settheAttendanceLocationDeletesErrorMessage: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const supportDocumentFetchSlice = createSlice({
  name: "SupportDocumentFetch",
  initialState: {
    SupportDocuments: [],
    Error: "",
    Loading: false,
  },

  reducers: {
    startFetchingSupportDocuments: (state) => {
      state.Loading = true;
      state.Error = "";
      state.SupportDocuments = [];
    },
    setSupportDocuments: (state, action) => {
      state.SupportDocuments = action.payload;
      state.Loading = false;
    },
    setSupportDocumentsError: (state, action) => {
      state.Error = action.payload;
      state.Loading = false;
    },
  },
});

const supportDocumentEditSlice = createSlice({
  name: "SupportDocumentEdit",
  initialState: {
    EditedSupportDocument: null,
    Error: "",
    Loading: false,
  },

  reducers: {
    startEditingSupportDocument: (state) => {
      state.Loading = true;
      state.Error = "";
      state.EditedSupportDocument = null;
    },
    setEditedSupportDocument: (state, action) => {
      state.EditedSupportDocument = action.payload;
      state.Loading = false;
    },
    setEditSupportDocumentError: (state, action) => {
      state.Error = action.payload;
      state.Loading = false;
    },
  },
});

const MyonboardingListSlice = createSlice({
  name: "myonboardingDatas",
  initialState: {
    myonboardingDatas: [],
    Error: "",
    Total_Count: "",
  },

  reducers: {
    gettheMyonboardignlisteddatas: (state) => {
      state.Error = "";
      state.myonboardingDatas = [];
      state.Total_Count = "";
    },
    getthemyonboardingreponsesdatas: (state, action) => {
      state.myonboardingDatas = action.payload;
    },
    settheMyonardingTotal_counts: (state, actions) => {
      state.Total_Count = actions.payload;
    },
    settheMyonboardinggetlisterror: (state, action) => {
      state.Error = action.payload;
    },
  },
});
const HRonboardingListSlice = createSlice({
  name: "HRonboardingDatas",
  initialState: {
    HRonboardingDatas: [],
    Error: "",
    Total_Count: "",
  },

  reducers: {
    gettheHRonboardignlisteddatas: (state) => {
      state.Error = "";
      state.HRonboardingDatas = [];
      state.Total_Count = "";
    },
    gettheHRonboardingreponsesdatas: (state, action) => {
      state.HRonboardingDatas = action.payload;
    },
    settheHRonardingTotal_counts: (state, actions) => {
      state.Total_Count = actions.payload;
    },
    settheHRonboardinggetlisterror: (state, action) => {
      state.Error = action.payload;
    },
  },
});

const RegenerateThePdfSlice = createSlice({
  name: "RegeneratePDFCalls",
  initialState: {
    RegenerateDatas: [],
    Error: "",
  },

  reducers: {
    gettheRegeneratePdfAction: (state) => {
      state.Error = "";
      state.RegenerateDatas = [];
    },
    gettheRegeneratePdfResponse: (state, action) => {
      state.RegenerateDatas = action.payload;
    },
    settheRegeneratorlisterror: (state, action) => {
      state.Error = action.payload;
    },
  },
});

const myManagerListForApproveRequestSlice = createSlice({
  name: "managerapproverequestdata",
  initialState: {
    managerRequestDataHold: [],
    Error: "",
  },

  reducers: {
    gettheApproveRequestInmnagaerList: (state) => {
      state.Error = "";
      state.managerRequestDataHold = [];
    },
    gettheapproveRequestManagerResponse: (state, action) => {
      state.managerRequestDataHold = action.payload;
    },

    gettheApproveRequestManagerListError: (state, action) => {
      state.Error = action.payload;
    },
  },
});

const RejoiningOnboaderListSlice = createSlice({
  name: "OnboarderRejoindata",
  initialState: {
    RejoiningonboaderData: [],
    Error: "",
    Total_Count: "",
  },

  reducers: {
    gettheoverallOnboaderDatas: (state) => {
      state.Error = "";
      state.RejoiningonboaderData = [];
      state.Total_Count = "";
    },
    getthestoretheoverallOnboaderData: (state, action) => {
      state.RejoiningonboaderData = action.payload;
    },
    gettheoverallonboarderTotalCounts: (state, actions) => {
      state.Total_Count = actions.payload;
    },
    getheOverallonboarderErrorMessage: (state, action) => {
      state.Error = action.payload;
    },
  },
});

const RejoiningPOSTSlices = createSlice({
  name: "getposttheRejoiningResponse",
  initialState: {
    getstoretherejoiningResponse: [],
    Error: "",
  },

  reducers: {
    gettheStoretheRejoiningActions: (state) => {
      state.Error = "";
      state.getstoretherejoiningResponse = [];
    },
    gettheRejoiningActionResponse: (state, action) => {
      state.getstoretherejoiningResponse = action.payload;
    },

    gettheRejoingError: (state, action) => {
      state.Error = action.payload;
    },
  },
});

const UserForBoththeEmployeeAndUDS_slice = createSlice({
  name: "bothuserASEmployeee",
  initialState: {
    boththeEmployeeandUDS: [],
    Error: "",
    Total_Count: "",
  },
  reducers: {
    setTheActionsBoth_theusers: (state, actions) => {
      state.boththeEmployeeandUDS = [];
      state.Error = "";
      state.Total_Count = "";
    },
    settheActionsreponsesforboththeUDSANDEMP: (state, actions) => {
      state.boththeEmployeeandUDS = actions.payload;
    },
    setBoththeUsersTotal_counts: (state, actions) => {
      state.Total_Count = actions.payload;
    },
    setBoththeUserError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

////----Reimbursement--_Datas----------
const FetchReimbursementEMPSlice = createSlice({
  name: "FetchReimbursementCall",
  initialState: {
    fetchReimbursementData: [],
    fetchReimbursementFeedData: [],
    Error: "",
  },
  reducers: {
    SetFetchReimbursementEMPAction: (state, actions) => {
      state.fetchReimbursementData = [];
      state.Error = "";
    },
    SetFetchReimbursementEMPSuccessResponse: (state, actions) => {
      state.fetchReimbursementData = actions.payload;
    },
    SetFetchReimbursementEMPResponse: (state, actions) => {
      state.fetchReimbursementFeedData = actions.payload;
    },
    SetFetchReimbursementEMPError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

///reimbursement ---create
const ReimbursementCreateforEmp = createSlice({
  name: "ReimbursementDataFetchEmp",
  initialState: {
    ReimbursementEmployeeData: [],
    Error: "",
  },
  reducers: {
    setTheCreateOfEmployeeReimbursementActions: (state, actions) => {
      state.ReimbursementEmployeeData = [];
      state.Error = "";
    },
    SetFetchReimbursementEMPCreateSuccessResponse: (state, actions) => {
      state.ReimbursementEmployeeData = actions.payload;
    },
    SetFetchReimbursementCreateEMPError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

///--payslip

const PaySlipForEmployeeSlice = createSlice({
  name: "PayLipEMployeeeData",
  initialState: {
    PaylipaEmployeeData: [],
    Total_count: [],
    JoiningDate: "",
    Error: "",
  },
  reducers: {
    setThePayslipDataactionforemp: (state, actions) => {
      state.PaylipaEmployeeData = [];
      state.Error = "";
      state.JoiningDate = "";
    },
    setthePayslipDataforEmp: (state, actions) => {
      state.PaylipaEmployeeData = actions.payload;
    },
    setThePayslipToatal_countForEmp: (state, actions) => {
      state.Total_count = actions.payload;
    },
    setTheJoiningDateForPayslipEmp: (state, actions) => {
      state.JoiningDate = actions.payload;
    },
    setTheErrorofPayslipemp: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

//----Reginations
const ResignationEmpSlice = createSlice({
  name: "ResignationDatasEMp",
  initialState: {
    ResignationDataForEmp: [],
    Error: "",
  },
  reducers: {
    setTheresignationForEmp: (state, actions) => {
      state.ResignationDataForEmp = [];
      state.Error = "";
    },
    setTheResignationsForEmp: (state, actions) => {
      state.ResignationDataForEmp = actions.payload;
    },

    setTheResignationForEMpError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

////--Resignation retrieve
const ResignationRetrieveSliceEmp = createSlice({
  name: "ResignationEmpRetrieveEmp",
  initialState: {
    ResignationDataForEmpRetrieve: [],
    Error: "",
  },
  reducers: {
    setTheresignationRetrieveForEmp: (state, actions) => {
      state.ResignationDataForEmpRetrieve = [];
      state.Error = "";
    },
    setTheResignationsRetrieveForEmp: (state, actions) => {
      state.ResignationDataForEmpRetrieve = actions.payload;
    },

    setTheResignationForEMpretrieveError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});
////Post
const NoDueFormEmployeeSlice = createSlice({
  name: "NodueFormEmployeeSLiceData",
  initialState: {
    NodueFormEmployeeFormDatas: [],
    Error: "",
  },
  reducers: {
    settheNodueFormEmpActionDatas: (state, actions) => {
      state.NodueFormEmployeeFormDatas = [];
      state.Error = "";
    },
    settheNoDueFormResponsesDataEmployeee: (state, actions) => {
      state.NodueFormEmployeeFormDatas = actions.payload;
    },

    settheNodueFormForEmpError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});
///---retriev
const NoDueFormEmployeeRetrieveSlice = createSlice({
  name: "NodueFormEmployeeSLiceRetrieveData",
  initialState: {
    NodueFormEmployeeFormRetrirveDatas: [],
    Error: "",
  },
  reducers: {
    settheNodueFormEmpretrieveActionDatas: (state, actions) => {
      state.NodueFormEmployeeFormRetrirveDatas = [];
      state.Error = "";
    },
    settheNoDueFormResponsesDataretrieveEmployeee: (state, actions) => {
      state.NodueFormEmployeeFormRetrirveDatas = actions.payload;
    },

    settheNodueFormForEmpErrorretrirve: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

///---edit

const NoDueFormEmployeeEditSlice = createSlice({
  name: "NodueFormEmployeeEditCalllData",
  initialState: {
    NodueFormEmployeeFormEditCallDatas: [],
    Error: "",
  },
  reducers: {
    settheNodueFormEmpEditActionDatas: (state, actions) => {
      state.NodueFormEmployeeFormEditCallDatas = [];
      state.Error = "";
    },
    settheNoDueFormResponsesDataEditEmployeee: (state, actions) => {
      state.NodueFormEmployeeFormEditCallDatas = actions.payload;
    },

    settheNodueFormForEmpErrorEditCall: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

///---grievence get list
const gettheGrievenceGetListFortheEmpSlice = createSlice({
  name: "grievenceDatasEmp",
  initialState: {
    grievenceDatasForEmployee: [],
    Error: "",
    Total_Count: "",
  },
  reducers: {
    settheGrievenceGetListForEMpActions: (state, actions) => {
      state.grievenceDatasForEmployee = [];
      state.Error = "";
      state.Total_Count = "";
    },
    settheActionsreponsesforGrievencegetlistEmp: (state, actions) => {
      state.grievenceDatasForEmployee = actions.payload;
    },
    setgrievencegetlistEmpTotal_counts: (state, actions) => {
      state.Total_Count = actions.payload;
    },
    setGrievencegetlistEmpError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const gettheGrievenceGetListFortheEmpTypeListSlice = createSlice({
  name: "grievenceTypeDatasEmp",
  initialState: {
    grievenceTypeDatasForEmployee: [],
    Error: "",
  },
  reducers: {
    settheGrievenceGetListForTYPEEMpActions: (state, actions) => {
      state.grievenceTypeDatasForEmployee = [];
      state.Error = "";
    },
    settheActionsreponsesforGrievenceTYPEgetlistEmp: (state, actions) => {
      state.grievenceTypeDatasForEmployee = actions.payload;
    },
    setGrievencegetlistEmpTYPEError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

///---grivance---create
const CreateGrivanceApplyFormForEMpForEmpSlice = createSlice({
  name: "GrievanceApplyForEmpData",
  initialState: {
    grievanceDataEmpApply: [],
    Error: "",
  },
  reducers: {
    SetCreateGrievanceApplyEmpAction: (state, actions) => {
      state.grievanceDataEmpApply = [];
      state.Error = "";
    },
    SetCreateGrievanceApplyEmpSuccessResponse: (state, actions) => {
      state.grievanceDataEmpApply = actions.payload;
    },
    SetCreateGrievanceApplyEmpError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

///-----Help---Desk----for---employee
const HelpDeskFormEmployeeSlice = createSlice({
  name: "HelpDeskDatasEMP",
  initialState: {
    HelpDeskForEmpDatas: [],
    Error: "",
    Total_Count: "",
  },
  reducers: {
    setHelpDatasEmpAction: (state, actions) => {
      state.HelpDeskForEmpDatas = [];
      state.Error = "";
      state.Total_Count = "";
    },
    SetHelpEmployeeDataresponse: (state, actions) => {
      state.HelpDeskForEmpDatas = actions.payload;
    },
    SetHelpEmployeetotalcountDataresponse: (state, actions) => {
      state.Total_Count = actions.payload;
    },
    setHelpEmployeeDataError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});
////===tracking ---parent
const trackingParentsliceForSliceEmp = createSlice({
  name: "TrackingParentEmp",
  initialState: {
    TrackingEmpDatasParent: [],
    Error: "",
  },
  reducers: {
    setTrackingParentDatasEmpAction: (state, actions) => {
      state.TrackingEmpDatasParent = [];
      state.Error = "";
    },
    SettrackingparentEmployeeDataresponse: (state, actions) => {
      state.TrackingEmpDatasParent = actions.payload;
    },

    setTrackingparentEmployeeDataError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const trackingSubCategorysliceForSliceEmp = createSlice({
  name: "TrackingsubCategorytEmp",
  initialState: {
    TrackingEmpDatasSubcategoryEMP: [],
    Error: "",
    Total_Count: "",
  },
  reducers: {
    setTrackingSubCategoryEmpDatasEmpAction: (state, actions) => {
      state.TrackingEmpDatasSubcategoryEMP = [];
      state.Error = "";
      state.Total_Count = "";
    },
    SettrackingSubCategoryEmpEmployeeDataresponse: (state, actions) => {
      state.TrackingEmpDatasSubcategoryEMP = actions.payload;
    },

    setTrackingSubCategoryEmpEmployeeDataError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

///--help desk post
const helpDeskPostFroEmployeeeSlice = createSlice({
  name: "helpDeskPostForEmployeee",
  initialState: {
    HelpDeskApplyingForEmp: [],
    Error: "",
  },
  reducers: {
    setHelpDeskEmpApplyEmpDatasEmpAction: (state, actions) => {
      state.HelpDeskApplyingForEmp = [];
      state.Error = "";
    },
    SetHelpDeskApplyEmpEmployeeDataresponse: (state, actions) => {
      state.HelpDeskApplyingForEmp = actions.payload;
    },

    setHelpDeskApplyEmpEmployeeDataError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

// //---emp attendance

const EmployeeAttendanceSliceData = createSlice({
  name: "EmpAttendaEmpDataGetList",
  initialState: {
    EmployeeAttendanceEMpDatas: [],
    Error: "",
    Total_Count: "",
  },
  reducers: {
    setEmpAttendanceEmpEmpAction: (state, actions) => {
      state.EmployeeAttendanceEMpDatas = [];
      state.Error = "";
      state.Total_Count = "";
    },
    SetEmployeeAttendanceEmpDataresponse: (state, actions) => {
      state.EmployeeAttendanceEMpDatas = actions.payload;
    },
    SetEmpAttendanceEMPtotalcountDataresponse: (state, actions) => {
      state.Total_Count = actions.payload;
    },
    setEmpAttendanceEMPDataError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

///---emp--blockedE
const EmployeeeBlockedGetListEmpSle = createSlice({
  name: "EmpBlockEmpDatagetStored",
  initialState: {
    EmpBlockDataStoreDtaas: [],
    Error: "",
    Total_Count: "",
    ForPopupData: [],
  },
  reducers: {
    setEmpBlockGetlistEmpEmpAction: (state, actions) => {
      state.EmpBlockDataStoreDtaas = [];
      state.Error = "";
      state.Total_Count = "";
      state.ForPopupData = [];
    },
    SetEmployeeEmpGetListEmpDataresponse: (state, actions) => {
      state.EmpBlockDataStoreDtaas = actions.payload;
    },
    SetEmpEmpGetBlockEMPtotalcountDataresponse: (state, actions) => {
      state.Total_Count = actions.payload;
    },
    setTheBlockEmployeelistDatasForPopup: (state, actions) => {
      state.ForPopupData = actions.payload;
    },

    setEmpBlockEmpGetEMPDataError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const UnbloadedEmpForGetlistSlice = createSlice({
  name: "UnbloadedEmployeeeDataEmp",
  initialState: {
    UnbloackedEmpDatas: [],
    Error: "",
  },
  reducers: {
    gettheUnboackedEmpActions: (state, actions) => {
      state.UnbloackedEmpDatas = [];
      state.Error = "";
    },
    SetUnbloackedEmployeesEmpDataresponse: (state, actions) => {
      state.UnbloackedEmpDatas = actions.payload;
    },
    setEmpUnbloackedEmployeesEMPDataError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const EmployeeeBlockedPOSTListEmpSlice = createSlice({
  name: "EmpBlockEmpDataPosttStored",
  initialState: {
    EmpBlockDatapostDtaas: [],
    Error: "",
  },
  reducers: {
    setEmpBlockpostistEmpEmpAction: (state, actions) => {
      state.EmpBlockDatapostDtaas = [];
      state.Error = "";
    },
    SetEmployeeEmppostListEmpDataresponse: (state, actions) => {
      state.EmpBlockDatapostDtaas = actions.payload;
    },
    setEmpBlockEmppostEMPDataError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

//---emp--site transfer
const employeeSiteTransferSliceData = createSlice({
  name: "EmpBlockEmpSiteTransferStored",
  initialState: {
    EmpsiteTransferstoreDtaas: [],
    Error: "",
    Total_Count: "",
  },
  reducers: {
    setEmpsiteTransferGetlistEmpEmpAction: (state, actions) => {
      state.EmpsiteTransferstoreDtaas = [];
      state.Error = "";
      state.Total_Count = "";
    },
    SetEmployeesitetransferListEmpDataresponse: (state, actions) => {
      state.EmpsiteTransferstoreDtaas = actions.payload;
    },
    SetEmpEmpGesiteTransferEMPtotalcountDataresponse: (state, actions) => {
      state.Total_Count = actions.payload;
    },
    setEmpsiteTransferEmpGetEMPDataError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const sitetransferemployeelistslice = createSlice({
  name: "sitetransferemployeeapidata",
  initialState: {
    sitetransferempdatalistempsite: [],
    Error: "",
  },
  reducers: {
    setEmsiteTransferEmployeedatasEmpEmpAction: (state, actions) => {
      state.sitetransferempdatalistempsite = [];
      state.Error = "";
    },
    SetEmployeeSitetransferresponseEmpDataresponse: (state, actions) => {
      state.sitetransferempdatalistempsite = actions.payload;
    },

    setEmpsiteEMPDataError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

///--site---create
const employeeSiteTransferCreateSliceData = createSlice({
  name: "EmpBlockEmpSiteTransferCreate",
  initialState: {
    EmpsiteTransferCreateDtaas: [],
    Error: "",
  },
  reducers: {
    setEmpsiteTransferGetlistCreateEmpEmpAction: (state, actions) => {
      state.EmpsiteTransferCreateDtaas = [];
      state.Error = "";
    },
    SetEmployeesitetransferListCreateEmpDataresponse: (state, actions) => {
      state.EmpsiteTransferCreateDtaas = actions.payload;
    },

    setEmpsiteTransferEmpCreateMPDataError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const EmployeeClientBranchListForEmpSlice = createSlice({
  name: "EmployeeClientBranchForEmpData",
  initialState: {
    ClientBranchDataForEmployee: [],
    Error: "",
  },
  reducers: {
    setEmpClientBranchListEmpEmpAction: (state, actions) => {
      state.ClientBranchDataForEmployee = [];
      state.Error = "";
    },
    SetEmployeeClientBrancheListEmpDataresponse: (state, actions) => {
      state.ClientBranchDataForEmployee = actions.payload;
    },

    setEmpClientBranchForEmpDataError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

///---Attendance_regularization_SignleAnd mulit

const AttendanceRegularizationSliceSignleMulti = createSlice({
  name: "AttendanceRegularizationSignlemulti",
  initialState: {
    AttendanceRegularizationDatasGetlist: [],
    Error: "",
    Total_Count: "",
  },
  reducers: {
    setEmpAttendanceRegularizationEmpGetlistEmpEmpAction: (state, actions) => {
      state.AttendanceRegularizationDatasGetlist = [];
      state.Error = "";
      state.Total_Count = "";
    },
    SetEmployeeAttendanceRegularizationEmpteamListEmpDataresponse: (
      state,
      actions,
    ) => {
      state.AttendanceRegularizationDatasGetlist = actions.payload;
    },
    SetEmpEmpGeAttendanceTeamEMPtotalcountDataresponse: (state, actions) => {
      state.Total_Count = actions.payload;
    },
    setEmpAttendanceTeamEmpGetEMPDataError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const AttendanceRegularizationTeamPostSliceSignleMulti = createSlice({
  name: "AttendanceRegularizationteamPostSignlemulti",
  initialState: {
    AttendanceRegularizationDatasTeamPostGetlist: [],
    Error: "",
  },
  reducers: {
    setEmpAttendanceRegularizationEmpTeamPostlistEmpEmpAction: (
      state,
      actions,
    ) => {
      state.AttendanceRegularizationDatasTeamPostGetlist = [];
      state.Error = "";
    },
    SetEmployeeAttendanceRegularizationEmpteamPOstListEmpDataresponse: (
      state,
      actions,
    ) => {
      state.AttendanceRegularizationDatasTeamPostGetlist = actions.payload;
    },
    setEmpAttendanceTeamEmpPostEMPDataError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const NodueformFetchDetailsSlice = createSlice({
  name: "NodueFormFetchDatasgetFetch",
  initialState: {
    noduformfetchdatasemp: [],
    Error: "",
  },
  reducers: {
    setEmpnoduformfetchdatasempEmpTeamlistEmpEmpAction: (state, actions) => {
      state.noduformfetchdatasemp = [];
      state.Error = "";
    },
    SetEmployenoduformfetchdatasempempteamListEmpDataresponse: (
      state,
      actions,
    ) => {
      state.noduformfetchdatasemp = actions.payload;
    },
    setEmpnoduformfetchdatasempgetMPDataError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const skillAssessmentEmpListSlice = createSlice({
  name: "SkillAssessmentEmpList",
  initialState: {
    skillAssessmentDataEMpdata: [],
    error: "",
    Total_Count: "",
  },
  reducers: {
    resetSkillAssessmentEmpData: (state) => {
      state.skillAssessmentDataEMpdata = [];
      state.error = "";
      state.Total_Count = "";
    },
    setSkillAssessmentEmpDataResponse: (state, action) => {
      state.skillAssessmentDataEMpdata = action.payload;
    },
    setSkillAssessmentotal_countEmpDataResponse: (state, action) => {
      state.Total_Count = action.payload;
    },
    setSkillAssessmentEmpDataError: (state, action) => {
      state.error = action.payload;
    },
  },
});

const stateFetchDetailsSlice = createSlice({
  name: "StateFetchDetails",
  initialState: {
    stateData: [],
    error: "",
  },
  reducers: {
    stateresetStateData: (state) => {
      state.stateData = [];
      state.error = "";
    },
    setStateDataResponse: (state, action) => {
      state.stateData = action.payload;
    },
    setStateDataError: (state, action) => {
      state.error = action.payload;
    },
  },
});

// Region Slice
const regionFetchDetailsSlice = createSlice({
  name: "RegionFetchDetails",
  initialState: {
    regionData: [],
    error: "",
  },
  reducers: {
    stateresetRegionData: (state) => {
      state.regionData = [];
      state.error = "";
    },
    setRegionDataResponse: (state, action) => {
      state.regionData = action.payload;
    },
    setRegionDataError: (state, action) => {
      state.error = action.payload;
    },
  },
});

// Zone Slice
const zoneFetchDetailsSlice = createSlice({
  name: "ZoneFetchDetails",
  initialState: {
    zoneData: [],
    error: "",
  },
  reducers: {
    stateresetZoneData: (state) => {
      state.zoneData = [];
      state.error = "";
    },
    setZoneDataResponse: (state, action) => {
      state.zoneData = action.payload;
    },
    setZoneDataError: (state, action) => {
      state.error = action.payload;
    },
  },
});

// Designation Slice
const designationFetchDetailsSlice = createSlice({
  name: "DesignationFetchDetails",
  initialState: {
    designationData: [],
    error: "",
  },
  reducers: {
    stateresetDesignationData: (state) => {
      state.designationData = [];
      state.error = "";
    },
    setDesignationDataResponse: (state, action) => {
      state.designationData = action.payload;
    },
    setDesignationDataError: (state, action) => {
      state.error = action.payload;
    },
  },
});
const branchFetchDetailsSlice = createSlice({
  name: "BranchFetchDetails",
  initialState: {
    branchData: [],
    error: "",
  },
  reducers: {
    stateresetBranchData: (state) => {
      state.branchData = [];
      state.error = "";
    },
    setBranchDataResponse: (state, action) => {
      state.branchData = action.payload;
    },
    setBranchDataError: (state, action) => {
      state.error = action.payload;
    },
  },
});

///----skill----assessments---retieve--------------

const skillassessmentSliceRetrieveEmpdatas = createSlice({
  name: "skillassessmentretieveempdatas",
  initialState: {
    skillassessmentsempDatas: [],
    error: "",
  },
  reducers: {
    gettheSkillassessmentRetireveEmpactions: (state) => {
      state.skillassessmentsempDatas = [];
      state.error = "";
    },
    gettheSkillassessmentretirvetheActionofemp: (state, action) => {
      state.skillassessmentsempDatas = action.payload;
    },
    gettheskillAssessmentEmpretirveemp: (state, action) => {
      state.error = action.payload;
    },
  },
});

const skillassessmentpostmethodforapplyempslice = createSlice({
  name: "skillassessmentforapplyemppostmethod",
  initialState: {
    skillassessmentspostempdatas: [],
    error: "",
  },
  reducers: {
    gettheSkillassessmentpostmethodEmpactions: (state) => {
      state.skillassessmentspostempdatas = [];
      state.error = "";
    },
    gettheSkillassessmentEmppostmethodstheActionofemp: (state, action) => {
      state.skillassessmentspostempdatas = action.payload;
    },
    gettheskillAssessmentEmpPostmethodemp: (state, action) => {
      state.error = action.payload;
    },
  },
});

const skillassessmentputmethodsapplyempslice = createSlice({
  name: "skillassessmentforapplyemp_put_method",
  initialState: {
    skillassessmentsputempdatas: [],
    error: "",
  },
  reducers: {
    gettheSkillassessmentputtmethodEmpactions: (state) => {
      state.skillassessmentsputempdatas = [];
      state.error = "";
    },
    gettheSkillassessmentEmpputmethodstheActionofemp: (state, action) => {
      state.skillassessmentsputempdatas = action.payload;
    },
    gettheskillAssessmentEmpPuttmethodemp: (state, action) => {
      state.error = action.payload;
    },
  },
});

const skillassessmentSlicequestiongetlist = createSlice({
  name: "skillquestionpaperassessment",
  initialState: {
    employeeData: [],
    error: "",
  },
  reducers: {
    resetEmployeeDataquestionslist: (state) => {
      state.employeeData = [];
      state.error = "";
    },
    setEmployeeDataquestionslist: (state, action) => {
      state.employeeData = action.payload;
    },
    setErrorquestionslist: (state, action) => {
      state.error = action.payload;
    },
  },
});
const innerQuestionSkillAssessmentSlice = createSlice({
  name: "innerquestionskillassessment",
  initialState: {
    questionData: [],
    error: "",
  },
  reducers: {
    resetQuestionData: (state) => {
      state.questionData = [];
      state.error = "";
    },
    setQuestionData: (state, action) => {
      state.questionData = action.payload;
    },
    setErrorinnerquestions: (state, action) => {
      state.error = action.payload;
    },
  },
});

const questionTypeSkillAssessmentSlice = createSlice({
  name: "questiontypeskillassessment",
  initialState: {
    questionTypeData: [],
    error: "",
  },
  reducers: {
    resetQuestionTypeData: (state) => {
      state.questionTypeData = [];
      state.error = "";
    },
    setQuestionTypeData: (state, action) => {
      state.questionTypeData = action.payload;
    },
    setErrorQuestionType: (state, action) => {
      state.error = action.payload;
    },
  },
});

const TicketCategoryQuestionsSlice = createSlice({
  name: "TicketQuetionsDatas",
  initialState: {
    TicketQuestionsDatas: [],
    Error: "",
    Total_Count: "",
  },
  reducers: {
    getTheTicketingQuestionsData: (state, actions) => {
      state.TicketQuestionsDatas = [];
      state.Error = "";
    },
    setTheticketQuestionsResponses: (state, actions) => {
      state.TicketQuestionsDatas = actions.payload;
    },
    setTheticketeQuestionsError: (state, actions) => {
      state.Error = actions.payload;
    },
    setTheticketQuestionTotalCounts: (state, actions) => {
      state.Total_Count = actions.payload;
    },
  },
});

///internal
const UDSCategoryQuestionsSlice = createSlice({
  name: "UDSQuetionsDatas",
  initialState: {
    UDSCateQuestionsDatas: [],
    Error: "",
    Total_Count: "",
  },
  reducers: {
    getTheUDSQuestionsData: (state, actions) => {
      state.UDSCateQuestionsDatas = [];
      state.Error = "";
    },
    setTheUDSQuestionsResponses: (state, actions) => {
      state.UDSCateQuestionsDatas = actions.payload;
    },
    setTheUdsQuestionsError: (state, actions) => {
      state.Error = actions.payload;
    },
    setTheUDsQuestionTotalCounts: (state, actions) => {
      state.Total_Count = actions.payload;
    },
  },
});

const InternalQuestionCreateSlice = createSlice({
  name: "InternalTicketCrud",
  initialState: {
    InternalQuestionCreate: [],
    Error: "",
  },

  reducers: {
    setTheInternalQuestionsCreateActions: (state, actions) => {
      state.InternalQuestionCreate = [];
      state.Error = "";
    },
    setTheInternalQuestionsCreateResponsive: (state, actions) => {
      state.InternalQuestionCreate = actions.payload;
    },
    SettheInternalQuestionsCreateError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});
const internalCategoryQuestionEditSlice = createSlice({
  name: "internalcategoryQuestionsEdition",
  initialState: {
    internalcategoryQuestionEdit: [],
    Error: "",
  },

  reducers: {
    setTheInternalCategoryQuestionsEdtionctions: (state, actions) => {
      state.internalcategoryQuestionEdit = [];
      state.Error = "";
    },
    setTheinternalCategoryQuestionsEditResponsive: (state, actions) => {
      state.internalcategoryQuestionEdit = actions.payload;
    },
    SettheinternalcategoryQuestionsEditError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const internalcategoryQuestionRetrieveSlice = createSlice({
  name: "internalcategoryQuestionsretrieve",
  initialState: {
    internalcategoryQuestionRetrieve: [],
    Error: "",
  },

  reducers: {
    setTheInteralcategoryQuestionsretrieveActions: (state, actions) => {
      state.internalcategoryQuestionRetrieve = [];
      state.Error = "";
    },
    setTheInternalcategoryQuestionsretrieveResponsive: (state, actions) => {
      state.internalcategoryQuestionRetrieve = actions.payload;
    },
    SettheinternalcategoryQuestionsretrieveError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const InternalQuestionDeleteSlice = createSlice({
  name: "InternalQuestionsDelete",
  initialState: {
    InternalQuestionDelete: [],
    Error: "",
  },

  reducers: {
    setTheInternalDeleteActions: (state, actions) => {
      state.InternalQuestionDelete = [];
      state.Error = "";
    },
    setThInternalQuestionsdeleteResponsive: (state, actions) => {
      state.InternalQuestionDelete = actions.payload;
    },
    SettheInternalQuestionsDeletError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

/// internal subcategory

/// internal subcategory

const InternalSubQuestionsSlice = createSlice({
  name: "InternalSubQuetionsDatas",
  initialState: {
    internalQuestionsDatas: [],
    Error: "",
    Total_Count: "",
  },
  reducers: {
    settheInternalSubQuestionActions: (state, actions) => {
      state.internalQuestionsDatas = [];
      state.Error = "";
    },
    setTheInternalSubQuestionsResponses: (state, actions) => {
      state.internalQuestionsDatas = actions.payload;
    },
    setTheunternalSubQuestionsError: (state, actions) => {
      state.Error = actions.payload;
    },
    setTheInternalSubQuestionTotalCounts: (state, actions) => {
      state.Total_Count = actions.payload;
    },
  },
});

///---query---------Editions---
const InternalSUbQuestionEdtionsSlice = createSlice({
  name: "InternalSubQuestionsEditions",
  initialState: {
    InternalSubQuestionEdit: [],
    Error: "",
  },

  reducers: {
    setTheInternalSubQuestionsEditionsActions: (state, actions) => {
      state.InternalSubQuestionEdit = [];
      state.Error = "";
    },
    setTheinternalSubQuestionsEditionsResponsive: (state, actions) => {
      state.InternalSubQuestionEdit = actions.payload;
    },
    SettheinternalSubQuestionsEditionError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const InternalSUbQuestionRetrieveSlice = createSlice({
  name: "InternalSubQuestionsRetrieve",
  initialState: {
    InternalSubQuestionRetrieve: [],
    Error: "",
  },

  reducers: {
    setTheinternalSubQuestionsRetrieveActions: (state, actions) => {
      state.InternalSubQuestionRetrieve = [];
      state.Error = "";
    },
    setTheinternalSubQuestionsRetrieveResponsive: (state, actions) => {
      state.InternalSubQuestionRetrieve = actions.payload;
    },
    SettheInternalSubQuestionsRetrieveError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const internalSubcategorydelete = createSlice({
  name: "InternalSUBQuestionsDelete",
  initialState: {
    InternalSUBQuestionDelete: [],
    Error: "",
  },

  reducers: {
    setTheInternalSUbQuestionsDeleteActions: (state, actions) => {
      state.InternalSUBQuestionDelete = [];
      state.Error = "";
    },
    setTheInternalSUbQuestionsdeleteResponsive: (state, actions) => {
      state.InternalSUBQuestionDelete = actions.payload;
    },
    SettheInternalSUbQuestionsDeletError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const InternalSUbQuestionCreateSlice = createSlice({
  name: "InternalSubQuestionsCreate",
  initialState: {
    InternalSubQuestionCreate: [],
    Error: "",
  },

  reducers: {
    setTheInternalSubQuestionsCreateActions: (state, actions) => {
      state.InternalSubQuestionCreate = [];
      state.Error = "";
    },
    setTheInternalSubQuestionsCreateResponsive: (state, actions) => {
      state.InternalSubQuestionCreate = actions.payload;
    },
    SettheInternalSubQuestionsCreateError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

///--- Department
const InternalSubDepartmentsSlice = createSlice({
  name: "InternalSubDepartmentsDatas",
  initialState: {
    internalDepartmentDatas: [],
    Error: "",
    Total_Count: "",
  },
  reducers: {
    settheInternalDepartmentsctions: (state, actions) => {
      state.internalDepartmentDatas = [];
      state.Error = "";
    },
    setTheInternalDepartmentsResponses: (state, actions) => {
      state.internalDepartmentDatas = actions.payload;
    },
    setTheinternalDepartmentsError: (state, actions) => {
      state.Error = actions.payload;
    },
    setTheInternalDepartmentsTotalCounts: (state, actions) => {
      state.Total_Count = actions.payload;
    },
  },
});

const internaldepartmentDelete = createSlice({
  name: "InternalDepartmentsDelete",
  initialState: {
    InternalDepartmentsDelete: [],
    Error: "",
  },

  reducers: {
    setTheInternalDepartmentDeleteActions: (state, actions) => {
      state.InternalDepartmentsDelete = [];
      state.Error = "";
    },
    setTheInternalDepartmentsdeleteResponsive: (state, actions) => {
      state.InternalDepartmentsDelete = actions.payload;
    },
    SettheInternalDepartmentsDeletError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});
const internaldepartmentCreated = createSlice({
  name: "InternalDepartmentsCreate",
  initialState: {
    InternalDepartmentsCreate: [],
    Error: "",
  },

  reducers: {
    setTheInternalDepartmentCreatedActions: (state, actions) => {
      state.InternalDepartmentsCreate = [];
      state.Error = "";
    },
    setTheInternalDepartmentsCreateResponsive: (state, actions) => {
      state.InternalDepartmentsCreate = actions.payload;
    },
    SettheInternalDepartmentsCreateError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const internaldepartmentRetrive = createSlice({
  name: "InternalDepartmentsRetrieveName",
  initialState: {
    InternalDepartmentsRetrievedatas: [],
    Error: "",
  },

  reducers: {
    setTheInternalDepartmentRetrieveActions: (state, actions) => {
      state.InternalDepartmentsRetrievedatas = [];
      state.Error = "";
    },
    setTheInternalDepartmentsRetrieveResponsive: (state, actions) => {
      state.InternalDepartmentsRetrievedatas = actions.payload;
    },
    SettheInternalDepartmentsRetrieveError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const internaldepartmentEdit = createSlice({
  name: "InternalDepartmentsEdit",
  initialState: {
    InternalDepartmentsEditdatas: [],
    Error: "",
  },

  reducers: {
    setTheInternalDepartmentEditActions: (state, actions) => {
      state.InternalDepartmentsEditdatas = [];
      state.Error = "";
    },
    setTheInternalDepartmentsEditResponsive: (state, actions) => {
      state.InternalDepartmentsEditdatas = actions.payload;
    },
    SettheInternalDepartmentsEditError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const DepartmentLevelUsersSlice = createSlice({
  name: "departmentLevelUserslist",
  initialState: {
    departmentLevelUsersData: [],
    Error: "",
  },

  reducers: {
    setTheInternalDepartmentlevelusersCreatedActions: (state, actions) => {
      state.departmentLevelUsersData = [];
      state.Error = "";
    },
    setTheInternalDepartmentsLevelUsersCreateResponsive: (state, actions) => {
      state.departmentLevelUsersData = actions.payload;
    },
    SettheInternalDepartmentsLevelUserCreateError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

///---query---------creations---
const TicketQuestionCreateSlice = createSlice({
  name: "TicketQuestionsCreate",
  initialState: {
    TicketQuestionCreate: [],
    Error: "",
  },

  reducers: {
    setTheTicketQuestionsCreateActions: (state, actions) => {
      state.TicketQuestionCreate = [];
      state.Error = "";
    },
    setTheTicketQuestionsCreateResponsive: (state, actions) => {
      state.TicketQuestionCreate = actions.payload;
    },
    SettheTicketQuestionsCreateError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const TicketQuestionEditSlice = createSlice({
  name: "TicketQuestionsEdition",
  initialState: {
    TicketQuestionEdit: [],
    Error: "",
  },

  reducers: {
    setTheTicketQuestionsEdtionctions: (state, actions) => {
      state.TicketQuestionEdit = [];
      state.Error = "";
    },
    setTheTicketQuestionsEditResponsive: (state, actions) => {
      state.TicketQuestionEdit = actions.payload;
    },
    SettheTicketQuestionsEditError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const TicketQuestionRetrieveSlice = createSlice({
  name: "TicketQuestionsretrieve",
  initialState: {
    TicketQuestionRetrieve: [],
    Error: "",
  },

  reducers: {
    setTheTicketQuestionsretrieveActions: (state, actions) => {
      state.TicketQuestionRetrieve = [];
      state.Error = "";
    },
    setTheTicketQuestionsretrieveResponsive: (state, actions) => {
      state.TicketQuestionRetrieve = actions.payload;
    },
    SettheTicketQuestionsretrieveError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const TicketingQuestionDeleteSlice = createSlice({
  name: "TicketingQuestionsDelete",
  initialState: {
    TicketingQuestionDelete: [],
    Error: "",
  },

  reducers: {
    setTheTickeitingtionsDeleteActions: (state, actions) => {
      state.TicketingQuestionDelete = [];
      state.Error = "";
    },
    setTheTicketingQuestionsdeleteResponsive: (state, actions) => {
      state.TicketingQuestionDelete = actions.payload;
    },
    SettheTicketingQuestionsDeletError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const TicketSubQuestionsSlice = createSlice({
  name: "TicketSubQuetionsDatas",
  initialState: {
    TicketQuestionsDatas: [],
    Error: "",
    Total_Count: "",
  },
  reducers: {
    settheTicketSubQuestionActions: (state, actions) => {
      state.TicketQuestionsDatas = [];
      state.Error = "";
    },
    setTheTicketSubQuestionsResponses: (state, actions) => {
      state.TicketQuestionsDatas = actions.payload;
    },
    setTheTicketSubQuestionsError: (state, actions) => {
      state.Error = actions.payload;
    },
    setTheTicketSubQuestionTotalCounts: (state, actions) => {
      state.Total_Count = actions.payload;
    },
  },
});

///---query---------creations---
const TicketSUbQuestionCreateSlice = createSlice({
  name: "TicketSubQuestionsCreate",
  initialState: {
    TicketSubQuestionCreate: [],
    Error: "",
  },

  reducers: {
    setTheTicketSubQuestionsCreateActions: (state, actions) => {
      state.TicketSubQuestionCreate = [];
      state.Error = "";
    },
    setTheTicketSubQuestionsCreateResponsive: (state, actions) => {
      state.TicketSubQuestionCreate = actions.payload;
    },
    SettheTicketSubQuestionsCreateError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

///---query---------Editions---
const TicketSUbQuestionEdtionsSlice = createSlice({
  name: "TicketingSubQuestionsEditions",
  initialState: {
    TicketSubQuestionEdit: [],
    Error: "",
  },

  reducers: {
    setTheTicketSubQuestionsEditionsActions: (state, actions) => {
      state.TicketSubQuestionEdit = [];
      state.Error = "";
    },
    setTheTicketSubQuestionsEditionsResponsive: (state, actions) => {
      state.TicketSubQuestionEdit = actions.payload;
    },
    SettheTicketSubQuestionsEditionError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const TicketSUbQuestionRetrieveSlice = createSlice({
  name: "TicketSubQuestionsRetrieve",
  initialState: {
    TicketSubQuestionRetrieve: [],
    Error: "",
  },

  reducers: {
    setTheTicketSubQuestionsRetrieveActions: (state, actions) => {
      state.TicketSubQuestionRetrieve = [];
      state.Error = "";
    },
    setTheTicketSubQuestionsRetrieveResponsive: (state, actions) => {
      state.TicketSubQuestionRetrieve = actions.payload;
    },
    SettheTicketSubQuestionsRetrieveError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const TicketSUBQuestionDeleteSlice = createSlice({
  name: "TickerSUBQuestionsDelete",
  initialState: {
    TicketSUBQuestionDelete: [],
    Error: "",
  },

  reducers: {
    setTheTicketSUbQuestionsDeleteActions: (state, actions) => {
      state.TicketSUBQuestionDelete = [];
      state.Error = "";
    },
    setTheTicketSUbQuestionsdeleteResponsive: (state, actions) => {
      state.TicketSUBQuestionDelete = actions.payload;
    },
    SettheTicketSUbQuestionsDeletError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const TrackingrecordOfSystemSlice = createSlice({
  name: "TrackingrecordgetOfSystemList",
  initialState: {
    TrackingrecordgetListOfSystemData: [],
    Error: "",
    Total_Count: "",
    TrackingReport: [],
  },
  reducers: {
    settheTicketsystemrecordgetListDataActions: (state, actions) => {
      state.TrackingrecordgetListOfSystemData = [];
      state.Error = "";
    },
    setTheTicketsystemrecordgetListDataResponses: (state, actions) => {
      state.TrackingrecordgetListOfSystemData = actions.payload;
    },
    setTicketsystemRecordListDashboardReport: (state, actions) => {
      state.TrackingReport = actions.payload;
    },
    setTheQTicketsystemrecordgetListDatasError: (state, actions) => {
      state.Error = actions.payload;
    },
    setTheTicketsystemrecordgetListDataTotalCounts: (state, actions) => {
      state.Total_Count = actions.payload;
    },
  },
});

const TicketingRecordDetailDashboardSlice = createSlice({
  name: "Ticketingrecord_dashboard",
  initialState: {
    ticketDashboardData: [],
    Error: "",
  },

  reducers: {
    settheTicketingDashboardActions: (state, actions) => {
      state.ticketDashboardData = [];
      state.Error = "";
    },
    settheTicketingDashboardActiondataStores: (state, actions) => {
      state.ticketDashboardData = actions.payload;
    },
    SettheTicketingDashboardErrDeletError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const TicketingSystemInretrievetheTicketsSlice = createSlice({
  name: "RetrieveTickingSystemdatas",
  initialState: {
    clientTicketingrecordRetrieve: [],
    Error: "",
  },

  reducers: {
    setTheTrackingrecordgetListRetrieveActions: (state, actions) => {
      state.clientTicketingrecordRetrieve = [];
      state.Error = "";
    },
    setTheTrackingrecordgetListRetrieveResponsive: (state, actions) => {
      state.clientTicketingrecordRetrieve = actions.payload;
    },
    SettheTicketingrecordgetListRetrieveError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const ticketremarksreviewlistSlice = createSlice({
  name: "retrievetheRemarks",
  initialState: {
    Remarksdataslist: [],
    Error: "",
  },

  reducers: {
    setTheTrackingrecordgetList_remarksRetrieveActions: (state, actions) => {
      state.Remarksdataslist = [];
      state.Error = "";
    },
    setTheTrackingrecordgetList_remarksRetrieveResponsive: (state, actions) => {
      state.Remarksdataslist = actions.payload;
    },
    SettheTicketingrecordgetListRetrieve_remarkError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const ticketcommentSlice = createSlice({
  name: "commentsDatas",
  initialState: {
    CommentsDatas: [],
    Error: "",
  },

  reducers: {
    setthecommentRetieveDatasActions: (state, actions) => {
      state.CommentsDatas = [];
      state.Error = "";
    },
    settheCommentRetieveDataList: (state, actions) => {
      state.CommentsDatas = actions.payload;
    },
    settheCommentRetieveErorActions: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const ticketFeedbackSlice = createSlice({
  name: "ticketFeedbacklistedslice",
  initialState: {
    feedbackrecords: [],
    Error: "",
  },

  reducers: {
    setthefeedbackRetieveDatasActions: (state, actions) => {
      state.feedbackrecords = [];
      state.Error = "";
    },
    setthefeedbackRetieveDataList: (state, actions) => {
      state.feedbackrecords = actions.payload;
    },
    settheFeedbackRetieveErorActions: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const ticketRemarksSliceActionsSlice = createSlice({
  name: "TickeetRemarkSliceDatas",
  initialState: {
    TickeetRemarkpostDatas: [],
    Error: "",
  },

  reducers: {
    settheticketcreateRetieveDatasActions: (state, actions) => {
      state.TickeetRemarkpostDatas = [];
      state.Error = "";
    },
    settheticketcreateRetieveDataList: (state, actions) => {
      state.TickeetRemarkpostDatas = actions.payload;
    },
    settheticketcreateRetieveErorActions: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const ticketTimelineSlice = createSlice({
  name: "ticketTimeLIneSlicedata",
  initialState: {
    TicketTimeLinerecords: [],
    Error: "",
  },

  reducers: {
    settheticketTimelineretieveDatasActions: (state, actions) => {
      state.TicketTimeLinerecords = [];
      state.Error = "";
    },
    settheticketTiemlineRetieveDataList: (state, actions) => {
      state.TicketTimeLinerecords = actions.payload;
    },
    settheticketTimeLineRetieveErorActions: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const ticketSTatusChangesSlice = createSlice({
  name: "ticketstatuschanges",
  initialState: {
    ticketStatusChanges: [],
    Error: "",
  },

  reducers: {
    settehTicketStatusChanges: (state, actions) => {
      state.ticketStatusChanges = [];
      state.Error = "";
    },
    settheTicketStatusChangesrespons: (state, actions) => {
      state.ticketStatusChanges = actions.payload;
    },
    settheTickeStatusErr: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const UDSTicketingSysttemexportslice = createSlice({
  name: "TicketingSystemIn",
  initialState: {
    ticketesportsdata: [],
    Error: "",
  },
  reducers: {
    setTheticketetailsExportActions: (state, actions) => {
      state.ticketesportsdata = [];
      state.Error = "";
    },
    setTheTicketsDetailsResponsiveExport: (state, actions) => {
      state.ticketesportsdata = actions.payload;
    },
    SettheTicketsDetailsErrorExport: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const ScopeGetlistSlice = createSlice({
  name: "ScopeGettheDatalist",
  initialState: {
    ScopeRecords: [],
    Error: "",
  },
  reducers: {
    setTheScopeDetailsExportActions: (state, actions) => {
      state.ScopeRecords = [];
      state.Error = "";
    },
    setTheScopeDetailsResponsiveExport: (state, actions) => {
      state.ScopeRecords = actions.payload;
    },
    SettheScopeDetailsErrorExport: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const ContactPersonEditSlice = createSlice({
  name: "ContactPersonEdit",
  initialState: {
    ContactPersonEditdata: [],
    Error: "",
  },
  reducers: {
    setTheContacteitDetailsExportActions: (state, actions) => {
      state.ContactPersonEditdata = [];
      state.Error = "";
    },
    setTheContactEditDetailsResponsiveExport: (state, actions) => {
      state.ContactPersonEditdata = actions.payload;
    },
    SettheContactEditDetailsErrorExport: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const ListofCategoryListedSlice = createSlice({
  name: "CategoryListed",
  initialState: {
    CategoryDatas: [],
    Error: "",
  },
  reducers: {
    setTheCategorydataDetailsExportActions: (state, actions) => {
      state.CategoryDatas = [];
      state.Error = "";
    },
    setTheCategoryEditDetailsResponsiveExport: (state, actions) => {
      state.CategoryDatas = actions.payload;
    },
    SettheCategoryEditDetailsErrorExport: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const SubCategoryDatasSlice = createSlice({
  name: "SubCategoryListed",
  initialState: {
    SubcategoryDatas: [],
    Error: "",
  },
  reducers: {
    setTheSubCategorydataDetailsExportActions: (state, actions) => {
      state.SubcategoryDatas = [];
      state.Error = "";
    },
    setTheSubCategoryEditDetailsResponsiveExport: (state, actions) => {
      state.SubcategoryDatas = actions.payload;
    },
    SettheSubCategoryEditDetailsErrorExport: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const SubCategoryDatasScopeEditSlice = createSlice({
  name: "SubCategoryeditandcreateScopeListed",
  initialState: {
    SubcategoryEditCreateDatas: [],
    Error: "",
  },
  reducers: {
    setTheSubCategorydataEditandcreateDetailsExportActions: (
      state,
      actions,
    ) => {
      state.SubcategoryEditCreateDatas = [];
      state.Error = "";
    },
    setTheSubCategoryEditandcreateDetailsResponsiveExport: (state, actions) => {
      state.SubcategoryEditCreateDatas = actions.payload;
    },
    SettheSubCategoryEditandcreateDetailsErrorExport: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const NearDueDataCallSlice = createSlice({
  name: "NearDueCallingdatas",
  initialState: {
    Nearduerecords: [],
    Error: "",
  },
  reducers: {
    settheNeardueActions: (state, actions) => {
      state.Nearduerecords = [];
      state.Error = "";
    },
    settheeardueresponsestore: (state, actions) => {
      state.Nearduerecords = actions.payload;
    },
    settheNeardueCallingErrors: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const UdsusersRemarklistedslice = createSlice({
  name: "UdsuserRemarkdssliced",
  initialState: {
    Remarleapicall: [],
    Error: "",
  },
  reducers: {
    settheRemarkspostActions: (state, actions) => {
      state.Remarleapicall = [];
      state.Error = "";
    },
    settheRemarkspostesponsestore: (state, actions) => {
      state.Remarleapicall = actions.payload;
    },
    settheremarkdpostCallingErrors: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const SubcategoryListedEditSlice = createSlice({
  name: "SubCategorySlicedatas",
  initialState: {
    BranchSubcategorylisted: [],
    Error: "",
  },
  reducers: {
    setthesubcategorybranchActionListed: (state, actions) => {
      state.BranchSubcategorylisted = [];
      state.Error = "";
    },
    setthesubcategorybranchResponses: (state, actions) => {
      state.BranchSubcategorylisted = actions.payload;
    },
    setthesubcategorybranchErrors: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const BranchQrcodeexports = createSlice({
  name: "branchqrcodes",
  initialState: {
    branchQrcodeexports: [],
    Error: "",
  },

  reducers: {
    settheqrcodelisted: (state, actions) => {
      state.branchQrcodeexports = [];
      state.Error = "";
    },
    settheqrexportedresponse: (state, actions) => {
      state.branchQrcodeexports = actions.payload;
    },
    settheQrcodeexports: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const Tracking_unregisterrecordOfSystemSlice = createSlice({
  name: "Tracking_unregisterrecordgetOfSystemList",
  initialState: {
    TrackingUnregisterrecordgetListOfSystemData: [],
    Error: "",
    Total_Count: "",
    TrackingReport: [],
  },
  reducers: {
    settheTicketsystem_unregisterrecordgetListDataActions: (state, actions) => {
      state.TrackingUnregisterrecordgetListOfSystemData = [];
      state.Error = "";
    },
    setTheTicketsystem_unregisterrecordgetListDataResponses: (
      state,
      actions,
    ) => {
      state.TrackingUnregisterrecordgetListOfSystemData = actions.payload;
    },
    setTicketsystem_unregisterRecordListDashboardReport: (state, actions) => {
      state.TrackingReport = actions.payload;
    },
    setTheQTicketsystem_unregisterrecordgetListDatasError: (state, actions) => {
      state.Error = actions.payload;
    },
    setTheTicketsystem_unregisterrecordgetListDataTotalCounts: (
      state,
      actions,
    ) => {
      state.Total_Count = actions.payload;
    },
  },
});

///internal
const gettheDepartmentLevelUsersSlice = createSlice({
  name: "DepartmentLevelUsersListe",
  initialState: {
    DepartmentLevelUsersRecords: [],
    Error: "",
    Total_Count: "",
  },
  reducers: {
    getTheLevelUsersListData: (state, actions) => {
      state.DepartmentLevelUsersRecords = [];
      state.Error = "";
    },
    setTheLevelUsersListResponses: (state, actions) => {
      state.DepartmentLevelUsersRecords = actions.payload;
    },
    setTheLevelUserslistError: (state, actions) => {
      state.Error = actions.payload;
    },
    setTheLevelUserListedTotalCounts: (state, actions) => {
      state.Total_Count = actions.payload;
    },
  },
});

const internaldepartmentUsersDelete = createSlice({
  name: "InternalDepartments_usersDelete",
  initialState: {
    InternalDepartments_usersDelete: [],
    Error: "",
  },

  reducers: {
    setTheInternalDepartmentDelete_usersActions: (state, actions) => {
      state.InternalDepartments_usersDelete = [];
      state.Error = "";
    },
    setTheInternalDepartmentsdelete_usersResponsive: (state, actions) => {
      state.InternalDepartments_usersDelete = actions.payload;
    },
    SettheInternalDepartmentsDelete_usersError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const internaldepartmentUsersRetrieve = createSlice({
  name: "InternalDepartments_usersRetrivee",
  initialState: {
    InternalDepartments_usersretrievedatas: [],
    Error: "",
  },

  reducers: {
    setTheInternalDepartmentRetreve_usersActions: (state, actions) => {
      state.InternalDepartments_usersretrievedatas = [];
      state.Error = "";
    },
    setTheInternalDepartmentsRetrieve_usersResponsive: (state, actions) => {
      state.InternalDepartments_usersretrievedatas = actions.payload;
    },
    SettheInternalDepartmentsRetrieve_usersError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const internaldepartmentUsersCrudEdtions = createSlice({
  name: "InternalDepartments_userCrudEditions",
  initialState: {
    InternalDepartments_usersEdtions: [],
    Error: "",
  },

  reducers: {
    setTheInternalDepartmentEdtions_usersActions: (state, actions) => {
      state.InternalDepartments_usersEdtions = [];
      state.Error = "";
    },
    setTheInternalDepartmentsEdtions_usersResponsive: (state, actions) => {
      state.InternalDepartments_usersEdtions = actions.payload;
    },
    SettheInternalDepartmentsEdtions_usersError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const InternalTrackingrecordOfSystemSlice = createSlice({
  name: "TrackingrecordgetOfSystemListInternalDepartment",
  initialState: {
    TrackingrecordgetInternalDepartmentsListOfSystemData: [],
    Error: "",
    Total_Count: "",
    TrackingReport: [],
  },
  reducers: {
    settheInternalTicketsystemrecordgetListInternalDepartmentsDataActions: (
      state,
      actions,
    ) => {
      state.TrackingrecordgetInternalDepartmentsListOfSystemData = [];
      state.Error = "";
    },
    setTheTicketsystemrecordgetListDataInternalDepartmentResponses: (
      state,
      actions,
    ) => {
      state.TrackingrecordgetInternalDepartmentsListOfSystemData =
        actions.payload;
    },
    setTicketsystemRecordListDashboardInternalDepartmentReport: (
      state,
      actions,
    ) => {
      state.TrackingReport = actions.payload;
    },
    setTheQTicketsystemrecordgetListDatasInternalDepartmentError: (
      state,
      actions,
    ) => {
      state.Error = actions.payload;
    },
    setTheTicketsystemrecordgetListDataInternalDepartmentTotalCounts: (
      state,
      actions,
    ) => {
      state.Total_Count = actions.payload;
    },
  },
});

const CreateInternalTicketSlice = createSlice({
  name: "CreateinternalTicketListed",
  initialState: {
    CreateInternalTicketListeds: [],
    Error: "",
  },

  reducers: {
    settheCreateInternalTickets: (state, actions) => {
      state.CreateInternalTicketListeds = [];
      state.Error = "";
    },
    settheCreateInternalTicketsResponse: (state, actions) => {
      state.CreateInternalTicketListeds = actions.payload;
    },
    SettheInternalInternalTicketCreations: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const InternalDepartmentTicketViews = createSlice({
  name: "internalTicketView",
  initialState: {
    InternalDepartments_Ticketsretrievedatas: [],
    Error: "",
  },

  reducers: {
    setTheInternalDepartmentRetreve_TicketViewsActions: (state, actions) => {
      state.InternalDepartments_Ticketsretrievedatas = [];
      state.Error = "";
    },
    setTheInternalDepartmentsRetrieve_TicketViewsResponsive: (
      state,
      actions,
    ) => {
      state.InternalDepartments_Ticketsretrievedatas = actions.payload;
    },
    SettheInternalDepartmentsRetrieve_TicketViewsError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const InternalDepartmentRemarks = createSlice({
  name: "internalTicketRemarks",
  initialState: {
    InternalDepartments_TicketsretrieveRemark: [],
    Error: "",
  },

  reducers: {
    setTheInternalDepartmentRetreve_TicketRemarksActions: (state, actions) => {
      state.InternalDepartments_TicketsretrieveRemark = [];
      state.Error = "";
    },
    setTheInternalDepartmentsRetrieve_TicketRemarksResponsive: (
      state,
      actions,
    ) => {
      state.InternalDepartments_TicketsretrieveRemark = actions.payload;
    },
    SettheInternalDepartmentsRetrieve_TickeRemarkError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const InternalDepartmentCRUDRemarks = createSlice({
  name: "internalTicketCRUDRemarks",
  initialState: {
    InternalDepartments_TicketsCRUDRemark: [],
    Error: "",
  },

  reducers: {
    setTheInternalDepartmentRetreve_TicketRemarksCRUDActions: (
      state,
      actions,
    ) => {
      state.InternalDepartments_TicketsCRUDRemark = [];
      state.Error = "";
    },
    setTheInternalDepartmentsRetrieve_TicketRemarksCURDResponsive: (
      state,
      actions,
    ) => {
      state.InternalDepartments_TicketsCRUDRemark = actions.payload;
    },
    SettheInternalDepartmentsRetrieve_TickeRemarkCRUDError: (
      state,
      actions,
    ) => {
      state.Error = actions.payload;
    },
  },
});

const InternalDepartmenttIMElINE = createSlice({
  name: "internalTicketTimeline",
  initialState: {
    InternalDepartments_TicketsretrieveTimeline: [],
    Error: "",
  },

  reducers: {
    setTheInternalDepartmentRetreve_TicketTImelinesActions: (
      state,
      actions,
    ) => {
      state.InternalDepartments_TicketsretrieveTimeline = [];
      state.Error = "";
    },
    setTheInternalDepartmentsRetrieve_TicketTimelineResponsive: (
      state,
      actions,
    ) => {
      state.InternalDepartments_TicketsretrieveTimeline = actions.payload;
    },
    SettheInternalDepartmentsRetrieve_TickeTimelineError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const InternalDepartmentFeedBack = createSlice({
  name: "internalTicketFeedBack",
  initialState: {
    InternalDepartments_TicketsFeedback: [],
    Error: "",
  },

  reducers: {
    setTheInternalDepartmentRetreve_TicketFeedbackActions: (state, actions) => {
      state.InternalDepartments_TicketsFeedback = [];
      state.Error = "";
    },
    setTheInternalDepartmentsRetrieve_TicketFeedbackResponsive: (
      state,
      actions,
    ) => {
      state.InternalDepartments_TicketsFeedback = actions.payload;
    },
    SettheInternalDepartmentsRetrieve_TicketFeedbackError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const InternalDepartmentFeedBackPost = createSlice({
  name: "internalTicketFeedBackpost",
  initialState: {
    InternalDepartments_TicketsFeedbackPost: [],
    Error: "",
  },

  reducers: {
    setTheInternalDepartment_TicketFeedbackPostActions: (state, actions) => {
      state.InternalDepartments_TicketsFeedbackPost = [];
      state.Error = "";
    },
    setTheInternalDepartments_TicketFeedbackPostResponsive: (
      state,
      actions,
    ) => {
      state.InternalDepartments_TicketsFeedbackPost = actions.payload;
    },
    SettheInternalDepartments_TicketFeedbackPostError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const InternalDepartmentTicketChanges = createSlice({
  name: "internalTicketChanges",
  initialState: {
    InternalDepartments_TicketsTicketChanges: [],
    Error: "",
  },

  reducers: {
    setTheInternalDepartmentRetreve_TicketTicketChangesActions: (
      state,
      actions,
    ) => {
      state.InternalDepartments_TicketsTicketChanges = [];
      state.Error = "";
    },
    setTheInternalDepartmentsRetrieve_TicketChangesResponsive: (
      state,
      actions,
    ) => {
      state.InternalDepartments_TicketsTicketChanges = actions.payload;
    },
    SettheInternalDepartmentsRetrieve_TicketChangesError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const internalcommandsticketpost = createSlice({
  name: "internalcommandticketpost",
  initialState: {
    internaldepartmentticketpost: [],
    Error: "",
  },

  reducers: {
    settheinternaldepartmentcommandpostaction: (state, actions) => {
      state.internaldepartmentticketpost = [];
      state.Error = "";
    },
    settheinternaldepartmentcommandpostresponse: (state, actions) => {
      state.internaldepartmentticketpost = actions.payload;
    },
    settheinternaldepartmentcommandpostError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const internalcommandsticketgetdataDepartment = createSlice({
  name: "internalcommandticketgetdata",
  initialState: {
    internaldepartmentticketgetdata: [],
    Error: "",
  },

  reducers: {
    settheinternaldepartmentcommanddatagetaction: (state, actions) => {
      state.internaldepartmentticketgetdata = [];
      state.Error = "";
    },
    settheinternaldepartmentcommandgetdataresponse: (state, actions) => {
      state.internaldepartmentticketgetdata = actions.payload;
    },
    settheinternaldepartmentcommangetdataError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const internalTicketDepartmentUsersSlice = createSlice({
  name: "internalTicketDepartmentUsersNames",
  initialState: {
    InernalUserTicketdatasOfSystemData: [],
    Error: "",
    Total_Count: "",
    TrackingReport: [],
  },
  reducers: {
    settheTicketsystemInternalrecordgetListDataActions: (state, actions) => {
      state.InernalUserTicketdatasOfSystemData = [];
      state.Error = "";
    },
    setTheTicketsystemInernalDepaertmentrecordgetListDataResponses: (
      state,
      actions,
    ) => {
      state.InernalUserTicketdatasOfSystemData = actions.payload;
    },
    setTicketsystemRecord_departmentListDashboardReport: (state, actions) => {
      state.TrackingReport = actions.payload;
    },
    setTheQTicketsystemrecordDepartmentgetListDatasError: (state, actions) => {
      state.Error = actions.payload;
    },
    setTheTicketsystemrecordgetDepartmentListDataTotalCounts: (
      state,
      actions,
    ) => {
      state.Total_Count = actions.payload;
    },
  },
});

const internal_remarkpostedslice = createSlice({
  name: "internalRemarks_postvaluesName",
  initialState: {
    internalRemarks_postvalues: [],
    Error: "",
  },

  reducers: {
    settheinternaldepartmentRemarksgetaction: (state, actions) => {
      state.internalRemarks_postvalues = [];
      state.Error = "";
    },
    settheinternaldepartmeentremarksdataresponse: (state, actions) => {
      state.internalRemarks_postvalues = actions.payload;
    },
    settheinternaldepartmentremarkdsdataError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const TicketingInernalDashboardSlice = createSlice({
  name: "TicketingInertnalDashboardCalls",
  initialState: {
    TicketingInternalDashboarddata: [],
    Error: "",
    Total_Count: "",
    TrackingReport: [],
  },
  reducers: {
    settheTicketsystemrecordgetListInternalDataActions: (state, actions) => {
      state.TicketingInternalDashboarddata = [];
      state.Error = "";
    },
    setTheTicketsystemrecordgetListInternalDataResponses: (state, actions) => {
      state.TicketingInternalDashboarddata = actions.payload;
    },
    setTicketsystemRecordListInternalDashboardReport: (state, actions) => {
      state.TrackingReport = actions.payload;
    },
    setTheQTicketsystemrecordgetListInternalDatasError: (state, actions) => {
      state.Error = actions.payload;
    },
    setTheTicketsystemrecordgetListInternalDataTotalCounts: (
      state,
      actions,
    ) => {
      state.Total_Count = actions.payload;
    },
  },
});

const TicktignNearDueSliceInternalTicketing = createSlice({
  name: "NeadueInternalTicketCalls",
  initialState: {
    TicketingInternalNearduedata: [],
    Error: "",
    Total_Count: "",
    TrackingReport: [],
  },
  reducers: {
    settheTicketsystemrecordgetListInternalNearDueDataActions: (
      state,
      actions,
    ) => {
      state.TicketingInternalNearduedata = [];
      state.Error = "";
    },
    setTheTicketsystemrecordgetListInternalNearDueDataResponses: (
      state,
      actions,
    ) => {
      state.TicketingInternalNearduedata = actions.payload;
    },
    setTicketsystemRecordListInternalNearDueDashboardReport: (
      state,
      actions,
    ) => {
      state.TrackingReport = actions.payload;
    },
    setTheQTicketsystemrecordgetListInternalNearDueDatasError: (
      state,
      actions,
    ) => {
      state.Error = actions.payload;
    },
    setTheTicketsystemrecordgetListInternaNearDuelDataTotalCounts: (
      state,
      actions,
    ) => {
      state.Total_Count = actions.payload;
    },
  },
});

const TicketReassignSliceDetails = createSlice({
  name: "TicketReassignAssignRejectCalls",
  initialState: {
    InternalAssignReassignReject: [],
    Error: "",
  },

  reducers: {
    setthereassignandAssignRejectDataActions: (state, actions) => {
      state.InternalAssignReassignReject = [];
      state.Error = "";
    },
    setthereassignandAssignRejectDataResponse: (state, actions) => {
      state.InternalAssignReassignReject = actions.payload;
    },
    setthereassignandAssignRejectDataError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const NotificationListoutapi = createSlice({
  name: "NotificationListoutapidatahold",
  initialState: {
    NotificationListoutDatas: [],
    Error: "",
    Total_counts: "",
  },

  reducers: {
    setthenotificationactionsgetlist: (state, actions) => {
      state.NotificationListoutDatas = [];
      state.Error = "";
    },
    settheNotificationToatalcounts: (state, actions) => {
      state.Total_counts = actions.payload;
    },
    setthenotificationactionsResponses: (state, actions) => {
      state.NotificationListoutDatas = actions.payload;
    },
    setthenotificationactionsErrors: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const NotificationListDelete = createSlice({
  name: "NotificationDeleteapidatahold",
  initialState: {
    NotificationListoutDelete: [],
    Error: "",
  },

  reducers: {
    setthenotificationactionDeletelist: (state, actions) => {
      state.NotificationListoutDelete = [];
      state.Error = "";
    },
    setthenotificationactionsDeletelistResponses: (state, actions) => {
      state.NotificationListoutDelete = actions.payload;
    },
    setthenotificationactionsDeletelistErrors: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const TicketDetailsListedslice = createSlice({
  name: "TicketDetailsListedNames",
  initialState: {
    ClientTicketDetailsForInternal: [],
    Error: "",
  },

  reducers: {
    settheClientTicketDeatilsDataActions: (state, actions) => {
      state.ClientTicketDetailsForInternal = [];
      state.Error = "";
    },
    settheClientTicketDetailsDataResponse: (state, actions) => {
      state.ClientTicketDetailsForInternal = actions.payload;
    },
    settheClientTciketDetailsDataError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const TicketUnregisterSliceAssigns = createSlice({
  name: "TicketUnregisterNameAssing",
  initialState: {
    TicketUnregisterDatasAssigns: [],
    Error: "",
  },

  reducers: {
    settheTicketUnregisterAssignActions: (state, actions) => {
      state.TicketUnregisterDatasAssigns = [];
      state.Error = "";
    },
    settheTicketUnregisterAssignResponse: (state, actions) => {
      state.TicketUnregisterDatasAssigns = actions.payload;
    },
    settheTicketUnregisterAssignError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const ticketexcalationSliceRecords = createSlice({
  name: "ticketexcalationrecordoflist",
  initialState: {
    ticketescalationdatas: [],
    Error: "",
  },

  reducers: {
    settheTicketescalationActions: (state, actions) => {
      state.ticketescalationdatas = [];
      state.Error = "";
    },
    settheTicketEscalationResponse: (state, actions) => {
      state.ticketescalationdatas = actions.payload;
    },
    settheTicketEscalationError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const TicketjounerySlicefortheboththe_internalandCliet = createSlice({
  name: "TicketJournydatasofinternlandcient",
  initialState: {
    ticketJourneyforinternal: [],
    Error: "",
  },

  reducers: {
    settheTicketTicketJourneyActions: (state, actions) => {
      state.ticketJourneyforinternal = [];
      state.Error = "";
    },
    settheTicketJourneyResponse: (state, actions) => {
      state.ticketJourneyforinternal = actions.payload;
    },
    settheTicketJourneyError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const TicketjounerySlicefortheClients = createSlice({
  name: "TicketJournydatasClient",
  initialState: {
    ticketJourneyforClients: [],
    Error: "",
  },

  reducers: {
    settheTicketTicketJourneyClientsideActions: (state, actions) => {
      state.ticketJourneyforClients = [];
      state.Error = "";
    },
    settheTicketJourneyResponseclientside: (state, actions) => {
      state.ticketJourneyforClients = actions.payload;
    },
    settheTicketJourneyErrorclient: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const SubTicketsFortheSlice = createSlice({
  name: "SubticketForthemanagements",
  initialState: {
    SubticketManagement: [],
    Error: "",
    Total_Count: "",
    TrackingReport: [],
  },
  reducers: {
    settheSubticketgetActions: (state, actions) => {
      state.SubticketManagement = [];
      state.Error = "";
    },
    settheSubticketgetActionsResponses: (state, actions) => {
      state.SubticketManagement = actions.payload;
    },
    settheSubticketgetActionsResponseofTracking: (state, actions) => {
      state.TrackingReport = actions.payload;
    },
    settheSubticketgetActionsErrors: (state, actions) => {
      state.Error = actions.payload;
    },
    settheSubticketgetActionsTotal_counts: (state, actions) => {
      state.Total_Count = actions.payload;
    },
  },
});

const ClientTicketListedSlice = createSlice({
  name: "ClientTicketListedDatahold",
  initialState: {
    ClientTicketholded: [],
    Error: "",
    Total_Count: "",
    TrackingReport: [],
  },
  reducers: {
    settheclientloneticketactions: (state, actions) => {
      state.ClientTicketholded = [];
      state.Error = "";
    },
    settheclientloneticketresponseActions: (state, actions) => {
      state.ClientTicketholded = actions.payload;
    },
    settheclientloneticketresponseActions_trackingone: (state, actions) => {
      state.TrackingReport = actions.payload;
    },
    settheclientloneticketActionsErrors: (state, actions) => {
      state.Error = actions.payload;
    },
    settheclientloneticketAction_total_counts: (state, actions) => {
      state.Total_Count = actions.payload;
    },
  },
});

const gettheClienCategoryDatasSlice = createSlice({
  name: "gettheClientCategoryDatas",
  initialState: {
    gettheClientCategoryDataas: [],
    Error: "",
  },

  reducers: {
    settheClientCategoryDataActions: (state, actions) => {
      state.gettheClientCategoryDataas = [];
      state.Error = "";
    },
    settheClientCategoryDataResponses: (state, actions) => {
      state.gettheClientCategoryDataas = actions.payload;
    },
    settheClientCategoryDataError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const gettheClientTicketPostforLones = createSlice({
  name: "gettheClientTicketPostforLonesDatastore",
  initialState: {
    gettheClientTicketPostforLonesListed: [],
    Error: "",
  },

  reducers: {
    settheClientCategoryDataLonesActions: (state, actions) => {
      state.gettheClientTicketPostforLonesListed = [];
      state.Error = "";
    },
    settheClientCategoryDataLonesResponses: (state, actions) => {
      state.gettheClientTicketPostforLonesListed = actions.payload;
    },
    settheClientCategoryDataLonesError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const gettheclientsubcategoryApiSlice = createSlice({
  name: "gettheclientsubcategoryApidatas",
  initialState: {
    gettheclientsubcategoryApidatasListed: [],
    Error: "",
  },

  reducers: {
    settheClientSubcategorylistedActions: (state, actions) => {
      state.gettheclientsubcategoryApidatasListed = [];
      state.Error = "";
    },
    settheClientSubcategorylistedresponses: (state, actions) => {
      state.gettheclientsubcategoryApidatasListed = actions.payload;
    },
    settheClientSubcategorylistedError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const NewDashboardSlice = createSlice({
  name: "NewDashboardNameHolds",
  initialState: {
    NewDashboardRecords: [],
    Error: "",
  },
  reducers: {
    settheNewDashboardRecordsActions: (state, actions) => {
      state.NewDashboardRecords = [];
      state.Error = "";
    },
    settheNewDashboardRecordsResponse: (state, actions) => {
      state.NewDashboardRecords = actions.payload;
    },
    settheNewDashboardErrors: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const SubAssignTicketDasboardSliceCall = createSlice({
  name: "SubAssignTicketDasboardDataHolds",
  initialState: {
    SubAssignTicketDasboardDataRecords: [],
    Error: "",
  },
  reducers: {
    settheSubAssignDashboardRecordsActions: (state, actions) => {
      state.SubAssignTicketDasboardDataRecords = [];
      state.Error = "";
    },
    settheSubAssignDashboardRecordsResponse: (state, actions) => {
      state.SubAssignTicketDasboardDataRecords = actions.payload;
    },
    settheSubAssignDashboardErrors: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const StatesOfAdvanceAttendanceRecordsSlice = createSlice({
  name: "StatesOfAdvanceAttendanceRecordsCall",
  initialState: {
    StatesOfAdvanceAttendanceRecordsData: [],
    Error: "",
  },
  reducers: {
    settheAdvanceStateDatasHold: (state, actions) => {
      state.StatesOfAdvanceAttendanceRecordsData = [];
      state.Error = "";
    },
    settheAdvanceStateResponsHold: (state, actions) => {
      state.StatesOfAdvanceAttendanceRecordsData = actions.payload;
    },
    setTheAdvanceStateErrorHold: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const EmployeeOfAdvanceAttendanceRecordsSlice = createSlice({
  name: "EmployeeOfAdvanceAttendanceRecordsCall",
  initialState: {
    EmployeeOfAdvanceAttendanceRecordsData: [],
    Error: "",
    Total_Count: "",
  },
  reducers: {
    settheAdvanceEmployeeDatasHold: (state, actions) => {
      state.EmployeeOfAdvanceAttendanceRecordsData = [];
      state.Error = "";
      state.Total_Count = "";
    },
    settheAdvanceEmployeeResponsHold: (state, actions) => {
      state.EmployeeOfAdvanceAttendanceRecordsData = actions.payload;
    },
    settheadvanceEmployeetotal_counts: (state, actions) => {
      state.Total_Count = actions.payload;
    },
    setTheAdvanceEmployeeErrorHold: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const EmployeeOfAdvanceAttendanceSummaryRecordsSlice = createSlice({
  name: "EmployeeOfAdvanceAttendance_summaryRecordsCall",
  initialState: {
    EmployeeOfAdvanceAttendanceRecordsData_summary: [],
    Error: "",
    Total_Count: "",
  },
  reducers: {
    settheAdvanceEmployeeDatas_summaryHold: (state, actions) => {
      state.EmployeeOfAdvanceAttendanceRecordsData_summary = [];
      state.Error = "";
      state.Total_Count = "";
    },
    settheAdvanceEmployeeRespons_summaryHold: (state, actions) => {
      state.EmployeeOfAdvanceAttendanceRecordsData_summary = actions.payload;
    },
    settheadvanceEmployeetotal_counts_summary: (state, actions) => {
      state.Total_Count = actions.payload;
    },
    setTheAdvanceEmployeeErrorHold_summary: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const AdvanceAttendance_CountsRecordsSlice = createSlice({
  name: "AdvanceAttendance_countsRecordsCall",
  initialState: {
    AdvanceAttendanceRecords_countsData: [],
    Error: "",
  },
  reducers: {
    settheAdvanceEmployeeDatas_countsHold: (state, actions) => {
      state.AdvanceAttendanceRecords_countsData = [];
      state.Error = "";
    },
    settheAdvanceEmployeeRespons_countHold: (state, actions) => {
      state.AdvanceAttendanceRecords_countsData = actions.payload;
    },
    setTheAdvanceEmployeeError_countsHold: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const advanceSecondStateSlice = createSlice({
  name: "advanceSecondStateSliceCall",
  initialState: {
    AdvanceAttendanceRecords_SecondState: [],
    Error: "",
  },
  reducers: {
    settheAdvancDatas_SecondStateHold: (state, actions) => {
      state.AdvanceAttendanceRecords_SecondState = [];
      state.Error = "";
    },
    settheAdvanceRespons_SecondStatHold: (state, actions) => {
      state.AdvanceAttendanceRecords_SecondState = actions.payload;
    },
    setTheAdvanceError_SecondStatHold: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const RegionalManagernboardDetails = createSlice({
  name: "regionalMangerRecords",
  initialState: {
    RegionalMangerOnboardDatas: [],
    Error: "",
  },
  reducers: {
    settheOnboarderdatalistedactions: (state, actions) => {
      state.RegionalMangerOnboardDatas = [];
      state.Error = "";
    },
    settheRegionalMangerdata_ResponseHolder: (state, actions) => {
      state.RegionalMangerOnboardDatas = actions.payload;
    },
    settheRegionalManagerErrors: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const Internal_Dashbaord_TableSlice = createSlice({
  name: "internaltable_dashbaord",
  initialState: {
    Internal_Table_dashboard_: [],
    Error: "",
    Total_Count: "",
  },
  reducers: {
    setinternaltable_dashboard: (state, actions) => {
      state.Internal_Table_dashboard_ = [];
      state.Error = "";
      state.Total_Count = "";
    },
    settheInternal_dashboard_ResponseHolder: (state, actions) => {
      state.Internal_Table_dashboard_ = actions.payload;
    },
    settheinternal_dashboard_total_counts: (state, actions) => {
      state.Total_Count = actions.payload;
    },
    settheInterna_dashboard_table_Errors: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const Customer_Dashbaord_TableSlice = createSlice({
  name: "Customer_table_dashbaord",
  initialState: {
    Customer_Table_datas_dashboard_: [],
    Error: "",
    Total_Count: "",
  },
  reducers: {
    setCustomer_table_dashboard: (state, actions) => {
      state.Customer_Table_datas_dashboard_ = [];
      state.Error = "";
      state.Total_Count = "";
    },
    settheCustomer_dashboard_ResponseHolder: (state, actions) => {
      state.Customer_Table_datas_dashboard_ = actions.payload;
    },
    settheCustomer_dashboard_total_counts: (state, actions) => {
      state.Total_Count = actions.payload;
    },
    settheCustomer_dashboard_table_Errors: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const StateBased_CustomerDashboard = createSlice({
  name: "Customer_table_dashbaord_statebased",
  initialState: {
    Customer_Table_datas_dashboard_StateBased: [],
    Error: "",
    Total_Count: "",
  },
  reducers: {
    setState_based_customerdashboard: (state, actions) => {
      state.Customer_Table_datas_dashboard_StateBased = [];
      state.Error = "";
      state.Total_Count = "";
    },
    settheState_basedCustomer_dashboard_ResponseHolder: (state, actions) => {
      state.Customer_Table_datas_dashboard_StateBased = actions.payload;
    },
    settheStateBasedCustomer_dashboard_total_counts: (state, actions) => {
      state.Total_Count = actions.payload;
    },
    settheStateBased_Customer_dashboard_table_Errors: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const Internal_State_TicketStatus_TableSlice = createSlice({
  name: "internal_statebased_ticketstatus_table",
  initialState: {
    internal_table_dataStatebased: [],
    internal_error: "",
    internal_total_count: "",
  },
  reducers: {
    setStatebasedInternalTable: (state) => {
      state.internal_table_dataStatebased = [];
      state.internal_error = "";
      state.internal_total_count = "";
    },
    setstatebasedInternalTableData: (state, action) => {
      state.internal_table_dataStatebased = action.payload;
    },
    setstatebasedInternalTotalCount: (state, action) => {
      state.internal_total_count = action.payload;
    },
    setstatebasedInternalError: (state, action) => {
      state.internal_error = action.payload;
    },
  },
});

const InternalExcalationDashboardSlice = createSlice({
  name: "internalEscalationsdashboard",
  initialState: {
    Escalation_dashboard_: [],
    escalationError: "",
  },
  reducers: {
    settheInternalescalationActions: (state) => {
      state.Escalation_dashboard_ = [];
      state.escalationError = "";
    },
    settheEscalationResponsehold: (state, action) => {
      state.Escalation_dashboard_ = action.payload;
    },

    settheEscalationErrormessgae: (state, action) => {
      state.escalationError = action.payload;
    },
  },
});

const ExternalExcalationDashboardSlice = createSlice({
  name: "ExternalEscalationsdashboard",
  initialState: {
    ExterenalEscalation_dashboard_: [],
    ExternalescalationError: "",
  },
  reducers: {
    settheexternalescalation_dashboardsactions: (state) => {
      state.ExterenalEscalation_dashboard_ = [];
      state.ExternalescalationError = "";
    },
    settheExternalEscalationResponsehold: (state, action) => {
      state.ExterenalEscalation_dashboard_ = action.payload;
    },

    settheExternalEscalationErrormessgae: (state, action) => {
      state.ExternalescalationError = action.payload;
    },
  },
});

const TicketTrendDashboardSlice = createSlice({
  name: "TicketTrendDashboard",
  initialState: {
    ticketTrendData: [],
    ticketTrendError: "",
  },
  reducers: {
    clearTicketTrendState: (state) => {
      state.ticketTrendData = [];
      state.ticketTrendError = "";
    },
    setTicketTrendData: (state, action) => {
      state.ticketTrendData = action.payload;
    },
    setTicketTrendError: (state, action) => {
      state.ticketTrendError = action.payload;
    },
  },
});

const PerformanceMetricsSlice = createSlice({
  name: "PerformanceMetrics",
  initialState: {
    performanceData: [],
    performanceError: "",
  },
  reducers: {
    clearPerformance_MatrixState: (state) => {
      state.performanceData = [];
      state.performanceError = "";
    },
    setPerformance_matrix_Data: (state, action) => {
      state.performanceData = action.payload;
    },
    setPerformance_Matrix_Error: (state, action) => {
      state.performanceError = action.payload;
    },
  },
});

const Issue_categoryfirstFivelist_customslice = createSlice({
  name: "IssueCategroyCustomChart",
  initialState: {
    CategoryChartFive: [],
    Categorycharterror: "",
  },
  reducers: {
    clearChartCategory_State: (state) => {
      state.CategoryChartFive = [];
      state.Categorycharterror = "";
    },
    setCategoryChart_Data: (state, action) => {
      state.CategoryChartFive = action.payload;
    },
    setCategoryChart_Error: (state, action) => {
      state.Categorycharterror = action.payload;
    },
  },
});
const Issue_categoryListed_customslice = createSlice({
  name: "IssueCategoryListedCustom", // 💡 Updated name to include "Custom"
  initialState: {
    CategoryListData: [],
    CategoryListError: "",
  },
  reducers: {
    clearCategoryList_State: (state) => {
      state.CategoryListData = [];
      state.CategoryListError = "";
    },

    setCategoryList_Data: (state, action) => {
      state.CategoryListData = action.payload;
    },

    setCategoryList_Error: (state, action) => {
      state.CategoryListError = action.payload;
    },
  },
});

const CustomerSupportChart_StateSlice = createSlice({
  name: "CustomerSupport_stateCard",
  initialState: {
    CustomerSupportState_TopTickets: [],
    CustomerSupport_stateError: "",
  },
  reducers: {
    clearCustomerSupportCardState: (state) => {
      state.CustomerSupportState_TopTickets = [];
      state.CustomerSupport_stateError = "";
    },
    setCustomerSupportCard_StateData: (state, action) => {
      state.CustomerSupportState_TopTickets = action.payload;
    },
    setCustomerSupportCard_StateError: (state, action) => {
      state.CustomerSupport_stateError = action.payload;
    },
  },
});

/// state chart

const CustomerSupportStateChartSlice = createSlice({
  name: "CustomerSupportStateChart",
  initialState: {
    CustomerSupportStateChartData: [],
    CustomerSupportStateChartError: "",
  },
  reducers: {
    clearCustomerSupportStateChart: (state) => {
      state.CustomerSupportStateChartData = [];
      state.CustomerSupportStateChartError = "";
    },
    setCustomerSupportStateChartData: (state, action) => {
      state.CustomerSupportStateChartData = action.payload;
    },
    setCustomerSupportStateChartError: (state, action) => {
      state.CustomerSupportStateChartError = action.payload;
    },
  },
});

const CustomerSupportStateListSlice = createSlice({
  name: "CustomerSupportStateList",
  initialState: {
    CustomerSupportStateListData: [],
    CustomerSupportStateListError: "",
  },
  reducers: {
    clearCustomerSupportStateList: (state) => {
      state.CustomerSupportStateListData = [];
      state.CustomerSupportStateListError = "";
    },
    setCustomerSupportStateListData: (state, action) => {
      state.CustomerSupportStateListData = action.payload;
    },
    setCustomerSupportStateListError: (state, action) => {
      state.CustomerSupportStateListError = action.payload;
    },
  },
});

/// reional chart
const CustomerSupportRegionalChartSlice = createSlice({
  name: "CustomerSupportRegionalChart",
  initialState: {
    CustomerSupportRegionalChartData: [],
    CustomerSupportRegionalChartError: "",
  },
  reducers: {
    clearCustomerSupportRegionalChart: (state) => {
      state.CustomerSupportRegionalChartData = [];
      state.CustomerSupportRegionalChartError = "";
    },
    setCustomerSupportRegionalChartData: (state, action) => {
      state.CustomerSupportRegionalChartData = action.payload;
    },
    setCustomerSupportRegionalChartError: (state, action) => {
      state.CustomerSupportRegionalChartError = action.payload;
    },
  },
});

/// regional list
const CustomerSupportRegionalListSlice = createSlice({
  name: "CustomerSupportRegionalList",
  initialState: {
    CustomerSupportRegionalListData: [],
    CustomerSupportRegionalListError: "",
  },
  reducers: {
    clearCustomerSupportRegionalList: (state) => {
      state.CustomerSupportRegionalListData = [];
      state.CustomerSupportRegionalListError = "";
    },
    setCustomerSupportRegionalListData: (state, action) => {
      state.CustomerSupportRegionalListData = action.payload;
    },
    setCustomerSupportRegionalListError: (state, action) => {
      state.CustomerSupportRegionalListError = action.payload;
    },
  },
});
///zone chart
const CustomerSupportZoneChartSlice = createSlice({
  name: "CustomerSupportZoneChart",
  initialState: {
    CustomerSupportZoneChartData: [],
    CustomerSupportZoneChartError: "",
  },
  reducers: {
    clearCustomerSupportZoneChart: (state) => {
      state.CustomerSupportZoneChartData = [];
      state.CustomerSupportZoneChartError = "";
    },
    setCustomerSupportZoneChartData: (state, action) => {
      state.CustomerSupportZoneChartData = action.payload;
    },
    setCustomerSupportZoneChartError: (state, action) => {
      state.CustomerSupportZoneChartError = action.payload;
    },
  },
});

/// zone list

const CustomerSupportZoneListSlice = createSlice({
  name: "CustomerSupportZoneList",
  initialState: {
    CustomerSupportZoneListData: [],
    CustomerSupportZoneListError: "",
  },
  reducers: {
    clearCustomerSupportZoneList: (state) => {
      state.CustomerSupportZoneListData = [];
      state.CustomerSupportZoneListError = "";
    },
    setCustomerSupportZoneListData: (state, action) => {
      state.CustomerSupportZoneListData = action.payload;
    },
    setCustomerSupportZoneListError: (state, action) => {
      state.CustomerSupportZoneListError = action.payload;
    },
  },
});

const CustomerSupportClientChartSlice = createSlice({
  name: "CustomerSupportClientChart",
  initialState: {
    CustomerSupportClientChartData: [],
    CustomerSupportClientChartError: "",
  },
  reducers: {
    clearCustomerSupportClientChart: (state) => {
      state.CustomerSupportClientChartData = [];
      state.CustomerSupportClientChartError = "";
    },
    setCustomerSupportClientChartData: (state, action) => {
      state.CustomerSupportClientChartData = action.payload;
    },
    setCustomerSupportClientChartError: (state, action) => {
      state.CustomerSupportClientChartError = action.payload;
    },
  },
});

const CustomerSupportClientListSlice = createSlice({
  name: "CustomerSupportClientList",
  initialState: {
    CustomerSupportClientListData: [],
    CustomerSupportClientListError: "",
  },
  reducers: {
    clearCustomerSupportClientList: (state) => {
      state.CustomerSupportClientListData = [];
      state.CustomerSupportClientListError = "";
    },
    setCustomerSupportClientListData: (state, action) => {
      state.CustomerSupportClientListData = action.payload;
    },
    setCustomerSupportClientListError: (state, action) => {
      state.CustomerSupportClientListError = action.payload;
    },
  },
});

const CustomPerformanceMatrix_StateSlice = createSlice({
  name: "CustomPerformanceMatrix",
  initialState: {
    CustomPerformanceMatrixData: [],
    CustomPerformanceMatrixError: "",
  },
  reducers: {
    clearCustomPerformanceMatrixState: (state) => {
      state.CustomPerformanceMatrixData = [];
      state.CustomPerformanceMatrixError = "";
    },
    setCustomPerformanceMatrixData: (state, action) => {
      state.CustomPerformanceMatrixData = action.payload;
    },
    setCustomPerformanceMatrixError: (state, action) => {
      state.CustomPerformanceMatrixError = action.payload;
    },
  },
});

//// Internal Supports slices

const InternalPerformanceMetricsSlice = createSlice({
  name: "InternalPerformanceMetrics",
  initialState: {
    internalPerformanceData: [],
    internalPerformanceError: "",
  },
  reducers: {
    clearInternalPerformanceState: (state) => {
      state.internalPerformanceData = [];
      state.internalPerformanceError = "";
    },
    setInternalPerformanceData: (state, action) => {
      state.internalPerformanceData = action.payload;
    },
    setInternalPerformanceError: (state, action) => {
      state.internalPerformanceError = action.payload;
    },
  },
});

const InternalIssueCategoryTopFiveSlice = createSlice({
  name: "InternalIssueCategoryTopFive",
  initialState: {
    internalCategoryTopFive: [],
    internalCategoryTopFiveError: "",
  },
  reducers: {
    clearInternalCategoryTopFive: (state) => {
      state.internalCategoryTopFive = [];
      state.internalCategoryTopFiveError = "";
    },
    setInternalCategoryTopFive: (state, action) => {
      state.internalCategoryTopFive = action.payload;
    },
    setInternalCategoryTopFiveError: (state, action) => {
      state.internalCategoryTopFiveError = action.payload;
    },
  },
});

const InternalIssueCategoryListSlice = createSlice({
  name: "InternalIssueCategoryList",
  initialState: {
    internalCategoryListData: [],
    internalCategoryListError: "",
  },
  reducers: {
    clearInternalCategoryList: (state) => {
      state.internalCategoryListData = [];
      state.internalCategoryListError = "";
    },
    setInternalCategoryList: (state, action) => {
      state.internalCategoryListData = action.payload;
    },
    setInternalCategoryListError: (state, action) => {
      state.internalCategoryListError = action.payload;
    },
  },
});

const InternalSupportChartStateSlice = createSlice({
  name: "InternalSupportChartState",
  initialState: {
    internalSupportChartStateData: [],
    internalSupportChartStateError: "",
  },
  reducers: {
    clearInternalSupportChartState: (state) => {
      state.internalSupportChartStateData = [];
      state.internalSupportChartStateError = "";
    },
    setInternalSupportChartStateData: (state, action) => {
      state.internalSupportChartStateData = action.payload;
    },
    setInternalSupportChartStateError: (state, action) => {
      state.internalSupportChartStateError = action.payload;
    },
  },
});

const InternalSupportStateListSlice = createSlice({
  name: "InternalSupportStateList",
  initialState: {
    internalSupportStateListData: [],
    internalSupportStateListError: "",
  },
  reducers: {
    clearInternalSupportStateList: (state) => {
      state.internalSupportStateListData = [];
      state.internalSupportStateListError = "";
    },
    setInternalSupportStateListData: (state, action) => {
      state.internalSupportStateListData = action.payload;
    },
    setInternalSupportStateListError: (state, action) => {
      state.internalSupportStateListError = action.payload;
    },
  },
});

const InternalSupportRegionalChartSlice = createSlice({
  name: "InternalSupportRegionalChart",
  initialState: {
    internalSupportRegionalChartData: [],
    internalSupportRegionalChartError: "",
  },
  reducers: {
    clearInternalSupportRegionalChart: (state) => {
      state.internalSupportRegionalChartData = [];
      state.internalSupportRegionalChartError = "";
    },
    setInternalSupportRegionalChartData: (state, action) => {
      state.internalSupportRegionalChartData = action.payload;
    },
    setInternalSupportRegionalChartError: (state, action) => {
      state.internalSupportRegionalChartError = action.payload;
    },
  },
});

const InternalSupportRegionalListSlice = createSlice({
  name: "InternalSupportRegionalList",
  initialState: {
    internalSupportRegionalListData: [],
    internalSupportRegionalListError: "",
  },
  reducers: {
    clearInternalSupportRegionalList: (state) => {
      state.internalSupportRegionalListData = [];
      state.internalSupportRegionalListError = "";
    },
    setInternalSupportRegionalListData: (state, action) => {
      state.internalSupportRegionalListData = action.payload;
    },
    setInternalSupportRegionalListError: (state, action) => {
      state.internalSupportRegionalListError = action.payload;
    },
  },
});

const InternalSupportZoneChartSlice = createSlice({
  name: "InternalSupportZoneChart",
  initialState: {
    internalSupportZoneChartData: [],
    internalSupportZoneChartError: "",
  },
  reducers: {
    clearInternalSupportZoneChart: (state) => {
      state.internalSupportZoneChartData = [];
      state.internalSupportZoneChartError = "";
    },
    setInternalSupportZoneChartData: (state, action) => {
      state.internalSupportZoneChartData = action.payload;
    },
    setInternalSupportZoneChartError: (state, action) => {
      state.internalSupportZoneChartError = action.payload;
    },
  },
});

const InternalSupportZoneListSlice = createSlice({
  name: "InternalSupportZoneList",
  initialState: {
    internalSupportZoneListData: [],
    internalSupportZoneListError: "",
  },
  reducers: {
    clearInternalSupportZoneList: (state) => {
      state.internalSupportZoneListData = [];
      state.internalSupportZoneListError = "";
    },
    setInternalSupportZoneListData: (state, action) => {
      state.internalSupportZoneListData = action.payload;
    },
    setInternalSupportZoneListError: (state, action) => {
      state.internalSupportZoneListError = action.payload;
    },
  },
});

const InternalSupportClientChartSlice = createSlice({
  name: "InternalSupportClientChart",
  initialState: {
    internalSupportClientChartData: [],
    internalSupportClientChartError: "",
  },
  reducers: {
    clearInternalSupportClientChart: (state) => {
      state.internalSupportClientChartData = [];
      state.internalSupportClientChartError = "";
    },
    setInternalSupportClientChartData: (state, action) => {
      state.internalSupportClientChartData = action.payload;
    },
    setInternalSupportClientChartError: (state, action) => {
      state.internalSupportClientChartError = action.payload;
    },
  },
});

const InternalSupportClientListSlice = createSlice({
  name: "InternalSupportClientList",
  initialState: {
    internalSupportClientListData: [],
    internalSupportClientListError: "",
  },
  reducers: {
    clearInternalSupportClientList: (state) => {
      state.internalSupportClientListData = [];
      state.internalSupportClientListError = "";
    },
    setInternalSupportClientListData: (state, action) => {
      state.internalSupportClientListData = action.payload;
    },
    setInternalSupportClientListError: (state, action) => {
      state.internalSupportClientListError = action.payload;
    },
  },
});

const InternalCustomPerformanceMatrixSlice = createSlice({
  name: "InternalCustomPerformanceMatrix",
  initialState: {
    internalCustomPerformanceMatrixData: [],
    internalCustomPerformanceMatrixError: "",
  },
  reducers: {
    clearInternalCustomPerformanceMatrix: (state) => {
      state.internalCustomPerformanceMatrixData = [];
      state.internalCustomPerformanceMatrixError = "";
    },
    setInternalCustomPerformanceMatrixData: (state, action) => {
      state.internalCustomPerformanceMatrixData = action.payload;
    },
    setInternalCustomPerformanceMatrixError: (state, action) => {
      state.internalCustomPerformanceMatrixError = action.payload;
    },
  },
});

const InternalSupportTrendTicketsSlice = createSlice({
  name: "InternalSupportTrendsTickets",
  initialState: {
    internalSupportGraph_Data: [],
    internalSupportGraph_Error: "",
  },
  reducers: {
    clearInternalSupportGraph_TrendActions: (state) => {
      state.internalSupportGraph_Data = [];
      state.internalSupportGraph_Error = "";
    },
    setInternalSupportTrendResponseData: (state, action) => {
      state.internalSupportGraph_Data = action.payload;
    },
    setInternalSupportTrendsActionsError: (state, action) => {
      state.internalSupportGraph_Error = action.payload;
    },
  },
});

const Customer_Geolocation_State_Slice = createSlice({
  name: "customer_geolocation_state",
  initialState: {
    state_table_data: [],
    state_error: "",
    state_total_count: "",
  },
  reducers: {
    resetStateData: (state) => {
      state.state_table_data = [];
      state.state_error = "";
      state.state_total_count = "";
    },
    setStateTableData: (state, action) => {
      state.state_table_data = action.payload;
    },
    setStateTotalCount: (state, action) => {
      state.state_total_count = action.payload;
    },
    setStateError: (state, action) => {
      state.state_error = action.payload;
    },
  },
});

const Customer_Geolocation_Regional_Slice = createSlice({
  name: "customer_geolocation_regional",
  initialState: {
    regional_table_data: [],
    regional_error: "",
    regional_total_count: "",
  },
  reducers: {
    resetRegionalData: (state) => {
      state.regional_table_data = [];
      state.regional_error = "";
      state.regional_total_count = "";
    },
    setRegionalTableData: (state, action) => {
      state.regional_table_data = action.payload;
    },
    setRegionalTotalCount: (state, action) => {
      state.regional_total_count = action.payload;
    },
    setRegionalError: (state, action) => {
      state.regional_error = action.payload;
    },
  },
});

const Customer_Geolocation_Zone_Slice = createSlice({
  name: "customer_geolocation_zone",
  initialState: {
    zone_table_data: [],
    zone_error: "",
    zone_total_count: "",
  },
  reducers: {
    resetZoneData: (state) => {
      state.zone_table_data = [];
      state.zone_error = "";
      state.zone_total_count = "";
    },
    setZoneTableData: (state, action) => {
      state.zone_table_data = action.payload;
    },
    setZoneTotalCount: (state, action) => {
      state.zone_total_count = action.payload;
    },
    setZoneError: (state, action) => {
      state.zone_error = action.payload;
    },
  },
});

const Customer_Geolocation_Client_Slice = createSlice({
  name: "customer_geolocation_client",
  initialState: {
    client_table_data: [],
    client_error: "",
    client_total_count: "",
  },
  reducers: {
    resetClientData: (state) => {
      state.client_table_data = [];
      state.client_error = "";
      state.client_total_count = "";
    },
    setClientTableData: (state, action) => {
      state.client_table_data = action.payload;
    },
    setClientTotalCount: (state, action) => {
      state.client_total_count = action.payload;
    },
    setClientError: (state, action) => {
      state.client_error = action.payload;
    },
  },
});

/// internal
const InternalSupport_RegionList_Slice = createSlice({
  name: "internalsupport_regionlist",
  initialState: {
    internal_table_data: [],
    internal_error: "",
    internal_total_count: "",
  },
  reducers: {
    resetInternalRegionData: (state) => {
      state.internal_table_data = [];
      state.internal_error = "";
      state.internal_total_count = "";
    },
    setInternalRegionTableData: (state, action) => {
      state.internal_table_data = action.payload;
    },
    setInternalRegionTotalCount: (state, action) => {
      state.internal_total_count = action.payload;
    },
    setInternalRegionError: (state, action) => {
      state.internal_error = action.payload;
    },
  },
});

const InternalSupport_Zone_Slice = createSlice({
  name: "internalsupport_zone",
  initialState: {
    zone_table_data: [],

    zone_error: "",
    zone_total_count: "",
  },
  reducers: {
    resetZoneData_internal: (state) => {
      state.zone_table_data = [];
      state.zone_error = "";
      state.zone_total_count = "";
    },
    setZoneTableData_internal: (state, action) => {
      state.zone_table_data = action.payload;
    },
    setZoneTotalCount_internal: (state, action) => {
      state.zone_total_count = action.payload;
    },
    setZoneError_internal: (state, action) => {
      state.zone_error = action.payload;
    },
  },
});

const InternalSupport_Client_Slice = createSlice({
  name: "internalsupport_client",
  initialState: {
    client_table_data: [],
    client_error: "",
    client_total_count: "",
  },
  reducers: {
    resetClientData_internal: (state) => {
      state.client_table_data = [];
      state.client_error = "";
      state.client_total_count = "";
    },
    setClientTableData_internal: (state, action) => {
      state.client_table_data = action.payload;
    },
    setClientTotalCount_internal: (state, action) => {
      state.client_total_count = action.payload;
    },
    setClientError_internal: (state, action) => {
      state.client_error = action.payload;
    },
  },
});

const Employee_actionOfEditSlice = createSlice({
  name: "EmployeeEditActions_exitings",
  initialState: {
    Employee_EditActions: [],
    EmployeeEditActions_error: "",
  },
  reducers: {
    resetEmployeeEditActionsdata: (state) => {
      state.Employee_EditActions = [];
      state.EmployeeEditActions_error = "";
    },
    settheExitignEmp_editActionsresponse: (state, action) => {
      state.Employee_EditActions = action.payload;
    },
    setEmployeeEditActionsError: (state, action) => {
      state.EmployeeEditActions_error = action.payload;
    },
  },
});

/// Master dashboard

const Master_dashboard_listedrecords = createSlice({
  name: "masterdashboard_records",
  initialState: {
    Master_dashboard: [],

    Errors: "",
    MasterDash_total_count: "",
  },
  reducers: {
    resetMasterdashData_internal: (state) => {
      state.Master_dashboard = [];
      state.Errors = "";
      state.MasterDash_total_count = "";
    },
    setMasterdashTableData_internal: (state, action) => {
      state.Master_dashboard = action.payload;
    },
    setMasterdashTotalCount_internal: (state, action) => {
      state.MasterDash_total_count = action.payload;
    },
    setMasterdashError_internal: (state, action) => {
      state.Errors = action.payload;
    },
  },
});

const Master_dashboard_cruds = createSlice({
  name: "masterdashboard_cruds_tocall",
  initialState: {
    Master_dashboard_cruds: [],

    Errors: "",
  },
  reducers: {
    resetMasterdashData_Crud_opretions: (state) => {
      state.Master_dashboard_cruds = [];
      state.Errors = "";
    },
    setMasterdashTableData_CrudOperation: (state, action) => {
      state.Master_dashboard_cruds = action.payload;
    },
    setMasterdashError_Crud_opreation: (state, action) => {
      state.Errors = action.payload;
    },
  },
});

const Organization_filterlist = createSlice({
  name: "organization_filterlist_tocall",
  initialState: {
    Organization_filterlist_records: [],
    Errors: "",
  },
  reducers: {
    resetOrganizationFilterlist: (state) => {
      state.Organization_filterlist_records = [];
      state.Errors = "";
    },
    setOrganizationFilterlistData: (state, action) => {
      state.Organization_filterlist_records = action.payload;
    },
    setOrganizationFilterlistError: (state, action) => {
      state.Errors = action.payload;
    },
  },
});
const organizationRm_filterlist = createSlice({
  name: "organizationRm_filterlist_tocall",
  initialState: {
    OrganizationRm_filterlist_records: [],
    Errors: "",
  },
  reducers: {
    resetOrganizationRmFilterlist: (state) => {
      state.OrganizationRm_filterlist_records = [];
      state.Errors = "";
    },
    setOrganizationRmFilterlistData: (state, action) => {
      state.OrganizationRm_filterlist_records = action.payload;
    },
    setOrganizationRmFilterlistError: (state, action) => {
      state.Errors = action.payload;
    },
  },
});

const clientDivisionLevel_dropdown = createSlice({
  name: "clientDivisionLevel_dropdown_tocall",
  initialState: {
    ClientDivisionLevel_records: [],
    Errors: "",
  },
  reducers: {
    resetClientDivisionLevelDropdown: (state) => {
      state.ClientDivisionLevel_records = [];
      state.Errors = "";
    },
    setClientDivisionLevelDropdownData: (state, action) => {
      state.ClientDivisionLevel_records = action.payload;
    },
    setClientDivisionLevelDropdownError: (state, action) => {
      state.Errors = action.payload;
    },
  },
});

const grievance_export_listedoptions = createSlice({
  name: "grievanceExportListCall",
  initialState: {
    grievanceExportDatas: [],
    Error: "",
  },
  reducers: {
    setGrievanceEMPexportAction: (state, actions) => {
      state.grievanceExportDatas = [];
      state.Error = "";
    },
    setGrievanceEMpExporttResponse: (state, actions) => {
      state.grievanceExportDatas = actions.payload;
    },

    setgrievanceEmpExportError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const Salary_export_Annualoptions = createSlice({
  name: "SalaryExportAnnualCall",
  initialState: {
    Salary_annualExportDatas: [],
    Error: "",
  },
  reducers: {
    setSalaryEMPexportAction: (state, actions) => {
      state.Salary_annualExportDatas = [];
      state.Error = "";
    },
    setSalaryEMpExporttResponse: (state, actions) => {
      state.Salary_annualExportDatas = actions.payload;
    },

    setSalaryEmpExportError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const Appointment_export_Annualoptions = createSlice({
  name: "AppointmentExportAnnualCall",
  initialState: {
    Appointment_annualExportDatas: [],
    Error: "",
  },
  reducers: {
    setAppointmentEMPexportAction: (state, actions) => {
      state.Appointment_annualExportDatas = [];
      state.Error = "";
    },
    setAppointmentEMpExporttResponse: (state, actions) => {
      state.Appointment_annualExportDatas = actions.payload;
    },

    setAppointmentEmpExportError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const Salary_export_letter_revision = createSlice({
  name: "SalaryExportletter_revisionCall",
  initialState: {
    Salary_annual_revisionDatas: [],
    Error: "",
  },
  reducers: {
    setSalaryexport_revision_Action: (state, actions) => {
      state.Salary_annual_revisionDatas = [];
      state.Error = "";
    },
    setSalaryrevisionExporttResponse: (state, actions) => {
      state.Salary_annual_revisionDatas = actions.payload;
    },

    setSalaryrevisionExportError: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});
const Contract_Renewal_Letter = createSlice({
  name: "Contract_Renewal_Letter_Call",
  initialState: {
    Contract_Renewal_Datas: [],
    Error: "",
  },
  reducers: {
    setContractRenewalAction: (state, action) => {
      state.Contract_Renewal_Datas = [];
      state.Error = "";
    },
    setContractRenewalResponse: (state, action) => {
      state.Contract_Renewal_Datas = action.payload;
    },
    setContractRenewalError: (state, action) => {
      state.Error = action.payload;
    },
  },
});

const Salary_Revision_Letter_Change = createSlice({
  name: "Salary_Revision_Letter_Change_Call",
  initialState: {
    Salary_Revision_Change_Datas: [],
    Error: "",
  },
  reducers: {
    setSalaryRevisionChangeAction: (state, action) => {
      state.Salary_Revision_Change_Datas = [];
      state.Error = "";
    },
    setSalaryRevisionChangeResponse: (state, action) => {
      state.Salary_Revision_Change_Datas = action.payload;
    },
    setSalaryRevisionChangeError: (state, action) => {
      state.Error = action.payload;
    },
  },
});

/// warning
const Warning_Letter_Poor_Performance = createSlice({
  name: "Warning_Letter_Poor_Performance_Call",
  initialState: {
    Warning_Poor_Performance_Datas: [],
    Error: "",
  },
  reducers: {
    setWarningPoorPerformanceAction: (state) => {
      state.Warning_Poor_Performance_Datas = [];
      state.Error = "";
    },
    setWarningPoorPerformanceResponse: (state, action) => {
      state.Warning_Poor_Performance_Datas = action.payload;
    },
    setWarningPoorPerformanceError: (state, action) => {
      state.Error = action.payload;
    },
  },
});

const Generate_Letter_slice = createSlice({
  name: "Generate_Letter_Call",
  initialState: {
    Genarated_letter_Datas: [],
    Error: "",
  },
  reducers: {
    // setGenerated_letterAction: (state) => {
    //   state.Genarated_letter_Datas = [];
    //   state.Error = "";
    // },
    setGenerated_letterAction: () => { },

    setGenerated_lettersResponse: (state, action) => {
      state.Genarated_letter_Datas = action.payload;
    },
    setGeneratedError: (state, action) => {
      state.Error = action.payload;
    },
  },
});

const Warning_Letter_Indiscipline = createSlice({
  name: "Warning_Letter_Indiscipline_Call",
  initialState: {
    Warning_Indiscipline_Datas: [],
    Error: "",
  },
  reducers: {
    setWarningIndisciplineAction: (state) => {
      state.Warning_Indiscipline_Datas = [];
      state.Error = "";
    },
    setWarningIndisciplineResponse: (state, action) => {
      state.Warning_Indiscipline_Datas = action.payload;
    },
    setWarningIndisciplineError: (state, action) => {
      state.Error = action.payload;
    },
  },
});

const Show_Cause_Absconding = createSlice({
  name: "Show_Cause_Absconding_Call",
  initialState: {
    Show_Cause_Absconding_Datas: [],
    Error: "",
  },
  reducers: {
    setShowCauseAbscondingAction: (state) => {
      state.Show_Cause_Absconding_Datas = [];
      state.Error = "";
    },
    setShowCauseAbscondingResponse: (state, action) => {
      state.Show_Cause_Absconding_Datas = action.payload;
    },
    setShowCauseAbscondingError: (state, action) => {
      state.Error = action.payload;
    },
  },
});

const Show_Cause_False_Attendance = createSlice({
  name: "Show_Cause_False_Attendance_Call",
  initialState: {
    Show_Cause_False_Attendance_Datas: [],
    Error: "",
  },
  reducers: {
    setShowCauseFalseAttendanceAction: (state) => {
      state.Show_Cause_False_Attendance_Datas = [];
      state.Error = "";
    },
    setShowCauseFalseAttendanceResponse: (state, action) => {
      state.Show_Cause_False_Attendance_Datas = action.payload;
    },
    setShowCauseFalseAttendanceError: (state, action) => {
      state.Error = action.payload;
    },
  },
});

const Show_Cause_False_Bills_Submission = createSlice({
  name: "Show_Cause_False_Bills_Submission_Call",
  initialState: {
    Show_Cause_False_Bills_Datas: [],
    Error: "",
  },
  reducers: {
    setShowCauseFalseBillsAction: (state) => {
      state.Show_Cause_False_Bills_Datas = [];
      state.Error = "";
    },
    setShowCauseFalseBillsResponse: (state, action) => {
      state.Show_Cause_False_Bills_Datas = action.payload;
    },
    setShowCauseFalseBillsError: (state, action) => {
      state.Error = action.payload;
    },
  },
});

/// attendance for sbi and hdfc
/// for count
const AdvanceAttendance_Counts_particularRecordsSlice = createSlice({
  name: "AdvanceAttendance_counts_particularRecordsCall",
  initialState: {
    AdvanceAttendance_particularRecords_countsData: [],
    Error: "",
  },
  reducers: {
    settheAdvanceEmployeeDatasparticular_countsHold: (state, actions) => {
      state.AdvanceAttendance_particularRecords_countsData = [];
      state.Error = "";
    },
    settheAdvanceEmployeeparticular_Respons_countHold: (state, actions) => {
      state.AdvanceAttendance_particularRecords_countsData = actions.payload;
    },
    setTheAdvanceEmployee_particularError_countsHold: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const StatesOfAdvanceAttendance_particular_RecordsSlice = createSlice({
  name: "StatesOfAdvanceAttendance_particularRecordsCall",
  initialState: {
    StatesOfAdvanceAttendanceparticularRecordsData: [],
    Error: "",
  },
  reducers: {
    settheAdvanceState_particularDatasHold: (state, actions) => {
      state.StatesOfAdvanceAttendanceparticularRecordsData = [];
      state.Error = "";
    },
    settheAdvanceState_particularResponsHold: (state, actions) => {
      state.StatesOfAdvanceAttendanceparticularRecordsData = actions.payload;
    },
    setTheAdvanceState_particularErrorHold: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const advanceSecond_particularStateSlice = createSlice({
  name: "advanceSecondState_particularSliceCall",
  initialState: {
    AdvanceAttendanceRecords_Second_particularState: [],
    Error: "",
  },
  reducers: {
    settheAdvancDatas_Second_particularStateHold: (state, actions) => {
      state.AdvanceAttendanceRecords_Second_particularState = [];
      state.Error = "";
    },
    settheAdvanceRespons_Second_particularStatHold: (state, actions) => {
      state.AdvanceAttendanceRecords_Second_particularState = actions.payload;
    },
    setTheAdvanceError_Second_particularStatHold: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const EmployeeOfAdvanceAttendance_particularRecordsSlice = createSlice({
  name: "EmployeeOfAdvanceAttendanceRecords_particularCall",
  initialState: {
    EmployeeOfAdvanceAttendance_particularRecordsData: [],
    Error: "",
    Total_Count: "",
  },
  reducers: {
    settheAdvanceEmployeeDatas_particularHold: (state, actions) => {
      state.EmployeeOfAdvanceAttendance_particularRecordsData = [];
      state.Error = "";
      state.Total_Count = "";
    },
    settheAdvanceEmployeeRespons_particularHold: (state, actions) => {
      state.EmployeeOfAdvanceAttendance_particularRecordsData = actions.payload;
    },
    settheadvanceEmployeetotal_counts_particular: (state, actions) => {
      state.Total_Count = actions.payload;
    },
    setTheAdvanceEmployeeErrorHold_particular: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const EmployeeOfAdvanceAttendance_particularSummaryRecordsSlice = createSlice({
  name: "EmployeeOfAdvanceAttendanceParticular_summaryRecordsCall",
  initialState: {
    EmployeeOfAdvanceAttendanceRecordsDataparticular_summary: [],
    Error: "",
    Total_Count: "",
  },
  reducers: {
    settheAdvanceEmployeeDatas_summary_particularHold: (state, actions) => {
      state.EmployeeOfAdvanceAttendanceRecordsDataparticular_summary = [];
      state.Error = "";
      state.Total_Count = "";
    },
    settheAdvanceEmployeeRespons_summary_particularHold: (state, actions) => {
      state.EmployeeOfAdvanceAttendanceRecordsDataparticular_summary =
        actions.payload;
    },
    settheadvanceEmployeetotal_counts_summary_particular: (state, actions) => {
      state.Total_Count = actions.payload;
    },
    setTheAdvanceEmployeeErrorHold_summary_particular: (state, actions) => {
      state.Error = actions.payload;
    },
  },
});

const signatureUploadSlice = createSlice({
  name: "signatureUpload",
  initialState: {
    loading: false,
    error: null,
    presignedData: null, // full presigned object
    uploadedUrl: null, // final S3 public URL
  },
  reducers: {
    getPresignedUrlRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    getPresignedUrlSuccess: (state, action) => {
      state.presignedData = action.payload;
      state.loading = false;
    },
    getPresignedUrlFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    uploadSignatureRequest: (state) => {
      state.loading = true;
    },
    uploadSignatureSuccess: (state, action) => {
      state.uploadedUrl = action.payload;
      state.loading = false;
    },
    uploadSignatureFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    resetSignatureUpload: () => ({
      loading: false,
      error: null,
      presignedData: null,
      uploadedUrl: null,
    }),
  },
});

const Selfonboarding_RetrieveCall = createSlice({
  name: "selfonboardingretriveslice",
  initialState: {
    Selfonboarding_Data: null,
    Error: "",
  },
  reducers: {
    setSelfonboardingRetrieveAction: (state) => {
      state.Selfonboarding_Data = null;
      state.Error = "";
    },

    setSelfonboardingRetrieveResponse: (state, action) => {
      state.Selfonboarding_Data = action.payload;
    },

    setSelfonboardingRetrieveError: (state, action) => {
      state.Error = action.payload;
    },
  },
});

const Selfonboarding_DataFetchCall = createSlice({
  name: "selfonboarddatafetchslice",
  initialState: {
    Selfonboarding_DataFetch_Data: null,
    Error: "",
  },
  reducers: {
    setSelfonboardingDataFetchAction: (state) => {
      state.Selfonboarding_DataFetch_Data = null;
      state.Error = "";
    },

    setSelfonboardingDataFetchResponse: (state, action) => {
      state.Selfonboarding_DataFetch_Data = action.payload;
    },

    setSelfonboardingDataFetchError: (state, action) => {
      state.Error = action.payload;
    },
  },
});

const Signature_Employee_RetrieveCall = createSlice({
  name: "Signature_Employee_RetrieveCall_actions",
  initialState: {
    Signature_Employee_Datas: null,
    Error: "",
  },
  reducers: {
    setSignatureEmployeeRetrieveAction: (state) => {
      state.Signature_Employee_Datas = null;
      state.Error = "";
    },

    setSignatureEmployeeRetrieveResponse: (state, action) => {
      state.Signature_Employee_Datas = action.payload;
    },

    setSignatureEmployeeRetrieveError: (state, action) => {
      state.Error = action.payload;
    },
  },
});
const Signature_Employee_UpdatedsCall = createSlice({
  name: "Signature_Employee_UpdatedsCall_actions",
  initialState: {
    Signature_Employee_Updateds: [],
    Error: "",
  },
  reducers: {
    setSignatureEmployeeUpdatedAction: (state) => {
      state.Signature_Employee_Updateds = [];
      state.Error = "";
    },

    setSignatureEmployeeUpdatedResponse: (state, action) => {
      state.Signature_Employee_Updateds = action.payload;
    },

    setSignatureEmployeeUpdatedError: (state, action) => {
      state.Error = action.payload;
    },
  },
});

const employeeEsignRetrieveSlice = createSlice({
  name: "employeeEsignRetrieve",
  initialState: {
    employeeEsignData: null,
    loading: false,
    error: null,
  },
  reducers: {
    getEmployeeEsignRetrieveRequest: (state) => {
      state.employeeEsignData = null;
      state.loading = true;
      state.error = null;
    },
    getEmployeeEsignRetrieveSuccess: (state, action) => {
      state.loading = false;
      state.employeeEsignData = action.payload;
    },
    getEmployeeEsignRetrieveFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

const employeeEsignUpdateSlice = createSlice({
  name: "employeeEsignUpdate",
  initialState: {
    employeeEsignUpdateData: null,
    presignedUrlData: null,
    loading: false,
    error: null,
  },
  reducers: {
    updateEmployeeEsignRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    updateEmployeeEsignSuccess: (state, action) => {
      state.loading = false;
      state.employeeEsignUpdateData = action.payload;
    },
    updateEmployeeEsignFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    getPresignedUrlEmployeeEsignRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    getPresignedUrlEmployeeEsignSuccess: (state, action) => {
      state.loading = false;
      state.presignedUrlData = action.payload;
    },
    getPresignedUrlEmployeeEsignFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    uploadSignatureEmployeeEsignRequest: (state) => {
      state.loading = true;
    },
  },
});

const Form_ExportsUsers_RetrieveCall = createSlice({
  name: "Form_ExportsUsers_RetrieveCall_actions",
  initialState: {
    Form_ExportsUsers: [],
    Error: "",
  },
  reducers: {
    setFormExportsUsersRetrieveAction: (state) => {
      state.Form_ExportsUsers = [];
      state.Error = "";
    },

    setFormExportsUsersRetrieveResponse: (state, action) => {
      state.Form_ExportsUsers = action.payload;
    },

    setFormExportsUsersRetrieveError: (state, action) => {
      state.Error = action.payload;
    },
  },
});

const Form_Reports_UpdatedCall = createSlice({
  name: "Form_Reports_UpdatedCall_actions",
  initialState: {
    Form_Reports_Updated: [],
    Error: "",
  },
  reducers: {
    setFormReportsUpdatedAction: (state) => {
      state.Form_Reports_Updated = [];
      state.Error = "";
    },

    setFormReportsUpdatedResponse: (state, action) => {
      state.Form_Reports_Updated = action.payload;
    },

    setFormReportsUpdatedError: (state, action) => {
      state.Error = action.payload;
    },
  },
});

/// skill assessments
const Skill_Assessment_Dashboard_Count_Slice = createSlice({
  name: "Skill_Assessment_Dashboard_Count_actions",
  initialState: {
    Skill_Assessment_Dashboard_Count: null,
    Error: "",
  },
  reducers: {
    setSkillAssessmentDashboardCountAction: (state) => {
      state.Skill_Assessment_Dashboard_Count = [];
      state.Error = "";
    },

    setSkillAssessmentDashboardCountResponse: (state, action) => {
      state.Skill_Assessment_Dashboard_Count = action.payload;
    },

    setSkillAssessmentDashboardCountError: (state, action) => {
      state.Error = action.payload;
    },
  },
});

//// For the State managements

const previousPagePositionSlice = createSlice({
  name: "previouspageposition",
  initialState: {
    TablePositionPersist: {},
  },
  reducers: {
    setTablePositionPersist: (state, action) => {
      state.TablePositionPersist[action.payload.pageName] = action.payload.data;
    },
  },
});
export const { setTablePositionPersist } = previousPagePositionSlice.actions;

const sonyBulkUploadTabSlice = createSlice({
  name: "sonybulkuploadtab",
  initialState: {
    selectedTab: "Onboarding",
  },
  reducers: {
    setSonyBulkUploadTab: (state, action) => {
      state.selectedTab = action.payload;
    },
  },
});

export const { setSonyBulkUploadTab } = sonyBulkUploadTabSlice.actions;

export const {
  setSkillAssessmentDashboardCountAction,
  setSkillAssessmentDashboardCountResponse,
  setSkillAssessmentDashboardCountError,
} = Skill_Assessment_Dashboard_Count_Slice.actions;

export const {
  setFormReportsUpdatedAction,
  setFormReportsUpdatedResponse,
  setFormReportsUpdatedError,
} = Form_Reports_UpdatedCall.actions;

export const {
  setFormExportsUsersRetrieveAction,
  setFormExportsUsersRetrieveResponse,
  setFormExportsUsersRetrieveError,
} = Form_ExportsUsers_RetrieveCall.actions;

export const {
  getPresignedUrlRequest,
  getPresignedUrlSuccess,
  getPresignedUrlFailure,
  uploadSignatureRequest,
  uploadSignatureSuccess,
  uploadSignatureFailure,
  resetSignatureUpload,
} = signatureUploadSlice.actions;

export const {
  setSignatureEmployeeUpdatedAction,
  setSignatureEmployeeUpdatedResponse,
  setSignatureEmployeeUpdatedError,
} = Signature_Employee_UpdatedsCall.actions;

export const {
  setSignatureEmployeeRetrieveAction,
  setSignatureEmployeeRetrieveResponse,
  setSignatureEmployeeRetrieveError,
} = Signature_Employee_RetrieveCall.actions;

export const {
  getEmployeeEsignRetrieveRequest,
  getEmployeeEsignRetrieveSuccess,
  getEmployeeEsignRetrieveFailure,
} = employeeEsignRetrieveSlice.actions;

export const {
  updateEmployeeEsignRequest,
  updateEmployeeEsignSuccess,
  updateEmployeeEsignFailure,
  getPresignedUrlEmployeeEsignRequest,
  getPresignedUrlEmployeeEsignSuccess,
  getPresignedUrlEmployeeEsignFailure,
  uploadSignatureEmployeeEsignRequest,
} = employeeEsignUpdateSlice.actions;

export const {
  setSelfonboardingRetrieveAction,
  setSelfonboardingRetrieveResponse,
  setSelfonboardingRetrieveError,
} = Selfonboarding_RetrieveCall.actions;

export const {
  setSelfonboardingDataFetchAction,
  setSelfonboardingDataFetchResponse,
  setSelfonboardingDataFetchError,
} = Selfonboarding_DataFetchCall.actions;

/// attendance
export const {
  settheAdvanceEmployeeDatasparticular_countsHold,
  settheAdvanceEmployeeparticular_Respons_countHold,
  setTheAdvanceEmployee_particularError_countsHold,
} = AdvanceAttendance_Counts_particularRecordsSlice.actions;

export const {
  settheAdvanceState_particularDatasHold,
  settheAdvanceState_particularResponsHold,
  setTheAdvanceState_particularErrorHold,
} = StatesOfAdvanceAttendance_particular_RecordsSlice.actions;

export const {
  settheAdvancDatas_Second_particularStateHold,
  settheAdvanceRespons_Second_particularStatHold,
  setTheAdvanceError_Second_particularStatHold,
} = advanceSecond_particularStateSlice.actions;
export const {
  settheAdvanceEmployeeDatas_particularHold,
  settheAdvanceEmployeeRespons_particularHold,
  settheadvanceEmployeetotal_counts_particular,
  setTheAdvanceEmployeeErrorHold_particular,
} = EmployeeOfAdvanceAttendance_particularRecordsSlice.actions;

export const {
  settheAdvanceEmployeeDatas_summary_particularHold,
  settheAdvanceEmployeeRespons_summary_particularHold,
  settheadvanceEmployeetotal_counts_summary_particular,
  setTheAdvanceEmployeeErrorHold_summary_particular,
} = EmployeeOfAdvanceAttendance_particularSummaryRecordsSlice.actions;

export const {
  setWarningPoorPerformanceAction,
  setWarningPoorPerformanceResponse,
  setWarningPoorPerformanceError,
} = Warning_Letter_Poor_Performance.actions;

export const {
  setGenerated_letterAction,
  setGenerated_lettersResponse,
  setGeneratedError,
} = Generate_Letter_slice.actions;

export const {
  setWarningIndisciplineAction,
  setWarningIndisciplineResponse,
  setWarningIndisciplineError,
} = Warning_Letter_Indiscipline.actions;

export const {
  setShowCauseAbscondingAction,
  setShowCauseAbscondingResponse,
  setShowCauseAbscondingError,
} = Show_Cause_Absconding.actions;

export const {
  setShowCauseFalseAttendanceAction,
  setShowCauseFalseAttendanceResponse,
  setShowCauseFalseAttendanceError,
} = Show_Cause_False_Attendance.actions;

export const {
  setShowCauseFalseBillsAction,
  setShowCauseFalseBillsResponse,
  setShowCauseFalseBillsError,
} = Show_Cause_False_Bills_Submission.actions;

export const {
  setSalaryexport_revision_Action,
  setSalaryrevisionExporttResponse,
  setSalaryrevisionExportError,
} = Salary_export_letter_revision.actions;

export const {
  setContractRenewalAction,
  setContractRenewalResponse,
  setContractRenewalError,
} = Contract_Renewal_Letter.actions;

export const {
  setSalaryRevisionChangeAction,
  setSalaryRevisionChangeResponse,
  setSalaryRevisionChangeError,
} = Salary_Revision_Letter_Change.actions;

export const {
  setAppointmentEMPexportAction,
  setAppointmentEMpExporttResponse,
  setAppointmentEmpExportError,
} = Appointment_export_Annualoptions.actions;

export const {
  setSalaryEMPexportAction,
  setSalaryEmpExportError,
  setSalaryEMpExporttResponse,
} = Salary_export_Annualoptions.actions;

export const {
  setGrievanceEMPexportAction,
  setGrievanceEMpExporttResponse,
  setgrievanceEmpExportError,
} = grievance_export_listedoptions.actions;

export const {
  resetOrganizationFilterlist,
  setOrganizationFilterlistData,
  setOrganizationFilterlistError,
} = Organization_filterlist.actions;
export const {
  resetOrganizationRmFilterlist,
  setOrganizationRmFilterlistData,
  setOrganizationRmFilterlistError,
} = organizationRm_filterlist.actions;
export const {
  resetClientDivisionLevelDropdown,
  setClientDivisionLevelDropdownData,
  setClientDivisionLevelDropdownError,
} = clientDivisionLevel_dropdown.actions;

export const {
  resetMasterdashData_Crud_opretions,
  setMasterdashTableData_CrudOperation,
  setMasterdashError_Crud_opreation,
} = Master_dashboard_cruds.actions;

export const {
  resetMasterdashData_internal,
  setMasterdashTableData_internal,
  setMasterdashTotalCount_internal,
  setMasterdashError_internal,
} = Master_dashboard_listedrecords.actions;

export const {
  resetEmployeeEditActionsdata,
  settheExitignEmp_editActionsresponse,
  setEmployeeEditActionsError,
} = Employee_actionOfEditSlice.actions;

export const {
  resetZoneData_internal,
  setZoneTableData_internal,
  setZoneTotalCount_internal,
  setZoneError_internal,
} = InternalSupport_Zone_Slice.actions;

export const {
  resetClientData_internal,
  setClientTableData_internal,
  setClientTotalCount_internal,
  setClientError_internal,
} = InternalSupport_Client_Slice.actions;

export const {
  resetInternalRegionData,
  setInternalRegionTableData,
  setInternalRegionTotalCount,
  setInternalRegionError,
} = InternalSupport_RegionList_Slice.actions;

export const {
  resetStateData,
  setStateTableData,
  setStateTotalCount,
  setStateError,
} = Customer_Geolocation_State_Slice.actions;

export const {
  resetRegionalData,
  setRegionalTableData,
  setRegionalTotalCount,
  setRegionalError,
} = Customer_Geolocation_Regional_Slice.actions;

export const {
  resetZoneData,
  setZoneTableData,
  setZoneTotalCount,
  setZoneError,
} = Customer_Geolocation_Zone_Slice.actions;

export const {
  resetClientData,
  setClientTableData,
  setClientTotalCount,
  setClientError,
} = Customer_Geolocation_Client_Slice.actions;

/// internal support

export const {
  clearInternalSupportGraph_TrendActions,
  setInternalSupportTrendResponseData,
  setInternalSupportTrendsActionsError,
} = InternalSupportTrendTicketsSlice.actions;

export const {
  clearInternalSupportStateList,
  setInternalSupportStateListData,
  setInternalSupportStateListError,
} = InternalSupportStateListSlice.actions;

export const {
  clearInternalPerformanceState,
  setInternalPerformanceData,
  setInternalPerformanceError,
} = InternalPerformanceMetricsSlice.actions;

export const {
  clearInternalCategoryTopFive,
  setInternalCategoryTopFive,
  setInternalCategoryTopFiveError,
} = InternalIssueCategoryTopFiveSlice.actions;

export const {
  clearInternalCategoryList,
  setInternalCategoryList,
  setInternalCategoryListError,
} = InternalIssueCategoryListSlice.actions;

export const {
  clearInternalSupportChartState,
  setInternalSupportChartStateData,
  setInternalSupportChartStateError,
} = InternalSupportChartStateSlice.actions;

export const {
  clearInternalSupportRegionalChart,
  setInternalSupportRegionalChartData,
  setInternalSupportRegionalChartError,
} = InternalSupportRegionalChartSlice.actions;

export const {
  clearInternalSupportRegionalList,
  setInternalSupportRegionalListData,
  setInternalSupportRegionalListError,
} = InternalSupportRegionalListSlice.actions;

export const {
  clearInternalSupportZoneChart,
  setInternalSupportZoneChartData,
  setInternalSupportZoneChartError,
} = InternalSupportZoneChartSlice.actions;

export const {
  clearInternalSupportZoneList,
  setInternalSupportZoneListData,
  setInternalSupportZoneListError,
} = InternalSupportZoneListSlice.actions;

export const {
  clearInternalSupportClientChart,
  setInternalSupportClientChartData,
  setInternalSupportClientChartError,
} = InternalSupportClientChartSlice.actions;

export const {
  clearInternalSupportClientList,
  setInternalSupportClientListData,
  setInternalSupportClientListError,
} = InternalSupportClientListSlice.actions;

export const {
  clearInternalCustomPerformanceMatrix,
  setInternalCustomPerformanceMatrixData,
  setInternalCustomPerformanceMatrixError,
} = InternalCustomPerformanceMatrixSlice.actions;

export const {
  clearCustomPerformanceMatrixState,
  setCustomPerformanceMatrixData,
  setCustomPerformanceMatrixError,
} = CustomPerformanceMatrix_StateSlice.actions;

export const {
  clearCategoryList_State,
  setCategoryList_Data,
  setCategoryList_Error,
} = Issue_categoryListed_customslice.actions;

export const {
  clearCustomerSupportStateList,
  setCustomerSupportStateListData,
  setCustomerSupportStateListError,
} = CustomerSupportStateListSlice.actions;

export const {
  clearCustomerSupportStateChart,
  setCustomerSupportStateChartData,
  setCustomerSupportStateChartError,
} = CustomerSupportStateChartSlice.actions;

export const {
  clearCustomerSupportRegionalChart,
  setCustomerSupportRegionalChartData,
  setCustomerSupportRegionalChartError,
} = CustomerSupportRegionalChartSlice.actions;

export const {
  clearCustomerSupportRegionalList,
  setCustomerSupportRegionalListData,
  setCustomerSupportRegionalListError,
} = CustomerSupportRegionalListSlice.actions;
export const {
  clearCustomerSupportZoneChart,
  setCustomerSupportZoneChartData,
  setCustomerSupportZoneChartError,
} = CustomerSupportZoneChartSlice.actions;

export const {
  clearCustomerSupportClientChart,
  setCustomerSupportClientChartData,
  setCustomerSupportClientChartError,
} = CustomerSupportClientChartSlice.actions;

export const {
  clearCustomerSupportCardState,
  setCustomerSupportCard_StateData,
  setCustomerSupportCard_StateError,
} = CustomerSupportChart_StateSlice.actions;

export const {
  clearCustomerSupportClientList,
  setCustomerSupportClientListData,
  setCustomerSupportClientListError,
} = CustomerSupportClientListSlice.actions;

export const {
  clearCustomerSupportZoneList,
  setCustomerSupportZoneListData,
  setCustomerSupportZoneListError,
} = CustomerSupportZoneListSlice.actions;

export const {
  clearChartCategory_State,
  setCategoryChart_Data,
  setCategoryChart_Error,
} = Issue_categoryfirstFivelist_customslice.actions;
export const {
  clearPerformance_MatrixState,
  setPerformance_matrix_Data,
  setPerformance_Matrix_Error,
} = PerformanceMetricsSlice.actions;

export const {
  clearTicketTrendState,
  setTicketTrendData,
  setTicketTrendError,
} = TicketTrendDashboardSlice.actions;

export const {
  settheInternalescalationActions,
  settheEscalationResponsehold,

  settheEscalationErrormessgae,
} = InternalExcalationDashboardSlice.actions;

export const {
  settheexternalescalation_dashboardsactions,
  settheExternalEscalationResponsehold,

  settheExternalEscalationErrormessgae,
} = ExternalExcalationDashboardSlice.actions;

export const {
  setState_based_customerdashboard,
  settheState_basedCustomer_dashboard_ResponseHolder,
  settheStateBasedCustomer_dashboard_total_counts,

  settheStateBased_Customer_dashboard_table_Errors,
} = StateBased_CustomerDashboard.actions;

export const {
  setStatebasedInternalTable,
  setstatebasedInternalTableData,
  setstatebasedInternalTotalCount,
  setstatebasedInternalError,
} = Internal_State_TicketStatus_TableSlice.actions;

export const {
  setinternaltable_dashboard,
  settheInternal_dashboard_ResponseHolder,
  settheinternal_dashboard_total_counts,
  settheInterna_dashboard_table_Errors,
} = Internal_Dashbaord_TableSlice.actions;

export const {
  setCustomer_table_dashboard,
  settheCustomer_dashboard_ResponseHolder,
  settheCustomer_dashboard_total_counts,
  settheCustomer_dashboard_table_Errors,
} = Customer_Dashbaord_TableSlice.actions;

export const {
  settheOnboarderdatalistedactions,
  settheRegionalMangerdata_ResponseHolder,
  settheRegionalManagerErrors,
} = RegionalManagernboardDetails.actions;
export const {
  settheAdvancDatas_SecondStateHold,
  settheAdvanceRespons_SecondStatHold,

  setTheAdvanceError_SecondStatHold,
} = advanceSecondStateSlice.actions;

export const {
  settheAdvanceStateDatasHold,
  settheAdvanceStateResponsHold,
  setTheAdvanceStateErrorHold,
} = StatesOfAdvanceAttendanceRecordsSlice.actions;

export const {
  settheAdvanceEmployeeDatasHold,
  settheAdvanceEmployeeResponsHold,
  setTheAdvanceEmployeeErrorHold,
  settheadvanceEmployeetotal_counts,
} = EmployeeOfAdvanceAttendanceRecordsSlice.actions;

export const {
  settheAdvanceEmployeeDatas_summaryHold,
  settheAdvanceEmployeeRespons_summaryHold,
  setTheAdvanceEmployeeErrorHold_summary,
  settheadvanceEmployeetotal_counts_summary,
} = EmployeeOfAdvanceAttendanceSummaryRecordsSlice.actions;

export const {
  settheAdvanceEmployeeDatas_countsHold,
  settheAdvanceEmployeeRespons_countHold,
  setTheAdvanceEmployeeError_countsHold,
} = AdvanceAttendance_CountsRecordsSlice.actions;

export const {
  settheSubAssignDashboardRecordsActions,
  settheSubAssignDashboardRecordsResponse,
  settheSubAssignDashboardErrors,
} = SubAssignTicketDasboardSliceCall.actions;
export const {
  settheNewDashboardRecordsActions,
  settheNewDashboardRecordsResponse,
  settheNewDashboardErrors,
} = NewDashboardSlice.actions;

export const {
  settheClientSubcategorylistedActions,
  settheClientSubcategorylistedresponses,
  settheClientSubcategorylistedError,
} = gettheclientsubcategoryApiSlice.actions;

export const {
  settheClientCategoryDataLonesActions,
  settheClientCategoryDataLonesResponses,
  settheClientCategoryDataLonesError,
} = gettheClientTicketPostforLones.actions;

export const {
  settheClientCategoryDataActions,
  settheClientCategoryDataResponses,
  settheClientCategoryDataError,
} = gettheClienCategoryDatasSlice.actions;

export const {
  settheclientloneticketactions,
  settheclientloneticketresponseActions,
  settheclientloneticketresponseActions_trackingone,
  settheclientloneticketActionsErrors,
  settheclientloneticketAction_total_counts,
} = ClientTicketListedSlice.actions;

export const {
  settheSubticketgetActions,
  settheSubticketgetActionsResponses,
  settheSubticketgetActionsResponseofTracking,
  settheSubticketgetActionsErrors,
  settheSubticketgetActionsTotal_counts,
} = SubTicketsFortheSlice.actions;

export const {
  settheTicketTicketJourneyActions,
  settheTicketJourneyResponse,
  settheTicketJourneyError,
} = TicketjounerySlicefortheboththe_internalandCliet.actions;

export const {
  settheTicketTicketJourneyClientsideActions,
  settheTicketJourneyResponseclientside,
  settheTicketJourneyErrorclient,
} = TicketjounerySlicefortheClients.actions;

export const {
  setthenotificationactionsgetlist,
  setthenotificationactionsResponses,
  setthenotificationactionsErrors,
  settheNotificationToatalcounts,
} = NotificationListoutapi.actions;

export const {
  setthenotificationactionDeletelist,
  setthenotificationactionsDeletelistResponses,
  setthenotificationactionsDeletelistErrors,
} = NotificationListDelete.actions;

export const {
  settheTicketescalationActions,
  settheTicketEscalationResponse,
  settheTicketEscalationError,
} = ticketexcalationSliceRecords.actions;

export const {
  settheTicketUnregisterAssignActions,
  settheTicketUnregisterAssignResponse,
  settheTicketUnregisterAssignError,
} = TicketUnregisterSliceAssigns.actions;

export const {
  settheClientTicketDeatilsDataActions,
  settheClientTicketDetailsDataResponse,
  settheClientTciketDetailsDataError,
} = TicketDetailsListedslice.actions;
export const {
  setthereassignandAssignRejectDataActions,
  setthereassignandAssignRejectDataResponse,
  setthereassignandAssignRejectDataError,
} = TicketReassignSliceDetails.actions;

export const {
  settheTicketsystemrecordgetListInternalNearDueDataActions,
  setTheTicketsystemrecordgetListInternalNearDueDataResponses,
  setTicketsystemRecordListInternalNearDueDashboardReport,
  setTheQTicketsystemrecordgetListInternalNearDueDatasError,
  setTheTicketsystemrecordgetListInternaNearDuelDataTotalCounts,
} = TicktignNearDueSliceInternalTicketing.actions;

export const {
  settheTicketsystemrecordgetListInternalDataActions,
  setTheTicketsystemrecordgetListInternalDataResponses,
  setTicketsystemRecordListInternalDashboardReport,
  setTheQTicketsystemrecordgetListInternalDatasError,
  setTheTicketsystemrecordgetListInternalDataTotalCounts,
} = TicketingInernalDashboardSlice.actions;

export const {
  settheinternaldepartmentRemarksgetaction,
  settheinternaldepartmeentremarksdataresponse,
  settheinternaldepartmentremarkdsdataError,
} = internal_remarkpostedslice.actions;

export const {
  settheTicketsystemInternalrecordgetListDataActions,
  setTheTicketsystemInernalDepaertmentrecordgetListDataResponses,
  setTicketsystemRecord_departmentListDashboardReport,
  setTheQTicketsystemrecordDepartmentgetListDatasError,
  setTheTicketsystemrecordgetDepartmentListDataTotalCounts,
} = internalTicketDepartmentUsersSlice.actions;

export const {
  settheinternaldepartmentcommandpostaction,
  settheinternaldepartmentcommandpostresponse,
  settheinternaldepartmentcommandpostError,
} = internalcommandsticketpost.actions;

export const {
  settheinternaldepartmentcommanddatagetaction,
  settheinternaldepartmentcommandgetdataresponse,
  settheinternaldepartmentcommangetdataError,
} = internalcommandsticketgetdataDepartment.actions;

export const {
  setTheInternalDepartmentRetreve_TicketTImelinesActions,
  setTheInternalDepartmentsRetrieve_TicketTimelineResponsive,
  SettheInternalDepartmentsRetrieve_TickeTimelineError,
} = InternalDepartmenttIMElINE.actions;

export const {
  setTheInternalDepartment_TicketFeedbackPostActions,
  setTheInternalDepartments_TicketFeedbackPostResponsive,
  SettheInternalDepartments_TicketFeedbackPostError,
} = InternalDepartmentFeedBackPost.actions;

export const {
  setTheInternalDepartmentRetreve_TicketRemarksActions,
  setTheInternalDepartmentsRetrieve_TicketRemarksResponsive,
  SettheInternalDepartmentsRetrieve_TickeRemarkError,
} = InternalDepartmentRemarks.actions;

export const {
  setTheInternalDepartmentRetreve_TicketViewsActions,
  setTheInternalDepartmentsRetrieve_TicketViewsResponsive,
  SettheInternalDepartmentsRetrieve_TicketViewsError,
} = InternalDepartmentTicketViews.actions;

export const {
  setTheInternalDepartmentRetreve_TicketRemarksCRUDActions,
  setTheInternalDepartmentsRetrieve_TicketRemarksCURDResponsive,
  SettheInternalDepartmentsRetrieve_TickeRemarkCRUDError,
} = InternalDepartmentCRUDRemarks.actions;

export const {
  setTheInternalDepartmentRetreve_TicketFeedbackActions,
  setTheInternalDepartmentsRetrieve_TicketFeedbackResponsive,
  SettheInternalDepartmentsRetrieve_TicketFeedbackError,
} = InternalDepartmentFeedBack.actions;

export const {
  setTheInternalDepartmentRetreve_TicketTicketChangesActions,
  setTheInternalDepartmentsRetrieve_TicketChangesResponsive,
  SettheInternalDepartmentsRetrieve_TicketChangesError,
} = InternalDepartmentTicketChanges.actions;

export const {
  settheCreateInternalTickets,
  settheCreateInternalTicketsResponse,
  SettheInternalInternalTicketCreations,
} = CreateInternalTicketSlice.actions;

export const {
  settheInternalTicketsystemrecordgetListInternalDepartmentsDataActions,
  setTheTicketsystemrecordgetListDataInternalDepartmentResponses,
  setTicketsystemRecordListDashboardInternalDepartmentReport,
  setTheQTicketsystemrecordgetListDatasInternalDepartmentError,
  setTheTicketsystemrecordgetListDataInternalDepartmentTotalCounts,
} = InternalTrackingrecordOfSystemSlice.actions;

export const {
  setTheInternalDepartmentDelete_usersActions,
  setTheInternalDepartmentsdelete_usersResponsive,
  SettheInternalDepartmentsDelete_usersError,
} = internaldepartmentUsersDelete.actions;

export const {
  setTheInternalDepartmentRetreve_usersActions,
  setTheInternalDepartmentsRetrieve_usersResponsive,
  SettheInternalDepartmentsRetrieve_usersError,
} = internaldepartmentUsersRetrieve.actions;

export const {
  setTheInternalDepartmentEdtions_usersActions,
  setTheInternalDepartmentsEdtions_usersResponsive,
  SettheInternalDepartmentsEdtions_usersError,
} = internaldepartmentUsersCrudEdtions.actions;

export const {
  setthesubcategorybranchActionListed,
  setthesubcategorybranchResponses,
  setthesubcategorybranchErrors,
} = SubcategoryListedEditSlice.actions;

export const {
  settheRemarkspostActions,
  settheRemarkspostesponsestore,
  settheremarkdpostCallingErrors,
} = UdsusersRemarklistedslice.actions;

export const {
  settheNeardueActions,
  settheeardueresponsestore,
  settheNeardueCallingErrors,
} = NearDueDataCallSlice.actions;

export const {
  setTheSubCategorydataEditandcreateDetailsExportActions,
  setTheSubCategoryEditandcreateDetailsResponsiveExport,
  SettheSubCategoryEditandcreateDetailsErrorExport,
} = SubCategoryDatasScopeEditSlice.actions;

export const {
  setTheCategorydataDetailsExportActions,
  setTheCategoryEditDetailsResponsiveExport,
  SettheCategoryEditDetailsErrorExport,
} = ListofCategoryListedSlice.actions;

export const {
  setTheSubCategorydataDetailsExportActions,
  setTheSubCategoryEditDetailsResponsiveExport,
  SettheSubCategoryEditDetailsErrorExport,
} = SubCategoryDatasSlice.actions;

export const {
  setTheContacteitDetailsExportActions,
  setTheContactEditDetailsResponsiveExport,
  SettheContactEditDetailsErrorExport,
} = ContactPersonEditSlice.actions;

export const {
  setTheScopeDetailsExportActions,
  setTheScopeDetailsResponsiveExport,
  SettheScopeDetailsErrorExport,
} = ScopeGetlistSlice.actions;

export const {
  setthefeedbackRetieveDatasActions,
  setthefeedbackRetieveDataList,
  settheFeedbackRetieveErorActions,
} = ticketFeedbackSlice.actions;

export const {
  setTheticketetailsExportActions,
  setTheTicketsDetailsResponsiveExport,
  SettheTicketsDetailsErrorExport,
} = UDSTicketingSysttemexportslice.actions;

export const {
  settheticketTimelineretieveDatasActions,
  settheticketTiemlineRetieveDataList,
  settheticketTimeLineRetieveErorActions,
} = ticketTimelineSlice.actions;

export const {
  settehTicketStatusChanges,
  settheTickeStatusErr,
  settheTicketStatusChangesrespons,
} = ticketSTatusChangesSlice.actions;

export const {
  setthecommentRetieveDatasActions,
  settheCommentRetieveDataList,
  settheCommentRetieveErorActions,
} = ticketcommentSlice.actions;

export const {
  setTheTrackingrecordgetList_remarksRetrieveActions,
  SettheTicketingrecordgetListRetrieve_remarkError,
  setTheTrackingrecordgetList_remarksRetrieveResponsive,
} = ticketremarksreviewlistSlice.actions;

export const {
  settheticketcreateRetieveDatasActions,
  settheticketcreateRetieveDataList,
  settheticketcreateRetieveErorActions,
} = ticketRemarksSliceActionsSlice.actions;

export const {
  setTheTrackingrecordgetListRetrieveActions,
  SettheTicketingrecordgetListRetrieveError,
  setTheTrackingrecordgetListRetrieveResponsive,
} = TicketingSystemInretrievetheTicketsSlice.actions;

export const {
  settheTicketingDashboardActions,
  settheTicketingDashboardActiondataStores,
  SettheTicketingDashboardErrDeletError,
} = TicketingRecordDetailDashboardSlice.actions;

export const {
  settheTicketsystemrecordgetListDataActions,
  setTheTicketsystemrecordgetListDataResponses,
  setTicketsystemRecordListDashboardReport,
  setTheQTicketsystemrecordgetListDatasError,
  setTheTicketsystemrecordgetListDataTotalCounts,
} = TrackingrecordOfSystemSlice.actions;

/// internal
export const {
  getTheUDSQuestionsData,
  setTheUDSQuestionsResponses,
  setTheUdsQuestionsError,
  setTheUDsQuestionTotalCounts,
} = UDSCategoryQuestionsSlice.actions;

export const {
  setTheInternalQuestionsCreateActions,
  setTheInternalQuestionsCreateResponsive,
  SettheInternalQuestionsCreateError,
} = InternalQuestionCreateSlice.actions;

export const {
  setTheInternalCategoryQuestionsEdtionctions,
  setTheinternalCategoryQuestionsEditResponsive,
  SettheinternalcategoryQuestionsEditError,
} = internalCategoryQuestionEditSlice.actions;

export const {
  setTheInteralcategoryQuestionsretrieveActions,
  setTheInternalcategoryQuestionsretrieveResponsive,
  SettheinternalcategoryQuestionsretrieveError,
} = internalcategoryQuestionRetrieveSlice.actions;

export const {
  setTheInternalDeleteActions,
  setThInternalQuestionsdeleteResponsive,
  SettheInternalQuestionsDeletError,
} = InternalQuestionDeleteSlice.actions;

export const {
  settheqrcodelisted,
  settheqrexportedresponse,
  settheQrcodeexports,
} = BranchQrcodeexports.actions;

export const {
  settheTicketsystem_unregisterrecordgetListDataActions,
  setTheTicketsystem_unregisterrecordgetListDataResponses,
  setTicketsystem_unregisterRecordListDashboardReport,
  setTheQTicketsystem_unregisterrecordgetListDatasError,
  setTheTicketsystem_unregisterrecordgetListDataTotalCounts,
} = Tracking_unregisterrecordOfSystemSlice.actions;

export const {
  settheInternalSubQuestionActions,
  setTheInternalSubQuestionsResponses,
  setTheunternalSubQuestionsError,
  setTheInternalSubQuestionTotalCounts,
} = InternalSubQuestionsSlice.actions;

export const {
  setTheInternalSubQuestionsEditionsActions,
  setTheinternalSubQuestionsEditionsResponsive,
  SettheinternalSubQuestionsEditionError,
} = InternalSUbQuestionEdtionsSlice.actions;

export const {
  setTheinternalSubQuestionsRetrieveActions,
  setTheinternalSubQuestionsRetrieveResponsive,
  SettheInternalSubQuestionsRetrieveError,
} = InternalSUbQuestionRetrieveSlice.actions;

export const {
  setTheInternalSUbQuestionsDeleteActions,
  setTheInternalSUbQuestionsdeleteResponsive,
  SettheInternalSUbQuestionsDeletError,
} = internalSubcategorydelete.actions;

export const {
  setTheInternalSubQuestionsCreateActions,
  setTheInternalSubQuestionsCreateResponsive,
  SettheInternalSubQuestionsCreateError,
} = InternalSUbQuestionCreateSlice.actions;

export const {
  settheInternalDepartmentsctions,
  setTheInternalDepartmentsResponses,
  setTheinternalDepartmentsError,
  setTheInternalDepartmentsTotalCounts,
} = InternalSubDepartmentsSlice.actions;

export const {
  setTheInternalDepartmentDeleteActions,
  setTheInternalDepartmentsdeleteResponsive,
  SettheInternalDepartmentsDeletError,
} = internaldepartmentDelete.actions;
export const {
  setTheInternalDepartmentCreatedActions,
  setTheInternalDepartmentsCreateResponsive,
  SettheInternalDepartmentsCreateError,
} = internaldepartmentCreated.actions;

export const {
  setTheInternalDepartmentlevelusersCreatedActions,
  setTheInternalDepartmentsLevelUsersCreateResponsive,
  SettheInternalDepartmentsLevelUserCreateError,
} = DepartmentLevelUsersSlice.actions;

export const {
  getTheLevelUsersListData,
  setTheLevelUsersListResponses,
  setTheLevelUserslistError,
  setTheLevelUserListedTotalCounts,
} = gettheDepartmentLevelUsersSlice.actions;

export const {
  setTheInternalDepartmentRetrieveActions,
  setTheInternalDepartmentsRetrieveResponsive,
  SettheInternalDepartmentsRetrieveError,
} = internaldepartmentRetrive.actions;
export const {
  setTheInternalDepartmentEditActions,
  setTheInternalDepartmentsEditResponsive,
  SettheInternalDepartmentsEditError,
} = internaldepartmentEdit.actions;

///--ticketign system

export const {
  getTheTicketingQuestionsData,
  setTheticketQuestionsResponses,
  setTheticketeQuestionsError,
  setTheticketQuestionTotalCounts,
} = TicketCategoryQuestionsSlice.actions;

export const {
  setTheTickeitingtionsDeleteActions,
  setTheTicketingQuestionsdeleteResponsive,
  SettheTicketingQuestionsDeletError,
} = TicketingQuestionDeleteSlice.actions;

export const {
  setTheTicketQuestionsEdtionctions,
  setTheTicketQuestionsEditResponsive,
  SettheTicketQuestionsEditError,
} = TicketQuestionEditSlice.actions;

export const {
  setTheTicketQuestionsCreateActions,
  setTheTicketQuestionsCreateResponsive,
  SettheTicketQuestionsCreateError,
} = TicketQuestionCreateSlice.actions;

export const {
  setTheTicketQuestionsretrieveActions,
  setTheTicketQuestionsretrieveResponsive,
  SettheTicketQuestionsretrieveError,
} = TicketQuestionRetrieveSlice.actions;

export const {
  resetQuestionTypeData,
  setQuestionTypeData,
  setErrorQuestionType,
} = questionTypeSkillAssessmentSlice.actions;

export const { resetQuestionData, setQuestionData, setErrorinnerquestions } =
  innerQuestionSkillAssessmentSlice.actions;

///---Sub ticketing

export const {
  settheTicketSubQuestionActions,
  setTheTicketSubQuestionsResponses,
  setTheTicketSubQuestionsError,
  setTheTicketSubQuestionTotalCounts,
} = TicketSubQuestionsSlice.actions;

export const {
  setTheTicketSubQuestionsCreateActions,
  setTheTicketSubQuestionsCreateResponsive,
  SettheTicketSubQuestionsCreateError,
} = TicketSUbQuestionCreateSlice.actions;

export const {
  setTheTicketSubQuestionsEditionsActions,
  setTheTicketSubQuestionsEditionsResponsive,
  SettheTicketSubQuestionsEditionError,
} = TicketSUbQuestionEdtionsSlice.actions;

export const {
  setTheTicketSubQuestionsRetrieveActions,
  setTheTicketSubQuestionsRetrieveResponsive,
  SettheTicketSubQuestionsRetrieveError,
} = TicketSUbQuestionRetrieveSlice.actions;

export const {
  setTheTicketSUbQuestionsDeleteActions,
  setTheTicketSUbQuestionsdeleteResponsive,
  SettheTicketSUbQuestionsDeletError,
} = TicketSUBQuestionDeleteSlice.actions;

export const {
  resetEmployeeDataquestionslist,
  setEmployeeDataquestionslist,
  setErrorquestionslist,
} = skillassessmentSlicequestiongetlist.actions;

export const {
  gettheSkillassessmentputtmethodEmpactions,
  gettheSkillassessmentEmpputmethodstheActionofemp,
  gettheskillAssessmentEmpPuttmethodemp,
} = skillassessmentputmethodsapplyempslice.actions;

export const {
  gettheSkillassessmentpostmethodEmpactions,
  gettheSkillassessmentEmppostmethodstheActionofemp,
  gettheskillAssessmentEmpPostmethodemp,
} = skillassessmentpostmethodforapplyempslice.actions;

export const {
  gettheSkillassessmentRetireveEmpactions,
  gettheSkillassessmentretirvetheActionofemp,
  gettheskillAssessmentEmpretirveemp,
} = skillassessmentSliceRetrieveEmpdatas.actions;

export const {
  stateresetBranchData,
  setBranchDataResponse,
  setBranchDataError,
} = branchFetchDetailsSlice.actions;

export const { stateresetStateData, setStateDataResponse, setStateDataError } =
  stateFetchDetailsSlice.actions;

export const {
  stateresetRegionData,
  setRegionDataResponse,
  setRegionDataError,
} = regionFetchDetailsSlice.actions;

export const { stateresetZoneData, setZoneDataResponse, setZoneDataError } =
  zoneFetchDetailsSlice.actions;

export const {
  stateresetDesignationData,
  setDesignationDataResponse,
  setDesignationDataError,
} = designationFetchDetailsSlice.actions;

export const {
  resetSkillAssessmentEmpData,
  setSkillAssessmentEmpDataResponse,
  setSkillAssessmentEmpDataError,
  setSkillAssessmentotal_countEmpDataResponse,
} = skillAssessmentEmpListSlice.actions;

export const {
  setEmsiteTransferEmployeedatasEmpEmpAction,
  SetEmployeeSitetransferresponseEmpDataresponse,
  setEmpsiteEMPDataError,
} = sitetransferemployeelistslice.actions;
export const {
  setEmpnoduformfetchdatasempEmpTeamlistEmpEmpAction,
  SetEmployenoduformfetchdatasempempteamListEmpDataresponse,
  setEmpnoduformfetchdatasempgetMPDataError,
} = NodueformFetchDetailsSlice.actions;
export const {
  setTheEmpProfileGetAttendanceProfileResponse,
  settheprofileErrorEmpAttendancemethod,
  setTheEMployeeAttendanceProfileActions,
} = EmployeeAttendanceProfileGetSlice.actions;

export const {
  setTheEMployeeAttendanceupdateProfileActions,
  setTheEmpProfileGetAttendanceupdateProfileResponse,
  settheprofileErrorEmpUpdateAttendancemethod,
} = UpdatePostUrlEmpAttendance.actions;

export const {
  setEmpClientBranchListEmpEmpAction,
  SetEmployeeClientBrancheListEmpDataresponse,
  setEmpClientBranchForEmpDataError,
} = EmployeeClientBranchListForEmpSlice.actions;

export const {
  gettheUnboackedEmpActions,
  SetUnbloackedEmployeesEmpDataresponse,
  setEmpUnbloackedEmployeesEMPDataError,
} = UnbloadedEmpForGetlistSlice.actions;

export const {
  setEmpAttendanceRegularizationEmpTeamPostlistEmpEmpAction,
  SetEmployeeAttendanceRegularizationEmpteamPOstListEmpDataresponse,
  setEmpAttendanceTeamEmpPostEMPDataError,
} = AttendanceRegularizationTeamPostSliceSignleMulti.actions;

export const {
  setEmpAttendanceRegularizationEmpGetlistEmpEmpAction,
  SetEmployeeAttendanceRegularizationEmpteamListEmpDataresponse,
  SetEmpEmpGeAttendanceTeamEMPtotalcountDataresponse,
  setEmpAttendanceTeamEmpGetEMPDataError,
} = AttendanceRegularizationSliceSignleMulti.actions;

export const {
  setEmpsiteTransferGetlistCreateEmpEmpAction,
  SetEmployeesitetransferListCreateEmpDataresponse,
  setEmpsiteTransferEmpCreateMPDataError,
} = employeeSiteTransferCreateSliceData.actions;

export const {
  setEmpsiteTransferGetlistEmpEmpAction,
  SetEmployeesitetransferListEmpDataresponse,
  SetEmpEmpGesiteTransferEMPtotalcountDataresponse,
  setEmpsiteTransferEmpGetEMPDataError,
} = employeeSiteTransferSliceData.actions;

export const {
  setEmpBlockpostistEmpEmpAction,
  SetEmployeeEmppostListEmpDataresponse,
  setEmpBlockEmppostEMPDataError,
} = EmployeeeBlockedPOSTListEmpSlice.actions;
export const {
  setEmpBlockGetlistEmpEmpAction,
  SetEmployeeEmpGetListEmpDataresponse,
  SetEmpEmpGetBlockEMPtotalcountDataresponse,
  setEmpBlockEmpGetEMPDataError,
  setTheBlockEmployeelistDatasForPopup,
} = EmployeeeBlockedGetListEmpSle.actions;

export const {
  setEmpAttendanceEmpEmpAction,
  SetEmployeeAttendanceEmpDataresponse,
  SetEmpAttendanceEMPtotalcountDataresponse,
  setEmpAttendanceEMPDataError,
} = EmployeeAttendanceSliceData.actions;
export const {
  setHelpDeskEmpApplyEmpDatasEmpAction,
  SetHelpDeskApplyEmpEmployeeDataresponse,
  setHelpDeskApplyEmpEmployeeDataError,
} = helpDeskPostFroEmployeeeSlice.actions;

//---tracking--category

export const {
  setTrackingSubCategoryEmpDatasEmpAction,

  SettrackingSubCategoryEmpEmployeeDataresponse,
  setTrackingSubCategoryEmpEmployeeDataError,
} = trackingSubCategorysliceForSliceEmp.actions;

///--tracking --parent
export const {
  setTrackingParentDatasEmpAction,
  SettrackingparentEmployeeDataresponse,
  setTrackingparentEmployeeDataError,
} = trackingParentsliceForSliceEmp.actions;

export const {
  setHelpDatasEmpAction,

  SetHelpEmployeeDataresponse,
  SetHelpEmployeetotalcountDataresponse,
  setHelpEmployeeDataError,
} = HelpDeskFormEmployeeSlice.actions;

export const {
  SetCreateGrievanceApplyEmpAction,
  SetCreateGrievanceApplyEmpError,
  SetCreateGrievanceApplyEmpSuccessResponse,
} = CreateGrivanceApplyFormForEMpForEmpSlice.actions;

export const {
  settheGrievenceGetListForEMpActions,
  settheActionsreponsesforGrievencegetlistEmp,

  setgrievencegetlistEmpTotal_counts,

  setGrievencegetlistEmpError,
} = gettheGrievenceGetListFortheEmpSlice.actions;

///--grievenceType for Emp
export const {
  settheGrievenceGetListForTYPEEMpActions,
  settheActionsreponsesforGrievenceTYPEgetlistEmp,
  setGrievencegetlistEmpTYPEError,
} = gettheGrievenceGetListFortheEmpTypeListSlice.actions;
export const {
  settheNodueFormForEmpErrorEditCall,
  settheNoDueFormResponsesDataEditEmployeee,
  settheNodueFormEmpEditActionDatas,
} = NoDueFormEmployeeEditSlice.actions;

export const {
  settheNodueFormForEmpErrorretrirve,
  settheNoDueFormResponsesDataretrieveEmployeee,
  settheNodueFormEmpretrieveActionDatas,
} = NoDueFormEmployeeRetrieveSlice.actions;

export const {
  settheNodueFormEmpActionDatas,
  settheNodueFormForEmpError,
  settheNoDueFormResponsesDataEmployeee,
} = NoDueFormEmployeeSlice.actions;
export const {
  setTheresignationRetrieveForEmp,
  setTheResignationForEMpretrieveError,
  setTheResignationsRetrieveForEmp,
} = ResignationRetrieveSliceEmp.actions;

export const {
  setTheresignationForEmp,
  setTheResignationsForEmp,
  setTheResignationForEMpError,
} = ResignationEmpSlice.actions;

export const {
  setThePayslipDataactionforemp,
  setthePayslipDataforEmp,
  setThePayslipToatal_countForEmp,
  setTheErrorofPayslipemp,
  setTheJoiningDateForPayslipEmp,
} = PaySlipForEmployeeSlice.actions;
export const {
  SetFetchReimbursementEMPAction,
  SetFetchReimbursementEMPSuccessResponse,
  SetFetchReimbursementEMPResponse,
  SetFetchReimbursementEMPError,
} = FetchReimbursementEMPSlice.actions;

export const {
  setTheCreateOfEmployeeReimbursementActions,
  SetFetchReimbursementEMPCreateSuccessResponse,
  SetFetchReimbursementCreateEMPError,
} = ReimbursementCreateforEmp.actions;

export const {
  setTheActionsBoth_theusers,
  settheActionsreponsesforboththeUDSANDEMP,
  setBoththeUsersTotal_counts,
  setBoththeUserError,
} = UserForBoththeEmployeeAndUDS_slice.actions;

////pan
export const {
  setThePANCARDSUBMITeportActions,
  setThePANCARDotpSUBMITResponsiveDatas,
  setThePANCARDSUBMITOTPResponse,
} = PANCARDSUBMIEDOtpSlice.actions;

//-------ExcelSheet---Making----Renders------
export const { SetTheExcelSheetRender } = MakingChangeSlice.actions;
//-----------Actions------------
export const {
  getUserAction,
  getUserSuccessAction,
  getUserErrorAction,
  getUserdata,
} = usersSlice.actions;
///---Error---Pages----------------
export const { SetErrorDisplayPage } = User401ErrorSlice.actions;
///-----SIdeBarsDisptches
export const { getSideBarStatus } = SideBarDispatchSlices.actions;
//------------------ForgotPassword-----------
export const {
  getForgotPasswordPerson,
  getForgotPasswordPerosonSuccessResponse,
  getForgotPasswordErrorMessage,
  getForgotPasswordEmail,
} = ForgotPasswordSlice.actions;
/////----SideBars----Drop---Down
export const { getSideBarDropActions } = SideBarDropSlice.actions;
//------SideBarfiles-------------------

export const {
  getSideBarfilesActions,
  gettheSideBarNotificationState,
  gettheNearDueDepartmentsFilterStates,
  gettheNearDueClientFilterStates,
  getthedhashboardtickeyTypeactions,
  gettheticketdhashboardofROutesActions,
  SetARole,
  setTheRoleName,
  settheKycroles,
  setTheUDSTOKEN,
  settheLoginIds,
  setTheUDSAttendanceTOKEN,
  setTheudsEmployeeImage,
  setTheUserEmailIDS,
  setthevalidationRange,
  setthepanvalidationTodateRange,
  setthepanvalidationRange,
  setthevalidationRangeTodate,
  setTheBankValidationRange,
  setTheWhatsAppValidations,
  setTheBankValidationTodateRange,
  setTheWhatsAppValidationsTodate,
  setTheUserIDFroCRUD,
  settheEmployeeUdsImages,
  setSelectedUploadTab,
} = SideBarfileActiveSlice.actions;
//--------------Otp---Verify----------------
export const {
  getOtpVerifyActions,
  getOtpVerifyActionsSuccessResponse,
  getOtpVerifyErrorResponse,
} = OptVerifySlice.actions;
//---------Update---Passwords
export const {
  getUpdatedPasswordActions,
  getUpdatedPasswordSuccessResponse,
  getUpdatedPassswordError,
} = UpdatePasswordSlice.actions;

// Sheet BulkUpload
export const { SheetBulkUploadSucess, SheetBulkUploadError } =
  sheetBulkUploadSlice.actions;
// Sheet BulkUpload Get

export const {
  GetSheetBulkUploadDataRequest,
  GetSheetBulkUploadDataSuccess,
  GetSheetBulkUploadDataError,
} = sheetBulkUploadGetSlice.actions;
// Employee BulkUpload
export const {
  getDenaveStateDataRequest,
  getDenaveStateDataSuccess,
  getDenaveStateDataError,
} = DenaveStateGetSlice.actions;
// Denave State Get Api

export const { EmployeeBulkUploadSucess, EmployeeBulkUploadError } =
  employeeBulkUploadSlice.actions;
// Employee BulkUpload Get

export const {
  GetEmployeeBulkUploadDataRequest,
  GetEmployeeBulkUploadDataSuccess,
  GetEmployeeBulkUploadDataError,
} = employeeBulkUploadGetSlice.actions;

// Denave Bulk Upload New
export const {
  DenaveBulkUploadNewSuccess,
  DenaveBulkUploadNewError,
} = denaveBulkUploadNewSlice.actions;

// Denave Bulk Upload New Get
export const {
  GetDenaveBulkUploadNewDataRequest,
  GetDenaveBulkUploadNewDataSuccess,
  GetDenaveBulkUploadNewDataFail,
} = denaveBulkUploadNewGetSlice.actions;

// Sony Bulk Upload
export const {
  SonyBulkUploadSuccess,
  SonyBulkUploadError,
} = sonyBulkUploadSlice.actions;

// Letter Onboarding Bulk Upload
export const {
  LetterOnboardingBulkUploadSuccess,
  LetterOnboardingBulkUploadError,
} = letterOnboardingBulkUploadSlice.actions;

// Letter Onboarding Employee List
export const {
  getLetterOnboardingEmployeeListRequest,
  getLetterOnboardingEmployeeListSuccess,
  getLetterOnboardingEmployeeListFail,
} = letterOnboardingEmployeeListSlice.actions;

// Sony Bulk Upload Get
export const {
  GetSonyBulkUploadDataRequest,
  GetSonyBulkUploadDataSuccess,
  GetSonyBulkUploadDataFail,
} = sonyBulkUploadGetSlice.actions;

// HRMS Connectivity List Actions
export const {
  getHrmsConnectivityListAction,
  getHrmsConnectivityListResponse,
  setHrmsConnectivityListTotalCount,
  setHrmsConnectivityListError,
} = HrmsConnectivityListSlice.actions;

// ID Card List Actions
export const {
  getIdCardListAction,
  getIdCardListResponse,
  setIdCardListTotalCount,
  setIdCardListError,
  setIdCardListStatus,
} = IdCardListSlice.actions;

// HRMS Connectivity Update Actions
export const {
  setHrmsConnectivityUpdateAction,
  setHrmsConnectivityUpdateResponse,
  setHrmsConnectivityUpdateError,
} = HrmsConnectivityUpdateSlice.actions;

// HRMS Connectivity Status Update Actions
export const {
  setHrmsConnectivityStatusUpdateAction,
  setHrmsConnectivityStatusUpdateResponse,
  setHrmsConnectivityStatusUpdateError,
} = HrmsConnectivityStatusUpdateSlice.actions;

// Smart Connect Employee List Actions
export const {
  getSmartConnectEmployeeListRequest,
  getSmartConnectEmployeeListSuccess,
  getSmartConnectEmployeeListFail,
} = SmartConnectEmployeeListSlice.actions;

// Smart Connect Hiring List Actions
export const {
  getSmartConnectHiringListRequest,
  getSmartConnectHiringListSuccess,
  getSmartConnectHiringListFail,
} = SmartConnectHiringListSlice.actions;


// Smart Connect Bulk Upload Actions
export const {
  smartConnectBulkUploadRequest,
  smartConnectBulkUploadSuccess,
  smartConnectBulkUploadFail,
} = SmartConnectBulkUploadSlice.actions;



//----Role----Lists-----
export const {
  getRoleListActions,
  getRoleListSuccessResponseActions,
  getRoleListTotal_pageCounst,
  getRoleListErroResponsen,
} = ROleListsSlice.actions;
export const {
  getRoleCreateActions,
  getRoleCreateSuccessActions,
  getRoleCreateErrors,
} = RoleCreateSlice.actions;
///----Role----Delete--Actions
export const {
  SetRoleDeleteCalActions,
  setRoleDeleteErrorActions,
  SetRoleDeleteSuccessResponseCall,
} = RoleDeleteSlice.actions;
///Role----Creates----
///-------Role----Retrieve----
export const {
  setRoleRetrieveActions,
  setRoleRetrieveSuccessResponseCall,
  setRoleRetrieveErrorCall,
} = RoleRetrieveSlice.actions;
///-----Role------Edits=-----
export const {
  setRoleEditActions,
  setRoleEditSuccessResponse,
  setRoleEditErrors,
} = RoleEditSlice.actions;
///-----------------Users----
export const {
  setUserActions,
  setUserSuccessResponse,
  setUserErrorsMessage,
  setTotal_count_user,
} = UserSlicess.actions;
//-----__UserDelete--------------
export const {
  setUserDeleteActions,
  setUserDeleteSuccessResponse,
  setUserDeleteErrorMessage,
} = UserDelteSlice.actions;

///-----sidebar-------
//------UserCreate---slice
export const {
  setUserCreateActions,
  setUserCreateSuccessAction,
  setUserCreateError,
} = userCreateSlice.actions;
//----UserEDitSlice
export const {
  SetUserEditActions,
  SteUserEditSuccessResponse,
  SetUserEditsErrorMessage,
} = UserEditsSlice.actions;
//-----UserREtrieve---
export const {
  SetUserREtrieveActions,
  SetUserRetrieveSuccessResponse,
  SetUserRetrieveError,
} = UserRetrieveSlice.actions;
export const { getsidebarActions } = SidebarSlice.actions;
export const { setLaguage } = LanguageSlice.actions;

//------------------Geo____Locations
export const {
  setGeoLoactionStateAction,
  setGeoStateSuccessResponseActions,
  setGeoStateErrorMessages,
  SetGeoListTotalCount,
} = GeoStateSlice.actions;
//-----States---------------
export const {
  getStateCreateActions,
  getStateCreateSuccessResponse,
  getStateErroMessage,
} = StateCreateSlice.actions;

export const {
  setStateDeleteActions,
  setSatteDeleteSuccessResponse,
  setStateDeleteErrorMessage,
} = StateDeleteSlice.actions;

export const {
  setStateEditActions,
  setStateEditErrors,
  setStateEditSuccessResponse,
} = StateEditSlice.actions;

export const {
  setStateetrieveAction,
  setStateRetrirveSuccessActions,
  setStateRetrieveErrorCall,
} = StateREtrieveSlice.actions;

//-------Regions-----------
export const {
  setRegionActions,
  setRegionSuccessResponse,
  setRegionTotal_counts,
  setRegionsError,
} = RegionSlice.actions;
//-------------
export const {
  getRegionCreateActions,
  getRegionCreateSuccessResponse,
  getRegionErroMessage,
} = RegionCreateSlice.actions;

export const {
  setRegionEditActions,
  setRegionEditSuccessResponse,
  setRegionEditErrors,
} = regionEditSlice.actions;
export const {
  setRegionetrieveAction,
  setRegionRetrirveSuccessActions,
  setRegionRetrieveErrorCall,
} = setRegionRetrievenSlice.actions;
export const {
  setRegionDeleteActions,
  setRegionDeleteSuccessResponse,
  setRegionDeleteErrorMessage,
} = RegionDelete.actions;
///-----------------ZONEs
export const {
  setZoneActions,
  setZoneSuccessResponse,
  setZoneErrorMessages,
  SteZoneListToTal_counts,
} = ZoneSlice.actions;
export const {
  getZoneCreateActions,
  getZoneCreateSuccessResponse,
  getZoneErroMessage,
} = ZoneCreateSlice.actions;
//-----Eidt
export const {
  setZoneEditActions,
  setZoneEditSuccessResponse,
  setZoneEditErrors,
} = ZoneEditSlice.actions;

//----Retrieve
export const {
  setZoneetrieveAction,
  setZoneRetrirveSuccessActions,
  setZoneRetrieveErrorCall,
} = ZoneRetrieveSlice.actions;

//--Delete
export const {
  setZoneDeleteActions,
  setZoneDeleteSuccessResponse,
  setZoneDeleteErrorMessage,
} = ZoneDeleteSlice.actions;
//-------------Client-----------
export const {
  SetClientActions,
  SetClientSuccessRespoenesActions,
  SetClientErrorActions,
  SetClientTotal_CountActions,
} = ClientSlice.actions;
//-----CLient---CURD
export const {
  getClientCreateActions,
  getClientCreateSuccessResponse,
  getClientErroMessage,
} = ClientCreateSlice.actions;
export const {
  setCLientDeleteActions,
  setCLientDeleteSuccessResponse,
  setClientDeleteErrorMessage,
} = ClientDeleteSlice.actions;
export const {
  setCLientetrieveAction,
  setClientRetrirveSuccessActions,
  setClientRetrieveErrorCall,
} = ClientRetrieveSlice.actions;
export const {
  setClientEditActions,
  setClientEditSuccessResponse,
  setClientEditErrors,
} = ClientEditSlice.actions;
///--------Client---Branches---List
export const {
  setClientBranchActions,
  setClientBranchesSuccessResponse,
  setClientBranchessTotal_count,
  setCLientBranchesErrorsMessage,
} = ClientBranchSLice.actions;
///-----Client-Branch-----Delete
export const {
  setClientBranchDeleteActions,
  setClientBranDeleteSuccessResponse,
  setClientBranDeleteErrorMessage,
} = ClienrBranchedDeleteSlice.actions;
export const {
  setClientBranchCreateActions,
  setClientBranchCreateSuccessAction,
  setClientBranchCreateError,
} = ClientBrancheCreateSlice.actions;
////--------Client----Branch-----------Edit
export const {
  setClientBranchesRetrieveActions,
  SetClientBranchesREtrieveErrorRetieve,
  SetClientBranchesRetrieveSuccessResponse,
} = ClientBranchesRetrieveSlice.actions;
export const {
  SetBranchEditActions,
  SetBranchEditSuccessResponse,
  SetBranchEditsErrorMessage,
} = BranchEditSlice.actions;
///---BranchSearch-------------
export const {
  setClientBranchSearchAction,
  setClientBrancheSearchSuccesRespones,
  setClientBranchSearchErrorActions,
  setClientBrancheSearchTotal_counts,
  setClientBranchSearchEmpty,
} = BranchSearchSlice.actions;
/////-----------------------Shifts------------
export const {
  setShiftListsActions,
  setshiftListResponseActions,
  setShiftErrorMessages,
  SetShiftTotal_countActions,
} = ShiftListSlice.actions;
//---With---Search
export const {
  SetShiftSearchActions,
  SetShiftSearchSuccessResponse,
  SetShiftSearchError,
  SetShiftSearchTotal_Counts,
} = ShiftSearchSlice.actions;
export const {
  setShiftDeletCall,
  setShiftDeleteSuccessResponse,
  setShiftDeleteErrorMessages,
} = ShiftDeleteSlice.actions;
//---Shift---Create
export const {
  setShiftCreateActions,
  SetShiftCreatedSuccessResponse,
  SteShiftCreateErrorResponse,
} = ShiftCreateSlice.actions;
//---Shift---Retrieve
export const {
  setShiftRetrieveActions,
  SetRetrieveSuccessAction,
  SetShiftRetrieveErrorActions,
} = ShiftRetrieveSlice.actions;
//-----Shift---Edits
export const {
  SetShiftEditSuccessActions,
  SetShiftEditsErrorMessages,
  SetShiftEditActions,
} = ShiftEditSlice.actions;
///----Employees--------------
export const {
  setEmployeetListsActions,
  setEmployeeListResponseActions,
  setEmployeeErrorMessages,
  SetEmployeeTotal_countActions,
} = EmployeeListSlice.actions;
export const {
  SetEmployeeActions,
  SetEmployeeSuccessResponen,
  SetEmployeeErrorActions,
} = EmployeeCreateSlice.actions;
///-----Employee---Delete
export const {
  SetEmployeeDeleteActions,
  SetEmployeeDeleteSuccessResponen,
  SetEmployeeDeleteErrorActions,
} = EmployeeDeleteSlice.actions;
//--Employe---REtrieve
export const {
  SetEmployeeRetrieveActions,
  SetEmployeeRetrieveSuccessResponen,
  SetEmployeeRetrieverrorActions,
} = EmployeeRetrieveSlice.actions;
///---Employee--Edit
export const {
  SetEmployeeEditcallActions,
  SetEmployeeEditcallSuccessResponse,
  SetEmployeeEditcallErrorActions,
} = EmployeeEditSlice.actions;
//-----Resend
export const { GetResendPerson, GetRespondError } = ReSendOtpSlice.actions;
///---------------Clietnt---Branchess
export const {
  getClientBranchIds,
  getEMployeeInquriyIDS,
  getClientEditActions,
  getSingleEmployeeActions,
  getClientbranchEditView,
  SetRole_id,
  setTheMonthandYearFilters,
  setTheuserprofileID, ///--user---proile---ids
  setDetailView,
  SetTHeNavigateList,
  SetEmployeeProfileDetailsID,
  SetISPendingDetails,
  setID,
  SetStatusBTN,
  SetDashboards,
  setTheShiftExcelSheetIDS,
  SetTheNo_due_formdata,
  setTheBranchObject, ///--branch---object
  setTheUserObjects, ////user----object
  setTheSUBROLE, //---get the login user in subrole
  setTheAUthoriedID,
  ////---user----In--state ,region----zone
  setTheuserStateName,
  setTheUserregionName,
  setTheUserDatasFortheFilters,
  setTheUserZoneName,
  setTheEmployeeeStateName,
  setTheEmployeeregionName,
  setTheEmployeeZoneName,
  seTheFilterfirstTime,
  setTheAttendanceregionObject,
  setTheAttendanceStateObject,
  setTheAttendanceZoneObject,
  setTheBranchListStateObject,
  setTheBranchListZONEObject,
  setTheApproveRequestStateObject,

  setTheApproverequestRegionObject,
  setTheApproveRequestZoneObject,
  setTheBranchListObject,
  setTheUSERDATASStateObject,
  setTheUSERDATASRegionObject,

  setTheUSERDATASZoneObject,
  setTheUSERKYCVERIFIEDObject,
  setTheUSERDATADEigntionsObject,
  setTheUserDesignationsObject,
  setTheApproveRequeststate,
  setTheTicketSystemStateObject,
  setTheTicketSystemRegionObject,
  setTheTicketSystemZoneObject,
  setTheTicketSystemPriorityObject,
  setTheTicketSystemStatusObject,
  setTheTicketSystemBranchObject,

  setTheTicketSystemlistZoneObject,
  setTheTicketSystemlistRegionObject,
  setTheTicketSystemListStateObject,
  setTheTicketSystemlistBranchObject,

  gettheinernalticketlistState,
  gettheinernallistRegion,
  gettheinernalticketlistone,
  gettheinernalListPriority,
  gettheinernalticketlisttatus,
  gettheinernalticketlistbranch,
  gettheinernalDashboardState,
  gettheinernalDashboardRegion,
  gettheinernalDashboardZone,
  gettheinernalDashboardPriority,
  gettheinernalDashboardStatus,
  gettheinernalDashboardbranch,

  gettheinernalticketlistLoneUsersState,
  gettheinternalUsersTicketingRangesTwo,
  gettheinternalUsersTicketingRangesone,
  gettheinernalTicketListLoneUserRegion,
  gettheinernalTicketLOneUsersZone,
  gettheinernalTicketLoneusersPriority,
  gettheinernalTicketLoneuserstatus,

  gettheinernalTicketLoneusersbranch,
  gettheAdvanceDashboardStateActions,
  gettheAdvanceDashboardRegionActions,
  gettheAdvanceDashboardZoneActions,
  getthe_client_InternalSupportSelected,
  gettheClient_internalsuportticketlisted,
} = RouteClientIdsSlice.actions;
//-----EMployee----Lists
export const {
  setEmployeeListsDATASActions,
  setEmployeeListDATASResponseActions,
  setEmployeeDataErrorMessages,
  SetEmployeeDataTotal_countActions,
} = EMployeeListSlice.actions;
///----EMployeee------------_Persons---List
export const {
  getEmployeeListPersonsListed,
  setEmployeeListSPersonsResponseActions,
  SetTheInquriyStatus,
  setEmployeeDataPersonsErrorMessages,
  SetEmployeeDataTotal_countPersonsActions,
} = EmployeePersonListSlice.actions;

//---approve Request
export const {
  getApproveRequestActionListed,
  setApproveRequestPersonsResponseActions,
  SetTheApproveRequestInquriyStatus,
  setApproveRequestPersonsErrorMessages,
  SetApproveRequestTotal_countPersonsActions,
} = ApproveRequestListSlice.actions;

////--------------Employeee------------------Needed===datas
export const {
  setadvanceAttendanceDashboard_state,
  settheadvance_attendanceloader,
  settheadvance_attendanceloader_summary,
  settheinternalDashboardloadBool,
  setthe_Advance_attendance_dashboard_employee_Designations,
  setadvanceAttendanceDashboard_Region,
  setadvanceAttendanceDashboard_Zone,
  setadvanceAttendanceDashboard_FromDate,
  setadvanceAttendanceDashboard_TODate,
  settheFromDateForAdvanceDashboard,
  settheToateForAdvanceDashboard,
  getEmployeeBranchName,
  getEmployeeBranchZones,
  getEmployeeEReuestlist,
  setTheFROMDATELIST,
  setTheAttendanceDhasboardStatus,
  setTheOnboardPhoneNumber,
  setTheTODATELISTINDASH,
  seTheWhiteCollor,
  seTheWhiteCollar_objects,
  settheStateObjects,
  setTheregionsObjects,
  setTheOnboardFromDateLIST,
  setOnboardTODtaeDASH,
  setTheZoneObjects,
  setTheAttendanceDateLIST,
  setAttendacenDASHTodate,
  setTheEmployeeLISTfromdate,
  setEmployeeLstTodate,
  setTheReportRange1,
  settheReportRange2,
  setTheEmployeeRangeOne,
  setTheEmployeeRangetwo,
  settheEmployeeActionState,
  settheEmployeeActionRegion,
  setRmOnboarderdatas,
  setthe_requested_employee_list_filters,
  setthe_attendance_client_filter_dashboard,
  settheEmployeeActionZone,
  setTheEmpoyeeAction_branch,
  setTheOverallReportTableDatas,
  settheAPI_Key_type,
  setTheAPI_type_IDS,
  settheApproveRequestEmployeelist_State,
  settheApproveRequestEmployeelist_Region,
  settheApproveRequestEmployeelist_Zone,
  settheApproveRequestEmployeelist_Client,
  settheApproveRequestEmployeelist_Organizations,
  settheApproveRequestEmployeelist_From_Date,

  settheApproveRequestEmployeelist_To_date,
  settheApproveRequestEmployeelist_FilterOptions,
  setthe_employeee_actions_forEmployee_filter,
  settheSonyEmployeeActionState,
  settheSonyEmployeeActionRegion,
  settheSonyEmployeeActionZone,
  setTheSonyEmpoyeeAction_branch,
  setthe_sony_requested_employee_list_filters,
  setthe_sony_employeee_actions_forEmployee_filter,
  setthe_sony_employeee_letter_type_filter,
} = EmployeeVerificationsNeededDatasSlice.actions;
//--Employee---Profile---Details----------------
export const {
  setEmployeeProfileDATASActions,
  setEmployeeListProfileSResponseActions,
  setEmployeeDataprofileErrorMessages,
  SetEmployeeDataprofileTotal_countActions,
} = EMployeeProfileSlice.actions;

//---Total---Form----Datas;

////----Forms----ID----Lists----------
export const {
  SetBasiformsID,
  SetActiveTabs,
  setDashboardactiveTabs,
  SetPreviousEmployeeID,
  SetAddressId,
  setfamliydetailsid,
  SetIdVeriications,
  SetEducationDetails,
  SetDeclarationId,
  setBankDetailsId,
  SetJobOfferID,
  SetEsiFormIdActions,
  SetTheUserIDS,
  SetOrganizationClientID,
} = FormsIdSlice.actions;

export const {
  SetActionsBasicFormsDetails,
  SETBASICFORMdetails,
  SETBasicFOrmError,
} = FormsSlice.actions;

///---Basic---Form--Create
export const {
  SetActionsBasicFormscreateDetails,
  SETBASICFORMcreatedetails,
  setTheBacisHoldDatas,
  setTheUser_ID,

  SETBasicFOrmcreateError,
} = BasicFormCreateSlice.actions;
export const { SetAddressForm, SetAddressFormAction, SetAddressFormError } =
  AddressFormSlice.actions;

///--Address---Create---
export const {
  SetAddressCreateForm,
  SetAddressFormcreateAction,
  SetAddressFormcreateError,
} = AddressCreateSlice.actions;
///---Id----Verifications------------
export const {
  setIdVerificationActions,
  SetIdVerificationFormAction,
  SetIdverificationFormError,
} = IDverificationSlice.actions;

///---ID---verification---Edit---
export const {
  SetTheIdVerifycationActions,
  SetTheIDverifycationEditResponse,
  SetIdverificationEditError,
} = IdverificationeditSlice.actions;
////---Bank---Details----------
export const {
  setBankDataActions,
  SetBankDataResponeActions,
  setBankDataError,
} = BankDetailsSlice.actions;

///-----Education----Details----------
export const {
  setEducationDataActions,
  SetEducationDataResponeActions,
  setEducationDataError,
} = EducationSlice.actions;

////---Previous----EMpl---Details
export const {
  setPreviousEmpDataActions,
  SetPreviuousEmpDataResponeActions,
  setPreviousDataError,
} = PreviousEmployeeSlice.actions;
///--Family---Details--------
export const {
  setFamilyEmpDataActions,
  SetFamilyEmpDataResponeActions,
  setFamilyDataError,
} = FamilyEmployeeSlice.actions;

///--DECALARATION---Details--------
export const {
  SetDeclarationAction,
  setDecalarationActionData,
  setDecalarationDataError,
} = DeclarationSlice.actions;

///--ESI---Details--------
export const { setESIDataError, SetESICALLAction, setESIRESPONSESData } =
  EsiFormSlice.actions;

///--Family---Details--------
export const { SetJObofferCall, SetJobofferresponse, SetJobofferError } =
  JOBOFFERSlice.actions;

///----Approval---Slices--------------

export const {
  SetApprovalCallsActions,
  SetApprovalResponseActions,
  SetApprovalErrorStatus,
} = ApprovelSlice.actions;

///---Verified---_Users-------------
export const {
  SetVerifiedUserActions,
  SetVerifiedUsersResponse,
  SetTotal_counts_for_VerifiedEmployees,
  SetVerifiedUserError,
} = VerifiedUsersSlice.actions;

//----Generat----the----Job---Offer-----letter----date
export const {
  SetTheJoiningDateCall,
  SetTheJoiningDateResponseCall,
  SetThaeJoiningDateErrorMessage,
} = JoningDateSlice.actions;

//---Signature------------------------
export const {
  SetSignatureActions,
  SetSignatureResponses,
  SetSignatureErrorMessage,
} = SignatureSlice.actions;
////----User---Filter----------------------
export const {
  SettheUserFilterActions,
  SetUserFilterResponses,
  setTotal_count_userfilter,
  setUserErrorsMessageFilter,
} = UserFilterSLice.actions;
////----Employeee---List---------Filter
export const {
  getEmployeeListFilterPersonsListed,
  SetTheInquriyStatusFilter,
  setEmployeeListSPersonsFilterResponseActions,
  setEmployeeDataPersonsFilterErrorMessages,
  SetEmployeeDataTotal_countPersonsFilterActions,
} = EmployeePersonFilterListSlice.actions;
///----excel----Sheet_-----For Shift----Uploads----------
export const {
  SettheExcelSheeetUpaloads,
  setTheExcelSheetresponseStatus,
  SetTheExcelSheetErrors,
} = UPloadExcelSheeSlice.actions;
///-----__Leave-------Type--_____Create----------
export const { SetActionForLeaveTypes, SetLeaveTypeCreate, SetLeaveTypeError } =
  LeaveTypeCreateSlice.actions;
///---Leave--Type---ListOuts
export const {
  SetLeaveTypeActions,
  setLeaveTypeResponses,
  setLeaveTypeResponseTotalCounts,
  SetLeaveTypeListError,
} = LeaveTypeListSlice.actions;
///--Leave---TYpe----Deleet
export const {
  SetLeaveTypeDeleteActions,
  setLeaveTypeResponsesDelete,
  SetLeaveTypeDeleteError,
} = LeaveTypeDeleteSlice.actions;

///----Leave--Type---Retieve
export const {
  SetLeaveTypeRetrieveActions,
  setLeaveTypeResponsesRetrieve,
  SetLeaveTypeRetrieveError,
} = LeaveTypeRetrieveSlice.actions;
///---Leave--_Type----Edits
export const {
  SetLeaveTypeEditActions,
  setLeaveTypeResponsesEdit,
  SetLeaveTypeEditError,
} = LeaveTypeEDITSSlice.actions;
////-----Leave-----Premission---List
export const {
  SetTheLeavePermissionListActions,
  SetTheLeavePermissionlistResponse,
  SetTheLeavePermissionListTotal_counts,
  SetTheLeavePermissionListError,
} = LeavePermissionListSlice.actions;

////-----Leave-----Premission---Search-----
export const {
  SetTheLeavePermissionListSearchActions,
  SetTheLeavePermissionlistSearchResponse,
  SetTheLeavePermissionListSearchTotal_counts,
  SetTheLeavePermissionListSearchError,
} = LeavePermissionListSearchSlice.actions;

///---LeavePermission--Delete---
export const {
  SetTheLeavePermissionDelete,
  SetTheLeavePermissionDeleteResponse,
  SetTheLeavePermissionDeleteError,
} = LeavePermissionDeleteSlice.actions;
///---Leave------Retrieve------------
export const {
  SetTheLeavePremissionRetrieveActions,
  SettheLeaveRetrievePremissionActions,
  SetTheLeavePermissionErrorRetrieve,
} = LeavePermissionRetrieveSlice.actions;
////--Leave----Edits-----
export const {
  SetTheLeavePremissionEditsActions,
  SettheLeaveEditsPremissionActions,
  SetTheLeavePermissionErrorEdits,
} = LeavePermissionEditsSlice.actions;
///---Dashboards--------------
export const {
  setTheDashboardactions,
  setTheDashboardResponses,
  setTheDashboardErrors,
  SetTheDashboardOrganizationListed,
  SetTheDashboardClientList,
} = DaShboardSlice.actions;
////-----DropDowns-----EmployeeListOptions---like---all--completed
export const {
  SettheAllOptions,
  settheSelectedValuesemplist,
  settheStore_filter_monthand_yeas,
  settheUsersStore_filter_monthand_yeas,
  settheDate_and_monthfilter_payslip,

  settheSelectedemployeeliststatust,
  SettheCompletedOptions,
  SetthePendingOptions,
  SettheDeclineOptions,
  SettheApproveOptions,
  setTheoptions,
  setDropDownRenders,
  setThecountBasedRenders,
  setAllemployeeListCounts,
  setEditableActions,
  settheEmployeeFormFilled,
  setaRoleChnage,
  setTheRoleRemoveFilters, ///to remove the role filters
  SettheBracnhId,
  setTheZoneObjectinEmployeeList,
  setTheemployeeRoleId,
  setTheRoleObjects,
  setTheWbsElements,
  setTheBranchoptions,
  setTheAllFormPdf,
  setTheBranchoptionsFieldAgent,
  setSelectedOnboardClient,
  setTheGrossSalary,
  setTheGrossSalarayAmount,
  setTheFirstNames,
  settheJobinfoBranchEmployeeProfile,
  setthejobinformationroleID,
  setTheBankNameVerification,
  setClient_options_inRole_list,
} = DropDownOptionNumbersSlice.actions;
///---SiganturePadSlice
export const {
  SetSignaturePops,
  SetTheSignatureImgaUrl,
  setTheSingatureFilename,
  SetTheSetUserSignError,
  SetTheCountNumbersNam,
  SetTheEditFunction,
  Files,
  setTheSignaturePadNumberSet,
  SetChangedUrl,
  settheFullPresentUrl,
  setThepresentUrlOfSignature,
  setThePresentUrlsSended,
} = SignaturePadSlice.actions;
////--Leave---Statues----
export const {
  getLeaveStatusPersonsListed,
  setLeaveStatusLisPersonsResponseActions,
  SetTheInquriyLeaveStatus,
  setLeaveStatusLisDataPersonsErrorMessages,
  SetLeaveStatusLisDataTotal_countPersonsActions,
} = LeaveStatusListSLice.actions;

///-----Shift----Get--Excel--Sheet----List
export const {
  getShiftStatusPersonsListed,
  setShiftStatusLisPersonsResponseActions,
  SetTheInquriyShiftsStatus,
  setShiftsDataPersonsErrorMessages,
  SetShiftDataTotal_countPersonsActions,
} = ShiftExcelSheetGetApiSlice.actions;
///---Shift---Permission----Lists
export const {
  setShiftPermissionActions,
  setTheshiftPermissionRespons,
  setTheShiftPermissionTotal_counts,
  setShiftPermissionError,
} = ShiftPermissionSlice.actions;
///-------Shift----retrieve---list
export const {
  SetTheShiftPremissionRetrieveActions,
  SettheShiftRetrievePremissionActions,
  SetTheShiftermissionErrorRetrieve,
} = ShiftPermissionRetrieveSlice.actions;
///----Shift----Edits----
export const {
  SetTheShiftPremissionEditsActions,
  SettheShiftditsPremissionActions,
  SetTheShiftPermissionErrorEdits,
} = ShiftPermissionEditsSlice.actions;
///---Shift----Delete---
export const {
  SetTheShiftPermissionDelete,
  SetTheshiftPermissionDeleteResponse,
  SetTheShiftPermissionDeleteError,
} = ShiftPermissionDeleteSlice.actions;
////---ReInvestment----Get-----
export const {
  setReinvestmentAction,
  setReinvestmentResponse,
  setReinvestmentTotal_counts,
  setReInvestmentError,
} = ReinvsetmentSlice.actions;
////---ReInvestment----Retireve-----
export const {
  SetTheReinvestmentRetrieveActions,
  SettheReinvestmentRetrieveActions,
  SetReinvestmentErrorRetrieve,
} = ReinvsetmentRetrirSlice.actions;
////---ReInvestment----Get-----
export const {
  SetTheReInvestmentEditsActions,
  SettheReInvestmentResponsesActions,
  SetTheReInvestmentErrorEdits,
} = ReinvsetmentEditSlice.actions;

///--------shiftExce---Sheet--Retrieve---
export const {
  setTheShiftexcelSheetRetrieveAction,
  setTheShiftexcelRetrieveResponse,
  setTheShiftExcelSheetError,
} = excelShiftSheetRetrieveSlice.actions;
////-----On---Duty----Get----Lists
export const {
  SetTheOndutyActions,
  SeTheOndutyRespones,
  SetheOndutytatolCounts,
  SetTheIndutyError,
} = OnDutySlice.actions;
///----On---Duty----Retrieve-----Datas----
export const {
  SetTheonDutyRetrieveActions,
  SettheOndutyResponeActions,
  SetTheOndutyErrorRetrieve,
} = OndutyRetrieveSlice.actions;
////----On---Duty----Edits----
export const {
  setTheOndutyEditAction,
  SettheOndutyEditReponse,
  SetTheOndutyErrorEdits,
} = OnDutyEditSlice.actions;
///----On---Duty----
export const {
  SetTheOndutynDelete,
  SetTheOndutyDeleteResponse,
  SetTheOndutyDeleteError,
} = ONdutyDeleteSlice.actions;
///------Resign------
export const {
  SetTheResignActions,
  SeTheResignRespones,
  SetheResigntatolCounts,
  SetTheresignError,
} = ResignSlice.actions;
//-----Resign---Retriev----
export const {
  SetTheResignRetrieveActions,
  SettheResignResponeActions,
  SetTheResignErrorRetrieve,
} = ResignRetrieveSlice.actions;
////---Resign-----Edits------------
export const {
  setTheResignEditAction,
  SettheResignEditReponse,
  SetTheResignErrorEdits,
} = ResignEditSlice.actions;
////...................Resin.>>>>>>Delete-------------------
export const {
  SetTheResignDelete,
  SetTheResginDeleteResponse,
  SetTheResignDeleteError,
} = ResignDeleteSlice.actions;

////---------------------exit-----Slice----
export const {
  SetTheExitActions,
  SeTheExitRespones,
  SetheExittatolCounts,
  SetTheExitError,
} = ExitSlice.actions;
export const {
  SetExitNoDueEditActions,
  SetExitNoDueEditResponeActions,
  SetExitNoDueEditErrorRetrieve,
} = ExitNoDueEditSlice.actions;

////----Exit----Retrieve---
export const {
  SetTheExitRetrieveActions,
  SettheExitResponeActions,
  SetTheExitErrorRetrieve,
} = ExitRetrieveSlice.actions;

////----Exit----Edit
export const {
  setTheExitEditAction,
  SettheExitEditReponse,
  SetTheExitErrorEdits,
} = ExitEditSlice.actions;

export const {
  SetTheExitDelete,
  SetTheExitDeleteResponse,
  SetTheExitDeleteError,
} = ExitDeleteSlice.actions;
//-----Appraisal----
export const {
  setAppraisalAction,
  setAppraisaltResponse,

  setAppraisalTotal_counts,
  setAppraisalError,
} = AppraisalSlice.actions;
///----Retrieve==============
export const {
  SetTheAppraisalRetrieveActions,
  SettheAppraisalRetrieveActions,
  SetAppraisalErrorRetrieve,
} = AppraisaltRetrirSlice.actions;
///----Appraisal---dit-----
export const {
  SetTheAppraisalditsActions,
  SetTheAppraisalErrorEdits,
  SettheAppraisalResponsesActions,
} = AppaisalEditSlice.actions;

////-----Pay----Slip----
export const {
  setThePayslipAcrions,
  getPaySlipSuccessResponseActions,
  getPaySlipTotal_pageCounst,
  getPaySlipErroResponsen,
} = PaySlipSlice.actions;
//-----PaySlip---Create
export const {
  setThePayslipCreateAcrions,
  getPaySlipSuccessCreaetResponseActions,
  getPaySlipErroCreateResponsen,
} = PaySlipCreateSlice.actions;
///---Retrieve---
export const {
  setThePayslipRtrievecrions,
  getPaySlipSuccessRrtrieveResponseActions,
  getPaySlipErroRetriveResponsen,
} = PaySlipRetrieveSlice.actions;
///---edit-----Pay--Slip-----
export const {
  setThePayslipEditActions,
  getPaySlipSuccessEditResponseActions,
  getPaySlipErroeditResponsen,
} = PaySlipEditSlice.actions;
///-------Remainder Email for approval status===
export const {
  SetRemainderMailCallAction,
  SetRemainderMailresponseCreate,
  SetRemainderMailErrorcreate,
} = RemainderMailSlice.actions;
///-------Job---offer-----Preview===
export const {
  SetJObofferPreviewCallAction,
  SetJobofferPreviewresponseCreate,
  SetJobofferPreviewErrorcreate,
} = JOBOFFERPreviewSlice.actions;
///-------Job---offer-----create===
export const {
  SetJObofferCallAction,
  SetJobofferresponseCreate,
  SetJobofferErrorcreate,
  setTherossSalaryCreateActions,
} = JOBOFFERCreateSlice.actions;
///----Back--detaile---Create----
export const {
  setBankDataCreateActions,
  SetBankDataResponecreateActions,
  setBankDatacreateError,
} = BankDetailsCreateSlice.actions;
///--education---details----
export const {
  setEducationDatacreateActions,
  SetEducationDataResponecrateActions,
  setEducationDatacreateError,
} = EducationcreateSlice.actions;
////------Field---agent0-------bramch---
export const {
  setThefieldAgentbranchactions,
  setfieldbranchResponseActions,
  setfieldagentErrorMessages,
  SetFieldagentTotalCount,
} = fieldAgentBranchListSlice.actions;

///------Manager----employee-list
export const {
  getEmployeeListcreatePersonsListed,
  setEmployeeListSPersonsManagerResponseActions,
  SetTheInquriyStatusmanager,
  setEmployeeDataPersonsManagerErrorMessages,
  SetEmployeeDataTotal_countPersonsManagerActions,
} = EmployeePersonManagerListSlice.actions;

////--Basic---From---edits----
export const {
  SetActionsBasicFormsEditDetails,
  SETBASICFORMEDITdetails,
  SETBasicFOrmEditError,
} = BasicFormEditSlice.actions;
///----Address---edit---
export const {
  SetAddressEditForm,
  SetAddressFormEDitAction,
  SetAddressFormEditError,
} = AddressEditSlice.actions;
///-----job---offer----edit---
export const {
  SetJObofferDITCallAction,
  SetJobofferresponseEDIT,
  setTherossSalaryActions,
  SetJobofferErrorEDIt,
} = JOBOFFEReditSlice.actions;
///-----HR Approval Slice---offer----edit---
export const {
  setHrApprovalCallAction,
  SetHrApprovalresponseEDIT,
  setHrApprovalErrorEdit,
} = hrApprovalSlice.actions;
///-------------id--verification-create---
export const {
  setIdVerificationActionsCreate,
  SetIdVerificationFormcreateAction,

  SetIdverificationFormcreateError,
} = IDverificationCreateSlice.actions;
///--Bank---details----edir---
export const {
  setBankDataEditActions,
  SetBankDataResponeEditActions,

  setBankDataEditError,
} = BankDetailsEditSlice.actions;
///-------Decalration---create-----
export const {
  SetDeclarationcreateAction,
  setDecalarationDatacreateError,
  setDecalarationActioncreateData,
} = DeclarationcreateSlice.actions;
//----Decalaaration----edit
export const {
  SetDeclarationEditAction,
  setDecalarationEditActionData,

  setDecalarationEditDataError,
} = DeclarationEditSlice.actions;
///---ESi-----create---
export const {
  SetESICraeteCALLAction,
  setESIRESPONSESCreateData,
  setESIDataCraeteError,
} = EsiFormCreateSlice.actions;
///----ESI----Edit--
export const {
  SetESIEditCALLAction,
  setESIRESPONSESEditData,
  setESIDataEditError,
} = EsiFormEditSlice.actions;
///-----Previous----Api----Call-Like---Form-Tabs--
export const {
  setPreviousDataFetchActions,
  SetThePreviousDataResponsesActions,
  setThePreviousErrAction,
} = PreviousApiCallSlice.actions;
///-0----Data---FETCH-----------------
export const {
  settheDataFetchActions,
  setTheDataFetchRESponse,
  setTheDataFETCHerror,
} = DATAFETCHslice.actions;
///---In---verifiy---Form---
export const {
  setIdVerificationActionsEdit,
  SetIdVerificationFormEditAction,
  SetIdverificationFormEditError,
} = IDverificationEditSlice.actions;
//---Previous----Employee---Create
export const {
  setPreviousEmpDataCreateActions,
  SetPreviuousEmpDataCreateResponeActions,
  setPreviousDataCreateError,
} = PreviousEmployeeCreateSlice.actions;
//----Previous---employe---edit--
export const {
  setPreviousEmpDataeditActions,

  SetPreviuousEmpDataEditResponeActions,
  setPreviousDataEditError,
} = PreviousEmployeeEditSlice.actions;

///--Grievance----
export const {
  setGrievanceAction,
  setGrievanceResponse,
  setgrievanceTotal_counts,
  setgrievanceError,
} = grievanceTypeSlice.actions;
///---Grievance-----create---
export const {
  settheGrievanceCreateActions,
  setTheGrievanceCreateRESponse,
  setTheGrievanceCreateerror,
} = GrievanceSlice.actions;

///---Grievance-----Retrieve---
export const {
  settheGrievanceRetrieveActions,
  setTheGrievanceRetrieveRESponse,
  setTheGrievanceREtriveerror,
} = GrievanceRetrieveSlice.actions;

///---Grievance-----create---
export const {
  settheGrievanceEditActions,
  setTheGrievanceEditRESponse,
  setTheGrievancediterror,
} = GrievanceEditSlice.actions;

///--Family-----------form---create--
export const {
  setFamilyEmpDatacreateActions,
  SetFamilyEmpDatacreateResponeActions,
  setFamilyDatacreateError,
} = FamilyEmployeeCreateSlice.actions;
////----Family----form---edits---
export const {
  SetFamilyEmpDataEditResponeActions,
  setFamilyEmpDataEditActions,
  setFamilyDataEditError,
} = FamilyEmployeeEditSlice.actions;

///--Performance----
export const {
  setPerformanceAction,
  setSelectedPerformer,
  setPerformanceResponse,
  setPerformanceTotal_counts,
  setPerformanceError,
} = performanceTypeSlice.actions;
///--Performance----Retreval
export const {
  setPerformanceRetreveAction,
  setPerformanceRetreveResponse,
  setPerformanceRetreveTotal_counts,
  setPerformanceRetreveError,
} = performanceTypeRetreveSlice.actions;
// Performance-Create
export const {
  setPerformanceCreateAction,
  setPerformanceCreateResponse,
  setPerformanceCreateError,
} = performanceTypeCreateSlice.actions;
// Performance-Update

export const {
  setPerformanceUpdateAction,
  setPerformanceUpdateResponse,
  setPerformanceUpdateError,
} = performanceTypeUpdateSlice.actions;
// Performance-Delete
export const {
  setPerformanceDeleteAction,
  setPerformanceDeleteResponse,
  setPerformanceDeleteError,
} = performanceTypeDeleteSlice.actions;
// --Performace ChildChild
export const {
  setPerformanceChildAction,
  setPerformanceChildResponse,
  setPerformanceChildTotal_counts,
  setPerformanceChildError,
} = performanceChildTypeSlice.actions;
///--Performance----Retreval
export const {
  setPerformanceChildRetreveAction,
  setPerformanceChildRetreveResponse,
  setPerformanceChildRetreveTotal_counts,
  setPerformanceChildRetreveError,
} = performanceChildTypeRetreveSlice.actions;
// Performance-Create
export const {
  setPerformanceChildCreateAction,
  setPerformanceChildCreateResponse,
  setPerformanceChildCreateError,
} = performanceTypeChildCreateSlice.actions;
export const {
  setEducationDataPutActions,
  SetEducationDataPutResponeActions,
  setEducationDataPutError,
} = EducationPutSlice.actions;

// Performance-Update

export const {
  setPerformanceUpdateChildAction,
  setPerformanceUpdateChildResponse,
  setPerformanceUpdateChildError,
} = performanceTypeUpdateChildSlice.actions;
// Performance-Delete
export const {
  setPerformanceChildDeleteAction,
  setPerformanceChildDeleteResponse,
  setPerformanceChildDeleteError,
} = performanceTypeChildDeleteSlice.actions;

///---Perform-s--------Field---agent-00-0
export const {
  setThePerformFieldAGentGet,
  setThePerformsFieldResponse,

  setPerformanceFieldTotal_counts,
  setPerformanceFieldError,
} = PerformFieldAgentSlice.actions;
////--------Performs_field-----agent---Retrieve----------
export const {
  setThePerformsAgentRetrieveACtion,
  setPerformanceRetrieveFieldResponse,
  setPerformanceRetrieveFielError,
} = PerformsFieldAGentetrieveSLice.actions;
////---Perform----Field----agent-----
export const {
  setThePerformsAgentCreateACtion,
  setPerformanceCreateFieldResponse,

  setPerformanceCreateFielError,
} = PerformsFieldAGentCReateSLice.actions;
export const {
  setThePerformsAgentEditACtion,
  setPerformanceEditFieldResponse,
  setPerformanceEditFielError,
} = PerformsFieldAGentEditSLice.actions;

///--Client----details------active---tas
export const {
  SettheActiveTabsActionClientDetails,
  Branch_EDIT_CLIENT_DETAILS,
  setTheUserProfileActive,
  setTheUseridEditIds,
  setCreateActive,
} = CountingForClientDetailsSlice.actions;
////--EXCEL___SHEET__UPLOAD_____STATE_CLIENT_
export const {
  setTheExcelSheetUploadSTActions,
  setTheExcelSheetuploadERROES,
  setTheSHeetuploaAction,
} = excelSheetUploadSomeSlice.actions;

///------CreaetEmploye----test===
export const {
  setThecreateEmploSigAction,
  settheCreateEmployeeResponse,
  settheCreareEmployeErr,
} = craeetEmployeeSignSlice.actions;
///--Grievance---Approval----
export const {
  SetTheGrievaceApprovalActions,
  setTheGrievanceApprovalResponse,
  setTheGrievanceApprovalErrors,
} = GrievaceApproveSlice.actions;

////---Grievance-----Approve---List
export const {
  setGrievanceEMPListAction,
  setGrievanceEMpListResponse,
  setgrievanceEmpListTotal_counts,
  setgrievanceEmpListError,
} = grievanceEMPLISTSlice.actions;
///--Grievance----Approve===Edit
export const {
  settheGrievanceEMPApproveretrieveActions,
  setTheGrievanceApproveEMPretrieveRESponse,

  setTheGrievanceApproveEMPretrieveerror,
} = GrievanceApproveRetrieveSlice.actions;
///-----Grieveance---delete------------
export const {
  setThegrieveacncedeleteActions,
  setThegrieveancedeletereponses,
  setThegrieveancedeleteErrors,
} = Grieveancedeleteslices.actions;

////--Attendance------List===
export const {
  StetheAttendanceActions,
  SetTheAttendanceResponseActions,
  setTeAttendanceTotal_counts,
  setTheAttendanceListError,
} = AttendanceListSlice.actions;

export const {
  StetheAttendanceRetrievActions,
  SetTheAttendanceResponseRetriveActions,
  setTheAttendanceListRetrieveError,
} = AttendanceRetriveListSlice.actions;

export const {
  SetTheAttendanceResponsepproveActions,
  StetheAttendanceApproveActions,
  setTheAttendanceListApproveError,
} = AttendanceApproveListSlice.actions;
///---Man--Power---Performs---
export const {
  setManpowerActivetabs,
  SetTheIDs,
  settheempsillassessmentsids,
  settheStandardIDS,
  setthetotal_ids,
  setTocalllRetrieve,
  setTheNameFormForm,
  settheEmpAssessmentNames,
  setthelistifskillassessment,
  settheformforskillassessment,
  setTheListNamesactions,
  setThePutIdAnswerIds,
  setTheLastPerformanceIds,
  setTheLastObjectwithTotal_points,
  setTheEsignatureCodes,
} = ManPowerActiveSlice.actions;

export const {
  StetheAttendanceExportActions,
  SetTheAttendanceResponseExportActions,
  setTheAttendanceListExportError,
} = AttendanceexportSlice.actions;

///---Man--Power---Performs--separate---stand----
export const {
  setThePerformsAgentRetrieveseparatestandACtion,
  setPerformanceRetrieveFieldseparateResponse,
  setPerformanceRetrieveFielseparateError,
} = PerformsFieldAGentetrieveSeparateSLice.actions;

////--Black---list--
export const {
  SetTheBlacklistActions,
  SetTheBlackllistResponse,
  SetTheBlackistTotal_counts,
  SetTheBlacklistError,
} = BlacklistListSlice.actions;
////---black--list----edit
export const {
  SetTheBlacklistEditsActions,
  SettheBlacklistResponsesActions,
  SetTheBlacklistErrorEdits,
} = BlacklistEditSlice.actions;

export const {
  SetTheBlacklistRetrieveActions,
  SettheBlacklistresponseRetrieveActions,
  SetBlacklistErrorRetrieve,
} = BlackListRetrirSlice.actions;
///--site----transfer----
export const {
  SetTheSiteTransferActions,

  SetThesiteTramsferResponse,
  SetThesiteTramfersTotal_counts,

  SetTheSiteTranferError,
} = SiteTramsferSlice.actions;
////---site--Transfer-------------
export const {
  SetTheSiteTransferRetrieveActions,
  SettheSiteTransferRetrieveResponsesActions,

  SetSiteTransferErrorRetrieve,
} = SiteTransferRetrirSlice.actions;
export const {
  SetTheSiteTransferEditsActions,
  SettheSiteTranfserResponsesActions,
  SetTheSiteTramsferErrorEdits,
} = SiteTramsferEditSlice.actions;
////--Site----------Transfer----------------
export const {
  SetTheSiteTransferCreateActions,
  SettheSiteTranfserResponsesCreateActions,
  SetTheSiteTramsferErrorCreate,
} = SiteTransferCreateSlice.actions;
////-----blacki--list--create=--
export const {
  SetTheBlacklistCreateActions,
  SettheBlacklistresponseCreateActions,
  SetBlacklistErrorCreate,
} = BlackListCREATESlice.actions;
////---send---notifations--------
export const {
  SetThesendNotificationCreateActions,
  setTheNotificationcreateResponse,
  SetTheSendnotificationErrorCreate,
} = sendnotificationcreateSlice.actions;
///---pdf----downloads---------------------
export const {
  sethtmlformatpdfdownoadActions,
  setHtlformatpdfdownloadreponse,
  sethtmlformatpdfdownloaderr,
} = PdfDownloadsSlices.actions;
///---Appraisal-------html formats-
export const {
  setAppraisalHtmlPostActions,
  settheAppraisalHtmlFormatsPostsResponse,
  setTheAppraisalErrorReponseshtmlForm,
} = AppraisalPostHtmlFormatsSlice.actions;
///--attendance---export---get---list
export const {
  setAttendanceExportgetlistActions,
  setTheAttendanceExportgetListReponse,
  setTheAttendanceExportTotal_counts,
  setTheAttendanceExportGetListError,
} = AttendanceExportGetlistSlice.actions;
///---admin---user---access--list
export const {
  setAdminuseraccesslistDatasgetlistActions,
  setTheAdminuseraccesslistDatasgetListReponse,
  setTheAdminuseraccesslistDatasTotal_counts,
  setTheAdminuseraccesslistDatasGetListError,
} = AdminuseraccesslistGetlistSlice.actions;
///---post----
export const {
  setadminuseraccessceateActions,
  settheadminuseraccesscratePostsResponse,
  setTheadminuseraccesscrateReponsesError,
} = adminuseraccesscreateSlice.actions;

///retrieve
export const {
  setadminuseraccessRetrieveActions,
  settheadminuseraccessRetrievePostsResponse,
  setTheadminuseraccessRetrieveReponsesError,
} = adminuseraccessRETRIEVESlice.actions;
///---put
export const {
  setadminuseraccessEDITActions,
  settheadminuseraccessEDITPutResponse,
  setTheadminuseraccessEDITReponsesError,
} = adminuseraccessEDITSlice.actions;

///---dlete
export const {
  setadminuseraccessdeleteActions,
  settheadminuseraccesdeleteResponse,
  setTheadminuseraccessdeleteReponsesError,
} = adminuseraccesDELETESlice.actions;

////---id--verifycations--------------
export const {
  setIDverifycationanotherapidatasActions,
  settheIDverifycationanotherapidatasResponse,
  setIDverifycationanotherapidatasReponsesError,
  settheAadarFrontImageAsBase64,
  setAadharBackSideImageAsbase64,
  settheAadarFrontFiles,
  setAadharBackSideFilesAs,
  setTheAadharFrontImageDatas,
  setTheAadharBackSideImageDatas,
  setTheAadharFristNumbers,

  setTHnUMBERSRESPONSES,
} = IDVERIFYCATIONUNKOWNAPISLICE.actions;

///--export---sheet---fornats=---
export const {
  setTheExcelsheetUploadDataForEmpCIlent,
  setTheExcelSheetDataforEMpANdclientResponses,

  setExcelSheetgetEmpANdClientReponsesError,
} = ExportEXCELFORMATTOEMPLOYEESLICE.actions;
///--Delete---Pay--slipe---
export const {
  setThePayslipDeleteActions,
  getPaySlipSuccessDeleteResponseActions,
  getPaySlipErrodeleteResponsen,
} = PaySlipDEleteSlice.actions;

//////----Bank--passbook--------
export const {
  setTheActionsFroTheBankPassbooks,
  setTheDataAsEncodedDataResponses,
  setTheDatabaseontheEncodededResponses,
  setThePassBookActionsErrorrs,
} = bacnkPassbookOrChecqueSlice.actions;
///--Otp---Verifications00
export const {
  setTheActionForOtpPhoneNumbers,
  setThePhoneNumberOtpREsponses,
  setTheStatusCodeFortheEmplyeeOnboards,
  setThePhoneNumberOfOtpVerified_Error,
} = OtpverifiiedSLice.actions;
///-resend

export const {
  setTheActionResentForOtpPhoneNumbers,
  setTheResentPhoneNumberOtpREsponses,
  setTheStatusResentCodeFortheEmplyeeOnboards,
  setThePhoneNumberResentOfOtpVerified_Error,
} = ResendOtpverifiiedSLice.actions;

///--Otp---Verifications00
export const {
  setTheActionForOtpwithPhoneNumbers,
  setThePhoneNumberwithOtpREsponses,
  setThePhoneNumberOfwithOtpVerified_Error,
} = OtpverifiiedWithSLice.actions;

///----Attendace----Request ------list
export const {
  setAttedancelistDatasgetlistActions,
  setTheAttendancesaccesslistDatasgetListReponse,
  setTheAttendanceslistDatasTotal_counts,

  setTheAdttendanceslistDatasGetListError,
} = WebAttandanceRequestSlice.actions;

////other party for pam
export const {
  setTheOtherpARTYaPIaCTIONS,
  setTheOtherPartyApiResponsesActions,
  setTheotherAPtyApiInErrorMsg,
} = PanCardAnother_OtherParyApisSlice.actions;

////---Active----employees-
export const {
  SetTheActiveEmployeeListACtions,
  setTheActiveEmployeeListActionsResponses,

  setTheActiveEmployeeListErrorReponses,

  setTheActiveEmployeeTotal_counts,
} = ActiveEmployeeListSlice.actions;

///---Empoyee---Approve---
export const {
  setTheApproveEmployeeTOLeftAOffice,
  setTheApproveEmployeeTOleftResponses,
  setTheApproveEmployeeTOleftError,
} = ApproveEmployeeToLeftSlice.actions;

//-------To retieve the data for approve the employees to left the active and inactive based
export const {
  setTheRetrieveForApproveEmployeeTOLeftAOffice,
  setTheRetrievForApproveEmployeeTOleftResponses,
  setTheRetieveFroApproveApproveEmployeeTOleftError,
} = RetirveForAPPEmployeeToLeftSlice.actions;

///---Active---Employeee----Create--
export const {
  setTheActiveEmployeeCreatesList,
  setTheActiveEmployeeActionResponses,
  setTheActiveEmployeesResponseInErrorMessage,
} = ActiveEmployeeCreateListSLice.actions;

///---export----Response
export const {
  SetThePerformanceExportSheetDatasActions,
  setThePerformanceExportSheetDatasReponses,
  setThPerformanceExportSheetDatasErrorReponses,
} = PerformSheetExportSLice.actions;
///---Appraisal
export const {
  SetTheAppraisalListActions,

  setTheAppraisalListedreponses,

  setTheAAppraiisalEroorerrorReponses,

  setTheAppraisalListCountsTotal_counts,
} = AppraisalDataSlices.actions;
///---Appraisall----rerteivee---

export const {
  SetTheAppraisalRetrieveDatasActions,
  setTheAppraisalRetrieveDatasReponses,
  setTheAppaisalRetrieveSlicesErrorReponses,
} = AppraisalSliceRetrieveSlices.actions;

///----supervior
export const {
  setTheSuperviorsgeteListActions,
  setThesuperViorsResponseActionss,
  setTheSuperviorseErrorResponses,
} = SuperviorsSlicePutlist.actions;

///---SuperviorsData

export const {
  SetTheSuperviorsListACtions,
  setTheSuperviorsListActionsResponses,

  setTheSuperviorsListErrorReponses,
  setTheSuperviorsTotal_counts,
} = SuperviorsSlicegetList.actions;

///---attedance mulitiple list

export const {
  settheAttedanceListMulitipleActions,
  setTheAttedanceListMulitipleResponses,
  setTheAttedanceListErrorMulitiples,
} = attendancemulitipleListSlice.actions;

///----Performance-----Headers-------
export const {
  setTheActionsListsPerformanceHeaderListed,
  setThePerformancesHeaderListedResponses,
  setThePerfromanceListedErrorResponses,
  setthePerformancesListedTotal_counts,
} = PerformanceHeaderSliceList.actions;

///---- Needed----datas
export const {
  setTheClientNamelisted,
  settheTicketViewIds,
  settheTicketSuccesspopuos,
  SettheTicketDashboardStatusManagement,
  setthefindthReassings,
  settehCLosingopups,
  setfirebasenotificationtoken,
  settheReassignTicketpopups,
  settheTicketraiseroutes,
  settehTicketthankspopup,
  setTheBranchNameAsListed,
  setTheIdOne,
  setTheSubQueryIDs,
  settheDateOfjoining,
  setTheUDSEmployeeLogin,
  setThePageIndex,
  setTheStatusFilter,
  setthemyonboardingListedDatas,
  settheHRonboardingListedDatas,
  settheHrmsConnectivityListedDatas,
} = NeededDatasAsSlice.actions;

///----EmployeeAttendaces
export const {
  SettheEmployeeAttedanceResults,
  SettheEmployeeAttendanceResponseDatas,
  setTheEmployeeDashboardAttedanceResults,
} = EmployeeDashboardSlice.actions;

////--test

export const {
  setTheDashboardwithEmpactions,
  setTheDashboardwithEmployeeattendanceResponses,
  setTheDashboardwithempAttendanceErrors,
} = DaShboardwithemployeedetailsSlice.actions;

///----User----Details---
export const {
  setTheUserDetailsExportActions,

  setTheUserDetailsResponsiveExport,
  SettheUserDetailsErrorExport,
} = UserDetailsInexportedSlice.actions;

///------------Queeryquestionsdata
export const {
  settheQueryQuestionActions,
  setTheQueryQuestionsResponses,
  setTheQueryQuestionsError,
  setTheQueryQuestionTotalCounts,
} = QueryQuestionsSlice.actions;

//----Query----Questions---create---
export const {
  setTheQueryQuestionsCreateActions,
  setTheQueryQuestionsCreateResponsive,
  SettheQueryQuestionsCreateError,
} = queryQuestionCreateSlice.actions;

//----Query----Questions---delete---
export const {
  setTheQueryQuestionsDeleteActions,
  setTheQueryQuestionsdeleteResponsive,
  SettheQueryQuestionsDeletError,
} = queryQuestionDeleteSlice.actions;

//----Query----Questions---Edit---
export const {
  setTheQueryQuestionsEditActions,
  setTheQueryQuestionsEditResponsive,
  SettheQueryQuestionsEditError,
} = queryQuestionEditSlice.actions;

//----Query----Questions---Retrieve---
export const {
  setTheQueryQuestionsRetrieveActions,
  setTheQueryQuestionsRetrieveResponsive,
  SettheQueryQuestionsRetrieveError,
} = queryQuestionRetrieveSlice.actions;

///----querysub quetions
export const {
  settheQuerySubQuestionActions,

  setTheQuerySubQuestionsResponses,
  setTheQuerySubQuestionsError,
  setTheQuerySubQuestionTotalCounts,
} = QuerySubQuestionsSlice.actions;
///----querysub quetions
export const {
  setTheQuerySubQuestionsCreateActions,

  setTheQuerySubQuestionsCreateResponsive,
  SettheQuerySubQuestionsCreateError,
} = QuerySUbQuestionCreateSlice.actions;

///----querysub quetions------retrieve
export const {
  setTheQuerySubQuestionsRetrieveActions,

  setTheQuerySubQuestionsRetrieveResponsive,
  SettheQuerySubQuestionsRetrieveError,
} = QuerySUbQuestionRetrieveSlice.actions;

///----querysub quetions------Edit
export const {
  setTheQuerySubQuestionsEditionsActions,

  setTheQuerySubQuestionsEditionsResponsive,
  SettheQuerySubQuestionsEditionError,
} = QuerySUbQuestionEdtionsSlice.actions;

//---sub---query--delete
export const {
  setTheQuerySUbQuestionsDeleteActions,
  setTheQuerySUbQuestionsdeleteResponsive,

  SettheQuerySUbQuestionsDeletError,
} = querySUBQuestionDeleteSlice.actions;
///------tracking----record--list
export const {
  settheTrackingrecordgetListDataActions,
  setTheTrackingrecordgetListDataResponses,
  setTrackignRecordListDashboardReport,

  setTheQTrackingrecordgetListDatasError,
  setTheTrackingrecordgetListDataTotalCounts,
} = TrackingrecordSlice.actions;
///----Tracking---retrieve----slice

export const {
  setTheQueryTrackingrecordgetListRetrieveActions,
  setTheQueryTrackingrecordgetListRetrieveResponsive,
  SettheTrackingrecordgetListRetrieveError,
} = QueryTrackingrecordgetListRetrieveSlice.actions;

///---tracking---edtions--------------------

export const {
  setTheTrackingEditionsActions,
  setTheTrackingEditionsResponsive,
  SettheTrackingEditionError,
} = QueryTrackingrecordgetListSlice.actions;

///--tracking---delte

export const {
  setTheTrackingDeleteActions,
  setTheTrackingdeleteResponsive,
  SettheTrackingDeletError,
} = TrackingDeleteSlice.actions;

//---Tracking ---Create-----Actions

export const {
  setTheTrackingCreateActions,
  setTheTrackingCreateResponses,

  setTheTrackingCreateError,
} = TrackingCreateSlice.actions;

///--Finance----slice
export const {
  setThefinanceDataActions,
  setThefinanceResponsiveDatas,
  setTheFinanceCountsDatas,
  setTheFinanceErrorResponse,
  setTheFinancetableTotal_Count,
  setThefinanceResponsivePancardDatas,
  setTheFinancetableTotal_CountPan,
  setThefinanceResponsiveWhatsapppDatas,
  setTheFinancetableTotal_CountwhatsApp,

  setThefinanceResponsiveBankDatas,
  setTheFinancetableTotal_CountBank,
} = FinanceGetlistedSlice.actions;

///finance export
export const {
  setThefinanceDataExportActions,
  setThefinanceResponsiveExportDatas,
  setTheFinanceErrorExportResponse,
} = FinanceGetlistedExportSlice.actions;

///---Attendance report

export const {
  setTheAttendanceReportActions,
  setTheAttendanceReportResponsiveDatas,
  setTheAttendanceReportTotal_Count,
  setTheAttendanceReportErrorResponse,
} = AttendanceREPORTSlice.actions;

////---Onborder---details

export const {
  setTheOnboarderdetailsReportActions,
  setTheOnboarderDetailsResponsiveDatas,
  setTheOnboaderdetailsReportErrorResponse,
  setTheAuthrorzedToatalCounts,
} = OnboaderDetailsSlice.actions;

///----Other0----Party--apis
export const {
  setTheOtherAAdhaarOtpPhoneNuberAction,
  setTheOtherPartyApiAADharReponse,
  settheAAdharPhoneNumberOtpSend,
  setTheClient_id,
} = OtherPartyAAdhaarsendOtpSlice.actions;

//----Aadhar-----submit--otp

export const {
  setTheaadharsentOtpReportActions,
  setTheAadharsendthesubmitotpResponsiveDatas,
  setTheaadharsubmitotpErrReportErrorResponse,
  setTheSumbitOtpFormsAadhar_verified,
} = AADharSubmitOtpSlice.actions;

///---Pancard

export const {
  setThePANCARDeportActions,
  setTheCLientID,

  setThePANCARDotpResponsiveDatas,
  setThePANCARDrrReportErrorResponse,
  setThePANCARDVerifyDatas,
} = PANCARDSubmitOtpSlice.actions;

///---supervirose---add
export const {
  SetTheSuperviorsLisEmployeeeetACtions,
  setTheSuperviorsListEmploeyeeActionsResponses,

  setTheSuperviorsListErrorEmployeeeReponses,
} = SuperviorsEmloyeegetList.actions;

///----attendance dashboard----user ---list
export const {
  setUserOptionDashboardEmployeesActions,

  setUserSuccessDashboardEmplpyeesResponse,
  setoptionResponseDashboardEmployeeTotal_count_user,
  setUserOptionResponseDashboardEmployeerrorsMessage,
} = UserSelectedDahboardEmployeesSlicess.actions;

///---User---select---options

export const {
  setUserOptionDatasActions,
  setUserSuccessOptionResponse,

  setoptionResponseTotal_count_user,
  setUserOptionResponserrorsMessage,
} = UserSelectedOptionsSlicess.actions;

///----penny drop---token--create
export const {
  CreateTokenForBankVerifyActions,
  Createtoken_store,
  createToken_store_erro_reposen,
} = tokenCreateForpennydropslice.actions;
///---penny--drop--verify
export const {
  BankVerifyActions,
  CreateResponse_store,
  createBankverifyed_store_error_reposen,
  setTheAccountExit,
  setTheTransactionID,
  settheBankHolderName,
} = BankVerifiedDropslice.actions;

///-----Customer---uds--employeee-------------------------------------------

export const {
  SetTheCustomerUDSEmployeeLogin,
  settheCustomerUDSemployeeloginresponse,
  settheCustomerUDSEmployeeErroMsg,
} = CustomUDSEmployeeLoginSlice.actions;

//----send---otp

export const {
  SetTheCustomerUDSEmployeeSendOtp,
  settheCustomerUDSemployeeSendOTPresponse,
  settheCustomerUDSEmployeeErroMsgSendOtp,
} = CustomUDSEmployeeLsendOtpSlice.actions;

//----Uds---actions---
export const {
  setTheUdsLoginPagechange,
  setTheBranchInlatANDLog,
  settheEmpAttendanceBoolValues,
  setTheCheckingIn,
  setTheWhiteCollarState,
  setTheAttendanceId,
  setTheLeaveApplyDateUDS_employee,
} = UDSROleEmployeeSLiceActions.actions;

///---emplyoeee permissio get liet
export const {
  SetTheAttendancegetlistempPermissionDatasActions,
  setTheAttendancegetlistempResponses,
  SetAttendancePermissiongetlistempResponse,
  setTheAttendancePermissiongetlistempDatasError,
  setTheAttendancePermissiongetListempTotal_counts,
} = AttenDanceGetlistempPermissionSlice.actions;

///---create permission
export const {
  SetCreatePermissionEmpAction,
  SetCreatePermissionEmpSuccessResponse,
  SetCreatePermissionEmpError,
} = CreatePermissionForEmpSlice.actions;

///--regularization
export const {
  SetTheAttendancegetlistempRegularizationDatasActions,
  setTheAttendancegetlistempResponsesRegularization,
  SetAttendanceRegularizationlistempResponse,
  setTheAttendanceRegularizationlistempDatasError,
  setTheAttendanceRegularizationListempTotal_counts,
} = AttendanceRegularizationForEmployee.actions;

export const {
  SetCreateAttendanceRegularizationEmpSuccessResponse,
  SetCreateAttendanceRegularizationEmpError,
  SetCreateAttendanceRegularizationEmpAction,
} = CreateRegularizationForEmpSlice.actions;

///-------------------report---get---list--
export const {
  getRoportpostActions,
  getRoportpostListSuccessResponseActions,

  getRoportPostListErroResponsen,
} = ReportSheetExportPostSlice.actions;

//---report---create
export const {
  getRoportDatasActions,
  getRoportdatsListSuccessResponseActions,
  getRoportsTotal_pageCounst,
  getRoportDatsListErroResponsen,
} = ReportSheetExportSlice.actions;

///---report delete
export const {
  getRoportDeletedActions,
  getRoportdatsListdeletedResponseActions,
  getRoportDatsListErrodeleteResponsen,
} = ReportSheetDeleteSlice.actions;

////--Attendance----Data----
export const {
  SetTheAttendanceDatasActions,
  setTheAttendanceTotal_counts,
  SetTheAttendanceDataresponse,
  setTheAttendanceDatasError,
  setTheAttendanceLeaveResponses,
} = AttenDanceSlice.actions;

export const {
  setTableData,
  setTableSuccessData,
  setTableErrorAction,
  setDataTotalPageCounts,
  Setis_show_false,
  setis_show_true,
} = TableDataSlice.actions;
///--Language---------------
////----Shift---Datas----
export const {
  SetTheShiftDatasActions,
  SetTheShiftDataresponse,
  setTheShiftDatasError,
} = ShiftDatasListSlice.actions;
//------SideBarfiles-------------------

export const {
  setOndutyDatasEmpAction,
  SetOndutyEmployeeDataresponse,
  SetOndutyEmployeetotalcountDataresponse,
  setOndutyEmployeeDataError,
} = OndutyDaysempDataSlice.actions;

export const {
  setOndutyDatasEmpCreateAction,
  SetOndutyEmployeeDataCreateresponse,
  setOndutyEmployeeDataCreateError,
} = OndutyEmployeeCreateSlice.actions;

export const {
  SetLeaveTypeDataActions,
  SetLeaveTypeDataresponse,
  setLeaveTypeDataError,
} = LeaveTypeDataSlice.actions;
export const {
  SetAttendancePermissionResponse,
  setTheAttendancePermissionDatasError,
  SetTheAttendancePermissionDatasActions,
  setTheAttendanceResponses,
  setTheAttendancePermissionTotal_counts,
} = AttenDancePermissionSlice.actions;
export const {
  SetTheOnDutyDatasActions,
  setTheOnDutyResponses,
  SetOnDutySuccessResponse,
  setTheOnDutyDatasError,
  setTheOnDutyTotal_counts,
} = OnDutyUDSSlice.actions;

export const {
  updateCreateLeaveActionResponse,
  SetCreateLeaveAction,
  SetCreateLeaveSuccessResponse,
  SetCreateLeaveError,
} = CreateLeaveSlice.actions;
export const {
  SetCreatePermissionAction,
  // updateCreatePermissionActionResponse,
  SetCreatePermissionSuccessResponse,
  SetCreatePermissionError,
} = CreatePermissionSlice.actions;
export const {
  SetCreateOnDutyAction,
  SetCreateOnDutySuccessResponse,
  SetCreateOnDutyError,
} = CreateOnDutySlice.actions;
export const {
  SetCalendarActions,
  SetCalendarSuccessResponse,
  setCalendarError,
} = CalendarSlice.actions;
export const {
  SetCheckInOutAction,
  SetCheckInOutSuccessResponse,
  SetCheckInOutError,
} = CheckInOutSlice.actions;

export const {
  SetCheckInOutputMethosAction,
  SetCheckInOutSuccessputmethodResponse,
  SetCheckInOutErrorputmethod,
} = CheckInOutPutMethodSlice.actions;

export const {
  SetFaceVerificationAction,
  SetCheckInOutSuccessFaceVerificationmethodResponse,
  SetCheckInOutFaceVerificationErrorputmethod,
} = FaceVerificationSlice.actions;

export const { SetPayslipActions, SetPayslipSuccessResponse, setPayslipError } =
  PayslipSlice.actions;
export const {
  SetFetchReimbursementAction,
  SetFetchReimbursementSuccessResponse,
  SetFetchReimbursementError,
  SetFetchReimbursementResponse,
} = FetchReimbursementSlice.actions;
export const { getLanguageSetUp } = LanguageSteup.actions;

///--------onboarding----count
export const {
  setAadhar_counts,
  setTheAadhar_front_count,
  setTheAadharBack_counts,

  setThPanVerifyCounts,
  setThePanFrontCOunt,
  setbankCounts,
} = OnboardingCountsSlices.actions;

//--Profile--signature--get--list
export const {
  setTheProfileSignatureActions,
  settheprofileSignatureGetLIStErrorputmethod,
  setTheProfileSignatureGetActionsResponse,
  setTheTotal_counts,
} = ProfilesignatureSlice.actions;

//--Sony--employee--calls
export const {
  setTheSonyEmployeeActions,
  setTheSonyEmployeeGetActionsResponse,
  setTheSonyEmployeeTotal_counts,
  settheSonyEmployeeGetLIStErrorputmethod,
} = SonyEmployeeCallsSlice.actions;

//--Profile--signature---edit
export const {
  setTheProfileSignatureEDITActions,
  setTheProfileSignatureEDITResponse,
  settheprofileSignatureEDITmethod,
} = ProfilesignatureEditSlice.actions;

////---over--All report
export const {
  setOverReportActions,
  setOverReportSuccessResponse,
  setTotal_count_OverReport,
  setOverReportErrorsMessage,
  setTheOverAllReportDatas,
  setThekycapproximatedvalue,
  settheapproximated_values,
} = OverAllReportSlice.actions;

export const {
  setOverReportCreateActions,
  setOverReportSuccessCreateResponse,
  setOverReportErrorsCreateMessage,
} = OverAllReportCreateSlice.actions;

export const {
  setOverReportEdiyActions,
  setOverReportSuccessEditResponse,
  setOverReportErrorsEditMessage,
} = OverAllReportEditSlice.actions;

export const {
  setOverReportRetrieveActions,
  setOverReportSuccessRetrieveResponse,
  setOverReportErrorsRetrieveMessage,
} = OverAllReportRetrieveSlice.actions;

////----OverAll---Employee_list
export const {
  setOverReportActionsEmployeeList,
  setOverReportSuccessResponseEmployeeList,
  setTotal_count_OverReportEmployeeList,
  setOverReportErrorsMessageEmployee,
} = OverAllEmployeeListSlice.actions;

export const {
  setOverReportActionsExportEmployeeList,
  setOverReportSuccessResponseExportEmployeeList,
  setOverReportErrorsMessageExportEmployee,
} = OverAllEmployeeListExportSlice.actions;

////---Send---Email---report

export const {
  setthesendEmailActions,
  setthesendEmailActionsResponse,
  setthesendEmailActionsEditError,
} = sendEmailReportEditSlice.actions;

//---report---get
export const {
  setthesendEmailGetListActions,
  setthesendEmailActionsgetListResponse,
  setthesendEmailActionsGetListError,
} = sendEmailReportgetslice.actions;

///--Onboarder---over---view
export const {
  setTheDashboardonboadOverviewactions,
  setTheDashboardOnboarderOverviewResponses,
  setTheDashboarOnboarderOverViewdErrors,
  SetTheDashboardonBoardOverViewClientList,
  settheOnboardOverviewDashboardClient,
  SetTheDashboardonBoardOverViewOrganizationListed_stateList,
} = DaShboardOnboardingOverviewSlice.actions;

///---overall state----
export const {
  SetTheStateGetListActions,
  settheStatesgetListResponse,
  settheStateGetListError,
} = Overallstateslice.actions;

///---Over all -->state -->region--->zone --statemanegement
export const {
  settheDefualtDatefilyer,
  // date filter
  setEmployee_filter_inRole,
  settheInternalDefualtDatefilyer,
  settheInternal_SupportFromDate,
  settheInternal_SupportToDate,
  settheCustomer_SupportFromDate,
  settheCustomer_SupportToDate,

  settheCustomerSupportTabActives,
  settheInternalSupportsTabActives,
  settheTicketUser_type,
  settheticketsummaryticketstatus,
  settheAssignAndReassigns,
  settheTicketStatusNames,
  settheTicketReassignIds,
  settheTicketingSUbOptionValuesListed,
  settheInnerDashbaordTicketDaterangeOne,
  settheExternalTicketviewslisted,
  settheInnerDashbaordTicketDaterangetwo,
  setTheDesignationMonthAndyearFilter,
  settheAttendanceReportState,
  setThaAttendanceReportRegion,
  setThaAttendanceReportZone,
  settheNodueFromState,
  setThaNodueFromrRegion,
  setThaNoDueFormZone,
  setthePermissionrequestState,
  setThePermissionRequestRegion,
  setThePermissionRequestZone,
  setThePermssionrequestRange1,
  setThePermissionRequestRange2,
  setTheOndutyrequestRange1,
  setTheOndutyRequestRange2,
  setTheOndutyRequestZone,
  setTheOndutyRequestState,
  setTheOndutyRequestRegion,
  setTheAttendance_RegularizationRange1,
  setTheAttendance_RegularizationRange2,
  setTheAttendance_RegularizationZone,
  setTheAttendance_RegularizationState,
  setTheAttendance_RegularizationRegion,
  setTheResignZone,
  setTheResignState,
  setTheResignRegion,
  setThePermissionStatusState,
  SettheOndutyRequestStatusState,
  setTheAttedanceRegurlarzationStatus,
  setTheOvertime_RegularizationRange1,
  setTheOvertime_RegularizationRange2,
  setTheOvertime_RegularizationZone,
  setTheOvertime_RegularizationState,
  setTheOvertime_RegularizationEmployeedesignation,
  setTheOvertime_RegularizationRegion,
  setTheOvertime_RegularizationStatusState,
  settheInternal_Statuss,
  settheNodueFormStatusState,
  setTheEmployeeDesginationPermission,
  setTheOndutyDesignation,
  setTheAttendance_regularizationDesignation,
  setTheNodueDesginations,
  setheResigndesignationStatus,
  setTheResignStateStatus,
  setTheReimbursementZone,
  setTheReimbursementState,
  setTheReimbursementRegion,
  setheReimbursementdesignationStatus,
  setTheReimbursementStateStatus,
  setTheReimbursementRange1,
  setTheReimbursementRange2,

  setTheEmployee_Block_RequestState,

  setTheEmployee_Block_RequestRegion,
  setTheEmployee_Block_RequestZone,

  setheEmployee_Block_RequestdesignationStatus,
  setTheEmployee_Block_RequestStateStatus,
  setTheEmployee_Block_RequestRange1,
  setTheEmployee_Block_RequestRange2,
  setTheAppraisalRange2,
  setTheAppraisalRange1,
  settheAppraisalEmployeeDesignation,
  setTheAppraisalEmploeeeStatuState,

  setTheSiteTransferState,
  setTheSiteTransferRegion,
  setTheSiteTransferZone,
  setheSiteTransferdesignationStatus,
  setTheSiteTransferStateStatus,
  setTheSiteTransferRange1,
  setTheSiteTransferRange2,
  setThePaylipDesignations,

  setTheGrievance_ListState,
  setTheGrievance_ListRegion,
  setTheGrievance_ListZone,

  setheGrievance_ListdesignationStatus,
  setTheGrievance_ListStateStatus,
  setTheGrievance_ListRange1,
  setTheGrievance_ListRange2,
  setTheTicketsStatusState,
  setTheTicketstRange1,
  setTheTicketsStatusStatuse,
  setTheTicktesRange2,

  setTheTicketingsystemStatusState,
  setthePriorityStatus,
  setTheTicketingsystemtRange1,
  setTheTicketingsystemRange2,
  setTheTicketingsystemtdashboardRange1,
  setTheTicketingsystemDashboardRange2,
  settheTicketIDSActions,
  settheClientIdTicketViewHolder,
  settheroutesforticketAssignsViews,
  setTheMYTicketsStatusState,
  setTheMYTicketstRange1,
  setTheMYTicktesRange2,

  setTheLeaveRequestState,
  setTheLeaveRequestRegion,
  setTheLeaveRequestZone,
  setheLeaveRequestesignationStatus,
  setTheLeaveRequestStateStatus,
  setTheLeaveRequestRange1,
  setTheLeaveRequestRange2,
  setTheLeaveRequestBranchList,

  setheMyOnboardingRequestState,
  setheMyOnboardingRequesteRegion,
  setheMyOnboardingRequestZone,
  setheHROnboardingRequestState,
  setheHROnboardingRequesteRegion,
  setheHROnboardingRequestZone,
  setTheMyonboardingRequestRange1,
  setTheMyOnboardingRequestRange2,
  setTheHRonboardingRequestRange1,
  setTheHRonboardingRequestRange2,
  setTheMyonboardingRequestBranchList,
  setTheHRonboardingRequestBranchList,
  setTheHrmsConnectivityRequestState,
  setTheHrmsConnectivityRequestRegion,
  setTheHrmsConnectivityRequestZone,
  setTheHrmsConnectivityRequestRange1,
  setTheHrmsConnectivityRequestRange2,
  setTheHrmsConnectivityRequestBranchList,
  setheticketsubcategoryactions,

  setTheSillAsssessmentsStatus,
  setTheSillAsssessmentsState,
  setTheSillAsssessmentsRegion,
  setTheSillAsssessmentsZONE,
  setTheSillAsssessmentsAppsideCompleted,
  setTHeSkillAssessmentsMonthanYearsFilter,
  setTHeSkillAssessmentsClient_Filter,
  setTHeSkillAssessmentsDesginationsFilter,
  settheSkillAssessmentsRanges1,
  setSkillAssessmentRange2date,
} = StateManagementSlice.actions;

///--Attendance --location---tab
export const {
  setTheAttendanceLocationAction,
  setheAttendanceLocationResponse,
  setTotal_count_AttedanceLocationEmployeeList,
  settheAttendanceLocationErrorMessage,
} = AttendanceLocationSlice.actions;

export const {
  setTheAttendanceLocationCreateAction,
  setheAttendanceLocationCreateResponse,
  settheAttendanceLocationCreateErrorMessage,
} = AttendanceLocationSliceCreate.actions;

export const {
  setTheAttendanceLocationEditionsAction,
  setheAttendanceLocationEditionsResponse,
  settheAttendanceLocationEditionsErrorMessage,
} = AttendanceLocationSliceEdit.actions;

export const {
  setTheAttendanceLocationDeleteAction,
  setheAttendanceLocationDeleteResponse,
  settheAttendanceLocationDeletesErrorMessage,
} = AttendanceLocationSliceDelete.actions;

export const {
  setTheAttendanceLocationRetrieveMetyhodAction,
  setheAttendanceLocationRetrievemethodResponse,
  settheAttendanceLocationRetrieveMethodErrorMessage,
} = AttendanceLocationSliceRetrievemethod.actions;
export const {
  startEditingSupportDocument,
  setEditedSupportDocument,
  setEditSupportDocumentError,
} = supportDocumentEditSlice.actions;
export const {
  startFetchingSupportDocuments,
  setSupportDocuments,
  setSupportDocumentsError,
} = supportDocumentFetchSlice.actions;

export const {
  gettheHRonboardignlisteddatas,
  gettheHRonboardingreponsesdatas,
  settheHRonardingTotal_counts,
  settheHRonboardinggetlisterror,
} = HRonboardingListSlice.actions;
export const {
  gettheMyonboardignlisteddatas,
  getthemyonboardingreponsesdatas,
  settheMyonardingTotal_counts,
  settheMyonboardinggetlisterror,
} = MyonboardingListSlice.actions;

export const {
  gettheRegeneratePdfAction,
  gettheRegeneratePdfResponse,
  settheRegeneratorlisterror,
} = RegenerateThePdfSlice.actions;

export const {
  gettheApproveRequestInmnagaerList,
  gettheapproveRequestManagerResponse,
  gettheApproveRequestManagerListError,
} = myManagerListForApproveRequestSlice.actions;

export const {
  setTheOvertimeAction,
  setheOvertimeResponse,

  setTotal_count_OvertimeEmployeeList,
  settheOvertimeErrorMessage,
} = overtimeGetlistslice.actions;

export const {
  SetOvertimeApproveActions,
  SetOvertimeResponseApproveActions,

  SetOvertimeListApproveError,
} = OvertimeApproveListSlice.actions;

export const {
  gettheoverallOnboaderDatas,
  getthestoretheoverallOnboaderData,
  gettheoverallonboarderTotalCounts,
  getheOverallonboarderErrorMessage,
} = RejoiningOnboaderListSlice.actions;

export const {
  gettheStoretheRejoiningActions,
  gettheRejoiningActionResponse,
  gettheRejoingError,
} = RejoiningPOSTSlices.actions;

///---my tickets
export const {
  settheMyTicketsDataActions,
  setTheMyticketsgetListDataResponses,
  setTheQMyTicketsListDatasError,
  setTheMyTicketsListDataTotalCounts,
  setTheMyticketsinChartList,
} = MyTicketsSlice.actions;

export const {
  settheOvertimeRegulrizationActions,
  setTheovertimeRegularizationResponse,
  settheOvertimeRegularizationsResponseStore,
  settheOvertimRegularizationErrorMsg,
  setTheOvertimeRegularizationListempTotal_counts,
} = OvertimeRegularizationEMpSlice.actions;

//------- ---REDUCERS----------------
export default {
  SideBarActive: SidebarSlice.reducer,
  sidebardispatchCall: SideBarDispatchSlices.reducer,
  userReducer: usersSlice.reducer,
  ForgotPassword: ForgotPasswordSlice.reducer,
  SideBarFiles: SideBarfileActiveSlice.reducer,
  OtpVerifyCall: OptVerifySlice.reducer,
  UpdatePassword: UpdatePasswordSlice.reducer,
  roleCreate: RoleCreateSlice.reducer,
  RoleLists: ROleListsSlice.reducer,
  roleDelete: RoleDeleteSlice.reducer,
  roleretrieve: RoleRetrieveSlice.reducer,
  RoleEditPart: RoleEditSlice.reducer,
  UserDelete: UserDelteSlice.reducer,
  UsergetList: UserSlicess.reducer,
  UserCreate: userCreateSlice.reducer,
  UserEdit: UserEditsSlice.reducer,
  UserRetrieve: UserRetrieveSlice.reducer,
  ResendOtp: ReSendOtpSlice.reducer,
  Language: LanguageSlice.reducer,
  GeoState: GeoStateSlice.reducer,
  stateCreates: StateCreateSlice.reducer,
  StateDelete: StateDeleteSlice.reducer,
  StateEdit: StateEditSlice.reducer,
  StateRetrieve: StateREtrieveSlice.reducer,
  regioncall: RegionSlice.reducer,
  regioncreate: RegionCreateSlice.reducer,
  RegionDelete: RegionDelete.reducer,
  RegionRetrieve: setRegionRetrievenSlice.reducer,
  RegionEditCalls: regionEditSlice.reducer,
  ZonePart: ZoneSlice.reducer,
  ZoneEditCalls: ZoneEditSlice.reducer,
  ZoneRetrieve: ZoneRetrieveSlice.reducer,
  ZoneDelete: ZoneDeleteSlice.reducer,
  ZoneCreate: ZoneCreateSlice.reducer,
  ClientList: ClientSlice.reducer,
  ClientCreate: ClientCreateSlice.reducer,
  ClientDeletes: ClientDeleteSlice.reducer,
  ClientRetrieves: ClientRetrieveSlice.reducer,
  ClientEditCalls: ClientEditSlice.reducer,
  ClientBranch: ClientBranchSLice.reducer,
  ClientBranchCreate: ClientBrancheCreateSlice.reducer,
  ClientBranchDeleteCall: ClienrBranchedDeleteSlice.reducer,
  BranchEdits: BranchEditSlice.reducer,
  BranchRetrieve: ClientBranchesRetrieveSlice.reducer,
  BranchSearchpart: BranchSearchSlice.reducer,
  ShiftList: ShiftListSlice.reducer,
  ShiftDelete: ShiftDeleteSlice.reducer,
  ShiftSearch: ShiftSearchSlice.reducer,
  shiftCreate: ShiftCreateSlice.reducer,
  ShiftEdits: ShiftEditSlice.reducer,
  ShiftRetrieveData: ShiftRetrieveSlice.reducer,
  EmployeeListsdata: EmployeeListSlice.reducer,
  EmployeeCreate: EmployeeCreateSlice.reducer,
  EmployeeDelete: EmployeeDeleteSlice.reducer,
  EmployeeEdits: EmployeeEditSlice.reducer,
  EmployeeRetrieve: EmployeeRetrieveSlice.reducer,
  ClientBranchIDs: RouteClientIdsSlice.reducer,
  EmployeeDATASList: EMployeeListSlice.reducer,
  EmployeeListPresons: EmployeePersonListSlice.reducer,
  EmployeeVerificationsNeed: EmployeeVerificationsNeededDatasSlice.reducer,
  EmployeeProfile: EMployeeProfileSlice.reducer,
  FormsSDETAILS: FormsSlice.reducer,
  FormsIDList: FormsIdSlice.reducer,
  AddressForms: AddressFormSlice.reducer,
  IdverificationName: IDverificationSlice.reducer,
  BankDetails: BankDetailsSlice.reducer,
  EducationAction: EducationSlice.reducer,
  PreviousEmp: PreviousEmployeeSlice.reducer,
  FamilyList: FamilyEmployeeSlice.reducer,
  DeclarationCall: DeclarationSlice.reducer,
  JOBOfferCall: JOBOFFERSlice.reducer,
  ESIdetails: EsiFormSlice.reducer,
  ErrorDisplay: User401ErrorSlice.reducer,
  IdVrificationEditCall: IdverificationeditSlice.reducer,
  ApprovalCall: ApprovelSlice.reducer,
  VerifiedUsers: VerifiedUsersSlice.reducer,
  JoningDateCall: JoningDateSlice.reducer,
  SignatureCall: SignatureSlice.reducer,

  // bulk upload
  sheetBulkUpload: sheetBulkUploadSlice.reducer,
  employeeBulkUpload: employeeBulkUploadSlice.reducer,
  sheetBulkUploadGetData: sheetBulkUploadGetSlice.reducer,
  denaveStateGetData: DenaveStateGetSlice.reducer,
  employeeBulkUploadGetData: employeeBulkUploadGetSlice.reducer,
  denaveBulkUploadNew: denaveBulkUploadNewSlice.reducer,
  denaveBulkUploadNewGetData: denaveBulkUploadNewGetSlice.reducer,
  sonyBulkUpload: sonyBulkUploadSlice.reducer,
  sonyBulkUploadGetData: sonyBulkUploadGetSlice.reducer,
  UserFilterCall: UserFilterSLice.reducer,
  EmployeeListfilterPresons: EmployeePersonFilterListSlice.reducer,
  excelsheets: UPloadExcelSheeSlice.reducer,
  makingChanges: MakingChangeSlice.reducer,
  LeaveTypeCareteCall: LeaveTypeCreateSlice.reducer,
  LeaveTypeList: LeaveTypeListSlice.reducer,
  LeaveTypeDelete: LeaveTypeDeleteSlice.reducer,
  LeaveTypeEditCall: LeaveTypeEDITSSlice.reducer,
  LeaveTypeRetrieveCall: LeaveTypeRetrieveSlice.reducer,
  LeavePremissionLists: LeavePermissionListSlice.reducer,
  LeavePremissionSearchLists: LeavePermissionListSearchSlice.reducer,
  LeavepermissionDeleteCall: LeavePermissionDeleteSlice.reducer,
  LeavePermissionRetrieveCall: LeavePermissionRetrieveSlice.reducer,
  LeavePermissionEditsCall: LeavePermissionEditsSlice.reducer,
  DashboardCall: DaShboardSlice.reducer,
  NumberCounts: DropDownOptionNumbersSlice.reducer,
  signaturepad: SignaturePadSlice.reducer,
  LeaveStatusListed: LeaveStatusListSLice.reducer,
  ShfitData: ShiftExcelSheetGetApiSlice.reducer,
  shiftPermission: ShiftPermissionSlice.reducer,
  ShiftPermissionEditsCall: ShiftPermissionEditsSlice.reducer,
  ShiftPermissionRetrieveCall: ShiftPermissionRetrieveSlice.reducer,
  ShiftpermissionDeleteCall: ShiftPermissionDeleteSlice.reducer,
  reinvestmentCall: ReinvsetmentSlice.reducer,
  reInvestmentRetrieveCall: ReinvsetmentRetrirSlice.reducer,
  ReinvestmentEditCall: ReinvsetmentEditSlice.reducer,
  ShifteexcelshettRetriev: excelShiftSheetRetrieveSlice.reducer,
  OndutyCalls: OnDutySlice.reducer,
  onDutyRetrieveCall: OndutyRetrieveSlice.reducer,
  OnDutyEditsCall: OnDutyEditSlice.reducer,
  OnDutyDeleteCall: ONdutyDeleteSlice.reducer,
  ResignRetrieveCall: ResignRetrieveSlice.reducer,
  resignCall: ResignSlice.reducer,
  ResignEditsCall: ResignEditSlice.reducer,
  ResignDeleteCall: ResignDeleteSlice.reducer,
  ExitCall: ExitSlice.reducer,
  ExitRetrieveCall: ExitRetrieveSlice.reducer,
  ExitEditsCall: ExitEditSlice.reducer,
  ExitDeleteCall: ExitDeleteSlice.reducer,
  ExitNodueEditCall: ExitNoDueEditSlice.reducer,
  AppraisliceCall: AppraisalSlice.reducer,
  AppraisalRetrieveCall: AppraisaltRetrirSlice.reducer,
  AppraisalEditCall: AppaisalEditSlice.reducer,
  payslip: PaySlipSlice.reducer,
  payslipCreate: PaySlipCreateSlice.reducer,
  payslipEdit: PaySlipEditSlice.reducer,
  payslipRetrieve: PaySlipRetrieveSlice.reducer,
  BasicFormCreated: BasicFormCreateSlice.reducer,
  AddressCraeteForms: AddressCreateSlice.reducer,
  JOBOfferCreateCall: JOBOFFERCreateSlice.reducer,
  JOBOfferPreviewCall: JOBOFFERPreviewSlice.reducer,
  RemainderMailCall: RemainderMailSlice.reducer,
  BankcreateDetails: BankDetailsCreateSlice.reducer,
  EducationcreateAction: EducationcreateSlice.reducer,
  fieldagentBracnhdata: fieldAgentBranchListSlice.reducer,
  EmployeeListManagerPresons: EmployeePersonManagerListSlice.reducer,
  BasicFormEdit: BasicFormEditSlice.reducer,
  AddressEditorms: AddressEditSlice.reducer,
  JOBOfferEditall: JOBOFFEReditSlice.reducer,
  HrApprovalDataCall: hrApprovalSlice.reducer,
  IdverificationNameCreate: IDverificationCreateSlice.reducer,
  BankEditDetails: BankDetailsEditSlice.reducer,
  DeclarationcreateCall: DeclarationcreateSlice.reducer,
  DeclarationEditCall: DeclarationEditSlice.reducer,
  ESIEditdetails: EsiFormEditSlice.reducer,
  ESICreatedetails: EsiFormCreateSlice.reducer,
  DatafetchCall: DATAFETCHslice.reducer,
  PreviousApiCallLine: PreviousApiCallSlice.reducer,
  IdverificationNameEdit: IDverificationEditSlice.reducer,
  PreviousEditEmp: PreviousEmployeeEditSlice.reducer,
  PreviousCreateEmp: PreviousEmployeeCreateSlice.reducer,
  grievanceTypeCall: grievanceTypeSlice.reducer,
  GrievanceEditCall: GrievanceEditSlice.reducer,
  GrievanceretrieveCall: GrievanceRetrieveSlice.reducer,
  GrievanceCall: GrievanceSlice.reducer,
  FamilyEditList: FamilyEmployeeEditSlice.reducer,
  FamilycreateList: FamilyEmployeeCreateSlice.reducer,
  performanceTypeCall: performanceTypeSlice.reducer,
  performanceRetrieveTypeCall: performanceTypeRetreveSlice.reducer,
  performanceCreateTypeCall: performanceTypeCreateSlice.reducer,
  performanceUpdateTypeCall: performanceTypeUpdateSlice.reducer,
  performanceDeleteTypeCall: performanceTypeDeleteSlice.reducer,
  EducationPutAction: EducationPutSlice.reducer,
  performanceChildTypeCall: performanceChildTypeSlice.reducer,
  performanceChildRetrieveTypeCall: performanceChildTypeRetreveSlice.reducer,
  performanceChildCreateTypeCall: performanceTypeChildCreateSlice.reducer,
  performanceUpdateChildTypeCall: performanceTypeUpdateChildSlice.reducer,
  performanceChildDeleteTypeCall: performanceTypeChildDeleteSlice.reducer,
  PerformFieldAGentGet: PerformFieldAgentSlice.reducer,
  PerformsFieldAgentRetrieve: PerformsFieldAGentetrieveSLice.reducer,
  PerformsFieldAgentEdit: PerformsFieldAGentEditSLice.reducer,
  PerformsFieldAgentCreate: PerformsFieldAGentCReateSLice.reducer,
  ExcelSheetUploadFieldST: excelSheetUploadSomeSlice.reducer,
  clientDetailsCall: CountingForClientDetailsSlice.reducer,
  createEmployeeCallSign: craeetEmployeeSignSlice.reducer,
  GrivanceDatas: GrievaceApproveSlice.reducer,
  GrievanceApproveretriveCall: GrievanceApproveRetrieveSlice.reducer,
  grievanceEMpListCall: grievanceEMPLISTSlice.reducer,
  AttendanceCall: AttendanceListSlice.reducer,
  AttendanceRetriveCall: AttendanceRetriveListSlice.reducer,
  AttendanceApproveeCall: AttendanceApproveListSlice.reducer,
  ManPowerActiveDataTabs: ManPowerActiveSlice.reducer,
  PerformsFieldAgentseparateRetrievename:
    PerformsFieldAGentetrieveSeparateSLice.reducer,
  AttendanceexportCall: AttendanceexportSlice.reducer,
  BlacklistLists: BlacklistListSlice.reducer,
  BlacklistEditCall: BlacklistEditSlice.reducer,
  BlacklistRetrieveCall: BlackListRetrirSlice.reducer,
  SiteTransfertLists: SiteTramsferSlice.reducer,
  SiteTramsferEditCall: SiteTramsferEditSlice.reducer,
  SiteTransferRetrieveCall: SiteTransferRetrirSlice.reducer,
  SiteTrabsferCreateCall: SiteTransferCreateSlice.reducer,
  BlacklistCreateCall: BlackListCREATESlice.reducer,
  SendNotificationferCreateCall: sendnotificationcreateSlice.reducer,
  pdfdownloadcall: PdfDownloadsSlices.reducer,
  GrievanceDeleteDataCall: Grieveancedeleteslices.reducer,
  AppraisalPostcall: AppraisalPostHtmlFormatsSlice.reducer,
  AttendanceExportDatacall: AttendanceExportGetlistSlice.reducer,
  AdminuseraccesslistCall: AdminuseraccesslistGetlistSlice.reducer,
  adminuseraccesscrate: adminuseraccesscreateSlice.reducer,
  adminuseraccessRETRIEVE: adminuseraccessRETRIEVESlice.reducer,
  adminuseraccesEDIT: adminuseraccessEDITSlice.reducer,
  adminuseraccesDelETE: adminuseraccesDELETESlice.reducer,
  idverfiyicationapidatas: IDVERIFYCATIONUNKOWNAPISLICE.reducer,
  exportexcelsheetforEMPandClien: ExportEXCELFORMATTOEMPLOYEESLICE.reducer,
  payslipDelete: PaySlipDEleteSlice.reducer,
  UpdateDatafromChequeOrPassbook: bacnkPassbookOrChecqueSlice.reducer,
  OtpVeririedPhoneNumbers: OtpverifiiedSLice.reducer,
  AttendancezRequestSliceList: WebAttandanceRequestSlice.reducer,
  OtherPartyApiForPAn: PanCardAnother_OtherParyApisSlice.reducer,
  ActveEmployeeList: ActiveEmployeeListSlice.reducer,
  ApproveEmployeeTOleft: ApproveEmployeeToLeftSlice.reducer,
  RetrieveForAproEmployeeTOleft: RetirveForAPPEmployeeToLeftSlice.reducer,
  ActiveEmployeeCreateData: ActiveEmployeeCreateListSLice.reducer,
  PerformanceAnswerExports: PerformSheetExportSLice.reducer,
  AppraisalDatasListesUDS: AppraisalDataSlices.reducer,
  AppraisalSliceDatasss: AppraisalSliceRetrieveSlices.reducer,
  PutCreateSuperviorserList: SuperviorsSlicePutlist.reducer,
  SuperviorsSlice: SuperviorsSlicegetList.reducer,
  attendacemulitipleLists: attendancemulitipleListSlice.reducer,
  PerfromancesheaderListedsicess: PerformanceHeaderSliceList.reducer,
  NeededdatasListed: NeededDatasAsSlice.reducer,
  EmployeeDashBoardAttedances: EmployeeDashboardSlice.reducer,
  DashboardwithempAttendanceCall: DaShboardwithemployeedetailsSlice.reducer,
  UserDetailsExportSheet: UserDetailsInexportedSlice.reducer,
  QueryQuetionsDatas: QueryQuestionsSlice.reducer,
  QueryQuestionsCreate: queryQuestionCreateSlice.reducer,
  QueryQuestionsEdit: queryQuestionEditSlice.reducer,
  QueryQuestionsRetrieve: queryQuestionRetrieveSlice.reducer,
  QuerySubQuetionsDatas: QuerySubQuestionsSlice.reducer,
  QuerySubQuestionsCreate: QuerySUbQuestionCreateSlice.reducer,
  QuerySubQuestionsEditions: QuerySUbQuestionEdtionsSlice.reducer,
  QuerySubQuestionsRetrieve: QuerySUbQuestionRetrieveSlice.reducer,
  QueryQuestionsDelete: queryQuestionDeleteSlice.reducer,
  QuerySUBQuestionsDelete: querySUBQuestionDeleteSlice.reducer,
  TrackingrecordgetList: TrackingrecordSlice.reducer,
  QueryTrackingrecordgetListEditions: QueryTrackingrecordgetListSlice.reducer,

  QueryTrackingrecordgetListRetrieve:
    QueryTrackingrecordgetListRetrieveSlice.reducer,
  TrackingDelete: TrackingDeleteSlice.reducer,

  TrackingCreateSliceName: TrackingCreateSlice.reducer,
  FinanceGetListedData: FinanceGetlistedSlice.reducer,
  FinanceGetListedExportData: FinanceGetlistedExportSlice.reducer,
  AttendanceREPORTDataCall: AttendanceREPORTSlice.reducer,
  OnboaderDetailsListOut: OnboaderDetailsSlice.reducer,
  AadharOtherPartyAPIPhoneOtp: OtherPartyAAdhaarsendOtpSlice.reducer,
  aadharsentSubmitthephoneotp: AADharSubmitOtpSlice.reducer,
  PANCARDthephoneotp: PANCARDSubmitOtpSlice.reducer,
  PANCARDtheSUBMITEDphoneotp: PANCARDSUBMIEDOtpSlice.reducer,
  SuperviorsEmployeee: SuperviorsEmloyeegetList.reducer,
  UserSelectedPayloadsSlice: UserSelectedOptionsSlicess.reducer,
  pennydropforBank: BankVerifiedDropslice.reducer,
  pennydropforBankVerify: tokenCreateForpennydropslice.reducer,
  ///----uds--employees---
  FetchReimbursementCall: FetchReimbursementEMPSlice.reducer,

  CustomUDSEMployeeLogin: CustomUDSEmployeeLoginSlice.reducer,
  CustomUDSEMployeeSendOTP: CustomUDSEmployeeLsendOtpSlice.reducer,
  UDSemployeeRoleActions: UDSROleEmployeeSLiceActions.reducer,
  laguagefoetheemployees: LanguageSteup.reducer,
  ShiftDatas: ShiftDatasListSlice.reducer,
  CalendarCall: CalendarSlice.reducer,
  AttenDanceCall: AttenDanceSlice.reducer,
  LeaveTypeData: LeaveTypeDataSlice.reducer,
  CreateLeaveCall: CreateLeaveSlice.reducer,
  CheckInOutPutMethodCall: CheckInOutPutMethodSlice.reducer,
  UserSelectedDashboArdEmployeesgetdatas:
    UserSelectedDahboardEmployeesSlicess.reducer,
  ReportSheetData: ReportSheetExportSlice.reducer,
  ReportSheetpostmethoh: ReportSheetExportPostSlice.reducer,
  OnboardngCounts: OnboardingCountsSlices.reducer,
  ProfileSignatureCalls: ProfilesignatureSlice.reducer,
  ProfileSignatureEditCalls: ProfilesignatureEditSlice.reducer,
  SonyEmployeeCalls: SonyEmployeeCallsSlice.reducer,
  OverAllReportCall: OverAllReportSlice.reducer,
  OverAllReportCreateCall: OverAllReportCreateSlice.reducer,
  OverAllReportEditCall: OverAllReportEditSlice.reducer,
  OverAllReportRetrieveCall: OverAllReportRetrieveSlice.reducer,
  OverAllReportEmployeeListCall: OverAllEmployeeListSlice.reducer,
  OverAllReportEmployeeListExportCall: OverAllEmployeeListExportSlice.reducer,
  sendEmailREportEditData: sendEmailReportEditSlice.reducer,
  sendEmailREportgetData: sendEmailReportgetslice.reducer,

  DashboardOnboardOverviewCall: DaShboardOnboardingOverviewSlice.reducer,
  OverallStateCallData: Overallstateslice.reducer,
  ResentOtpVeririedPhoneNumbers: ResendOtpverifiiedSLice.reducer,
  StateManagementOverallCall: StateManagementSlice.reducer,
  AttendanceLocationSliceCall: AttendanceLocationSlice.reducer,
  AttendanceLocationSliceCreateCall: AttendanceLocationSliceCreate.reducer,
  AttendanceLocationSliceEditionCall: AttendanceLocationSliceEdit.reducer,
  AttendanceLocationSliceDeletionCall: AttendanceLocationSliceDelete.reducer,

  AttendanceLocationSliceRetrieveMethosCall:
    AttendanceLocationSliceRetrievemethod.reducer,
  SupportDocumentFetch: supportDocumentFetchSlice.reducer,
  SupportDocumentEdit: supportDocumentEditSlice.reducer,
  HRonboardingDatas: HRonboardingListSlice.reducer,
  myonboardingDatas: MyonboardingListSlice.reducer,

  ApproverequestDatass: ApproveRequestListSlice.reducer,
  RegeneratePDFCalls: RegenerateThePdfSlice.reducer,
  managerapproverequestdata: myManagerListForApproveRequestSlice.reducer,
  ReportSheetDeleted: ReportSheetDeleteSlice.reducer,
  OvertimeSliceCall: overtimeGetlistslice.reducer,
  OvertimeApprove: OvertimeApproveListSlice.reducer,
  getposttheRejoiningResponse: RejoiningPOSTSlices.reducer,
  OnboarderRejoindata: RejoiningOnboaderListSlice.reducer,
  MyTicketsSliceDatas: MyTicketsSlice.reducer,
  bothuserASEmployeee: UserForBoththeEmployeeAndUDS_slice.reducer,
  OndutyDaysemp: OndutyDaysempDataSlice.reducer,
  OndutyDaysempCreate: OndutyEmployeeCreateSlice.reducer,
  AttenDance_RegularizationCallEmp: AttendanceRegularizationForEmployee.reducer,
  CreateRegularizationEmp: CreateRegularizationForEmpSlice.reducer,
  AttenDancePermissionCallEmp: AttenDanceGetlistempPermissionSlice.reducer,
  Overtime_RegularizationCallEmp: OvertimeRegularizationEMpSlice.reducer,
  PayLipEMployeeeData: PaySlipForEmployeeSlice.reducer,
  FaceVerificationDatas: FaceVerificationSlice.reducer,
  ResignationDatasEMp: ResignationEmpSlice.reducer,
  ResignationEmpRetrieveEmp: ResignationRetrieveSliceEmp.reducer,
  NodueFormEmployeeSLiceData: NoDueFormEmployeeSlice.reducer,
  NodueFormEmployeeEditCalllData: NoDueFormEmployeeEditSlice.reducer,
  NodueFormEmployeeSLiceRetrieveData: NoDueFormEmployeeRetrieveSlice.reducer,
  ReimbursementDataFetchEmp: ReimbursementCreateforEmp.reducer,
  grievenceTypeDatasEmp: gettheGrievenceGetListFortheEmpTypeListSlice.reducer,
  grievenceDatasEmp: gettheGrievenceGetListFortheEmpSlice.reducer,
  GrievanceApplyForEmpData: CreateGrivanceApplyFormForEMpForEmpSlice.reducer,
  HelpDeskDatasEMP: HelpDeskFormEmployeeSlice.reducer,
  TrackingParentEmp: trackingParentsliceForSliceEmp.reducer,
  TrackingsubCategorytEmp: trackingSubCategorysliceForSliceEmp.reducer,
  helpDeskPostForEmployeee: helpDeskPostFroEmployeeeSlice.reducer,
  EmpAttendaEmpDataGetList: EmployeeAttendanceSliceData.reducer,
  EmpBlockEmpDatagetStored: EmployeeeBlockedGetListEmpSle.reducer,
  EmpBlockEmpDataPosttStored: EmployeeeBlockedPOSTListEmpSlice.reducer,
  EmpBlockEmpSiteTransferStored: employeeSiteTransferSliceData.reducer,
  EmpBlockEmpSiteTransferCreate: employeeSiteTransferCreateSliceData.reducer,
  AttendanceRegularizationSignlemulti:
    AttendanceRegularizationSliceSignleMulti.reducer,
  AttendanceRegularizationteamPostSignlemulti:
    AttendanceRegularizationTeamPostSliceSignleMulti.reducer,
  UnbloadedEmployeeeDataEmp: UnbloadedEmpForGetlistSlice.reducer,
  EmployeeClientBranchForEmpData: EmployeeClientBranchListForEmpSlice.reducer,
  EmployeeProfileGetListData: EmployeeAttendanceProfileGetSlice.reducer,
  EmployeeProfilepostUpdateListData: UpdatePostUrlEmpAttendance.reducer,
  NodueFormFetchDatasgetFetch: NodueformFetchDetailsSlice.reducer,
  sitetransferemployeeapidata: sitetransferemployeelistslice.reducer,
  SkillAssessmentEmpList: skillAssessmentEmpListSlice.reducer,
  StateFetchDetails: stateFetchDetailsSlice.reducer,
  RegionFetchDetails: regionFetchDetailsSlice.reducer,
  ZoneFetchDetails: zoneFetchDetailsSlice.reducer,
  DesignationFetchDetails: designationFetchDetailsSlice.reducer,
  BranchFetchDetails: branchFetchDetailsSlice.reducer,
  skillassessmentretieveempdatas: skillassessmentSliceRetrieveEmpdatas.reducer,
  skillassessmentforapplyemppostmethod:
    skillassessmentpostmethodforapplyempslice.reducer,
  skillquestionpaperassessment: skillassessmentSlicequestiongetlist.reducer,
  innerquestionskillassessment: innerQuestionSkillAssessmentSlice.reducer,
  questiontypeskillassessment: questionTypeSkillAssessmentSlice.reducer,

  skillassessmentforapplyemp_put_method:
    skillassessmentputmethodsapplyempslice.reducer,
  TicketQuetionsDatas: TicketCategoryQuestionsSlice.reducer,
  TicketQuestionsCreate: TicketQuestionCreateSlice.reducer,
  TicketQuestionsretrieve: TicketQuestionRetrieveSlice.reducer,
  TicketingQuestionsDelete: TicketingQuestionDeleteSlice.reducer,
  TicketQuestionsEdition: TicketQuestionEditSlice.reducer,

  TicketSubQuetionsDatas: TicketSubQuestionsSlice.reducer,
  TicketSubQuestionsCreate: TicketSUbQuestionCreateSlice.reducer,
  TicketingSubQuestionsEditions: TicketSUbQuestionEdtionsSlice.reducer,
  TicketSubQuestionsRetrieve: TicketSUbQuestionRetrieveSlice.reducer,
  TickerSUBQuestionsDelete: TicketSUBQuestionDeleteSlice.reducer,

  TrackingrecordgetOfSystemList: TrackingrecordOfSystemSlice.reducer,
  Ticketingrecord_dashboard: TicketingRecordDetailDashboardSlice.reducer,

  RetrieveTickingSystemdatas: TicketingSystemInretrievetheTicketsSlice.reducer,
  commentsDatas: ticketcommentSlice.reducer,
  TickeetRemarkSliceDatas: ticketRemarksSliceActionsSlice.reducer,
  retrievetheRemarks: ticketremarksreviewlistSlice.reducer,
  ticketstatuschanges: ticketSTatusChangesSlice.reducer,
  ticketTimeLIneSlicedata: ticketTimelineSlice.reducer,
  TicketingSystemIn: UDSTicketingSysttemexportslice.reducer,
  ticketFeedbacklistedslice: ticketFeedbackSlice.reducer,
  ScopeGettheDatalist: ScopeGetlistSlice.reducer,
  ContactPersonEdit: ContactPersonEditSlice.reducer,
  CategoryListed: ListofCategoryListedSlice.reducer,
  SubCategoryListed: SubCategoryDatasSlice.reducer,
  SubCategoryeditandcreateScopeListed: SubCategoryDatasScopeEditSlice.reducer,
  NearDueCallingdatas: NearDueDataCallSlice.reducer,
  UdsuserRemarkdssliced: UdsusersRemarklistedslice.reducer,
  SubCategorySlicedatas: SubcategoryListedEditSlice.reducer,

  UDSQuetionsDatas: UDSCategoryQuestionsSlice.reducer,
  InternalTicketCrud: InternalQuestionCreateSlice.reducer,
  internalcategoryQuestionsEdition: internalCategoryQuestionEditSlice.reducer,
  internalcategoryQuestionsretrieve:
    internalcategoryQuestionRetrieveSlice.reducer,
  InternalQuestionsDelete: InternalQuestionDeleteSlice.reducer,
  branchqrcodes: BranchQrcodeexports.reducer,
  InternalSubQuetionsDatas: InternalSubQuestionsSlice.reducer,
  InternalSubQuestionsEditions: InternalSUbQuestionEdtionsSlice.reducer,
  InternalSubQuestionsRetrieve: InternalSUbQuestionRetrieveSlice.reducer,
  InternalSUBQuestionsDelete: internalSubcategorydelete.reducer,
  InternalSubQuestionsCreate: InternalSUbQuestionCreateSlice.reducer,
  Tracking_unregisterrecordgetOfSystemList:
    Tracking_unregisterrecordOfSystemSlice.reducer,
  InternalSubDepartmentsDatas: InternalSubDepartmentsSlice.reducer,
  InternalDepartmentsDelete: internaldepartmentDelete.reducer,
  InternalDepartmentsCreate: internaldepartmentCreated.reducer,
  InternalDepartmentsRetrieveName: internaldepartmentRetrive.reducer,
  InternalDepartmentsEdit: internaldepartmentEdit.reducer,
  departmentLevelUserslist: DepartmentLevelUsersSlice.reducer,
  DepartmentLevelUsersListe: gettheDepartmentLevelUsersSlice.reducer,
  InternalDepartments_usersDelete: internaldepartmentUsersDelete.reducer,
  InternalDepartments_usersRetrivee: internaldepartmentUsersRetrieve.reducer,
  InternalDepartments_userCrudEditions:
    internaldepartmentUsersCrudEdtions.reducer,
  TrackingrecordgetOfSystemListInternalDepartment:
    InternalTrackingrecordOfSystemSlice.reducer,
  CreateinternalTicketListed: CreateInternalTicketSlice.reducer,
  internalTicketView: InternalDepartmentTicketViews.reducer,
  internalTicketFeedBack: InternalDepartmentFeedBack.reducer,
  internalTicketChanges: InternalDepartmentTicketChanges.reducer,
  internalTicketRemarks: InternalDepartmentRemarks.reducer,
  internalTicketTimeline: InternalDepartmenttIMElINE.reducer,
  internalTicketFeedBackpost: InternalDepartmentFeedBackPost.reducer,
  internalcommandticketpost: internalcommandsticketpost.reducer,
  internalcommandticketgetdata: internalcommandsticketgetdataDepartment.reducer,
  internalTicketDepartmentUsersNames:
    internalTicketDepartmentUsersSlice.reducer,
  internalTicketCRUDRemarks: InternalDepartmentCRUDRemarks.reducer,
  internalRemarks_postvaluesName: internal_remarkpostedslice.reducer,
  TicketingInertnalDashboardCalls: TicketingInernalDashboardSlice.reducer,
  NeadueInternalTicketCalls: TicktignNearDueSliceInternalTicketing.reducer,
  TicketReassignAssignRejectCalls: TicketReassignSliceDetails.reducer,
  TicketDetailsListedNames: TicketDetailsListedslice.reducer,
  TicketUnregisterNameAssing: TicketUnregisterSliceAssigns.reducer,
  ticketexcalationrecordoflist: ticketexcalationSliceRecords.reducer,
  TicketJournydatasClient: TicketjounerySlicefortheClients.reducer,
  TicketJournydatasofinternlandcient:
    TicketjounerySlicefortheboththe_internalandCliet.reducer,
  SubticketForthemanagements: SubTicketsFortheSlice.reducer,
  ClientTicketListedDatahold: ClientTicketListedSlice.reducer,
  gettheClientCategoryDatas: gettheClienCategoryDatasSlice.reducer,
  gettheClientTicketPostforLonesDatastore:
    gettheClientTicketPostforLones.reducer,

  gettheclientsubcategoryApidatas: gettheclientsubcategoryApiSlice.reducer,
  NotificationDeleteapidatahold: NotificationListDelete.reducer,
  NotificationListoutapidatahold: NotificationListoutapi.reducer,
  NewDashboardNameHolds: NewDashboardSlice.reducer,
  SubAssignTicketDasboardDataHolds: SubAssignTicketDasboardSliceCall.reducer,

  StatesOfAdvanceAttendanceRecordsCall:
    StatesOfAdvanceAttendanceRecordsSlice.reducer,
  EmployeeOfAdvanceAttendanceRecordsCall:
    EmployeeOfAdvanceAttendanceRecordsSlice.reducer,
  AdvanceAttendance_countsRecordsCall:
    AdvanceAttendance_CountsRecordsSlice.reducer,
  advanceSecondStateSliceCall: advanceSecondStateSlice.reducer,
  regionalMangerRecords: RegionalManagernboardDetails.reducer,
  Customer_table_dashbaord: Customer_Dashbaord_TableSlice.reducer,
  internaltable_dashbaord: Internal_Dashbaord_TableSlice.reducer,
  Customer_table_dashbaord_statebased: StateBased_CustomerDashboard.reducer,
  internal_statebased_ticketstatus_table:
    Internal_State_TicketStatus_TableSlice.reducer,
  ExternalEscalationsdashboard: ExternalExcalationDashboardSlice.reducer,
  internalEscalationsdashboard: InternalExcalationDashboardSlice.reducer,
  TicketTrendDashboard: TicketTrendDashboardSlice.reducer,
  PerformanceMetrics: PerformanceMetricsSlice.reducer,
  IssueCategroyCustomChart: Issue_categoryfirstFivelist_customslice.reducer,
  CustomerSupport_stateCard: CustomerSupportChart_StateSlice.reducer,

  CustomerSupportStateChart: CustomerSupportStateChartSlice.reducer,
  CustomerSupportStateList: CustomerSupportStateListSlice.reducer,

  CustomerSupportRegionalChart: CustomerSupportRegionalChartSlice.reducer,
  CustomerSupportRegionalList: CustomerSupportRegionalListSlice.reducer,
  CustomerSupportZoneChart: CustomerSupportZoneChartSlice.reducer,
  CustomerSupportZoneList: CustomerSupportZoneListSlice.reducer,
  CustomerSupportClientChart: CustomerSupportClientChartSlice.reducer,
  CustomerSupportClientList: CustomerSupportClientListSlice.reducer,
  IssueCategoryListedCustom: Issue_categoryListed_customslice.reducer,
  CustomPerformanceMatrix: CustomPerformanceMatrix_StateSlice.reducer,

  InternalPerformanceMetrics: InternalPerformanceMetricsSlice.reducer,
  InternalIssueCategoryTopFive: InternalIssueCategoryTopFiveSlice.reducer,
  InternalIssueCategoryList: InternalIssueCategoryListSlice.reducer,
  InternalSupportChartState: InternalSupportChartStateSlice.reducer,
  InternalSupportRegionalChart: InternalSupportRegionalChartSlice.reducer,
  InternalSupportRegionalList: InternalSupportRegionalListSlice.reducer,
  InternalSupportZoneChart: InternalSupportZoneChartSlice.reducer,
  InternalSupportZoneList: InternalSupportZoneListSlice.reducer,
  InternalSupportClientChart: InternalSupportClientChartSlice.reducer,
  InternalSupportClientList: InternalSupportClientListSlice.reducer,
  InternalCustomPerformanceMatrix: InternalCustomPerformanceMatrixSlice.reducer,
  InternalSupportStateList: InternalSupportStateListSlice.reducer,
  InternalSupportTrendsTickets: InternalSupportTrendTicketsSlice.reducer,

  customer_geolocation_state: Customer_Geolocation_State_Slice.reducer,
  customer_geolocation_regional: Customer_Geolocation_Regional_Slice.reducer,
  customer_geolocation_zone: Customer_Geolocation_Zone_Slice.reducer,
  customer_geolocation_client: Customer_Geolocation_Client_Slice.reducer,

  internalsupport_regionlist: InternalSupport_RegionList_Slice.reducer,
  internalsupport_zone: InternalSupport_Zone_Slice.reducer,
  internalsupport_client: InternalSupport_Client_Slice.reducer,
  EmployeeEditActions_exitings: Employee_actionOfEditSlice.reducer,

  masterdashboard_records: Master_dashboard_listedrecords.reducer,
  masterdashboard_cruds_tocall: Master_dashboard_cruds.reducer,

  organization_filterlist_tocall: Organization_filterlist.reducer,
  organizationRm_filterlist_tocall: organizationRm_filterlist.reducer,
  clientDivisionLevel_dropdown_tocall: clientDivisionLevel_dropdown.reducer,
  grievanceExportListCall: grievance_export_listedoptions.reducer,
  EmployeeOfAdvanceAttendance_summaryRecordsCall:
    EmployeeOfAdvanceAttendanceSummaryRecordsSlice.reducer,
  SalaryExportAnnualCall: Salary_export_Annualoptions?.reducer,

  AppointmentExportAnnualCall: Appointment_export_Annualoptions.reducer,
  SalaryExportletter_revisionCall: Salary_export_letter_revision.reducer,
  Contract_Renewal_Letter_Call: Contract_Renewal_Letter.reducer,
  Salary_Revision_Letter_Change_Call: Salary_Revision_Letter_Change.reducer,
  Warning_Letter_Poor_Performance_Call: Warning_Letter_Poor_Performance.reducer,

  Generate_Letter_Call: Generate_Letter_slice.reducer,

  Warning_Letter_Indiscipline_Call: Warning_Letter_Indiscipline.reducer,

  Show_Cause_Absconding_Call: Show_Cause_Absconding.reducer,

  Show_Cause_False_Attendance_Call: Show_Cause_False_Attendance.reducer,

  Show_Cause_False_Bills_Submission_Call:
    Show_Cause_False_Bills_Submission.reducer,

  AdvanceAttendance_counts_particularRecordsCall:
    AdvanceAttendance_Counts_particularRecordsSlice.reducer,

  StatesOfAdvanceAttendance_particularRecordsCall:
    StatesOfAdvanceAttendance_particular_RecordsSlice.reducer,

  advanceSecondState_particularSliceCall:
    advanceSecond_particularStateSlice.reducer,

  EmployeeOfAdvanceAttendanceRecords_particularCall:
    EmployeeOfAdvanceAttendance_particularRecordsSlice.reducer,

  EmployeeOfAdvanceAttendanceParticular_summaryRecordsCall:
    EmployeeOfAdvanceAttendance_particularSummaryRecordsSlice.reducer,

  signatureUpload: signatureUploadSlice.reducer,

  Signature_Employee_RetrieveCall_actions:
    Signature_Employee_RetrieveCall.reducer,
  selfonboardingretriveslice: Selfonboarding_RetrieveCall.reducer,
  selfonboarddatafetchslice: Selfonboarding_DataFetchCall.reducer,
  Signature_Employee_UpdatedsCall_actions:
    Signature_Employee_UpdatedsCall.reducer,

  Form_ExportsUsers_RetrieveCall_actions:
    Form_ExportsUsers_RetrieveCall.reducer,
  Form_Reports_UpdatedCall_actions: Form_Reports_UpdatedCall.reducer,
  // state management
  PreviousPagePosition: previousPagePositionSlice.reducer,
  Skill_Assessment_Dashboard_Count_actions:
    Skill_Assessment_Dashboard_Count_Slice.reducer,
  hrmsConnectivityList: HrmsConnectivityListSlice.reducer,
  idCardList: IdCardListSlice.reducer,
  hrmsConnectivityUpdate: HrmsConnectivityUpdateSlice.reducer,
  hrmsConnectivityStatusUpdate: HrmsConnectivityStatusUpdateSlice.reducer,
  smartConnectEmployeeList: SmartConnectEmployeeListSlice.reducer,
  smartConnectHiringList: SmartConnectHiringListSlice.reducer,
  smartConnectBulkUpload: SmartConnectBulkUploadSlice.reducer,
  employeeEsignRetrieve: employeeEsignRetrieveSlice.reducer,
  employeeEsignUpdate: employeeEsignUpdateSlice.reducer,
  letterOnboardingBulkUpload: letterOnboardingBulkUploadSlice.reducer,
  letterOnboardingEmployeeList: letterOnboardingEmployeeListSlice.reducer,
  sonyBulkUploadTab: sonyBulkUploadTabSlice.reducer,
};
